// setTimeout(function(){
//   // ---------------------------------------------------------------------------------------------
//   //                                         ShopifyCommonJS          
//   // ---------------------------------------------------------------------------------------------
//   "undefined" == typeof window.Shopify && (window.Shopify = {}),
//   Shopify.bind = function(t, e) {
//       return function() {
//           return t.apply(e, arguments)
//       }
//   }
//   ,
//   Shopify.setSelectorByValue = function(t, e) {
//       for (var n = 0, i = t.options.length; n < i; n++) {
//           var o = t.options[n];
//           if (e == o.value || e == o.innerHTML)
//               return t.selectedIndex = n
//       }
//   }
//   ,
//   Shopify.addListener = function(t, e, n) {
//       t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent("on" + e, n)
//   }
//   ,
//   Shopify.postLink = function(t, e) {
//       var n = (e = e || {}).method || "post"
//         , i = e.parameters || {}
//         , o = document.createElement("form");
//       for (var r in o.setAttribute("method", n),
//       o.setAttribute("action", t),
//       i) {
//           var l = document.createElement("input");
//           l.setAttribute("type", "hidden"),
//           l.setAttribute("name", r),
//           l.setAttribute("value", i[r]),
//           o.appendChild(l)
//       }
//       document.body.appendChild(o),
//       o.submit(),
//       document.body.removeChild(o)
//   }
//   ,
//   Shopify.CountryProvinceSelector = function(t, e, n) {
//       this.countryEl = document.getElementById(t),
//       this.provinceEl = document.getElementById(e),
//       this.provinceContainer = document.getElementById(n.hideElement || e),
//       Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
//       this.initCountry(),
//       this.initProvince()
//   }
//   ,
//   Shopify.CountryProvinceSelector.prototype = {
//       initCountry: function() {
//           var t = this.countryEl.getAttribute("data-default");
//           Shopify.setSelectorByValue(this.countryEl, t),
//           this.countryHandler()
//       },
//       initProvince: function() {
//           var t = this.provinceEl.getAttribute("data-default");
//           t && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, t)
//       },
//       countryHandler: function() {
//           var t = (i = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces")
//             , e = JSON.parse(t);
//           if (this.clearOptions(this.provinceEl),
//           e && 0 == e.length)
//               this.provinceContainer.style.display = "none";
//           else {
//               for (var n = 0; n < e.length; n++) {
//                   var i;
//                   (i = document.createElement("option")).value = e[n][0],
//                   i.innerHTML = e[n][1],
//                   this.provinceEl.appendChild(i)
//               }
//               this.provinceContainer.style.display = ""
//           }
//       },
//       clearOptions: function(t) {
//           for (; t.firstChild; )
//               t.removeChild(t.firstChild)
//       },
//       setOptions: function(t, e) {
//           var n = 0;
//           for (e.length; n < e.length; n++) {
//               var i = document.createElement("option");
//               i.value = e[n],
//               i.innerHTML = e[n],
//               t.appendChild(i)
//           }
//       }
//   };
  
//   // ---------------------------------------------------------------------------------------------
//   //                                          Net-term starts here           
//   // ---------------------------------------------------------------------------------------------
//   (function() {
  
//       var netTermDesign = function(cart) {
//           if (cart.items && Object.keys(cart.items).length && typeof WSAIO.customer.id != 'undefined' && WSAIO.netTerm.enabled) {
//               // ============================= Global variables =============================
//               var WSAIO_customer = WSAIO.customer
//                 , WSAIO_netTerm = WSAIO.netTerm;
//               var WSAIO_money_format = WSAIO.shopInfo.money_format
//                 , WSAIO_shop_money_format = WSAIO.shop_money_format
//                 , enable_new_delivery_date = WSAIO_netTerm.show_delivery_date
//                 , enable_nerterm_options = WSAIO_netTerm.show_payment_mode
//                 , enable_nerterm_PO = WSAIO_netTerm.enable_po
//                 , netTerm_page_tab = 'information'
//                 , coupon_applied_value = 0
//                 , WSAIO_show_wholesale_shipping = WSAIO_netTerm.display_shipping_rates.app
//                 , WSAIO_show_shopify_shipping = WSAIO_netTerm.display_shipping_rates.shopify
//                 , WSAIO_hide_freeShipping = WSAIO_netTerm.hide_freeshipping
//                 , app_url = WSAIO.App.checkoutURL
//                 , update_items = {}
//                 , shop_logo = WSAIO.cart_additional_info[0].shop.logo_img
//                 , shop_logo_banner = WSAIO.cart_additional_info[0].shop.shop_logo_banner
//                 , delivery_options = WSAIO_netTerm.delivery_options
//                 , delivery_options_pickup_notes = WSAIO_netTerm.delivery_options_pickup_notes
//                 , number_of_days_disabled = parseInt(WSAIO_netTerm.number_of_days_disabled)
//                 , enable_notes = WSAIO_netTerm.enable_notes
//                 , notes = WSAIO_netTerm.notes
//                 , free_shipping_coupon_applied = false
//                 , shopify_shipping_request = 1
//                 , show_default_shipping_address = WSAIO_netTerm.is_default_address_checked
//                 , is_logo = WSAIO_netTerm.net_term_logo
//                 , is_billing_address_checked = WSAIO_netTerm.is_billing_same_as_shipping
//                 , WSAIO_generalSetting = WSAIO.general_settings;
//               var netTerm_order_method = WSAIO.netTerm.order_method;
//               WSAIO.netTerm_order_tags = 'NetTerm';
//               var hide_shipping_content = false;
//               if ((!WSAIO_netTerm.display_shipping_rates.app && !WSAIO_netTerm.display_shipping_rates.beskpoke && !WSAIO_netTerm.display_shipping_rates.shopify) || (delivery_options == 'only_pickup' || delivery_options == 'none')) {
//                   hide_shipping_content = true;
//               }
  
//               if (delivery_options == 'only_pickup' || delivery_options == 'none') {
//                   enable_new_delivery_date = false;
//               }
  
//               var Show_additional_coupon_field = false;
//               if (WSAIO_generalSetting.enable_additional_coupon_code) {
//                   Show_additional_coupon_field = true;
//               } else if (WSAIO_generalSetting.additional_coupon_code_tag_based != null && WSAIO_generalSetting.additional_coupon_code_tag_based.enabled) {
//                   var setting_tags = WSAIO_generalSetting.additional_coupon_code_tag_based.tags;
//                   setting_tags.forEach(function(tag) {
//                       const isMatchFound = WSAIO_customer.tags.some(function(customerTag) {
//                           return tag === customerTag;
//                       });
  
//                       if (isMatchFound) {
//                           Show_additional_coupon_field = true;
//                           return;
//                       }
//                   });
//               }
  
//               WSAIO.product_collections = [];
//               try {
//                   WSAIO.products_with_collections.forEach(function(val) {
//                       delete val.product_variants;
//                       WSAIO.product_collections.push(val);
//                   });
//               } catch (e) {}
  
//               if ('undefined' === typeof WSAIO.Currency) {
//                   WSAIO.Currency = {};
//               }
//               WSAIO.Currency.storeCurrency = WSAIO.shopInfo.currency;
//               if ("undefined" !== typeof window.Currency) {
//                   WSAIO.Currency.rates = window.Currency.rates;
//               }
  
//               // ============================= format money function =============================
//               WSAIO_formatMoney = function(t, g) {
//                   a = parseFloat(t);
//                   "string" === typeof a && (a = a.replace(".", ""));
//                   var c = ""
//                     , e = /\{\{\s*(\w+)\s*\}\}/
//                     , f = g || WSAIO_money_format || WSAIO_shop_money_format;
//                   Number.prototype.format_pricing = function(n, x, s, c) {
//                       var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
//                         , num = this.toFixed(Math.max(0, ~~n));
//                       return (c ? num.replace('.', c) : num).replace(new RegExp(re,'g'), '$&' + (s || ','));
//                   }
//                   ;
//                   switch (f.match(e)[1]) {
//                   case "amount":
//                       a = parseFloat(a);
//                       return f.replace(e, a.format_pricing(2));
//                       break;
//                   case "amount_no_decimals":
//                       a = parseFloat(a);
//                       return f.replace(e, a.format_pricing(0));
//                       break;
//                   case "amount_with_comma_separator":
//                       a = parseFloat(a);
//                       return f.replace(e, a.format_pricing(2, 3, '.', ','));
//                       break;
//                   case "amount_no_decimals_with_comma_separator":
//                       a = parseFloat(a);
//                       return f.replace(e, a.format_pricing(2, 0, '.').replace('.00', ''));
//                       break;
//                   case "amount_no_decimals_with_space_separator":
//                       a = parseFloat(a);
//                       return f.replace(e, a.format_pricing(2, 3, ' ').replace('.00', ''));
//                       break;
//                   case "  ":
//                       a = parseFloat(a);
//                       return f.replace(e, a.format_pricing(2, 3, "'"));
//                   }
//                   return f.replace(e, c)
//               }
//               ;
  
//               function check_formate(value) {
//                   var formate_check = WSAIO_formatMoney(value);
//                   if (formate_check.indexOf('class=hidePrice') > -1) {
//                       formate_check = formate_check.split('<span class=hidePrice>')[1];
//                       formate_check = formate_check.split('</span>')[0];
//                   }
//                   if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
//                       formate_check = WSAIO.change_currency_sign(formate_check);
//                   }
//                   return formate_check;
//               }
  
//               // ========================payment options=============================
//               if (enable_nerterm_options) {
//                   var _payment_options = []
//                     , customize_payment_option = [];
//                   if (typeof WSAIO.netTerm.separate_payment_mode != 'undefined' && WSAIO.netTerm.separate_payment_mode) {
//                       WSAIO.netTerm.separate_payment_items.forEach(function(e) {
//                           WSAIO_customer.tags.forEach(function(t) {
//                               if (t.toLowerCase() == e.tag.trim().toLowerCase()) {
//                                   if (e.option_text.indexOf(',') > -1) {
//                                       var options_value = e.option_text.split(',');
//                                       options_value.forEach(function(v) {
//                                           if (v.trim() != '') {
//                                               var option = {
//                                                   'value': v.trim(),
//                                                   'text': v.trim()
//                                               };
//                                               if (!customize_payment_option.some(function(o) {
//                                                   return o.value.toLowerCase() === option.value.toLowerCase();
//                                               })) {
//                                                   customize_payment_option.push(option);
//                                               }
//                                           }
//                                       })
//                                   } else {
//                                       if (e.option_text.trim() != '') {
//                                           var option = {
//                                               'value': e.option_text.trim(),
//                                               'text': e.option_text.trim()
//                                           };
//                                           if (!customize_payment_option.some(function(o) {
//                                               return o.value.toLowerCase() === option.value.toLowerCase();
//                                           })) {
//                                               customize_payment_option.push(option);
//                                           }
//                                       }
//                                   }
//                               }
//                           })
//                       })
//                   } else {
//                       WSAIO_netTerm.payment_options.split(',').forEach(function(d, i) {
//                           if (d != '') {
//                               _payment_options.push({
//                                   value: d,
//                                   text: d
//                               })
//                           }
//                       })
//                       if (_payment_options.length) {
//                           _payment_options.forEach(function(e) {
//                               WSAIO_customer.tags.forEach(function(t) {
//                                   if (e.value.trim().toLowerCase() == t.toLowerCase() && e.value != '') {
//                                       customize_payment_option.push({
//                                           'value': e.value.trim(),
//                                           'text': e.value.trim()
//                                       });
//                                   }
//                               })
//                           })
//                       }
//                   }
//                   if (customize_payment_option.length) {
//                       _payment_options = customize_payment_option
//                   }
//                   _payment_options.forEach(function(po, i) {
//                       _payment_options += '<option value="' + po.value + '">' + po.text + '</option>';
//                   });
//               }
//               // ============================= Auto address dropdown values =============================
//               var new_customer_addresses_HTML = ''
//                 , selectaddress1 = ''
//                 , selectaddress2 = ''
//                 , new_customer_addresses = WSAIO_customer.addresses;
//               new_customer_addresses.forEach(function(address, i) {
//                   new_customer_addresses_HTML += '<option value="' + i + '">Address : ' + address.city + ' : ' + address.address1 + '</option>';
//               });
//               if (new_customer_addresses_HTML == '') {
//                   selectaddress1 = '';
//                   selectaddress2 = '';
//               } else {
//                   selectaddress1 = '  <div class="new_net--input_field ship_field" style="position:relative;">  ' + '                   <select class="new_shipping_auto_address new_field_style new_w-100"><option value="">Sélectionnez votre adresse</option><option value="default">Adresse par défaut</option>' + new_customer_addresses_HTML + '<option value="">Use a different address</option></select> <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg> ' + '                 </div>  ';
//                   selectaddress2 = '                 <div class="new_net--input_field ship_field">  ' + '                   <select class="new_billing_auto_address new_field_style new_w-100"><option value="">Sélectionnez votre adresse</option><option value="default">Adresse par défaut</option>' + new_customer_addresses_HTML + '<option value="">Use a different address</option></select>  ' + '                 </div>  ';
//               }
  
//               // ============================= Countries Province dropdown code =============================
//               var country_and_states = {
//                   "country": {
//                       "AF": "Afghanistan",
//                       "AX": "Åland Islands",
//                       "AL": "Albania",
//                       "DZ": "Algeria",
//                       "AD": "Andorra",
//                       "AO": "Angola",
//                       "AI": "Anguilla",
//                       "AG": "Antigua & Barbuda",
//                       "AR": "Argentina",
//                       "AM": "Armenia",
//                       "AW": "Aruba",
//                       "AC": "Ascension Island",
//                       "AU": "Australia",
//                       "AT": "Austria",
//                       "AZ": "Azerbaijan",
//                       "BS": "Bahamas",
//                       "BH": "Bahrain",
//                       "BD": "Bangladesh",
//                       "BB": "Barbados",
//                       "BY": "Belarus",
//                       "BE": "Belgium",
//                       "BZ": "Belize",
//                       "BJ": "Benin",
//                       "BM": "Bermuda",
//                       "BT": "Bhutan",
//                       "BO": "Bolivia",
//                       "BA": "Bosnia & Herzegovina",
//                       "BW": "Botswana",
//                       "BR": "Brazil",
//                       "IO": "British Indian Ocean Territory",
//                       "VG": "British Virgin Islands",
//                       "BN": "Brunei",
//                       "BG": "Bulgaria",
//                       "BF": "Burkina Faso",
//                       "BI": "Burundi",
//                       "KH": "Cambodia",
//                       "CM": "Cameroon",
//                       "CA": "Canada",
//                       "CV": "Cape Verde",
//                       "BQ": "Caribbean Netherlands",
//                       "KY": "Cayman Islands",
//                       "CF": "Central African Republic",
//                       "TD": "Chad",
//                       "CL": "Chile",
//                       "CN": "China",
//                       "CX": "Christmas Island",
//                       "CC": "Cocos (Keeling) Islands",
//                       "CO": "Colombia",
//                       "KM": "Comoros",
//                       "CG": "Congo - Brazzaville",
//                       "CD": "Congo - Kinshasa",
//                       "CK": "Cook Islands",
//                       "CR": "Costa Rica",
//                       "CI": "Côte d’Ivoire",
//                       "HR": "Croatia",
//                       "CW": "Curaçao",
//                       "CY": "Cyprus",
//                       "CZ": "Czech Republic",
//                       "DK": "Denmark",
//                       "DJ": "Djibouti",
//                       "DM": "Dominica",
//                       "DO": "Dominican Republic",
//                       "EC": "Ecuador",
//                       "EG": "Egypt",
//                       "SV": "El Salvador",
//                       "GQ": "Equatorial Guinea",
//                       "ER": "Eritrea",
//                       "EE": "Estonia",
//                       "SZ": "Eswatini",
//                       "ET": "Ethiopia",
//                       "FK": "Falkland Islands",
//                       "FO": "Faroe Islands",
//                       "FJ": "Fiji",
//                       "FI": "Finland",
//                       "FR": "France",
//                       "GF": "French Guiana",
//                       "PF": "French Polynesia",
//                       "TF": "French Southern Territories",
//                       "GA": "Gabon",
//                       "GM": "Gambia",
//                       "GE": "Georgia",
//                       "DE": "Germany",
//                       "GH": "Ghana",
//                       "GI": "Gibraltar",
//                       "GR": "Greece",
//                       "GL": "Greenland",
//                       "GD": "Grenada",
//                       "GP": "Guadeloupe",
//                       "GT": "Guatemala",
//                       "GG": "Guernsey",
//                       "GN": "Guinea",
//                       "GW": "Guinea-Bissau",
//                       "GY": "Guyana",
//                       "HT": "Haiti",
//                       "HN": "Honduras",
//                       "HK": "Hong Kong SAR",
//                       "HU": "Hungary",
//                       "IS": "Iceland",
//                       "IN": "India",
//                       "ID": "Indonesia",
//                       "IQ": "Iraq",
//                       "IE": "Ireland",
//                       "IM": "Isle of Man",
//                       "IL": "Israel",
//                       "IT": "Italy",
//                       "JM": "Jamaica",
//                       "JP": "Japan",
//                       "JE": "Jersey",
//                       "JO": "Jordan",
//                       "KZ": "Kazakhstan",
//                       "KE": "Kenya",
//                       "KI": "Kiribati",
//                       "XK": "Kosovo",
//                       "KW": "Kuwait",
//                       "KG": "Kyrgyzstan",
//                       "LA": "Laos",
//                       "LV": "Latvia",
//                       "LB": "Lebanon",
//                       "LS": "Lesotho",
//                       "LR": "Liberia",
//                       "LY": "Libya",
//                       "LI": "Liechtenstein",
//                       "LT": "Lithuania",
//                       "LU": "Luxembourg",
//                       "MO": "Macao SAR",
//                       "MG": "Madagascar",
//                       "MW": "Malawi",
//                       "MY": "Malaysia",
//                       "MV": "Maldives",
//                       "ML": "Mali",
//                       "MT": "Malta",
//                       "MQ": "Martinique",
//                       "MR": "Mauritania",
//                       "MU": "Mauritius",
//                       "YT": "Mayotte",
//                       "MX": "Mexico",
//                       "MD": "Moldova",
//                       "MC": "Monaco",
//                       "MN": "Mongolia",
//                       "ME": "Montenegro",
//                       "MS": "Montserrat",
//                       "MA": "Morocco",
//                       "MZ": "Mozambique",
//                       "MM": "Myanmar (Burma)",
//                       "NA": "Namibia",
//                       "NR": "Nauru",
//                       "NP": "Nepal",
//                       "NL": "Netherlands",
//                       "NC": "New Caledonia",
//                       "NZ": "New Zealand",
//                       "NI": "Nicaragua",
//                       "NE": "Niger",
//                       "NG": "Nigeria",
//                       "NU": "Niue",
//                       "NF": "Norfolk Island",
//                       "MK": "North Macedonia",
//                       "NO": "Norway",
//                       "OM": "Oman",
//                       "PK": "Pakistan",
//                       "PS": "Palestinian Territories",
//                       "PA": "Panama",
//                       "PG": "Papua New Guinea",
//                       "PY": "Paraguay",
//                       "PE": "Peru",
//                       "PH": "Philippines",
//                       "PN": "Pitcairn Islands",
//                       "PL": "Poland",
//                       "PT": "Portugal",
//                       "QA": "Qatar",
//                       "RE": "Réunion",
//                       "RO": "Romania",
//                       "RU": "Russia",
//                       "RW": "Rwanda",
//                       "WS": "Samoa",
//                       "SM": "San Marino",
//                       "ST": "São Tomé & Príncipe",
//                       "SA": "Saudi Arabia",
//                       "SN": "Senegal",
//                       "RS": "Serbia",
//                       "SC": "Seychelles",
//                       "SL": "Sierra Leone",
//                       "SG": "Singapore",
//                       "SX": "Sint Maarten",
//                       "SK": "Slovakia",
//                       "SI": "Slovenia",
//                       "SB": "Solomon Islands",
//                       "SO": "Somalia",
//                       "ZA": "South Africa",
//                       "GS": "South Georgia & South Sandwich Islands",
//                       "KR": "South Korea",
//                       "SS": "South Sudan",
//                       "ES": "Spain",
//                       "LK": "Sri Lanka",
//                       "BL": "St Barthélemy",
//                       "SH": "St Helena",
//                       "KN": "St Kitts & Nevis",
//                       "LC": "St Lucia",
//                       "MF": "St Martin",
//                       "PM": "St Pierre & Miquelon",
//                       "VC": "St Vincent & the Grenadines",
//                       "SD": "Sudan",
//                       "SR": "Suriname",
//                       "SJ": "Svalbard & Jan Mayen",
//                       "SE": "Sweden",
//                       "CH": "Switzerland",
//                       "TW": "Taiwan",
//                       "TJ": "Tajikistan",
//                       "TZ": "Tanzania",
//                       "TH": "Thailand",
//                       "TL": "Timor-Leste",
//                       "TG": "Togo",
//                       "TK": "Tokelau",
//                       "TO": "Tonga",
//                       "TT": "Trinidad & Tobago",
//                       "TA": "Tristan da Cunha",
//                       "TN": "Tunisia",
//                       "TR": "Turkey",
//                       "TM": "Turkmenistan",
//                       "TC": "Turks & Caicos Islands",
//                       "TV": "Tuvalu",
//                       "UM": "US Outlying Islands",
//                       "UG": "Uganda",
//                       "UA": "Ukraine",
//                       "AE": "United Arab Emirates",
//                       "GB": "United Kingdom",
//                       "US": "United States",
//                       "UY": "Uruguay",
//                       "UZ": "Uzbekistan",
//                       "VU": "Vanuatu",
//                       "VA": "Vatican City",
//                       "VE": "Venezuela",
//                       "VN": "Vietnam",
//                       "WF": "Wallis & Futuna",
//                       "EH": "Western Sahara",
//                       "YE": "Yemen",
//                       "ZM": "Zambia",
//                       "ZW": "Zimbabwe"
//                   },
//                   "states": {
//                       "AR": [{
//                           "name": "Buenos Aires",
//                           "code": "B"
//                       }, {
//                           "name": "Catamarca",
//                           "code": "K"
//                       }, {
//                           "name": "Chaco",
//                           "code": "H"
//                       }, {
//                           "name": "Chubut",
//                           "code": "U"
//                       }, {
//                           "name": "Ciudad Autónoma de Buenos Aires",
//                           "code": "C"
//                       }, {
//                           "name": "Córdoba",
//                           "code": "X"
//                       }, {
//                           "name": "Corrientes",
//                           "code": "W"
//                       }, {
//                           "name": "Entre Ríos",
//                           "code": "E"
//                       }, {
//                           "name": "Formosa",
//                           "code": "P"
//                       }, {
//                           "name": "Jujuy",
//                           "code": "Y"
//                       }, {
//                           "name": "La Pampa",
//                           "code": "L"
//                       }, {
//                           "name": "La Rioja",
//                           "code": "F"
//                       }, {
//                           "name": "Mendoza",
//                           "code": "M"
//                       }, {
//                           "name": "Misiones",
//                           "code": "N"
//                       }, {
//                           "name": "Neuquén",
//                           "code": "Q"
//                       }, {
//                           "name": "Río Negro",
//                           "code": "R"
//                       }, {
//                           "name": "Salta",
//                           "code": "A"
//                       }, {
//                           "name": "San Juan",
//                           "code": "J"
//                       }, {
//                           "name": "San Luis",
//                           "code": "D"
//                       }, {
//                           "name": "Santa Cruz",
//                           "code": "Z"
//                       }, {
//                           "name": "Santa Fe",
//                           "code": "S"
//                       }, {
//                           "name": "Santiago Del Estero",
//                           "code": "G"
//                       }, {
//                           "name": "Tierra Del Fuego",
//                           "code": "V"
//                       }, {
//                           "name": "Tucumán",
//                           "code": "T"
//                       }],
//                       "AU": [{
//                           "name": "Australian Capital Territory",
//                           "code": "ACT"
//                       }, {
//                           "name": "New South Wales",
//                           "code": "NSW"
//                       }, {
//                           "name": "Northern Territory",
//                           "code": "NT"
//                       }, {
//                           "name": "Queensland",
//                           "code": "QLD"
//                       }, {
//                           "name": "South Australia",
//                           "code": "SA"
//                       }, {
//                           "name": "Tasmania",
//                           "code": "TAS"
//                       }, {
//                           "name": "Victoria",
//                           "code": "VIC"
//                       }, {
//                           "name": "Western Australia",
//                           "code": "WA"
//                       }],
//                       "BR": [{
//                           "name": "Acre",
//                           "code": "AC"
//                       }, {
//                           "name": "Alagoas",
//                           "code": "AL"
//                       }, {
//                           "name": "Amapá",
//                           "code": "AP"
//                       }, {
//                           "name": "Amazonas",
//                           "code": "AM"
//                       }, {
//                           "name": "Bahia",
//                           "code": "BA"
//                       }, {
//                           "name": "Ceará",
//                           "code": "CE"
//                       }, {
//                           "name": "Distrito Federal",
//                           "code": "DF"
//                       }, {
//                           "name": "Espírito Santo",
//                           "code": "ES"
//                       }, {
//                           "name": "Goiás",
//                           "code": "GO"
//                       }, {
//                           "name": "Maranhão",
//                           "code": "MA"
//                       }, {
//                           "name": "Mato Grosso",
//                           "code": "MT"
//                       }, {
//                           "name": "Mato Grosso do Sul",
//                           "code": "MS"
//                       }, {
//                           "name": "Minas Gerais",
//                           "code": "MG"
//                       }, {
//                           "name": "Pará",
//                           "code": "PA"
//                       }, {
//                           "name": "Paraíba",
//                           "code": "PB"
//                       }, {
//                           "name": "Paraná",
//                           "code": "PR"
//                       }, {
//                           "name": "Pernambuco",
//                           "code": "PE"
//                       }, {
//                           "name": "Piauí",
//                           "code": "PI"
//                       }, {
//                           "name": "Rio de Janeiro",
//                           "code": "RJ"
//                       }, {
//                           "name": "Rio Grande do Norte",
//                           "code": "RN"
//                       }, {
//                           "name": "Rio Grande do Sul",
//                           "code": "RS"
//                       }, {
//                           "name": "Rondônia",
//                           "code": "RO"
//                       }, {
//                           "name": "Roraima",
//                           "code": "RR"
//                       }, {
//                           "name": "Santa Catarina",
//                           "code": "SC"
//                       }, {
//                           "name": "São Paulo",
//                           "code": "SP"
//                       }, {
//                           "name": "Sergipe",
//                           "code": "SE"
//                       }, {
//                           "name": "Tocantins",
//                           "code": "TO"
//                       }],
//                       "CA": [{
//                           "name": "Alberta",
//                           "code": "AB"
//                       }, {
//                           "name": "British Columbia",
//                           "code": "BC"
//                       }, {
//                           "name": "Manitoba",
//                           "code": "MB"
//                       }, {
//                           "name": "New Brunswick",
//                           "code": "NB"
//                       }, {
//                           "name": "Newfoundland and Labrador",
//                           "code": "NL"
//                       }, {
//                           "name": "Northwest Territories",
//                           "code": "NT"
//                       }, {
//                           "name": "Nova Scotia",
//                           "code": "NS"
//                       }, {
//                           "name": "Nunavut",
//                           "code": "NU"
//                       }, {
//                           "name": "Ontario",
//                           "code": "ON"
//                       }, {
//                           "name": "Prince Edward Island",
//                           "code": "PE"
//                       }, {
//                           "name": "Quebec",
//                           "code": "QC"
//                       }, {
//                           "name": "Saskatchewan",
//                           "code": "SK"
//                       }, {
//                           "name": "Yukon",
//                           "code": "YT"
//                       }],
//                       "CL": [{
//                           "name": "Antofagasta",
//                           "code": "AN"
//                       }, {
//                           "name": "Araucanía",
//                           "code": "AR"
//                       }, {
//                           "name": "Arica and Parinacota",
//                           "code": "AP"
//                       }, {
//                           "name": "Atacama",
//                           "code": "AT"
//                       }, {
//                           "name": "Aysén",
//                           "code": "AI"
//                       }, {
//                           "name": "Biobío",
//                           "code": "BI"
//                       }, {
//                           "name": "Coquimbo",
//                           "code": "CO"
//                       }, {
//                           "name": "Los Lagos",
//                           "code": "LL"
//                       }, {
//                           "name": "Los Ríos",
//                           "code": "LR"
//                       }, {
//                           "name": "Magallanes",
//                           "code": "MA"
//                       }, {
//                           "name": "Maule",
//                           "code": "ML"
//                       }, {
//                           "name": "Ñuble",
//                           "code": "NB"
//                       }, {
//                           "name": "O'Higgins",
//                           "code": "LI"
//                       }, {
//                           "name": "Santiago",
//                           "code": "RM"
//                       }, {
//                           "name": "Tarapacá",
//                           "code": "TA"
//                       }, {
//                           "name": "Valparaíso",
//                           "code": "VS"
//                       }],
//                       "CN": [{
//                           "name": "Anhui",
//                           "code": "AH"
//                       }, {
//                           "name": "Beijing",
//                           "code": "BJ"
//                       }, {
//                           "name": "Chongqing",
//                           "code": "CQ"
//                       }, {
//                           "name": "Fujian",
//                           "code": "FJ"
//                       }, {
//                           "name": "Gansu",
//                           "code": "GS"
//                       }, {
//                           "name": "Guangdong",
//                           "code": "GD"
//                       }, {
//                           "name": "Guangxi",
//                           "code": "GX"
//                       }, {
//                           "name": "Guizhou",
//                           "code": "GZ"
//                       }, {
//                           "name": "Hainan",
//                           "code": "HI"
//                       }, {
//                           "name": "Hebei",
//                           "code": "HE"
//                       }, {
//                           "name": "Heilongjiang",
//                           "code": "HL"
//                       }, {
//                           "name": "Henan",
//                           "code": "HA"
//                       }, {
//                           "name": "Hubei",
//                           "code": "HB"
//                       }, {
//                           "name": "Hunan",
//                           "code": "HN"
//                       }, {
//                           "name": "Inner Mongolia",
//                           "code": "NM"
//                       }, {
//                           "name": "Jiangsu",
//                           "code": "JS"
//                       }, {
//                           "name": "Jiangxi",
//                           "code": "JX"
//                       }, {
//                           "name": "Jilin",
//                           "code": "JL"
//                       }, {
//                           "name": "Liaoning",
//                           "code": "LN"
//                       }, {
//                           "name": "Ningxia",
//                           "code": "NX"
//                       }, {
//                           "name": "Qinghai",
//                           "code": "QH"
//                       }, {
//                           "name": "Shaanxi",
//                           "code": "SN"
//                       }, {
//                           "name": "Shandong",
//                           "code": "SD"
//                       }, {
//                           "name": "Shanghai",
//                           "code": "SH"
//                       }, {
//                           "name": "Shanxi",
//                           "code": "SX"
//                       }, {
//                           "name": "Sichuan",
//                           "code": "SC"
//                       }, {
//                           "name": "Tianjin",
//                           "code": "TJ"
//                       }, {
//                           "name": "Xinjiang",
//                           "code": "XJ"
//                       }, {
//                           "name": "Xizang",
//                           "code": "YZ"
//                       }, {
//                           "name": "Yunnan",
//                           "code": "YN"
//                       }, {
//                           "name": "Zhejiang",
//                           "code": "ZJ"
//                       }],
//                       "CO": [{
//                           "name": "Amazonas",
//                           "code": "AMA"
//                       }, {
//                           "name": "Antioquia",
//                           "code": "ANT"
//                       }, {
//                           "name": "Arauca",
//                           "code": "ARA"
//                       }, {
//                           "name": "Atlántico",
//                           "code": "ATL"
//                       }, {
//                           "name": "Bogotá, D.C.",
//                           "code": "DC"
//                       }, {
//                           "name": "Bolívar",
//                           "code": "BOL"
//                       }, {
//                           "name": "Boyacá",
//                           "code": "BOY"
//                       }, {
//                           "name": "Caldas",
//                           "code": "CAL"
//                       }, {
//                           "name": "Caquetá",
//                           "code": "CAQ"
//                       }, {
//                           "name": "Casanare",
//                           "code": "CAS"
//                       }, {
//                           "name": "Cauca",
//                           "code": "CAU"
//                       }, {
//                           "name": "Cesar",
//                           "code": "CES"
//                       }, {
//                           "name": "Chocó",
//                           "code": "CHO"
//                       }, {
//                           "name": "Córdoba",
//                           "code": "COR"
//                       }, {
//                           "name": "Cundinamarca",
//                           "code": "CUN"
//                       }, {
//                           "name": "Guainía",
//                           "code": "GUA"
//                       }, {
//                           "name": "Guaviare",
//                           "code": "GUV"
//                       }, {
//                           "name": "Huila",
//                           "code": "HUI"
//                       }, {
//                           "name": "La Guajira",
//                           "code": "LAG"
//                       }, {
//                           "name": "Magdalena",
//                           "code": "MAG"
//                       }, {
//                           "name": "Meta",
//                           "code": "MET"
//                       }, {
//                           "name": "Nariño",
//                           "code": "NAR"
//                       }, {
//                           "name": "Norte de Santander",
//                           "code": "NSA"
//                       }, {
//                           "name": "Putumayo",
//                           "code": "PUT"
//                       }, {
//                           "name": "Quindío",
//                           "code": "QUI"
//                       }, {
//                           "name": "Risaralda",
//                           "code": "RIS"
//                       }, {
//                           "name": "San Andrés, Providencia y Santa Catalina",
//                           "code": "SAP"
//                       }, {
//                           "name": "Santander",
//                           "code": "SAN"
//                       }, {
//                           "name": "Sucre",
//                           "code": "SUC"
//                       }, {
//                           "name": "Tolima",
//                           "code": "TOL"
//                       }, {
//                           "name": "Valle del Cauca",
//                           "code": "VAC"
//                       }, {
//                           "name": "Vaupés",
//                           "code": "VAU"
//                       }, {
//                           "name": "Vichada",
//                           "code": "VID"
//                       }],
//                       "CR": [{
//                           "name": "Alajuela",
//                           "code": "CR-A"
//                       }, {
//                           "name": "Cartago",
//                           "code": "CR-C"
//                       }, {
//                           "name": "Guanacaste",
//                           "code": "CR-G"
//                       }, {
//                           "name": "Heredia",
//                           "code": "CR-H"
//                       }, {
//                           "name": "Limón",
//                           "code": "CR-L"
//                       }, {
//                           "name": "Puntarenas",
//                           "code": "CR-P"
//                       }, {
//                           "name": "San José",
//                           "code": "CR-SJ"
//                       }],
//                       "EG": [{
//                           "name": "6th of October",
//                           "code": "SU"
//                       }, {
//                           "name": "Al Sharqia",
//                           "code": "SHR"
//                       }, {
//                           "name": "Alexandria",
//                           "code": "ALX"
//                       }, {
//                           "name": "Aswan",
//                           "code": "ASN"
//                       }, {
//                           "name": "Asyut",
//                           "code": "AST"
//                       }, {
//                           "name": "Beheira",
//                           "code": "BH"
//                       }, {
//                           "name": "Beni Suef",
//                           "code": "BNS"
//                       }, {
//                           "name": "Cairo",
//                           "code": "C"
//                       }, {
//                           "name": "Dakahlia",
//                           "code": "DK"
//                       }, {
//                           "name": "Damietta",
//                           "code": "DT"
//                       }, {
//                           "name": "Faiyum",
//                           "code": "FYM"
//                       }, {
//                           "name": "Gharbia",
//                           "code": "GH"
//                       }, {
//                           "name": "Giza",
//                           "code": "GZ"
//                       }, {
//                           "name": "Helwan",
//                           "code": "HU"
//                       }, {
//                           "name": "Ismailia",
//                           "code": "IS"
//                       }, {
//                           "name": "Kafr el-Sheikh",
//                           "code": "KFS"
//                       }, {
//                           "name": "Luxor",
//                           "code": "LX"
//                       }, {
//                           "name": "Matrouh",
//                           "code": "MT"
//                       }, {
//                           "name": "Minya",
//                           "code": "MN"
//                       }, {
//                           "name": "Monufia",
//                           "code": "MNF"
//                       }, {
//                           "name": "New Valley",
//                           "code": "WAD"
//                       }, {
//                           "name": "North Sinai",
//                           "code": "SIN"
//                       }, {
//                           "name": "Port Said",
//                           "code": "PTS"
//                       }, {
//                           "name": "Qalyubia",
//                           "code": "KB"
//                       }, {
//                           "name": "Qena",
//                           "code": "KN"
//                       }, {
//                           "name": "Red Sea",
//                           "code": "BA"
//                       }, {
//                           "name": "Sohag",
//                           "code": "SHG"
//                       }, {
//                           "name": "South Sinai",
//                           "code": "JS"
//                       }, {
//                           "name": "Suez",
//                           "code": "SUZ"
//                       }],
//                       "SV": [{
//                           "name": "Ahuachapán",
//                           "code": "SV-AH"
//                       }, {
//                           "name": "Cabañas",
//                           "code": "SV-CA"
//                       }, {
//                           "name": "Chalatenango",
//                           "code": "SV-CH"
//                       }, {
//                           "name": "Cuscatlán",
//                           "code": "SV-CU"
//                       }, {
//                           "name": "La Libertad",
//                           "code": "SV-LI"
//                       }, {
//                           "name": "La Paz",
//                           "code": "SV-PA"
//                       }, {
//                           "name": "La Unión",
//                           "code": "SV-UN"
//                       }, {
//                           "name": "Morazán",
//                           "code": "SV-MO"
//                       }, {
//                           "name": "San Miguel",
//                           "code": "SV-SM"
//                       }, {
//                           "name": "San Salvador",
//                           "code": "SV-SS"
//                       }, {
//                           "name": "San Vicente",
//                           "code": "SV-SV"
//                       }, {
//                           "name": "Santa Ana",
//                           "code": "SV-SA"
//                       }, {
//                           "name": "Sonsonate",
//                           "code": "SV-SO"
//                       }, {
//                           "name": "Usulután",
//                           "code": "SV-US"
//                       }],
//                       "GT": [{
//                           "name": "Alta Verapaz",
//                           "code": "AVE"
//                       }, {
//                           "name": "Baja Verapaz",
//                           "code": "BVE"
//                       }, {
//                           "name": "Chimaltenango",
//                           "code": "CMT"
//                       }, {
//                           "name": "Chiquimula",
//                           "code": "CQM"
//                       }, {
//                           "name": "El Progreso",
//                           "code": "EPR"
//                       }, {
//                           "name": "Escuintla",
//                           "code": "ESC"
//                       }, {
//                           "name": "Guatemala",
//                           "code": "GUA"
//                       }, {
//                           "name": "Huehuetenango",
//                           "code": "HUE"
//                       }, {
//                           "name": "Izabal",
//                           "code": "IZA"
//                       }, {
//                           "name": "Jalapa",
//                           "code": "JAL"
//                       }, {
//                           "name": "Jutiapa",
//                           "code": "JUT"
//                       }, {
//                           "name": "Petén",
//                           "code": "PET"
//                       }, {
//                           "name": "Quetzaltenango",
//                           "code": "QUE"
//                       }, {
//                           "name": "Quiché",
//                           "code": "QUI"
//                       }, {
//                           "name": "Retalhuleu",
//                           "code": "RET"
//                       }, {
//                           "name": "Sacatepéquez",
//                           "code": "SAC"
//                       }, {
//                           "name": "San Marcos",
//                           "code": "SMA"
//                       }, {
//                           "name": "Santa Rosa",
//                           "code": "SRO"
//                       }, {
//                           "name": "Sololá",
//                           "code": "SOL"
//                       }, {
//                           "name": "Suchitepéquez",
//                           "code": "SUC"
//                       }, {
//                           "name": "Totonicapán",
//                           "code": "TOT"
//                       }, {
//                           "name": "Zacapa",
//                           "code": "ZAC"
//                       }],
//                       "HK": [{
//                           "name": "Hong Kong Island",
//                           "code": "HK"
//                       }, {
//                           "name": "Kowloon",
//                           "code": "KL"
//                       }, {
//                           "name": "New Territories",
//                           "code": "NT"
//                       }],
//                       "IN": [{
//                           "name": "Andaman and Nicobar Islands",
//                           "code": "AN"
//                       }, {
//                           "name": "Andhra Pradesh",
//                           "code": "AP"
//                       }, {
//                           "name": "Arunachal Pradesh",
//                           "code": "AR"
//                       }, {
//                           "name": "Assam",
//                           "code": "AS"
//                       }, {
//                           "name": "Bihar",
//                           "code": "BR"
//                       }, {
//                           "name": "Chandigarh",
//                           "code": "CH"
//                       }, {
//                           "name": "Chhattisgarh",
//                           "code": "CG"
//                       }, {
//                           "name": "Dadra and Nagar Haveli",
//                           "code": "DN"
//                       }, {
//                           "name": "Daman and Diu",
//                           "code": "DD"
//                       }, {
//                           "name": "Delhi",
//                           "code": "DL"
//                       }, {
//                           "name": "Goa",
//                           "code": "GA"
//                       }, {
//                           "name": "Gujarat",
//                           "code": "GJ"
//                       }, {
//                           "name": "Haryana",
//                           "code": "HR"
//                       }, {
//                           "name": "Himachal Pradesh",
//                           "code": "HP"
//                       }, {
//                           "name": "Jammu and Kashmir",
//                           "code": "JK"
//                       }, {
//                           "name": "Jharkhand",
//                           "code": "JH"
//                       }, {
//                           "name": "Karnataka",
//                           "code": "KA"
//                       }, {
//                           "name": "Kerala",
//                           "code": "KL"
//                       }, {
//                           "name": "Ladakh",
//                           "code": "LA"
//                       }, {
//                           "name": "Lakshadweep",
//                           "code": "LD"
//                       }, {
//                           "name": "Madhya Pradesh",
//                           "code": "MP"
//                       }, {
//                           "name": "Maharashtra",
//                           "code": "MH"
//                       }, {
//                           "name": "Manipur",
//                           "code": "MN"
//                       }, {
//                           "name": "Meghalaya",
//                           "code": "ML"
//                       }, {
//                           "name": "Mizoram",
//                           "code": "MZ"
//                       }, {
//                           "name": "Nagaland",
//                           "code": "NL"
//                       }, {
//                           "name": "Odisha",
//                           "code": "OR"
//                       }, {
//                           "name": "Puducherry",
//                           "code": "PY"
//                       }, {
//                           "name": "Punjab",
//                           "code": "PB"
//                       }, {
//                           "name": "Rajasthan",
//                           "code": "RJ"
//                       }, {
//                           "name": "Sikkim",
//                           "code": "SK"
//                       }, {
//                           "name": "Tamil Nadu",
//                           "code": "TN"
//                       }, {
//                           "name": "Telangana",
//                           "code": "TS"
//                       }, {
//                           "name": "Tripura",
//                           "code": "TR"
//                       }, {
//                           "name": "Uttar Pradesh",
//                           "code": "UP"
//                       }, {
//                           "name": "Uttarakhand",
//                           "code": "UK"
//                       }, {
//                           "name": "West Bengal",
//                           "code": "WB"
//                       }],
//                       "ID": [{
//                           "name": "Aceh",
//                           "code": "AC"
//                       }, {
//                           "name": "Bali",
//                           "code": "BA"
//                       }, {
//                           "name": "Bangka Belitung",
//                           "code": "BB"
//                       }, {
//                           "name": "Banten",
//                           "code": "BT"
//                       }, {
//                           "name": "Bengkulu",
//                           "code": "BE"
//                       }, {
//                           "name": "Gorontalo",
//                           "code": "GO"
//                       }, {
//                           "name": "Jakarta",
//                           "code": "JK"
//                       }, {
//                           "name": "Jambi",
//                           "code": "JA"
//                       }, {
//                           "name": "Jawa Barat",
//                           "code": "JB"
//                       }, {
//                           "name": "Jawa Tengah",
//                           "code": "JT"
//                       }, {
//                           "name": "Jawa Timur",
//                           "code": "JI"
//                       }, {
//                           "name": "Kalimantan Barat",
//                           "code": "KB"
//                       }, {
//                           "name": "Kalimantan Selatan",
//                           "code": "KS"
//                       }, {
//                           "name": "Kalimantan Tengah",
//                           "code": "KT"
//                       }, {
//                           "name": "Kalimantan Timur",
//                           "code": "KI"
//                       }, {
//                           "name": "Kalimantan Utara",
//                           "code": "KU"
//                       }, {
//                           "name": "Kepulauan Riau",
//                           "code": "KR"
//                       }, {
//                           "name": "Lampung",
//                           "code": "LA"
//                       }, {
//                           "name": "Maluku",
//                           "code": "MA"
//                       }, {
//                           "name": "Maluku Utara",
//                           "code": "MU"
//                       }, {
//                           "name": "North Sumatra",
//                           "code": "SU"
//                       }, {
//                           "name": "Nusa Tenggara Barat",
//                           "code": "NB"
//                       }, {
//                           "name": "Nusa Tenggara Timur",
//                           "code": "NT"
//                       }, {
//                           "name": "Papua",
//                           "code": "PA"
//                       }, {
//                           "name": "Papua Barat",
//                           "code": "PB"
//                       }, {
//                           "name": "Riau",
//                           "code": "RI"
//                       }, {
//                           "name": "South Sumatra",
//                           "code": "SS"
//                       }, {
//                           "name": "Sulawesi Barat",
//                           "code": "SR"
//                       }, {
//                           "name": "Sulawesi Selatan",
//                           "code": "SN"
//                       }, {
//                           "name": "Sulawesi Tengah",
//                           "code": "ST"
//                       }, {
//                           "name": "Sulawesi Tenggara",
//                           "code": "SG"
//                       }, {
//                           "name": "Sulawesi Utara",
//                           "code": "SA"
//                       }, {
//                           "name": "West Sumatra",
//                           "code": "SB"
//                       }, {
//                           "name": "Yogyakarta",
//                           "code": "YO"
//                       }],
//                       "IE": [{
//                           "name": "Carlow",
//                           "code": "CW"
//                       }, {
//                           "name": "Cavan",
//                           "code": "CN"
//                       }, {
//                           "name": "Clare",
//                           "code": "CE"
//                       }, {
//                           "name": "Cork",
//                           "code": "CO"
//                       }, {
//                           "name": "Donegal",
//                           "code": "DL"
//                       }, {
//                           "name": "Dublin",
//                           "code": "D"
//                       }, {
//                           "name": "Galway",
//                           "code": "G"
//                       }, {
//                           "name": "Kerry",
//                           "code": "KY"
//                       }, {
//                           "name": "Kildare",
//                           "code": "KE"
//                       }, {
//                           "name": "Kilkenny",
//                           "code": "KK"
//                       }, {
//                           "name": "Laois",
//                           "code": "LS"
//                       }, {
//                           "name": "Leitrim",
//                           "code": "LM"
//                       }, {
//                           "name": "Limerick",
//                           "code": "LK"
//                       }, {
//                           "name": "Longford",
//                           "code": "LD"
//                       }, {
//                           "name": "Louth",
//                           "code": "LH"
//                       }, {
//                           "name": "Mayo",
//                           "code": "MO"
//                       }, {
//                           "name": "Meath",
//                           "code": "MH"
//                       }, {
//                           "name": "Monaghan",
//                           "code": "MN"
//                       }, {
//                           "name": "Offaly",
//                           "code": "OY"
//                       }, {
//                           "name": "Roscommon",
//                           "code": "RN"
//                       }, {
//                           "name": "Sligo",
//                           "code": "SO"
//                       }, {
//                           "name": "Tipperary",
//                           "code": "TA"
//                       }, {
//                           "name": "Waterford",
//                           "code": "WD"
//                       }, {
//                           "name": "Westmeath",
//                           "code": "WH"
//                       }, {
//                           "name": "Wexford",
//                           "code": "WX"
//                       }, {
//                           "name": "Wicklow",
//                           "code": "WW"
//                       }],
//                       "IT": [{
//                           "name": "Agrigento",
//                           "code": "AG"
//                       }, {
//                           "name": "Alessandria",
//                           "code": "AL"
//                       }, {
//                           "name": "Ancona",
//                           "code": "AN"
//                       }, {
//                           "name": "Aosta",
//                           "code": "AO"
//                       }, {
//                           "name": "Arezzo",
//                           "code": "AR"
//                       }, {
//                           "name": "Ascoli Piceno",
//                           "code": "AP"
//                       }, {
//                           "name": "Asti",
//                           "code": "AT"
//                       }, {
//                           "name": "Avellino",
//                           "code": "AV"
//                       }, {
//                           "name": "Bari",
//                           "code": "BA"
//                       }, {
//                           "name": "Barletta-Andria-Trani",
//                           "code": "BT"
//                       }, {
//                           "name": "Belluno",
//                           "code": "BL"
//                       }, {
//                           "name": "Benevento",
//                           "code": "BN"
//                       }, {
//                           "name": "Bergamo",
//                           "code": "BG"
//                       }, {
//                           "name": "Biella",
//                           "code": "BI"
//                       }, {
//                           "name": "Bologna",
//                           "code": "BO"
//                       }, {
//                           "name": "Bolzano",
//                           "code": "BZ"
//                       }, {
//                           "name": "Brescia",
//                           "code": "BS"
//                       }, {
//                           "name": "Brindisi",
//                           "code": "BR"
//                       }, {
//                           "name": "Cagliari",
//                           "code": "CA"
//                       }, {
//                           "name": "Caltanissetta",
//                           "code": "CL"
//                       }, {
//                           "name": "Campobasso",
//                           "code": "CB"
//                       }, {
//                           "name": "Carbonia-Iglesias",
//                           "code": "CI"
//                       }, {
//                           "name": "Caserta",
//                           "code": "CE"
//                       }, {
//                           "name": "Catania",
//                           "code": "CT"
//                       }, {
//                           "name": "Catanzaro",
//                           "code": "CZ"
//                       }, {
//                           "name": "Chieti",
//                           "code": "CH"
//                       }, {
//                           "name": "Como",
//                           "code": "CO"
//                       }, {
//                           "name": "Cosenza",
//                           "code": "CS"
//                       }, {
//                           "name": "Cremona",
//                           "code": "CR"
//                       }, {
//                           "name": "Crotone",
//                           "code": "KR"
//                       }, {
//                           "name": "Cuneo",
//                           "code": "CN"
//                       }, {
//                           "name": "Enna",
//                           "code": "EN"
//                       }, {
//                           "name": "Fermo",
//                           "code": "FM"
//                       }, {
//                           "name": "Ferrara",
//                           "code": "FE"
//                       }, {
//                           "name": "Firenze",
//                           "code": "FI"
//                       }, {
//                           "name": "Foggia",
//                           "code": "FG"
//                       }, {
//                           "name": "Forlì-Cesena",
//                           "code": "FC"
//                       }, {
//                           "name": "Frosinone",
//                           "code": "FR"
//                       }, {
//                           "name": "Genova",
//                           "code": "GE"
//                       }, {
//                           "name": "Gorizia",
//                           "code": "GO"
//                       }, {
//                           "name": "Grosseto",
//                           "code": "GR"
//                       }, {
//                           "name": "Imperia",
//                           "code": "IM"
//                       }, {
//                           "name": "Isernia",
//                           "code": "IS"
//                       }, {
//                           "name": "L'Aquila",
//                           "code": "AQ"
//                       }, {
//                           "name": "La Spezia",
//                           "code": "SP"
//                       }, {
//                           "name": "Latina",
//                           "code": "LT"
//                       }, {
//                           "name": "Lecce",
//                           "code": "LE"
//                       }, {
//                           "name": "Lecco",
//                           "code": "LC"
//                       }, {
//                           "name": "Livorno",
//                           "code": "LI"
//                       }, {
//                           "name": "Lodi",
//                           "code": "LO"
//                       }, {
//                           "name": "Lucca",
//                           "code": "LU"
//                       }, {
//                           "name": "Macerata",
//                           "code": "MC"
//                       }, {
//                           "name": "Mantova",
//                           "code": "MN"
//                       }, {
//                           "name": "Massa-Carrara",
//                           "code": "MS"
//                       }, {
//                           "name": "Matera",
//                           "code": "MT"
//                       }, {
//                           "name": "Medio Campidano",
//                           "code": "VS"
//                       }, {
//                           "name": "Messina",
//                           "code": "ME"
//                       }, {
//                           "name": "Milano",
//                           "code": "MI"
//                       }, {
//                           "name": "Modena",
//                           "code": "MO"
//                       }, {
//                           "name": "Monza e Brianza",
//                           "code": "MB"
//                       }, {
//                           "name": "Napoli",
//                           "code": "NA"
//                       }, {
//                           "name": "Novara",
//                           "code": "NO"
//                       }, {
//                           "name": "Nuoro",
//                           "code": "NU"
//                       }, {
//                           "name": "Ogliastra",
//                           "code": "OG"
//                       }, {
//                           "name": "Olbia-Tempio",
//                           "code": "OT"
//                       }, {
//                           "name": "Oristano",
//                           "code": "OR"
//                       }, {
//                           "name": "Padova",
//                           "code": "PD"
//                       }, {
//                           "name": "Palermo",
//                           "code": "PA"
//                       }, {
//                           "name": "Parma",
//                           "code": "PR"
//                       }, {
//                           "name": "Pavia",
//                           "code": "PV"
//                       }, {
//                           "name": "Perugia",
//                           "code": "PG"
//                       }, {
//                           "name": "Pesaro e Urbino",
//                           "code": "PU"
//                       }, {
//                           "name": "Pescara",
//                           "code": "PE"
//                       }, {
//                           "name": "Piacenza",
//                           "code": "PC"
//                       }, {
//                           "name": "Pisa",
//                           "code": "PI"
//                       }, {
//                           "name": "Pistoia",
//                           "code": "PT"
//                       }, {
//                           "name": "Pordenone",
//                           "code": "PN"
//                       }, {
//                           "name": "Potenza",
//                           "code": "PZ"
//                       }, {
//                           "name": "Prato",
//                           "code": "PO"
//                       }, {
//                           "name": "Ragusa",
//                           "code": "RG"
//                       }, {
//                           "name": "Ravenna",
//                           "code": "RA"
//                       }, {
//                           "name": "Reggio Calabria",
//                           "code": "RC"
//                       }, {
//                           "name": "Reggio Emilia",
//                           "code": "RE"
//                       }, {
//                           "name": "Rieti",
//                           "code": "RI"
//                       }, {
//                           "name": "Rimini",
//                           "code": "RN"
//                       }, {
//                           "name": "Roma",
//                           "code": "RM"
//                       }, {
//                           "name": "Rovigo",
//                           "code": "RO"
//                       }, {
//                           "name": "Salerno",
//                           "code": "SA"
//                       }, {
//                           "name": "Sassari",
//                           "code": "SS"
//                       }, {
//                           "name": "Savona",
//                           "code": "SV"
//                       }, {
//                           "name": "Siena",
//                           "code": "SI"
//                       }, {
//                           "name": "Siracusa",
//                           "code": "SR"
//                       }, {
//                           "name": "Sondrio",
//                           "code": "SO"
//                       }, {
//                           "name": "Taranto",
//                           "code": "TA"
//                       }, {
//                           "name": "Teramo",
//                           "code": "TE"
//                       }, {
//                           "name": "Terni",
//                           "code": "TR"
//                       }, {
//                           "name": "Torino",
//                           "code": "TO"
//                       }, {
//                           "name": "Trapani",
//                           "code": "TP"
//                       }, {
//                           "name": "Trento",
//                           "code": "TN"
//                       }, {
//                           "name": "Treviso",
//                           "code": "TV"
//                       }, {
//                           "name": "Trieste",
//                           "code": "TS"
//                       }, {
//                           "name": "Udine",
//                           "code": "UD"
//                       }, {
//                           "name": "Varese",
//                           "code": "VA"
//                       }, {
//                           "name": "Venezia",
//                           "code": "VE"
//                       }, {
//                           "name": "Verbano-Cusio-Ossola",
//                           "code": "VB"
//                       }, {
//                           "name": "Vercelli",
//                           "code": "VC"
//                       }, {
//                           "name": "Verona",
//                           "code": "VR"
//                       }, {
//                           "name": "Vibo Valentia",
//                           "code": "VV"
//                       }, {
//                           "name": "Vicenza",
//                           "code": "VI"
//                       }, {
//                           "name": "Viterbo",
//                           "code": "VT"
//                       }],
//                       "JP": [{
//                           "name": "Aichi",
//                           "code": "JP-23"
//                       }, {
//                           "name": "Akita",
//                           "code": "JP-05"
//                       }, {
//                           "name": "Aomori",
//                           "code": "JP-02"
//                       }, {
//                           "name": "Chiba",
//                           "code": "JP-12"
//                       }, {
//                           "name": "Ehime",
//                           "code": "JP-38"
//                       }, {
//                           "name": "Fukui",
//                           "code": "JP-18"
//                       }, {
//                           "name": "Fukuoka",
//                           "code": "JP-40"
//                       }, {
//                           "name": "Fukushima",
//                           "code": "JP-07"
//                       }, {
//                           "name": "Gifu",
//                           "code": "JP-21"
//                       }, {
//                           "name": "Gunma",
//                           "code": "JP-10"
//                       }, {
//                           "name": "Hiroshima",
//                           "code": "JP-34"
//                       }, {
//                           "name": "Hokkaidō",
//                           "code": "JP-01"
//                       }, {
//                           "name": "Hyōgo",
//                           "code": "JP-28"
//                       }, {
//                           "name": "Ibaraki",
//                           "code": "JP-08"
//                       }, {
//                           "name": "Ishikawa",
//                           "code": "JP-17"
//                       }, {
//                           "name": "Iwate",
//                           "code": "JP-03"
//                       }, {
//                           "name": "Kagawa",
//                           "code": "JP-37"
//                       }, {
//                           "name": "Kagoshima",
//                           "code": "JP-46"
//                       }, {
//                           "name": "Kanagawa",
//                           "code": "JP-14"
//                       }, {
//                           "name": "Kōchi",
//                           "code": "JP-39"
//                       }, {
//                           "name": "Kumamoto",
//                           "code": "JP-43"
//                       }, {
//                           "name": "Kyōto",
//                           "code": "JP-26"
//                       }, {
//                           "name": "Mie",
//                           "code": "JP-24"
//                       }, {
//                           "name": "Miyagi",
//                           "code": "JP-04"
//                       }, {
//                           "name": "Miyazaki",
//                           "code": "JP-45"
//                       }, {
//                           "name": "Nagano",
//                           "code": "JP-20"
//                       }, {
//                           "name": "Nagasaki",
//                           "code": "JP-42"
//                       }, {
//                           "name": "Nara",
//                           "code": "JP-29"
//                       }, {
//                           "name": "Niigata",
//                           "code": "JP-15"
//                       }, {
//                           "name": "Ōita",
//                           "code": "JP-44"
//                       }, {
//                           "name": "Okayama",
//                           "code": "JP-33"
//                       }, {
//                           "name": "Okinawa",
//                           "code": "JP-47"
//                       }, {
//                           "name": "Ōsaka",
//                           "code": "JP-27"
//                       }, {
//                           "name": "Saga",
//                           "code": "JP-41"
//                       }, {
//                           "name": "Saitama",
//                           "code": "JP-11"
//                       }, {
//                           "name": "Shiga",
//                           "code": "JP-25"
//                       }, {
//                           "name": "Shimane",
//                           "code": "JP-32"
//                       }, {
//                           "name": "Shizuoka",
//                           "code": "JP-22"
//                       }, {
//                           "name": "Tochigi",
//                           "code": "JP-09"
//                       }, {
//                           "name": "Tokushima",
//                           "code": "JP-36"
//                       }, {
//                           "name": "Tōkyō",
//                           "code": "JP-13"
//                       }, {
//                           "name": "Tottori",
//                           "code": "JP-31"
//                       }, {
//                           "name": "Toyama",
//                           "code": "JP-16"
//                       }, {
//                           "name": "Wakayama",
//                           "code": "JP-30"
//                       }, {
//                           "name": "Yamagata",
//                           "code": "JP-06"
//                       }, {
//                           "name": "Yamaguchi",
//                           "code": "JP-35"
//                       }, {
//                           "name": "Yamanashi",
//                           "code": "JP-19"
//                       }],
//                       "KW": [{
//                           "name": "Al Ahmadi",
//                           "code": "KW-AH"
//                       }, {
//                           "name": "Al Asimah",
//                           "code": "KW-KU"
//                       }, {
//                           "name": "Al Farwaniyah",
//                           "code": "KW-FA"
//                       }, {
//                           "name": "Al Jahra",
//                           "code": "KW-JA"
//                       }, {
//                           "name": "Hawalli",
//                           "code": "KW-HA"
//                       }, {
//                           "name": "Mubarak Al-Kabeer",
//                           "code": "KW-MU"
//                       }],
//                       "MY": [{
//                           "name": "Johor",
//                           "code": "JHR"
//                       }, {
//                           "name": "Kedah",
//                           "code": "KDH"
//                       }, {
//                           "name": "Kelantan",
//                           "code": "KTN"
//                       }, {
//                           "name": "Kuala Lumpur",
//                           "code": "KUL"
//                       }, {
//                           "name": "Labuan",
//                           "code": "LBN"
//                       }, {
//                           "name": "Melaka",
//                           "code": "MLK"
//                       }, {
//                           "name": "Negeri Sembilan",
//                           "code": "NSN"
//                       }, {
//                           "name": "Pahang",
//                           "code": "PHG"
//                       }, {
//                           "name": "Penang",
//                           "code": "PNG"
//                       }, {
//                           "name": "Perak",
//                           "code": "PRK"
//                       }, {
//                           "name": "Perlis",
//                           "code": "PLS"
//                       }, {
//                           "name": "Putrajaya",
//                           "code": "PJY"
//                       }, {
//                           "name": "Sabah",
//                           "code": "SBH"
//                       }, {
//                           "name": "Sarawak",
//                           "code": "SWK"
//                       }, {
//                           "name": "Selangor",
//                           "code": "SGR"
//                       }, {
//                           "name": "Terengganu",
//                           "code": "TRG"
//                       }],
//                       "MX": [{
//                           "name": "Aguascalientes",
//                           "code": "AGS"
//                       }, {
//                           "name": "Baja California",
//                           "code": "BC"
//                       }, {
//                           "name": "Baja California Sur",
//                           "code": "BCS"
//                       }, {
//                           "name": "Campeche",
//                           "code": "CAMP"
//                       }, {
//                           "name": "Chiapas",
//                           "code": "CHIS"
//                       }, {
//                           "name": "Chihuahua",
//                           "code": "CHIH"
//                       }, {
//                           "name": "Ciudad de México",
//                           "code": "DF"
//                       }, {
//                           "name": "Coahuila",
//                           "code": "COAH"
//                       }, {
//                           "name": "Colima",
//                           "code": "COL"
//                       }, {
//                           "name": "Durango",
//                           "code": "DGO"
//                       }, {
//                           "name": "Guanajuato",
//                           "code": "GTO"
//                       }, {
//                           "name": "Guerrero",
//                           "code": "GRO"
//                       }, {
//                           "name": "Hidalgo",
//                           "code": "HGO"
//                       }, {
//                           "name": "Jalisco",
//                           "code": "JAL"
//                       }, {
//                           "name": "México",
//                           "code": "MEX"
//                       }, {
//                           "name": "Michoacán",
//                           "code": "MICH"
//                       }, {
//                           "name": "Morelos",
//                           "code": "MOR"
//                       }, {
//                           "name": "Nayarit",
//                           "code": "NAY"
//                       }, {
//                           "name": "Nuevo León",
//                           "code": "NL"
//                       }, {
//                           "name": "Oaxaca",
//                           "code": "OAX"
//                       }, {
//                           "name": "Puebla",
//                           "code": "PUE"
//                       }, {
//                           "name": "Querétaro",
//                           "code": "QRO"
//                       }, {
//                           "name": "Quintana Roo",
//                           "code": "Q ROO"
//                       }, {
//                           "name": "San Luis Potosí",
//                           "code": "SLP"
//                       }, {
//                           "name": "Sinaloa",
//                           "code": "SIN"
//                       }, {
//                           "name": "Sonora",
//                           "code": "SON"
//                       }, {
//                           "name": "Tabasco",
//                           "code": "TAB"
//                       }, {
//                           "name": "Tamaulipas",
//                           "code": "TAMPS"
//                       }, {
//                           "name": "Tlaxcala",
//                           "code": "TLAX"
//                       }, {
//                           "name": "Veracruz",
//                           "code": "VER"
//                       }, {
//                           "name": "Yucatán",
//                           "code": "YUC"
//                       }, {
//                           "name": "Zacatecas",
//                           "code": "ZAC"
//                       }],
//                       "NZ": [{
//                           "name": "Auckland",
//                           "code": "AUK"
//                       }, {
//                           "name": "Bay of Plenty",
//                           "code": "BOP"
//                       }, {
//                           "name": "Canterbury",
//                           "code": "CAN"
//                       }, {
//                           "name": "Chatham Islands",
//                           "code": "CIT"
//                       }, {
//                           "name": "Gisborne",
//                           "code": "GIS"
//                       }, {
//                           "name": "Hawke's Bay",
//                           "code": "HKB"
//                       }, {
//                           "name": "Manawatu-Wanganui",
//                           "code": "MWT"
//                       }, {
//                           "name": "Marlborough",
//                           "code": "MBH"
//                       }, {
//                           "name": "Nelson",
//                           "code": "NSN"
//                       }, {
//                           "name": "Northland",
//                           "code": "NTL"
//                       }, {
//                           "name": "Otago",
//                           "code": "OTA"
//                       }, {
//                           "name": "Southland",
//                           "code": "STL"
//                       }, {
//                           "name": "Taranaki",
//                           "code": "TKI"
//                       }, {
//                           "name": "Tasman",
//                           "code": "TAS"
//                       }, {
//                           "name": "Waikato",
//                           "code": "WKO"
//                       }, {
//                           "name": "Wellington",
//                           "code": "WGN"
//                       }, {
//                           "name": "West Coast",
//                           "code": "WTC"
//                       }],
//                       "NG": [{
//                           "name": "Abia",
//                           "code": "AB"
//                       }, {
//                           "name": "Abuja Federal Capital Territory",
//                           "code": "FC"
//                       }, {
//                           "name": "Adamawa",
//                           "code": "AD"
//                       }, {
//                           "name": "Akwa Ibom",
//                           "code": "AK"
//                       }, {
//                           "name": "Anambra",
//                           "code": "AN"
//                       }, {
//                           "name": "Bauchi",
//                           "code": "BA"
//                       }, {
//                           "name": "Bayelsa",
//                           "code": "BY"
//                       }, {
//                           "name": "Benue",
//                           "code": "BE"
//                       }, {
//                           "name": "Borno",
//                           "code": "BO"
//                       }, {
//                           "name": "Cross River",
//                           "code": "CR"
//                       }, {
//                           "name": "Delta",
//                           "code": "DE"
//                       }, {
//                           "name": "Ebonyi",
//                           "code": "EB"
//                       }, {
//                           "name": "Edo",
//                           "code": "ED"
//                       }, {
//                           "name": "Ekiti",
//                           "code": "EK"
//                       }, {
//                           "name": "Enugu",
//                           "code": "EN"
//                       }, {
//                           "name": "Gombe",
//                           "code": "GO"
//                       }, {
//                           "name": "Imo",
//                           "code": "IM"
//                       }, {
//                           "name": "Jigawa",
//                           "code": "JI"
//                       }, {
//                           "name": "Kaduna",
//                           "code": "KD"
//                       }, {
//                           "name": "Kano",
//                           "code": "KN"
//                       }, {
//                           "name": "Katsina",
//                           "code": "KT"
//                       }, {
//                           "name": "Kebbi",
//                           "code": "KE"
//                       }, {
//                           "name": "Kogi",
//                           "code": "KO"
//                       }, {
//                           "name": "Kwara",
//                           "code": "KW"
//                       }, {
//                           "name": "Lagos",
//                           "code": "LA"
//                       }, {
//                           "name": "Nasarawa",
//                           "code": "NA"
//                       }, {
//                           "name": "Niger",
//                           "code": "NI"
//                       }, {
//                           "name": "Ogun",
//                           "code": "OG"
//                       }, {
//                           "name": "Ondo",
//                           "code": "ON"
//                       }, {
//                           "name": "Osun",
//                           "code": "OS"
//                       }, {
//                           "name": "Oyo",
//                           "code": "OY"
//                       }, {
//                           "name": "Plateau",
//                           "code": "PL"
//                       }, {
//                           "name": "Rivers",
//                           "code": "RI"
//                       }, {
//                           "name": "Sokoto",
//                           "code": "SO"
//                       }, {
//                           "name": "Taraba",
//                           "code": "TA"
//                       }, {
//                           "name": "Yobe",
//                           "code": "YO"
//                       }, {
//                           "name": "Zamfara",
//                           "code": "ZA"
//                       }],
//                       "PA": [{
//                           "name": "Bocas del Toro",
//                           "code": "PA-1"
//                       }, {
//                           "name": "Chiriquí",
//                           "code": "PA-4"
//                       }, {
//                           "name": "Coclé",
//                           "code": "PA-2"
//                       }, {
//                           "name": "Colón",
//                           "code": "PA-3"
//                       }, {
//                           "name": "Darién",
//                           "code": "PA-5"
//                       }, {
//                           "name": "Emberá",
//                           "code": "PA-EM"
//                       }, {
//                           "name": "Herrera",
//                           "code": "PA-6"
//                       }, {
//                           "name": "Kuna Yala",
//                           "code": "PA-KY"
//                       }, {
//                           "name": "Los Santos",
//                           "code": "PA-7"
//                       }, {
//                           "name": "Ngöbe-Buglé",
//                           "code": "PA-NB"
//                       }, {
//                           "name": "Panamá",
//                           "code": "PA-8"
//                       }, {
//                           "name": "Panamá Oeste",
//                           "code": "PA-10"
//                       }, {
//                           "name": "Veraguas",
//                           "code": "PA-9"
//                       }],
//                       "PE": [{
//                           "name": "Amazonas",
//                           "code": "PE-AMA"
//                       }, {
//                           "name": "Áncash",
//                           "code": "PE-ANC"
//                       }, {
//                           "name": "Apurímac",
//                           "code": "PE-APU"
//                       }, {
//                           "name": "Arequipa",
//                           "code": "PE-ARE"
//                       }, {
//                           "name": "Ayacucho",
//                           "code": "PE-AYA"
//                       }, {
//                           "name": "Cajamarca",
//                           "code": "PE-CAJ"
//                       }, {
//                           "name": "Callao",
//                           "code": "PE-CAL"
//                       }, {
//                           "name": "Cuzco",
//                           "code": "PE-CUS"
//                       }, {
//                           "name": "Huancavelica",
//                           "code": "PE-HUV"
//                       }, {
//                           "name": "Huánuco",
//                           "code": "PE-HUC"
//                       }, {
//                           "name": "Ica",
//                           "code": "PE-ICA"
//                       }, {
//                           "name": "Junín",
//                           "code": "PE-JUN"
//                       }, {
//                           "name": "La Libertad",
//                           "code": "PE-LAL"
//                       }, {
//                           "name": "Lambayeque",
//                           "code": "PE-LAM"
//                       }, {
//                           "name": "Lima (departamento)",
//                           "code": "PE-LIM"
//                       }, {
//                           "name": "Lima (provincia)",
//                           "code": "PE-LMA"
//                       }, {
//                           "name": "Loreto",
//                           "code": "PE-LOR"
//                       }, {
//                           "name": "Madre de Dios",
//                           "code": "PE-MDD"
//                       }, {
//                           "name": "Moquegua",
//                           "code": "PE-MOQ"
//                       }, {
//                           "name": "Pasco",
//                           "code": "PE-PAS"
//                       }, {
//                           "name": "Piura",
//                           "code": "PE-PIU"
//                       }, {
//                           "name": "Puno",
//                           "code": "PE-PUN"
//                       }, {
//                           "name": "San Martín",
//                           "code": "PE-SAM"
//                       }, {
//                           "name": "Tacna",
//                           "code": "PE-TAC"
//                       }, {
//                           "name": "Tumbes",
//                           "code": "PE-TUM"
//                       }, {
//                           "name": "Ucayali",
//                           "code": "PE-UCA"
//                       }],
//                       "PH": [{
//                           "name": "Abra",
//                           "code": "PH-ABR"
//                       }, {
//                           "name": "Agusan del Norte",
//                           "code": "PH-AGN"
//                       }, {
//                           "name": "Agusan del Sur",
//                           "code": "PH-AGS"
//                       }, {
//                           "name": "Aklan",
//                           "code": "PH-AKL"
//                       }, {
//                           "name": "Albay",
//                           "code": "PH-ALB"
//                       }, {
//                           "name": "Antique",
//                           "code": "PH-ANT"
//                       }, {
//                           "name": "Apayao",
//                           "code": "PH-APA"
//                       }, {
//                           "name": "Aurora",
//                           "code": "PH-AUR"
//                       }, {
//                           "name": "Basilan",
//                           "code": "PH-BAS"
//                       }, {
//                           "name": "Bataan",
//                           "code": "PH-BAN"
//                       }, {
//                           "name": "Batanes",
//                           "code": "PH-BTN"
//                       }, {
//                           "name": "Batangas",
//                           "code": "PH-BTG"
//                       }, {
//                           "name": "Benguet",
//                           "code": "PH-BEN"
//                       }, {
//                           "name": "Biliran",
//                           "code": "PH-BIL"
//                       }, {
//                           "name": "Bohol",
//                           "code": "PH-BOH"
//                       }, {
//                           "name": "Bukidnon",
//                           "code": "PH-BUK"
//                       }, {
//                           "name": "Bulacan",
//                           "code": "PH-BUL"
//                       }, {
//                           "name": "Cagayan",
//                           "code": "PH-CAG"
//                       }, {
//                           "name": "Camarines Norte",
//                           "code": "PH-CAN"
//                       }, {
//                           "name": "Camarines Sur",
//                           "code": "PH-CAS"
//                       }, {
//                           "name": "Camiguin",
//                           "code": "PH-CAM"
//                       }, {
//                           "name": "Capiz",
//                           "code": "PH-CAP"
//                       }, {
//                           "name": "Catanduanes",
//                           "code": "PH-CAT"
//                       }, {
//                           "name": "Cavite",
//                           "code": "PH-CAV"
//                       }, {
//                           "name": "Cebu",
//                           "code": "PH-CEB"
//                       }, {
//                           "name": "Cotabato",
//                           "code": "PH-NCO"
//                       }, {
//                           "name": "Davao de Oro",
//                           "code": "PH-COM"
//                       }, {
//                           "name": "Davao del Norte",
//                           "code": "PH-DAV"
//                       }, {
//                           "name": "Davao del Sur",
//                           "code": "PH-DAS"
//                       }, {
//                           "name": "Davao Occidental",
//                           "code": "PH-DAO"
//                       }, {
//                           "name": "Davao Oriental",
//                           "code": "PH-DAO"
//                       }, {
//                           "name": "Dinagat Islands",
//                           "code": "PH-DIN"
//                       }, {
//                           "name": "Eastern Samar",
//                           "code": "PH-EAS"
//                       }, {
//                           "name": "Guimaras",
//                           "code": "PH-GUI"
//                       }, {
//                           "name": "Ifugao",
//                           "code": "PH-IFU"
//                       }, {
//                           "name": "Ilocos Norte",
//                           "code": "PH-ILN"
//                       }, {
//                           "name": "Ilocos Sur",
//                           "code": "PH-ILS"
//                       }, {
//                           "name": "Iloilo",
//                           "code": "PH-ILI"
//                       }, {
//                           "name": "Isabela",
//                           "code": "PH-ISA"
//                       }, {
//                           "name": "Kalinga",
//                           "code": "PH-KAL"
//                       }, {
//                           "name": "La Union",
//                           "code": "PH-LUN"
//                       }, {
//                           "name": "Laguna",
//                           "code": "PH-LAG"
//                       }, {
//                           "name": "Lanao del Norte",
//                           "code": "PH-LAN"
//                       }, {
//                           "name": "Lanao del Sur",
//                           "code": "PH-LAS"
//                       }, {
//                           "name": "Leyte",
//                           "code": "PH-LEY"
//                       }, {
//                           "name": "Maguindanao",
//                           "code": "PH-MAG"
//                       }, {
//                           "name": "Marinduque",
//                           "code": "PH-MAD"
//                       }, {
//                           "name": "Masbate",
//                           "code": "PH-MAS"
//                       }, {
//                           "name": "Metro Manila",
//                           "code": "PH-00"
//                       }, {
//                           "name": "Misamis Occidental",
//                           "code": "PH-MSC"
//                       }, {
//                           "name": "Misamis Oriental",
//                           "code": "PH-MSR"
//                       }, {
//                           "name": "Mountain Province",
//                           "code": "PH-MOU"
//                       }, {
//                           "name": "Negros Occidental",
//                           "code": "PH-NEC"
//                       }, {
//                           "name": "Negros Oriental",
//                           "code": "PH-NER"
//                       }, {
//                           "name": "Northern Samar",
//                           "code": "PH-NSA"
//                       }, {
//                           "name": "Nueva Ecija",
//                           "code": "PH-NUE"
//                       }, {
//                           "name": "Nueva Vizcaya",
//                           "code": "PH-NUV"
//                       }, {
//                           "name": "Occidental Mindoro",
//                           "code": "PH-MDC"
//                       }, {
//                           "name": "Oriental Mindoro",
//                           "code": "PH-MDR"
//                       }, {
//                           "name": "Palawan",
//                           "code": "PH-PLW"
//                       }, {
//                           "name": "Pampanga",
//                           "code": "PH-PAM"
//                       }, {
//                           "name": "Pangasinan",
//                           "code": "PH-PAN"
//                       }, {
//                           "name": "Quezon",
//                           "code": "PH-QUE"
//                       }, {
//                           "name": "Quirino",
//                           "code": "PH-QUI"
//                       }, {
//                           "name": "Rizal",
//                           "code": "PH-RIZ"
//                       }, {
//                           "name": "Romblon",
//                           "code": "PH-ROM"
//                       }, {
//                           "name": "Samar",
//                           "code": "PH-WSA"
//                       }, {
//                           "name": "Sarangani",
//                           "code": "PH-SAR"
//                       }, {
//                           "name": "Siquijor",
//                           "code": "PH-SIG"
//                       }, {
//                           "name": "Sorsogon",
//                           "code": "PH-SOR"
//                       }, {
//                           "name": "South Cotabato",
//                           "code": "PH-SCO"
//                       }, {
//                           "name": "Southern Leyte",
//                           "code": "PH-SLE"
//                       }, {
//                           "name": "Sultan Kudarat",
//                           "code": "PH-SUK"
//                       }, {
//                           "name": "Sulu",
//                           "code": "PH-SLU"
//                       }, {
//                           "name": "Surigao del Norte",
//                           "code": "PH-SUN"
//                       }, {
//                           "name": "Surigao del Sur",
//                           "code": "PH-SUR"
//                       }, {
//                           "name": "Tarlac",
//                           "code": "PH-TAR"
//                       }, {
//                           "name": "Tawi-Tawi",
//                           "code": "PH-TAW"
//                       }, {
//                           "name": "Zambales",
//                           "code": "PH-ZMB"
//                       }, {
//                           "name": "Zamboanga del Norte",
//                           "code": "PH-ZAN"
//                       }, {
//                           "name": "Zamboanga del Sur",
//                           "code": "PH-ZAS"
//                       }, {
//                           "name": "Zamboanga Sibugay",
//                           "code": "PH-ZSI"
//                       }],
//                       "PT": [{
//                           "name": "Açores",
//                           "code": "PT-20"
//                       }, {
//                           "name": "Aveiro",
//                           "code": "PT-01"
//                       }, {
//                           "name": "Beja",
//                           "code": "PT-02"
//                       }, {
//                           "name": "Braga",
//                           "code": "PT-03"
//                       }, {
//                           "name": "Bragança",
//                           "code": "PT-04"
//                       }, {
//                           "name": "Castelo Branco",
//                           "code": "PT-05"
//                       }, {
//                           "name": "Coimbra",
//                           "code": "PT-06"
//                       }, {
//                           "name": "Évora",
//                           "code": "PT-07"
//                       }, {
//                           "name": "Faro",
//                           "code": "PT-08"
//                       }, {
//                           "name": "Guarda",
//                           "code": "PT-09"
//                       }, {
//                           "name": "Leiria",
//                           "code": "PT-10"
//                       }, {
//                           "name": "Lisboa",
//                           "code": "PT-11"
//                       }, {
//                           "name": "Madeira",
//                           "code": "PT-30"
//                       }, {
//                           "name": "Portalegre",
//                           "code": "PT-12"
//                       }, {
//                           "name": "Porto",
//                           "code": "PT-13"
//                       }, {
//                           "name": "Santarém",
//                           "code": "PT-14"
//                       }, {
//                           "name": "Setúbal",
//                           "code": "PT-15"
//                       }, {
//                           "name": "Viana do Castelo",
//                           "code": "PT-16"
//                       }, {
//                           "name": "Vila Real",
//                           "code": "PT-17"
//                       }, {
//                           "name": "Viseu",
//                           "code": "PT-18"
//                       }],
//                       "RO": [{
//                           "name": "Alba",
//                           "code": "AB"
//                       }, {
//                           "name": "Arad",
//                           "code": "AR"
//                       }, {
//                           "name": "Argeș",
//                           "code": "AG"
//                       }, {
//                           "name": "Bacău",
//                           "code": "BC"
//                       }, {
//                           "name": "Bihor",
//                           "code": "BH"
//                       }, {
//                           "name": "Bistrița-Năsăud",
//                           "code": "BN"
//                       }, {
//                           "name": "Botoșani",
//                           "code": "BT"
//                       }, {
//                           "name": "Brăila",
//                           "code": "BR"
//                       }, {
//                           "name": "Brașov",
//                           "code": "BV"
//                       }, {
//                           "name": "București",
//                           "code": "B"
//                       }, {
//                           "name": "Buzău",
//                           "code": "BZ"
//                       }, {
//                           "name": "Călărași",
//                           "code": "CL"
//                       }, {
//                           "name": "Caraș-Severin",
//                           "code": "CS"
//                       }, {
//                           "name": "Cluj",
//                           "code": "CJ"
//                       }, {
//                           "name": "Constanța",
//                           "code": "CT"
//                       }, {
//                           "name": "Covasna",
//                           "code": "CV"
//                       }, {
//                           "name": "Dâmbovița",
//                           "code": "DB"
//                       }, {
//                           "name": "Dolj",
//                           "code": "DJ"
//                       }, {
//                           "name": "Galați",
//                           "code": "GL"
//                       }, {
//                           "name": "Giurgiu",
//                           "code": "GR"
//                       }, {
//                           "name": "Gorj",
//                           "code": "GJ"
//                       }, {
//                           "name": "Harghita",
//                           "code": "HR"
//                       }, {
//                           "name": "Hunedoara",
//                           "code": "HD"
//                       }, {
//                           "name": "Ialomița",
//                           "code": "IL"
//                       }, {
//                           "name": "Iași",
//                           "code": "IS"
//                       }, {
//                           "name": "Ilfov",
//                           "code": "IF"
//                       }, {
//                           "name": "Maramureș",
//                           "code": "MM"
//                       }, {
//                           "name": "Mehedinți",
//                           "code": "MH"
//                       }, {
//                           "name": "Mureș",
//                           "code": "MS"
//                       }, {
//                           "name": "Neamț",
//                           "code": "NT"
//                       }, {
//                           "name": "Olt",
//                           "code": "OT"
//                       }, {
//                           "name": "Prahova",
//                           "code": "PH"
//                       }, {
//                           "name": "Sălaj",
//                           "code": "SJ"
//                       }, {
//                           "name": "Satu Mare",
//                           "code": "SM"
//                       }, {
//                           "name": "Sibiu",
//                           "code": "SB"
//                       }, {
//                           "name": "Suceava",
//                           "code": "SV"
//                       }, {
//                           "name": "Teleorman",
//                           "code": "TR"
//                       }, {
//                           "name": "Timiș",
//                           "code": "TM"
//                       }, {
//                           "name": "Tulcea",
//                           "code": "TL"
//                       }, {
//                           "name": "Vâlcea",
//                           "code": "VL"
//                       }, {
//                           "name": "Vaslui",
//                           "code": "VS"
//                       }, {
//                           "name": "Vrancea",
//                           "code": "VN"
//                       }],
//                       "RU": [{
//                           "name": "Altai Krai",
//                           "code": "ALT"
//                       }, {
//                           "name": "Altai Republic",
//                           "code": "AL"
//                       }, {
//                           "name": "Amur Oblast",
//                           "code": "AMU"
//                       }, {
//                           "name": "Arkhangelsk Oblast",
//                           "code": "ARK"
//                       }, {
//                           "name": "Astrakhan Oblast",
//                           "code": "AST"
//                       }, {
//                           "name": "Belgorod Oblast",
//                           "code": "BEL"
//                       }, {
//                           "name": "Bryansk Oblast",
//                           "code": "BRY"
//                       }, {
//                           "name": "Chechen Republic",
//                           "code": "CE"
//                       }, {
//                           "name": "Chelyabinsk Oblast",
//                           "code": "CHE"
//                       }, {
//                           "name": "Chukotka Autonomous Okrug",
//                           "code": "CHU"
//                       }, {
//                           "name": "Chuvash Republic",
//                           "code": "CU"
//                       }, {
//                           "name": "Irkutsk Oblast",
//                           "code": "IRK"
//                       }, {
//                           "name": "Ivanovo Oblast",
//                           "code": "IVA"
//                       }, {
//                           "name": "Jewish Autonomous Oblast",
//                           "code": "YEV"
//                       }, {
//                           "name": "Kabardino-Balkarian Republic",
//                           "code": "KB"
//                       }, {
//                           "name": "Kaliningrad Oblast",
//                           "code": "KGD"
//                       }, {
//                           "name": "Kaluga Oblast",
//                           "code": "KLU"
//                       }, {
//                           "name": "Kamchatka Krai",
//                           "code": "KAM"
//                       }, {
//                           "name": "Karachay–Cherkess Republic",
//                           "code": "KC"
//                       }, {
//                           "name": "Kemerovo Oblast",
//                           "code": "KEM"
//                       }, {
//                           "name": "Khabarovsk Krai",
//                           "code": "KHA"
//                       }, {
//                           "name": "Khanty-Mansi Autonomous Okrug",
//                           "code": "KHM"
//                       }, {
//                           "name": "Kirov Oblast",
//                           "code": "KIR"
//                       }, {
//                           "name": "Komi Republic",
//                           "code": "KO"
//                       }, {
//                           "name": "Kostroma Oblast",
//                           "code": "KOS"
//                       }, {
//                           "name": "Krasnodar Krai",
//                           "code": "KDA"
//                       }, {
//                           "name": "Krasnoyarsk Krai",
//                           "code": "KYA"
//                       }, {
//                           "name": "Kurgan Oblast",
//                           "code": "KGN"
//                       }, {
//                           "name": "Kursk Oblast",
//                           "code": "KRS"
//                       }, {
//                           "name": "Leningrad Oblast",
//                           "code": "LEN"
//                       }, {
//                           "name": "Lipetsk Oblast",
//                           "code": "LIP"
//                       }, {
//                           "name": "Magadan Oblast",
//                           "code": "MAG"
//                       }, {
//                           "name": "Mari El Republic",
//                           "code": "ME"
//                       }, {
//                           "name": "Moscow",
//                           "code": "MOW"
//                       }, {
//                           "name": "Moscow Oblast",
//                           "code": "MOS"
//                       }, {
//                           "name": "Murmansk Oblast",
//                           "code": "MUR"
//                       }, {
//                           "name": "Nizhny Novgorod Oblast",
//                           "code": "NIZ"
//                       }, {
//                           "name": "Novgorod Oblast",
//                           "code": "NGR"
//                       }, {
//                           "name": "Novosibirsk Oblast",
//                           "code": "NVS"
//                       }, {
//                           "name": "Omsk Oblast",
//                           "code": "OMS"
//                       }, {
//                           "name": "Orenburg Oblast",
//                           "code": "ORE"
//                       }, {
//                           "name": "Oryol Oblast",
//                           "code": "ORL"
//                       }, {
//                           "name": "Penza Oblast",
//                           "code": "PNZ"
//                       }, {
//                           "name": "Perm Krai",
//                           "code": "PER"
//                       }, {
//                           "name": "Primorsky Krai",
//                           "code": "PRI"
//                       }, {
//                           "name": "Pskov Oblast",
//                           "code": "PSK"
//                       }, {
//                           "name": "Republic of Adygeya",
//                           "code": "AD"
//                       }, {
//                           "name": "Republic of Bashkortostan",
//                           "code": "BA"
//                       }, {
//                           "name": "Republic of Buryatia",
//                           "code": "BU"
//                       }, {
//                           "name": "Republic of Dagestan",
//                           "code": "DA"
//                       }, {
//                           "name": "Republic of Ingushetia",
//                           "code": "IN"
//                       }, {
//                           "name": "Republic of Kalmykia",
//                           "code": "KL"
//                       }, {
//                           "name": "Republic of Karelia",
//                           "code": "KR"
//                       }, {
//                           "name": "Republic of Khakassia",
//                           "code": "KK"
//                       }, {
//                           "name": "Republic of Mordovia",
//                           "code": "MO"
//                       }, {
//                           "name": "Republic of North Ossetia–Alania",
//                           "code": "SE"
//                       }, {
//                           "name": "Republic of Tatarstan",
//                           "code": "TA"
//                       }, {
//                           "name": "Rostov Oblast",
//                           "code": "ROS"
//                       }, {
//                           "name": "Ryazan Oblast",
//                           "code": "RYA"
//                       }, {
//                           "name": "Saint Petersburg",
//                           "code": "SPE"
//                       }, {
//                           "name": "Sakha Republic (Yakutia)",
//                           "code": "SA"
//                       }, {
//                           "name": "Sakhalin Oblast",
//                           "code": "SAK"
//                       }, {
//                           "name": "Samara Oblast",
//                           "code": "SAM"
//                       }, {
//                           "name": "Saratov Oblast",
//                           "code": "SAR"
//                       }, {
//                           "name": "Smolensk Oblast",
//                           "code": "SMO"
//                       }, {
//                           "name": "Stavropol Krai",
//                           "code": "STA"
//                       }, {
//                           "name": "Sverdlovsk Oblast",
//                           "code": "SVE"
//                       }, {
//                           "name": "Tambov Oblast",
//                           "code": "TAM"
//                       }, {
//                           "name": "Tomsk Oblast",
//                           "code": "TOM"
//                       }, {
//                           "name": "Tula Oblast",
//                           "code": "TUL"
//                       }, {
//                           "name": "Tver Oblast",
//                           "code": "TVE"
//                       }, {
//                           "name": "Tyumen Oblast",
//                           "code": "TYU"
//                       }, {
//                           "name": "Tyva Republic",
//                           "code": "TY"
//                       }, {
//                           "name": "Udmurtia",
//                           "code": "UD"
//                       }, {
//                           "name": "Ulyanovsk Oblast",
//                           "code": "ULY"
//                       }, {
//                           "name": "Vladimir Oblast",
//                           "code": "VLA"
//                       }, {
//                           "name": "Volgograd Oblast",
//                           "code": "VGG"
//                       }, {
//                           "name": "Vologda Oblast",
//                           "code": "VLG"
//                       }, {
//                           "name": "Voronezh Oblast",
//                           "code": "VOR"
//                       }, {
//                           "name": "Yamalo-Nenets Autonomous Okrug",
//                           "code": "YAN"
//                       }, {
//                           "name": "Yaroslavl Oblast",
//                           "code": "YAR"
//                       }, {
//                           "name": "Zabaykalsky Krai",
//                           "code": "ZAB"
//                       }],
//                       "ZA": [{
//                           "name": "Eastern Cape",
//                           "code": "EC"
//                       }, {
//                           "name": "Free State",
//                           "code": "FS"
//                       }, {
//                           "name": "Gauteng",
//                           "code": "GP"
//                       }, {
//                           "name": "KwaZulu-Natal",
//                           "code": "NL"
//                       }, {
//                           "name": "Limpopo",
//                           "code": "LP"
//                       }, {
//                           "name": "Mpumalanga",
//                           "code": "MP"
//                       }, {
//                           "name": "North West",
//                           "code": "NW"
//                       }, {
//                           "name": "Northern Cape",
//                           "code": "NC"
//                       }, {
//                           "name": "Western Cape",
//                           "code": "WC"
//                       }],
//                       "KR": [{
//                           "name": "Busan",
//                           "code": "KR-26"
//                       }, {
//                           "name": "Chungbuk",
//                           "code": "KR-43"
//                       }, {
//                           "name": "Chungnam",
//                           "code": "KR-44"
//                       }, {
//                           "name": "Daegu",
//                           "code": "KR-27"
//                       }, {
//                           "name": "Daejeon",
//                           "code": "KR-30"
//                       }, {
//                           "name": "Gangwon",
//                           "code": "KR-42"
//                       }, {
//                           "name": "Gwangju",
//                           "code": "KR-29"
//                       }, {
//                           "name": "Gyeongbuk",
//                           "code": "KR-47"
//                       }, {
//                           "name": "Gyeonggi",
//                           "code": "KR-41"
//                       }, {
//                           "name": "Gyeongnam",
//                           "code": "KR-48"
//                       }, {
//                           "name": "Incheon",
//                           "code": "KR-28"
//                       }, {
//                           "name": "Jeju",
//                           "code": "KR-49"
//                       }, {
//                           "name": "Jeonbuk",
//                           "code": "KR-45"
//                       }, {
//                           "name": "Jeonnam",
//                           "code": "KR-46"
//                       }, {
//                           "name": "Sejong",
//                           "code": "KR-50"
//                       }, {
//                           "name": "Seoul",
//                           "code": "KR-11"
//                       }, {
//                           "name": "Ulsan",
//                           "code": "KR-31"
//                       }],
//                       "ES": [{
//                           "name": "A Coruña",
//                           "code": "C"
//                       }, {
//                           "name": "Álava",
//                           "code": "VI"
//                       }, {
//                           "name": "Albacete",
//                           "code": "AB"
//                       }, {
//                           "name": "Alicante",
//                           "code": "A"
//                       }, {
//                           "name": "Almería",
//                           "code": "AL"
//                       }, {
//                           "name": "Asturias",
//                           "code": "O"
//                       }, {
//                           "name": "Ávila",
//                           "code": "AV"
//                       }, {
//                           "name": "Badajoz",
//                           "code": "BA"
//                       }, {
//                           "name": "Balears",
//                           "code": "PM"
//                       }, {
//                           "name": "Barcelona",
//                           "code": "B"
//                       }, {
//                           "name": "Burgos",
//                           "code": "BU"
//                       }, {
//                           "name": "Cáceres",
//                           "code": "CC"
//                       }, {
//                           "name": "Cádiz",
//                           "code": "CA"
//                       }, {
//                           "name": "Cantabria",
//                           "code": "S"
//                       }, {
//                           "name": "Castellón",
//                           "code": "CS"
//                       }, {
//                           "name": "Ceuta",
//                           "code": "CE"
//                       }, {
//                           "name": "Ciudad Real",
//                           "code": "CR"
//                       }, {
//                           "name": "Córdoba",
//                           "code": "CO"
//                       }, {
//                           "name": "Cuenca",
//                           "code": "CU"
//                       }, {
//                           "name": "Girona",
//                           "code": "GI"
//                       }, {
//                           "name": "Granada",
//                           "code": "GR"
//                       }, {
//                           "name": "Guadalajara",
//                           "code": "GU"
//                       }, {
//                           "name": "Guipúzcoa",
//                           "code": "SS"
//                       }, {
//                           "name": "Huelva",
//                           "code": "H"
//                       }, {
//                           "name": "Huesca",
//                           "code": "HU"
//                       }, {
//                           "name": "Jaén",
//                           "code": "J"
//                       }, {
//                           "name": "La Rioja",
//                           "code": "LO"
//                       }, {
//                           "name": "Las Palmas",
//                           "code": "GC"
//                       }, {
//                           "name": "León",
//                           "code": "LE"
//                       }, {
//                           "name": "Lleida",
//                           "code": "L"
//                       }, {
//                           "name": "Lugo",
//                           "code": "LU"
//                       }, {
//                           "name": "Madrid",
//                           "code": "M"
//                       }, {
//                           "name": "Málaga",
//                           "code": "MA"
//                       }, {
//                           "name": "Melilla",
//                           "code": "ML"
//                       }, {
//                           "name": "Murcia",
//                           "code": "MU"
//                       }, {
//                           "name": "Navarra",
//                           "code": "NA"
//                       }, {
//                           "name": "Ourense",
//                           "code": "OR"
//                       }, {
//                           "name": "Palencia",
//                           "code": "P"
//                       }, {
//                           "name": "Pontevedra",
//                           "code": "PO"
//                       }, {
//                           "name": "Salamanca",
//                           "code": "SA"
//                       }, {
//                           "name": "Santa Cruz de Tenerife",
//                           "code": "TF"
//                       }, {
//                           "name": "Segovia",
//                           "code": "SG"
//                       }, {
//                           "name": "Sevilla",
//                           "code": "SE"
//                       }, {
//                           "name": "Soria",
//                           "code": "SO"
//                       }, {
//                           "name": "Tarragona",
//                           "code": "T"
//                       }, {
//                           "name": "Teruel",
//                           "code": "TE"
//                       }, {
//                           "name": "Toledo",
//                           "code": "TO"
//                       }, {
//                           "name": "Valencia",
//                           "code": "V"
//                       }, {
//                           "name": "Valladolid",
//                           "code": "VA"
//                       }, {
//                           "name": "Vizcaya",
//                           "code": "BI"
//                       }, {
//                           "name": "Zamora",
//                           "code": "ZA"
//                       }, {
//                           "name": "Zaragoza",
//                           "code": "Z"
//                       }],
//                       "TH": [{
//                           "name": "Amnat Charoen",
//                           "code": "TH-37"
//                       }, {
//                           "name": "Ang Thong",
//                           "code": "TH-15"
//                       }, {
//                           "name": "Bangkok",
//                           "code": "TH-10"
//                       }, {
//                           "name": "Bueng Kan",
//                           "code": "TH-38"
//                       }, {
//                           "name": "Buriram",
//                           "code": "TH-31"
//                       }, {
//                           "name": "Chachoengsao",
//                           "code": "TH-24"
//                       }, {
//                           "name": "Chai Nat",
//                           "code": "TH-18"
//                       }, {
//                           "name": "Chaiyaphum",
//                           "code": "TH-36"
//                       }, {
//                           "name": "Chanthaburi",
//                           "code": "TH-22"
//                       }, {
//                           "name": "Chiang Mai",
//                           "code": "TH-50"
//                       }, {
//                           "name": "Chiang Rai",
//                           "code": "TH-57"
//                       }, {
//                           "name": "Chon Buri",
//                           "code": "TH-20"
//                       }, {
//                           "name": "Chumphon",
//                           "code": "TH-86"
//                       }, {
//                           "name": "Kalasin",
//                           "code": "TH-46"
//                       }, {
//                           "name": "Kamphaeng Phet",
//                           "code": "TH-62"
//                       }, {
//                           "name": "Kanchanaburi",
//                           "code": "TH-71"
//                       }, {
//                           "name": "Khon Kaen",
//                           "code": "TH-40"
//                       }, {
//                           "name": "Krabi",
//                           "code": "TH-81"
//                       }, {
//                           "name": "Lampang",
//                           "code": "TH-52"
//                       }, {
//                           "name": "Lamphun",
//                           "code": "TH-51"
//                       }, {
//                           "name": "Loei",
//                           "code": "TH-42"
//                       }, {
//                           "name": "Lopburi",
//                           "code": "TH-16"
//                       }, {
//                           "name": "Mae Hong Son",
//                           "code": "TH-58"
//                       }, {
//                           "name": "Maha Sarakham",
//                           "code": "TH-44"
//                       }, {
//                           "name": "Mukdahan",
//                           "code": "TH-49"
//                       }, {
//                           "name": "Nakhon Nayok",
//                           "code": "TH-26"
//                       }, {
//                           "name": "Nakhon Pathom",
//                           "code": "TH-73"
//                       }, {
//                           "name": "Nakhon Phanom",
//                           "code": "TH-48"
//                       }, {
//                           "name": "Nakhon Ratchasima",
//                           "code": "TH-30"
//                       }, {
//                           "name": "Nakhon Sawan",
//                           "code": "TH-60"
//                       }, {
//                           "name": "Nakhon Si Thammarat",
//                           "code": "TH-80"
//                       }, {
//                           "name": "Nan",
//                           "code": "TH-55"
//                       }, {
//                           "name": "Narathiwat",
//                           "code": "TH-96"
//                       }, {
//                           "name": "Nong Bua Lam Phu",
//                           "code": "TH-39"
//                       }, {
//                           "name": "Nong Khai",
//                           "code": "TH-43"
//                       }, {
//                           "name": "Nonthaburi",
//                           "code": "TH-12"
//                       }, {
//                           "name": "Pathum Thani",
//                           "code": "TH-13"
//                       }, {
//                           "name": "Pattani",
//                           "code": "TH-94"
//                       }, {
//                           "name": "Pattaya",
//                           "code": "TH-S"
//                       }, {
//                           "name": "Phangnga",
//                           "code": "TH-82"
//                       }, {
//                           "name": "Phatthalung",
//                           "code": "TH-93"
//                       }, {
//                           "name": "Phayao",
//                           "code": "TH-56"
//                       }, {
//                           "name": "Phetchabun",
//                           "code": "TH-67"
//                       }, {
//                           "name": "Phetchaburi",
//                           "code": "TH-76"
//                       }, {
//                           "name": "Phichit",
//                           "code": "TH-66"
//                       }, {
//                           "name": "Phitsanulok",
//                           "code": "TH-65"
//                       }, {
//                           "name": "Phra Nakhon Si Ayutthaya",
//                           "code": "TH-14"
//                       }, {
//                           "name": "Phrae",
//                           "code": "TH-54"
//                       }, {
//                           "name": "Phuket",
//                           "code": "TH-83"
//                       }, {
//                           "name": "Prachin Buri",
//                           "code": "TH-25"
//                       }, {
//                           "name": "Prachuap Khiri Khan",
//                           "code": "TH-77"
//                       }, {
//                           "name": "Ranong",
//                           "code": "TH-85"
//                       }, {
//                           "name": "Ratchaburi",
//                           "code": "TH-70"
//                       }, {
//                           "name": "Rayong",
//                           "code": "TH-21"
//                       }, {
//                           "name": "Roi Et",
//                           "code": "TH-45"
//                       }, {
//                           "name": "Sa Kaeo",
//                           "code": "TH-27"
//                       }, {
//                           "name": "Sakon Nakhon",
//                           "code": "TH-47"
//                       }, {
//                           "name": "Samut Prakan",
//                           "code": "TH-11"
//                       }, {
//                           "name": "Samut Sakhon",
//                           "code": "TH-74"
//                       }, {
//                           "name": "Samut Songkhram",
//                           "code": "TH-75"
//                       }, {
//                           "name": "Saraburi",
//                           "code": "TH-19"
//                       }, {
//                           "name": "Satun",
//                           "code": "TH-91"
//                       }, {
//                           "name": "Sing Buri",
//                           "code": "TH-17"
//                       }, {
//                           "name": "Sisaket",
//                           "code": "TH-33"
//                       }, {
//                           "name": "Songkhla",
//                           "code": "TH-90"
//                       }, {
//                           "name": "Sukhothai",
//                           "code": "TH-64"
//                       }, {
//                           "name": "Suphan Buri",
//                           "code": "TH-72"
//                       }, {
//                           "name": "Surat Thani",
//                           "code": "TH-84"
//                       }, {
//                           "name": "Surin",
//                           "code": "TH-32"
//                       }, {
//                           "name": "Tak",
//                           "code": "TH-63"
//                       }, {
//                           "name": "Trang",
//                           "code": "TH-92"
//                       }, {
//                           "name": "Trat",
//                           "code": "TH-23"
//                       }, {
//                           "name": "Ubon Ratchathani",
//                           "code": "TH-34"
//                       }, {
//                           "name": "Udon Thani",
//                           "code": "TH-41"
//                       }, {
//                           "name": "Uthai Thani",
//                           "code": "TH-61"
//                       }, {
//                           "name": "Uttaradit",
//                           "code": "TH-53"
//                       }, {
//                           "name": "Yala",
//                           "code": "TH-95"
//                       }, {
//                           "name": "Yasothon",
//                           "code": "TH-35"
//                       }],
//                       "AE": [{
//                           "name": "Abu Dhabi",
//                           "code": "AZ"
//                       }, {
//                           "name": "Ajman",
//                           "code": "AJ"
//                       }, {
//                           "name": "Dubai",
//                           "code": "DU"
//                       }, {
//                           "name": "Fujairah",
//                           "code": "FU"
//                       }, {
//                           "name": "Ras al-Khaimah",
//                           "code": "RK"
//                       }, {
//                           "name": "Sharjah",
//                           "code": "SH"
//                       }, {
//                           "name": "Umm al-Quwain",
//                           "code": "UQ"
//                       }],
//                       "GB": [{
//                           "name": "British Forces",
//                           "code": "BFP"
//                       }, {
//                           "name": "England",
//                           "code": "ENG"
//                       }, {
//                           "name": "Northern Ireland",
//                           "code": "NIR"
//                       }, {
//                           "name": "Scotland",
//                           "code": "SCT"
//                       }, {
//                           "name": "Wales",
//                           "code": "WLS"
//                       }],
//                       "US": [{
//                           "name": "Alabama",
//                           "code": "AL"
//                       }, {
//                           "name": "Alaska",
//                           "code": "AK"
//                       }, {
//                           "name": "American Samoa",
//                           "code": "AS"
//                       }, {
//                           "name": "Arizona",
//                           "code": "AZ"
//                       }, {
//                           "name": "Arkansas",
//                           "code": "AR"
//                       }, {
//                           "name": "Armed Forces Americas",
//                           "code": "AA"
//                       }, {
//                           "name": "Armed Forces Europe",
//                           "code": "AE"
//                       }, {
//                           "name": "Armed Forces Pacific",
//                           "code": "AP"
//                       }, {
//                           "name": "California",
//                           "code": "CA"
//                       }, {
//                           "name": "Colorado",
//                           "code": "CO"
//                       }, {
//                           "name": "Connecticut",
//                           "code": "CT"
//                       }, {
//                           "name": "Delaware",
//                           "code": "DE"
//                       }, {
//                           "name": "District of Columbia",
//                           "code": "DC"
//                       }, {
//                           "name": "Federated States of Micronesia",
//                           "code": "FM"
//                       }, {
//                           "name": "Florida",
//                           "code": "FL"
//                       }, {
//                           "name": "Georgia",
//                           "code": "GA"
//                       }, {
//                           "name": "Guam",
//                           "code": "GU"
//                       }, {
//                           "name": "Hawaii",
//                           "code": "HI"
//                       }, {
//                           "name": "Idaho",
//                           "code": "ID"
//                       }, {
//                           "name": "Illinois",
//                           "code": "IL"
//                       }, {
//                           "name": "Indiana",
//                           "code": "IN"
//                       }, {
//                           "name": "Iowa",
//                           "code": "IA"
//                       }, {
//                           "name": "Kansas",
//                           "code": "KS"
//                       }, {
//                           "name": "Kentucky",
//                           "code": "KY"
//                       }, {
//                           "name": "Louisiana",
//                           "code": "LA"
//                       }, {
//                           "name": "Maine",
//                           "code": "ME"
//                       }, {
//                           "name": "Marshall Islands",
//                           "code": "MH"
//                       }, {
//                           "name": "Maryland",
//                           "code": "MD"
//                       }, {
//                           "name": "Massachusetts",
//                           "code": "MA"
//                       }, {
//                           "name": "Michigan",
//                           "code": "MI"
//                       }, {
//                           "name": "Minnesota",
//                           "code": "MN"
//                       }, {
//                           "name": "Mississippi",
//                           "code": "MS"
//                       }, {
//                           "name": "Missouri",
//                           "code": "MO"
//                       }, {
//                           "name": "Montana",
//                           "code": "MT"
//                       }, {
//                           "name": "Nebraska",
//                           "code": "NE"
//                       }, {
//                           "name": "Nevada",
//                           "code": "NV"
//                       }, {
//                           "name": "New Hampshire",
//                           "code": "NH"
//                       }, {
//                           "name": "New Jersey",
//                           "code": "NJ"
//                       }, {
//                           "name": "New Mexico",
//                           "code": "NM"
//                       }, {
//                           "name": "New York",
//                           "code": "NY"
//                       }, {
//                           "name": "North Carolina",
//                           "code": "NC"
//                       }, {
//                           "name": "North Dakota",
//                           "code": "ND"
//                       }, {
//                           "name": "Northern Mariana Islands",
//                           "code": "MP"
//                       }, {
//                           "name": "Ohio",
//                           "code": "OH"
//                       }, {
//                           "name": "Oklahoma",
//                           "code": "OK"
//                       }, {
//                           "name": "Oregon",
//                           "code": "OR"
//                       }, {
//                           "name": "Palau",
//                           "code": "PW"
//                       }, {
//                           "name": "Pennsylvania",
//                           "code": "PA"
//                       }, {
//                           "name": "Puerto Rico",
//                           "code": "PR"
//                       }, {
//                           "name": "Rhode Island",
//                           "code": "RI"
//                       }, {
//                           "name": "South Carolina",
//                           "code": "SC"
//                       }, {
//                           "name": "South Dakota",
//                           "code": "SD"
//                       }, {
//                           "name": "Tennessee",
//                           "code": "TN"
//                       }, {
//                           "name": "Texas",
//                           "code": "TX"
//                       }, {
//                           "name": "Utah",
//                           "code": "UT"
//                       }, {
//                           "name": "Vermont",
//                           "code": "VT"
//                       }, {
//                           "name": "Virgin Islands",
//                           "code": "VI"
//                       }, {
//                           "name": "Virginia",
//                           "code": "VA"
//                       }, {
//                           "name": "Washington",
//                           "code": "WA"
//                       }, {
//                           "name": "West Virginia",
//                           "code": "WV"
//                       }, {
//                           "name": "Wisconsin",
//                           "code": "WI"
//                       }, {
//                           "name": "Wyoming",
//                           "code": "WY"
//                       }],
//                       "UY": [{
//                           "name": "Artigas",
//                           "code": "UY-AR"
//                       }, {
//                           "name": "Canelones",
//                           "code": "UY-CA"
//                       }, {
//                           "name": "Cerro Largo",
//                           "code": "UY-CL"
//                       }, {
//                           "name": "Colonia",
//                           "code": "UY-CO"
//                       }, {
//                           "name": "Durazno",
//                           "code": "UY-DU"
//                       }, {
//                           "name": "Flores",
//                           "code": "UY-FS"
//                       }, {
//                           "name": "Florida",
//                           "code": "UY-FD"
//                       }, {
//                           "name": "Lavalleja",
//                           "code": "UY-LA"
//                       }, {
//                           "name": "Maldonado",
//                           "code": "UY-MA"
//                       }, {
//                           "name": "Montevideo",
//                           "code": "UY-MO"
//                       }, {
//                           "name": "Paysandú",
//                           "code": "UY-PA"
//                       }, {
//                           "name": "Río Negro",
//                           "code": "UY-RN"
//                       }, {
//                           "name": "Rivera",
//                           "code": "UY-RV"
//                       }, {
//                           "name": "Rocha",
//                           "code": "UY-RO"
//                       }, {
//                           "name": "Salto",
//                           "code": "UY-SA"
//                       }, {
//                           "name": "San José",
//                           "code": "UY-SJ"
//                       }, {
//                           "name": "Soriano",
//                           "code": "UY-SO"
//                       }, {
//                           "name": "Tacuarembó",
//                           "code": "UY-TA"
//                       }, {
//                           "name": "Treinta y Tres",
//                           "code": "UY-TT"
//                       }],
//                       "VE": [{
//                           "name": "Amazonas",
//                           "code": "VE-Z"
//                       }, {
//                           "name": "Anzoátegui",
//                           "code": "VE-B"
//                       }, {
//                           "name": "Apure",
//                           "code": "VE-C"
//                       }, {
//                           "name": "Aragua",
//                           "code": "VE-D"
//                       }, {
//                           "name": "Barinas",
//                           "code": "VE-E"
//                       }, {
//                           "name": "Bolívar",
//                           "code": "VE-F"
//                       }, {
//                           "name": "Carabobo",
//                           "code": "VE-G"
//                       }, {
//                           "name": "Cojedes",
//                           "code": "VE-H"
//                       }, {
//                           "name": "Delta Amacuro",
//                           "code": "VE-Y"
//                       }, {
//                           "name": "Dependencias Federales",
//                           "code": "VE-W"
//                       }, {
//                           "name": "Distrito Capital",
//                           "code": "VE-A"
//                       }, {
//                           "name": "Falcón",
//                           "code": "VE-I"
//                       }, {
//                           "name": "Guárico",
//                           "code": "VE-J"
//                       }, {
//                           "name": "La Guaira",
//                           "code": "VE-X"
//                       }, {
//                           "name": "Lara",
//                           "code": "VE-K"
//                       }, {
//                           "name": "Mérida",
//                           "code": "VE-L"
//                       }, {
//                           "name": "Miranda",
//                           "code": "VE-M"
//                       }, {
//                           "name": "Monagas",
//                           "code": "VE-N"
//                       }, {
//                           "name": "Nueva Esparta",
//                           "code": "VE-O"
//                       }, {
//                           "name": "Portuguesa",
//                           "code": "VE-P"
//                       }, {
//                           "name": "Sucre",
//                           "code": "VE-R"
//                       }, {
//                           "name": "Táchira",
//                           "code": "VE-S"
//                       }, {
//                           "name": "Trujillo",
//                           "code": "VE-T"
//                       }, {
//                           "name": "Yaracuy",
//                           "code": "VE-U"
//                       }, {
//                           "name": "Zulia",
//                           "code": "VE-V"
//                       }]
//                   }
//               };
//               var countries_based_on_code = country_and_states.country;
//               function swapcountryJSON(j) {
//                   var res = {};
//                   Object.keys(j).forEach(function(key) {
//                       res[j[key]] = key;
//                   });
//                   return res;
//               }
//               var countries_based_on_name = swapcountryJSON(countries_based_on_code);
//               // Get the country name and state name from the imported script.
//               let country_list = country_and_states['country'];
//               let states_list = country_and_states['states'];
//               window.user_country_code = "US";
//               // creating country name drop-down
//               let ship_countries_dropdown_values = ''
//                 , bill_countries_dropdown_values = '';
//               ship_countries_dropdown_values += '<option value="default">sélectionner un pays</option>';
//               bill_countries_dropdown_values += '<option value="default">sélectionner un pays</option>';
//               var htmlObject = document.createElement('select');
//               var all_countries = false
//                 , allowed_countries = []
//                 , check_specific_country = false;
//               if (WSAIO.shipping_zone_countries != 'undefined' && WSAIO.shipping_zone_countries != '') {
//                   htmlObject.innerHTML = WSAIO.shipping_zone_countries;
//                   for (var i = 0; i < htmlObject.length; i++) {
//                       if (htmlObject[i] != undefined) {
//                           allowed_countries[i] = htmlObject[i].value
//                       }
//                   }
//                   user_country_code = "";
//               } else {
//                   all_countries = true;
//                   check_specific_country = true;
//               }
//               for (let country_code in country_list) {
//                   // set selected option user country
//                   if (allowed_countries.indexOf(country_list[country_code]) != '-1' || all_countries) {
//                       let selected = (country_code == user_country_code) ? ' selected' : '';
//                       ship_countries_dropdown_values += '<option value="' + country_code + '"' + selected + '>' + country_list[country_code] + '</option>';
//                   }
//               }
//               for (let country_code in country_list) {
//                   // set selected option user country
//                   if (allowed_countries.indexOf(country_list[country_code]) != '-1' || all_countries) {
//                       let selected = (country_code == user_country_code) ? ' selected' : '';
//                       bill_countries_dropdown_values += '<option value="' + country_code + '"' + selected + '>' + country_list[country_code] + '</option>';
//                   }
//               }
  
//               function ship_create_states_dropdown() {
//                   // get selected country code
//                   let country_code = document.getElementById("AddressCountryNew").value;
//                   let states = states_list[country_code];
//                   // invalid country code or no states add textbox
//                   let option = '';
//                   if (states != undefined && states.length > 0) {
//                       for (let i = 0; i < states.length; i++) {
//                           option += '<option value="' + states[i].name + '" code="' + states[i].code + '">' + states[i].name + '</option>';
//                       }
//                   }
//                   if (option == '') {
//                       document.querySelector('.new_slct_state').style.display = 'none';
//                   } else {
//                       document.querySelector('.new_slct_state').style.display = 'inline-block';
//                   }
//                   document.querySelector('[name="new_waioaddress[provice]"]').innerHTML = option;
//               }
//               function bill_create_states_dropdown() {
//                   // get selected country code
//                   let country_code = document.getElementById("AddressbillCountryNew").value;
//                   let states = states_list[country_code];
//                   let option = '';
//                   if (states != undefined && states.length > 0) {
//                       for (let i = 0; i < states.length; i++) {
//                           option += '<option value="' + states[i].name + '" code="' + states[i].code + '">' + states[i].name + '</option>';
//                       }
//                   }
//                   if (option == '') {
//                       document.querySelector('.new_slct_statebill').style.display = 'none';
//                   } else {
//                       document.querySelector('.new_slct_statebill').style.display = 'inline-block';
//                   }
//                   document.querySelector('[name="new_waiobilladdress[provice]"]').innerHTML = option;
//               }
  
//               // =========handle undefined variables=====
  
//               if (WSAIO.netTerm.net_term_title == undefined) {
//                   WSAIO.netTerm.net_term_title = 'Net term Order';
//               }
//               if (is_logo == undefined) {
//                   is_logo = false;
//               }
//               if (is_billing_address_checked == undefined) {
//                   is_billing_address_checked = true;
//               }
  
//               //=========================== Page design start  =======================//
//               let new_netTerm_banner = document.createElement('div');
//               new_netTerm_banner.className = 'new_netTerm_banner';
//               if (typeof shop_logo_banner != 'undefined' && shop_logo_banner != '' && is_logo == true) {
//                   new_netTerm_banner.style.backgroundImage = 'url(' + shop_logo_banner + ')';
//                   new_netTerm_banner.style.backgroundSize = 'cover';
//                   new_netTerm_banner.style.backgroundPosition = 'center';
//                   new_netTerm_banner.style.backgroundRepeat = 'no-repeat';
//                   new_netTerm_banner.style.display = 'block';
//                   if (typeof shop_logo != 'undefined' && shop_logo != '') {
//                       new_netTerm_banner.innerHTML = '<div style="width: 100%; display: flex; flex-wrap: wrap; align-items: center; height: 100%;"> <div style="width: 60%;"> <a href="' + WSAIO.local_param + '" style="width: 100% !important; max-width: 600px !important; margin: auto !important; padding: 0px 30px !important; display: flex;"><img src="' + shop_logo + '" style="margin:66px 0px 30px 0px !important;display: block;width:150px; " /></a></div> </div>';
//                   }
//               }
  
//               let ParentBody = document.createElement('div');
//               ParentBody.className = 'NetTerm_div';
  
//               // Mobile view Top design
//               var Mobile_Accordian = document.createElement('div');
//               Mobile_Accordian.className = 'new_net_mobile_div';
//               Mobile_Accordian.style.display = 'none';
//               Mobile_Accordian.style.backgroundColor = 'white';
//               if ((typeof shop_logo != 'undefined' && shop_logo != '') && (typeof shop_logo_banner == 'undefined' || shop_logo_banner == '') && is_logo == true) {
//                   Mobile_Accordian.innerHTML = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="display: block; margin: auto !important; padding: 20px 0px !important;width:150px;" /></a>';
//               }
//               if ((is_logo == false || (typeof shop_logo == 'undefined' || shop_logo == '')) && WSAIO.netTerm.net_term_title != undefined) {
//                   Mobile_Accordian.innerHTML += '<h1 class="new_net_title" style="text-align:center;padding-top: 10px;">' + WSAIO.netTerm.net_term_title + '</h1>';
//               }
//               Mobile_Accordian.innerHTML += '<div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;">Cart</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black;font-size: 14px !important;">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:#6666667a !important;font-size: 14px !important;">Shipping</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;"> Checkout </span> </div><br>';
//               var mobile_inner = document.createElement('div');
//               mobile_inner.className = 'new_mobile_vie_accordian';
//               mobile_inner.innerHTML = '<button class="new_net_accordion" style="position:relative;box-shadow: 0 0 0 1px #fafafa !important;display:none ;color: #ef520e !important;background: #fafafa !important;border: 1px solid rgba(179,179,179,0.34) !important; border-left: none !important;border-right: none !important;"><span class="hOuter"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#fa314a;position:absolute;left: 20px !important;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#f4743c"><path d="M31.63411,14.30534l-24.43945,0.12598l0.06999,14.33333l14.83724,-0.06999l23.61361,56.64746l-8.5804,13.73145c-2.86667,4.58667 -3.01493,10.38036 -0.39193,15.10319c2.623,4.72283 7.59991,7.65657 13.00358,7.65657h86.41992v-14.33333h-86.41992l-0.46191,-0.83985l8.42643,-13.49349h53.52604c5.21017,0 10.005,-2.83296 12.52767,-7.37663l25.8252,-46.47135c1.23983,-2.22167 1.20601,-4.93167 -0.08399,-7.12467c-1.29,-2.18583 -3.64985,-3.52734 -6.18685,-3.52734h-105.69434zM43.58789,43h87.55371l-19.9043,35.83333h-52.71419zM50.16667,129c-7.91608,0 -14.33333,6.41725 -14.33333,14.33333c0,7.91608 6.41725,14.33333 14.33333,14.33333c7.91608,0 14.33333,-6.41725 14.33333,-14.33333c0,-7.91608 -6.41725,-14.33333 -14.33333,-14.33333zM121.83333,129c-7.91608,0 -14.33333,6.41725 -14.33333,14.33333c0,7.91608 6.41725,14.33333 14.33333,14.33333c7.91608,0 14.33333,-6.41725 14.33333,-14.33333c0,-7.91608 -6.41725,-14.33333 -14.33333,-14.33333z"></path></g></g></svg><span class="summry" style="padding-left: 30px;">Show order summary</span> <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#fa314a;height: 22px; position: absolute;" class="net_down"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#f4743c"><path d="M53.24609,68.08333l-10.75,10.75l43.50391,43.5039l43.5039,-43.5039l-10.75,-10.75l-32.7539,32.7539z"></path></g></g></svg><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#fa314a;height: 22px; position: absolute;display:none;" class="net_up"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ef520e"><path d="M86,49.66276l-43.50391,43.50391l10.75,10.75l32.75391,-32.75391l32.7539,32.75391l10.75,-10.75z"></path></g></g></svg><p class="net_prices net--subtotal" style="float:right;text-align: right;">' + WSAIO_formatMoney(cart.items_subtotal_price / 100) + '</p><span></span></span></button>';
//               var mobile_inner_items = document.createElement('div');
//               mobile_inner_items.className = 'new_net_panel';
//               mobile_inner_items.style.transition = 'all 0.5s ease-in-out';
//               // mobile cart items html
//               var cart_items = cart.items;
//               if (cart_items.length > 0) {
//                   var item = '';
//                   cart_items.forEach(function(items) {
//                       const htmlArray = [];
//                       var obj = items.properties;
//                       if (items.sku != '' && items.sku != null) {
//                           htmlArray.push(`<div class="net_line_properties net_line_sku">SKU: ${items.sku}</div>`);
//                       }
//                       for (const key in obj) {
//                           if (obj.hasOwnProperty(key)) {
//                               htmlArray.push(`<div class="net_line_properties">${key}: ${obj[key]}</div>`);
//                           }
//                       }
//                       var var_title = items.variant_title;
//                       if (var_title == null)
//                           var_title = '';
//                       item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <img src="' + items.image + '" alt="' + items.product_title + '"> <span class="new_net_qty">' + items.quantity + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + items.product_title + ' <div class="net_variant_info"> ' + var_title + ' ' + htmlArray.join('') + ' </div> </div> <div class="new_net_item_total"> <span class="new_net_total net-item-total-price-' + (items.key).replace(':', '_') + '"><s></s> <span class="new_order-discount">' + WSAIO_formatMoney(items.price / 100) + '</span></span> </div> </div>';
//                   })
//                   if (WSAIO_generalSetting.additionalFee_enabled) {
//                       item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <svg id="ezg9palcYyL1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 79 80" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" style=" "><image width="79" height="80" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABQCAYAAABYtCjIAAADlUlEQVR4Ae2d15KjMBBF+f8PdM45vtnP2jpU9a5WBUZ4kIPmPqhIEkaH7tuNxDDF/X53Vk6nk5vNZm4wGLher6fiMYAJbGBkvApWbrebWywWbjKZuN1u5y6Xi7teryoeA5jABkawglkJjw2KgMUZjPEqMENoClwcOOMEswI/xhxtp5ZxEGFWIITSuDhgvmHBrCCq+ju1Hg9S8LyI2tZwBE/w4l2trXU9qi/Lk+XJ8r4u6stt5bZyW7nto9Ce2zFpnjRPmifNy03XHvVHmifNk+ZJ86o0gvH+5XJZzntOp1OXqjAfw8zWarV6yY1IrnmAe8cE+isAJoeHxQFvu92Ws+1MnKQq5/PZHQ4H1+/33Xg8Tm59yeHhSsBjfrjKpVPsGw6HjpLi3P45k8ND34D3yunN0WhUvm/jdzTF+lfC40bgnnU3RPBqkleTAQtCbIdWJXgV8DabTSkBwAEaSwtGPkDBq4A3n89LWKQhQLNIzn7BqwDmQyEBBhrwsDyDx9KvJ8urAHk8Hkt4ACQVYUkJ0yDBq4CHdRFlSYAtEWbbtzrWgcfxcH/X21+ZqjRB+DXweGxDs4ikTVBij/8KeBY9TbuqcrZYYH697OEZODq63+9LHQNiFwCzhmcpB51kJASr4VGLQADAMG/zrSpmPVt4VeAMiA+Qerb/0ZI2pDB+nSzhWVJLjmYW53eadR9g04AmQYaUBGtl9Ia2nCM7eDHgDKQPcL1e/2dVVof9QONtfv4mgnXcnrbZwaNzWFz4NGAwwiWWCQTahWmMDRAAzs5HoKEubbKBZwD8joag6rZ9gOSD1GNZdyMsguPKWTxh2DNoKOp1wML9PkCLxoAxiwvrG0AAh8e63v6KxzN0DChAIzA03QisXPBqBgeaLCgbzXvXBFAWmid4T7oP7mUpRF1S3OSCzxzHbdG9Z9q2aZM8YNjjWNWgZZsLbVMXlwVgmzbP1E0OzyZr6BBpC51KWfgdIm0XozNNQJPD4wIASI4GPDr304JL1hVuzCvA0a+XwGu6g996XPB+EAwFT/D0TnLy1KJrbZXbym3ltnLbrnXlk88nzZPmSfOkeZ+sUV1fmzRPmifNk+Z1rSuffD5pnjTvTZrHXIC91/bJLvJp1wYzfer3SbctP/XL20b6yHR7ty8/Ms234ZmYjn0H+NPc5x3XY7z0Yf1It0XjcFUsDnh/P6xv/6IAF2bCmCDCrLvKPwYwgQ2MjNcfoIujjv48ru8AAAAASUVORK5CYII=" preserveAspectRatio="xMidYMid meet"></image></svg> <span class="new_net_qty">' + 1 + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + WSAIO_generalSetting.additionalFee_label + ' </div> <div class="new_net_item_total"> <span class="new_net_total"> <span class="net_additionalFee">...</span></span> </div> </div>';
//                   }
//                   mobile_inner_items.innerHTML += '<div class="net_items">' + item + '</div>';
//               }
//               if (Show_additional_coupon_field) {
//                   // coupon code field html
//                   mobile_inner_items.innerHTML += '<div class="new_discount-code-forms"> <span class="new_wsaio--coupon-code-forms"> <input type="text" name="new_wsaio--discount-code-fields" placeholder="Discount code"> <button name="new_wsaio--discount-code-btns" class="btn new_wsaio--coupon-code-buttons" disabled="disabled" style="opacity:0.2">Apply</button><div class="discount_code_loader" style="display:none;cursor: pointer;background: black;color: white !important;width: 100px !important;margin-top: 10px !important;border-radius: 5px !important;margin-left: 10px !important;"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="40px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="margin: auto !important; display: block;height: 40px !important; "> <path fill="#808080" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path> </svg></div> </span> </div>';
//               }
  
//               mobile_inner_items.innerHTML += '<div class="new_coupon_error" style="color:red;width: 78% !important;margin: auto !important;display: none;"><p style=" color: red !important; ">Discount code is invalid</p></div><div class="new_coupon_label_div" style="display:none;"> <svg style="width: 14px; margin-right: 3px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="coupon_text" style="font-size: 14px; font-weight: 500; text-transform: uppercase;"></p> <svg class="remove_coupon" style="cursor: pointer;width: 16px !important; height: 24px; margin-left: 10px !important;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M40.90039,30.76628l-10.13411,10.13411l45.09961,45.09961l-45.09961,45.09961l10.13411,10.13411l45.09961,-45.09961l45.09961,45.09961l10.13411,-10.13411l-45.09961,-45.09961l45.09961,-45.09961l-10.13411,-10.13411l-45.09961,45.09961z"></path></g></g></svg> </div>';
  
//               // subtotal html
//               if (WSAIO_generalSetting.additionalFee_enabled) {
//                   var fee = 0;
//                   if (WSAIO_generalSetting.additionalFee_value_type == 'fixed') {
//                       fee = (cart.items_subtotal_price / 100) + parseFloat(WSAIO_generalSetting.additionalFee_value);
//                       fee = WSAIO_formatMoney(parseFloat(fee));
//                   } else {
//                       var p = ((parseFloat(WSAIO_generalSetting.additionalFee_value) / 100) * (cart.items_subtotal_price / 100)).toFixed(2);
//                       fee = WSAIO_formatMoney((cart.items_subtotal_price / 100) + parseFloat(p));
//                   }
//                   mobile_inner_items.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + fee + '</p> </div>';
//               } else {
//                   mobile_inner_items.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + WSAIO_formatMoney(cart.items_subtotal_price / 100) + '</p> </div>';
//               }
//               // coupon applied html
//               mobile_inner_items.innerHTML += '<div class="applied_coupon_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>Rabais</p> <svg style="width: 10px; margin-right: 3px !important;margin-left: 6px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="applied_coupon_text"style="font-size: 12px; font-weight: 500; text-transform: uppercase;"></p> </span> <p class="net_prices new_net--coupon_deduct"></p> </div> </div>';
//               // shipping html
//               if (!hide_shipping_content) {
//                   mobile_inner_items.innerHTML += '<div class="new_net_shipping_div"> <p>Expédition</p><p class="new_net--shipping" style="margin-left: auto !important;">Calculé dans le prochaine étape</p> </div>';
//               }
//               // VAT html
//               mobile_inner_items.innerHTML += '<div class="new_applied_vat_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>VAT (incl.)</p> </span> <p class="net_prices new_net--vat_deduct"></p> </div> </div>';
//               // total html
//               mobile_inner_items.innerHTML += '<div class="new_net_total_div" style="padding: 10px 0px;"> <p style="font-size: 18px !important;">Total</p><p class="net_prices new_net_subtotal" style="font-size: 18px !important;"><span style="font-size:14px !important;">USD</span> 0</p> </div>';
  
//               mobile_inner.appendChild(mobile_inner_items);
//               Mobile_Accordian.appendChild(mobile_inner);
  
//               // Soldout or less inventory issue side design
//               var inventoryParentLeftChild = document.createElement('div');
//               inventoryParentLeftChild.className = 'new_net_box new_net_box_1 new_net_stockerror_box';
//               inventoryParentLeftChild.style.display = 'none';
//               inventoryParentLeftChild.style.background = 'white';
//               var inventoryLeftChild_inner = document.createElement('div');
//               inventoryLeftChild_inner.style.display = 'flex';
//               inventoryLeftChild_inner.style.background = 'white';
//               inventoryLeftChild_inner.className = 'net_address_fields net_stockerror_div';
//               inventoryLeftChild_inner.innerHTML += '<div style="padding-top: 85px;padding-right: 10px; " class="new_net_tick"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 172 172" style=" fill:#000000;"><g transform=""><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><path d="M0,86c0,-47.49649 38.50351,-86 86,-86c47.49649,0 86,38.50351 86,86c0,47.49649 -38.50351,86 -86,86c-47.49649,0 -86,-38.50351 -86,-86zM86,165.12c43.69677,0 79.12,-35.42323 79.12,-79.12c0,-43.69677 -35.42323,-79.12 -79.12,-79.12c-43.69677,0 -79.12,35.42323 -79.12,79.12c0,43.69677 35.42323,79.12 79.12,79.12z" fill="#666666"></path><g fill="#666666"><path d="M85.92861,37.18424c-2.68959,0.03942 -4.83874,2.25033 -4.80195,4.93996v68.25522c-0.02486,1.7575 0.89852,3.39224 2.41655,4.27824c1.51803,0.886 3.39553,0.886 4.91356,0c1.51803,-0.886 2.44141,-2.52074 2.41655,-4.27824v-68.25522c0.01801,-1.31643 -0.49732,-2.58414 -1.42871,-3.51463c-0.93139,-0.93049 -2.1996,-1.4446 -3.51601,-1.42533zM86,124.97087c-2.69147,0 -4.87333,2.18187 -4.87333,4.87333c0,2.69147 2.18187,4.87333 4.87333,4.87333c2.69147,0 4.87333,-2.18187 4.87333,-4.87333c0,-2.69147 -2.18187,-4.87333 -4.87333,-4.87333z"></path></g><path d="" fill="none"></path><path d="" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path></g></g></svg> </div>';
//               var inventoryLeftChild_inner_div = document.createElement('div');
//               inventoryLeftChild_inner_div.style.width = '100%';
//               var logo_or_name = '<h1 class="new_success_title" style="font-size: 26px !important; margin-bottom: 20px !important; text-transform: none !important; letter-spacing: normal !important;">' + WSAIO.netTerm.net_term_title + '</h1>';
//               if (typeof shop_logo_banner == 'undefined' && (typeof shop_logo != 'undefined' && shop_logo != '') && is_logo == true) {
//                   var logo_or_name = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a>';
//               }
//               inventoryLeftChild_inner_div.innerHTML += logo_or_name + '<p style="font-size:18px;">Out of stock</p> <p style="color:#666666 !important;">Some items are no longer available. Your cart has been updated.</p> <div style="display:flex;margin-top: 60px !important;margin-bottom: 18px !important; font-weight: 500;"> <p>Description</p> <p style="margin-left: auto !important;">Quantity</p> </div>';
//               var inventoryLeftChild_inner_div_sub = document.createElement('div');
//               inventoryLeftChild_inner_div_sub.style.border = '1px solid #cecece38';
//               inventoryLeftChild_inner_div_sub.style.borderLeft = 'none';
//               inventoryLeftChild_inner_div_sub.style.borderRight = 'none';
//               inventoryLeftChild_inner_div_sub.style.paddingTop = '10px';
//               inventoryLeftChild_inner_div_sub.style.paddingBottom = '10px';
  
//               cart.items.forEach(function(e) {
//                   var item_qty = parseInt(e.quantity)
//                     , update_item = '';
//                   WSAIO.cart_additional_info[0].line_item.forEach(function(ee) {
//                       if (e.id == ee.variant_id) {
//                           var available_qty = parseInt(ee.inventory_quantity);
//                           if (item_qty > available_qty) {
//                               if (ee.track_inventory_management == "shopify" && ee.continue_inventory_policy == 'deny') {
//                                   inventoryLeftChild_inner_div_sub.innerHTML += '<div class="net_item" available_qty="' + available_qty + '" vid="' + ee.variant_id + '"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <img src="' + e.image + '" alt="' + e.product_title + '"> <span class="new_net_qty">' + item_qty + '</span> </span> </a> </div> <div class="new_net_item_title" style="color:#666666 !important;"> ' + e.product_title + ' </div> <div class="new_net_item_total" style="color:#666666 !important;"> ' + item_qty + ' <svg style="width: 14px; padding-top: 14px !important;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M129,57.33333v21.5h-129v14.33333h129v21.5l40.13053,-28.66667z"></path></g></g></svg> ' + available_qty + ' <svg class="new_net_remove_item" vid="' + ee.variant_id + '" style="cursor:pointer;position: absolute; left: 80px; top: 7px; width: 15px;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M86,14.33333c-39.48833,0 -71.66667,32.17833 -71.66667,71.66667c0,39.48833 32.17833,71.66667 71.66667,71.66667c39.48833,0 71.66667,-32.17833 71.66667,-71.66667c0,-39.48833 -32.17833,-71.66667 -71.66667,-71.66667zM131.22167,121.11667c-2.86667,3.79833 -6.30667,7.23833 -10.105,10.105l-35.11667,-35.11667l-35.11667,35.11667c-3.79833,-2.86667 -7.23833,-6.30667 -10.105,-10.105l35.11667,-35.11667l-35.11667,-35.11667c2.86667,-3.79833 6.30667,-7.23833 10.105,-10.105l35.11667,35.11667l35.11667,-35.11667c3.79833,2.86667 7.23833,6.30667 10.105,10.105l-35.11667,35.11667z"></path></g></g></svg> </div> </div>'
//                                   update_items[ee.variant_id] = available_qty;
//                               }
//                           } else if (available_qty <= 0) {
//                               update_items[ee.variant_id] = 0;
//                           }
//                       }
//                   })
//               })
  
//               inventoryLeftChild_inner_div.appendChild(inventoryLeftChild_inner_div_sub);
//               inventoryLeftChild_inner_div.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a class="new_net-continue" style="max-height: 50px !important;justify-content: center !important; border-radius: 6px !important; background: black; color: white !important; padding: 12px 22px; display: block; max-width: 182px; margin: auto !important; border: none !important; margin-top: 30px !important; margin-bottom: 20px !important; text-align: center;">Continue</a> <a href="' + WSAIO.local_param + 'cart" style="margin-left: 20px !important; font-weight: 500;margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> Retour au panier</a> </div></div>';
  
//               inventoryLeftChild_inner.appendChild(inventoryLeftChild_inner_div);
//               inventoryParentLeftChild.appendChild(inventoryLeftChild_inner);
  
//               // Shipping left side design
//               var ShippingParentLeftChild = document.createElement('div');
//               ShippingParentLeftChild.className = 'new_net_box new_net_box_1 net-shipping-div';
//               ShippingParentLeftChild.style.display = 'none';
//               if ((typeof shop_logo != 'undefined' && shop_logo != '') && (typeof shop_logo_banner == 'undefined' || shop_logo_banner == '') && is_logo == true) {
//                   ShippingParentLeftChild.innerHTML = '<div class="net_address_fields" style="display:flex;"><a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a></div>';
//               }
//               if ((is_logo == false || (typeof shop_logo == 'undefined' || shop_logo == '')) && WSAIO.netTerm.net_term_title != undefined) {
//                   ShippingParentLeftChild.innerHTML += '<div class="net_address_fields" style="display:flex;"> <h1 class="new_net_title">' + WSAIO.netTerm.net_term_title + '</h1> </div>';
//               }
//               ShippingParentLeftChild.innerHTML += '<div class="net_address_fields" style="display:flex;"> <div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;cursor: pointer;">Panier</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:#6666667a !important;font-size: 14px !important;cursor: pointer;" class="info_link">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black !important;font-size: 14px !important;cursor: pointer;" class="ship_link">Expédition</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;" class="new_checkout_link"> Vérifier </span> </div> </div>';
//               var ShippingLeftChild_inner = document.createElement('div');
//               ShippingLeftChild_inner.className = 'net_address_fields';
//               var ShippingLeftChild_inner_sub = document.createElement('div');
//               ShippingLeftChild_inner_sub.className = 'new_net--input_field';
//               ShippingLeftChild_inner_sub.style.width = '100%';
//               ShippingLeftChild_inner_sub.innerHTML += '<div class="new_shipping_first_box" style="border: 1px solid #d9d9d9 !important; border-radius: 5px;margin-bottom: 40px !important;"> <div class="new_first_row" style="display: flex; padding: 12px 0px; border-bottom: 1px solid #d9d9d9; width: 96%; margin: auto !important;"> <div style="width:25%;font-size: 14px;color:#545454 !important;">Contact</div> <div style="width:60%;font-size: 14px;color:#545454 !important;" class="new_customer_email">' + WSAIO_customer.email + '</div> <div class="new_change_address"  style="cursor: pointer;font-size: 14px;text-align: right; width: 15%; color: #1773b0 !important; text-transform: capitalize;"></div> </div> <div class="new_second_row" style="display: flex; padding: 12px 0px; width: 96%; margin: auto !important;"> <div style="width:25%;font-size: 14px;color:#545454 !important;">Envoyez à</div> <div style="width:60%;font-size: 14px;color:#545454 !important;" class="new_customer_address"></div> <div class="new_change_address"  style="cursor: pointer;font-size: 14px;text-align: right; width: 15%; color: #1773b0 !important; text-transform: capitalize;">change</div> </div> </div>';
//               ShippingLeftChild_inner_sub.innerHTML += '<span class="new_net_shipping_method" style=""> <label class="new_net_shipping_method_title">Méthode dexpédition</label> <div style="border: 1px solid #d9d9d9 !important; border-radius: 5px; padding: 30px;" class="new_net_shipping_loader new_net--input_field"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px"  viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="margin: auto !important; display: block; "> <path fill="#808080" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path> </svg><p style=" text-align: center; padding-top: 10px; ">Getting available shipping rates...</p></div><div class="new_net--input_field new_net_shipping_method_box" style="display:none;"> </div> </span>';
//               ShippingLeftChild_inner_sub.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <div class="new_return_information" style="margin-top: 16px !important;display: inline-flex;line-height:22px ;color: black !important;cursor:pointer;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22pxvertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour aux informations</div> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span> <button class="new_place_order new_net--input_field ship_field" style="cursor: pointer; border: none !important; float: right !important; margin-top: 0px !important; background: black !important; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; display: block;">Passer la commande</button> </div>';
  
//               ShippingLeftChild_inner.appendChild(ShippingLeftChild_inner_sub);
//               ShippingParentLeftChild.appendChild(ShippingLeftChild_inner);
  
//               // thanku page left side design
//               var thankuParentLeftChild = document.createElement('div');
//               thankuParentLeftChild.className = 'new_net_box new_net_box_1 new_net-thank-div';
//               thankuParentLeftChild.style.display = 'none';
//               var thankuLeftChild_inner = document.createElement('div');
//               thankuLeftChild_inner.style.display = 'flex';
//               thankuLeftChild_inner.className = 'net_address_fields';
//               var logo_or_name = '<h1 class="new_success_title" style="font-size: 26px !important; margin-bottom: 20px !important; text-transform: none !important; letter-spacing: normal !important;">' + WSAIO.netTerm.net_term_title + '</h1>';
//               if (typeof shop_logo_banner == 'undefined' && (typeof shop_logo != 'undefined' && shop_logo != '') && is_logo == true) {
//                   var logo_or_name = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a>';
//               }
//               thankuLeftChild_inner.innerHTML += '<div> ' + logo_or_name + ' <p>Order <span class="new_net_order_name"></span></p> <h6 class="" style="font-size: 26px !important;padding-bottom: 20px !important;">Merci!</h6> <div style="border: 1px solid #cecece38;padding: 10px !important;border-radius: 5px !important;"> <p style="font-size: 16px !important;font-weight: 600;padding-bottom: 10px;">' + WSAIO.netTerm.messages.confirmation + '</p> <p style="font-size: 14px !important;"> ' + WSAIO.netTerm.messages.thank_you + '</p> </div> <div style="border: 1px solid #cecece38;padding: 10px !important;border-radius: 5px !important;margin-top: 10px !important;"><p style="font-size: 16px !important;font-weight: 600;padding-bottom: 10px;">Détails de la commande</p><div style=" display: flex; "><div style=" width: 50%; "><p style="font-size: 14px !important;font-weight: 600;">Coordonnées</p><p style="font-size: 13px !important;">' + WSAIO_customer.email + '</p></div><div style=" width: 50%; "><p style="font-weight: 600; display: block; font-size: 14px !important;display:none;" class="waioNT_shipping_info">Méthode d expédition</p><p style="font-size: 13px !important; display: block;" class="waioNT_shipping_info waioNt_shipping_method"></p></div></div><div style=" display: flex;    margin-top: 14px !important; "><div style=" width: 50%; "><p style="font-weight: 600; display: block; font-size: 14px !important;display:none; " class="waioNT_shipping_info">Méthode d expédition</p><div class="wsaio_shipping_address waioNT_shipping_info" style="display: none;"></div></div><div style=" width: 50%; "><p style="font-weight: 600; display: block; font-size: 14px !important; display:none;" class="waioNT_shipping_info">Mode de facturation</p><div class="wsaio_billing_address waioNT_shipping_info" style="display: none;"></div></div></div></div> <a class="new_net-continue" href="' + WSAIO.local_param + '" style="max-height: 50px !important;justify-content: center !important; border-radius: 6px !important; background: black; color: white !important; padding: 12px 22px; display: block; max-width: 182px; margin-left: auto !important; border: none !important; margin-top: 30px !important; margin-bottom: 20px !important; text-align: center;justify-content: center !important;">Continuer vos achats</a> </div>';
  
//               thankuParentLeftChild.appendChild(thankuLeftChild_inner);
  
//               // Information left side design
//               var ParentLeftChild = document.createElement('form');
//               ParentLeftChild.className = 'new_net_box new_net_box_1 new_net-detail-div ';
//               ParentLeftChild.setAttribute('onsubmit', 'return WSAIO.check_available_shipping(event)');
//               var LeftChild_inner = document.createElement('div');
//               LeftChild_inner.className = 'net_address_fields';
//               if ((typeof shop_logo != 'undefined' && shop_logo != '') && (typeof shop_logo_banner == 'undefined' || shop_logo_banner == '') && is_logo == true) {
//                   LeftChild_inner.innerHTML = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a>';
//               }
//               if ((is_logo == false || (typeof shop_logo == 'undefined' || shop_logo == '')) && WSAIO.netTerm.net_term_title != undefined) {
//                   LeftChild_inner.innerHTML += '<h1 class="new_net_title">' + WSAIO.netTerm.net_term_title + '</h1>';
//               }
//               if (hide_shipping_content) {
//                   LeftChild_inner.innerHTML += '<div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;cursor: pointer;">Panier</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black;font-size: 14px !important;cursor: pointer;" class="info_link">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;" class="new_checkout_link"> Vérifier </span> </div>';
//               } else {
//                   LeftChild_inner.innerHTML += '<div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;cursor: pointer;">Panier</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black;font-size: 14px !important;cursor: pointer;" class="info_link">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:#6666667a !important;font-size: 14px !important;" class="ship_link">Expédition</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;" class="new_checkout_link"> Vérifier </span> </div>';
//               }
//               if (enable_notes && notes != '') {
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field"><div class="new_w-100 new_field_style" style=" padding: 20px 16px; border: 1px solid #0000ff38 !important; background-color: #0000ff26 !important; ">' + notes + '</div></div>';
//               }
//               var cart_note = '';
//               if (cart.note != '' && cart.note != null) {
//                   cart_note = cart.note
//               }
//               LeftChild_inner.innerHTML += '<div class="new_net--input_field"> <textarea class="new_net_shipping_area new_w-100 new_field_style" name="new_shipping_notes" placeholder="Remarque sur la commande">' + cart_note + '</textarea> </div>';
  
//               if (enable_nerterm_PO) {
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field Net_PO_field"> <label style="font-size:14px !important;">PO Number</label> <input type="text" id="PO" name="PO" autocomplete="off" placeholder="Enter PO Number" class="new_w-100 new_field_style" style="width: -webkit-fill-available;width: -moz-available; padding: 12px 10px;margin-top: 5px !important;"> </div>';
//               }
  
//               if (delivery_options == 'pickup_and_shipping_dshipping') {
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field new_pkc" style="display:inline-flex; align-items: center; justify-content: left;"> <label style=" display: block; font-size: 14px !important;padding-right: 14px; ">Options de livraison: </label> <input id="new_shippingx" checked="" name="new_pickupx" value="new_Shipping" type="radio" class="new_shippingchoose" style="cursor:pointer;"> <label for="new_shippingx" style="cursor:pointer; padding: 5px; padding-top: 5px;">Shipping</label><input id="new_pickup" name="new_pickupx" type="radio" value="new_pickup" class="pickupchoose" style="cursor:pointer; margin-left: 10px !important;"> <label for="new_pickup" style=" padding: 5px;padding-top: 5px;cursor:pointer; ">Pickup</label><br> </div>';
//               }
//               if (delivery_options == 'pickup_and_shipping_dpickep') {
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field new_pkc" style="display:inline-flex; align-items: center; justify-content: left;"> <label style=" display: block;font-size: 14px !important; ">Options de livraison: </label><input id="new_pickup" name="new_pickupx" checked="" type="radio" value="new_pickup" class="pickupchoose" style=" margin-left: 10px !important;cursor:pointer; "> <label for="new_pickup" style="cursor:pointer; padding: 5px; padding-top: 5px;">Pickup</label> <input id="new_shippingx"  name="new_pickupx" value="new_Shipping" type="radio" class="new_shippingchoose" style="cursor:pointer;"> <label for="new_shippingx" style="cursor:pointer; padding: 5px; padding-top: 5px; ">Shipping</label></div>';
//               }
  
//               if (enable_new_delivery_date) {
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <label style="font-size:14px !important;">Sélectionnez la date de livraison</label> <input type="date" id="datepicker" name="new_delivery_date" autocomplete="off" placeholder="Sélectionnez la date de livraison (FUTURE-MM/DD/YYYY)" class="new_w-100 new_field_style" style="width: -webkit-fill-available;width: -moz-available; padding: 12px 10px;margin-top: 5px !important;"> </div>';
//               }
  
//               if (enable_nerterm_options && _payment_options.length > 0) {
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field"> <select name="new_payment" required="" class="new_w-100 new_field_style"> <option value="" class="new_payments_option">Sélectionnez une option de paiement</option>' + _payment_options;
//                   LeftChild_inner.innerHTML += '</select></div>';
//               }
  
//               //==============================Pickup address fields =====
//               if (delivery_options !== 'none') {
//                   LeftChild_inner.innerHTML += '<br><label class="shipping new_net_shipping_title pick_field">Adresse de retrait</label>';
//                   LeftChild_inner.innerHTML += '<div class="new_net_shipping_area new_w-100 new_field_style pick_field" name="new_pickup_address"  readonly style="margin-top: 10px !important;background-color: #d9d9d95c !important; padding: 20px 15px;">' + delivery_options_pickup_notes + '</div>';
//               }
//               //==============================Shipping address fields ==================================== -->
  
//               if (delivery_options !== 'none') {
//                   LeftChild_inner.innerHTML += '<br><label class="shipping new_net_shipping_title ship_field">Adresse de livraison</label>';
//                   LeftChild_inner.innerHTML += selectaddress1;
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field new_d-flex" style="display:flex;"> <input type="text" name="new_waioaddress[first_name]" placeholder="Prénom" required="" class="new_w-46 new_field_style"> <input type="text" name="new_waioaddress[last_name]" placeholder="Nom de famille" required="" class="new_w-46 new_field_style new_right_input"> </div>';
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[company]" placeholder="Entreprise" class="new_w-100 new_field_style"> </div>';
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[address1]" placeholder="Adresse Ligne 1" required="" class="new_w-100 new_field_style"> </div>';
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[address2]" placeholder="Adresse Ligne 2" class="new_w-100 new_field_style"> </div>';
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[city]" placeholder="Ville" required="" class="new_w-100 new_field_style"> </div>';
//                   var ship_country_province_zip_div = document.createElement('div');
//                   ship_country_province_zip_div.className = 'new_net--input_field new_net_small_div new_netterm_countries ship_field';
//                   ship_country_province_zip_div.innerHTML += '<span class="new_slct_cntry" style="position:relative;"> <select id="AddressCountryNew" name="new_waioaddress[country] " data-default=""  class="new_field_style" >' + ship_countries_dropdown_values + '</select> <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg></span>';
//                   ship_country_province_zip_div.innerHTML += '<span class="new_slct_state" style="position:relative;"> <select name="new_waioaddress[provice]" class="new_field_style" > <option value="">State/Province</option> </select><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg> </span>';
//                   ship_country_province_zip_div.innerHTML += '<input type="text" name="new_waioaddress[zip]" placeholder="Zip/Postcode" required="" class="new_field_style">';
//                   LeftChild_inner.appendChild(ship_country_province_zip_div);
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="number" name="new_waioaddress[phone]" placeholder="Téléphone" class="new_w-100 new_field_style"> </div>';
  
//                   //==============================Billing address fields ==================================== -->
//                   var billing_checkbox_field = '<input type="checkbox" name="new_billing_address_same_as_shipping_address" checked="checked">';
//                   if (is_billing_address_checked != undefined && !is_billing_address_checked) {
//                       billing_checkbox_field = '<input type="checkbox" name="new_billing_address_same_as_shipping_address">';
//                   }
//                   LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field" style="display:inline-block;"> ' + billing_checkbox_field + ' <span class="new_net_checkbox_shipping" style="cursor:pointer;">Adresse de facturation identique à adresse de livraison</span> </div>';
//                   var billing_address_fields = document.createElement('div');
//                   billing_address_fields.className = 'new_billingaddress ship_field';
//                   if (is_billing_address_checked == undefined || is_billing_address_checked) {
//                       billing_address_fields.style.display = 'none';
//                   }
//                   billing_address_fields.innerHTML += '<br><h2 class="new_net_shipping_title" style="text-align: left;">Billing address</h2>';
//                   billing_address_fields.innerHTML += selectaddress2;
//                   billing_address_fields.innerHTML += '<div class="new_net--input_field" style="display:flex;flex-wrap:wrap;"> <input type="text" name="new_waiobilladdress[first_name]" placeholder="Prénom" class="new_w-46 new_field_style billing_address_required"> <input type="text" name="new_waiobilladdress[last_name]" placeholder="Last Name" class="new_w-46 new_field_style new_right_input billing_address_required"> </div>';
//                   billing_address_fields.innerHTML += '<div class="new_net--input_field "> <input type="text" name="new_waiobilladdress[company]" placeholder="Company" class="new_w-100 new_field_style"> </div>';
//                   billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="text" name="new_waiobilladdress[address1]" placeholder="Address Line 1" class="new_w-100 new_field_style billing_address_required"> </div>';
//                   billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="text" name="new_waiobilladdress[address2]" placeholder="Address Line 2" class="new_w-100 new_field_style"> </div>';
//                   billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="text" name="new_waiobilladdress[city]" placeholder="City" class="new_w-100 new_field_style billing_address_required"> </div>';
//                   var bill_country_province_zip_div = document.createElement('div');
//                   bill_country_province_zip_div.className = 'new_net--input_field new_net_small_div new_netterm_countries';
//                   bill_country_province_zip_div.innerHTML += '<span class="new_slct_cntrybill" style="position:relative;"> <select id="AddressbillCountryNew" name="new_waiobilladdress[country] " data-default=""  class="new_field_style" >' + bill_countries_dropdown_values + '</select> <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg></span>';
//                   bill_country_province_zip_div.innerHTML += '<span class="new_slct_statebill" style="position:relative;"> <select name="new_waiobilladdress[provice]" class="new_field_style" > <option value="">State/Province</option> </select><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg> </span>';
//                   bill_country_province_zip_div.innerHTML += '<input type="text" name="new_waiobilladdress[zip]" placeholder="Zip/Postcode"  class="new_field_style billing_address_required">';
//                   billing_address_fields.appendChild(bill_country_province_zip_div);
//                   billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="number" name="new_waiobilladdress[phone]" placeholder="Phone" class="new_w-100 new_field_style"> </div>';
  
//                   LeftChild_inner.appendChild(billing_address_fields);
//               }
//               //==============================continue and back button ==================================== -->
//               if (delivery_options !== 'none') {
//                   if (hide_shipping_content) {
//                       LeftChild_inner.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a href="' + WSAIO.local_param + 'cart" style="margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22px;vertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour au panier</a> <span class="continue_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><input class="new_net--input_field ship_field continue_shipping" type="submit" value="Place Order" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;height: 50px !important;justify-content: center !important; border-radius: 6px !important;"> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><button class="new_place_order new_net--input_field pick_field" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;background: black !important;color: white !important;width: 200px;height: 60px !important;border-radius: 10px !important;">Passer la commande</button> </div>';
//                   } else {
//                       LeftChild_inner.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a href="' + WSAIO.local_param + 'cart" style="margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22px;vertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour au panier</a> <span class="continue_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><input class="new_net--input_field ship_field continue_shipping" type="submit" value="Continue" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;height: 50px !important;justify-content: center !important; border-radius: 6px !important;"> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><button class="new_place_order new_net--input_field pick_field" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;background: black !important;color: white !important;width: 200px;height: 60px !important;border-radius: 10px !important;">Passer la commande</button> </div>';
//                   }
//               } else {
//                   LeftChild_inner.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a href="' + WSAIO.local_param + 'cart" style="margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22px;vertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour au panier</a> <span class="continue_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><button class="new_place_order new_net--input_field pick_field" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;background: black !important;color: white !important;width: 200px;height: 60px !important;border-radius: 10px !important;">Passer la commande</button> </div>';
//               }
  
//               ParentLeftChild.appendChild(LeftChild_inner);
  
//               // right side
//               var ParentRightChild = document.createElement('div');
//               ParentRightChild.className = 'new_net_box new_net_box_2';
  
//               // cart items html
//               var cart_items = cart.items;
//               if (cart_items.length > 0) {
//                   var item = '';
//                   cart_items.forEach(function(items) {
//                       const htmlArray = [];
//                       var obj = items.properties;
//                       if (items.sku != '' && items.sku != null) {
//                           htmlArray.push(`<div class="net_line_properties net_line_sku">SKU: ${items.sku}</div>`);
//                       }
//                       for (const key in obj) {
//                           if (obj.hasOwnProperty(key)) {
//                               htmlArray.push(`<div class="net_line_properties">${key}: ${obj[key]}</div>`);
//                           }
//                       }
//                       var var_title = items.variant_title;
//                       if (var_title == null)
//                           var_title = '';
//                       item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <img src="' + items.image + '" alt="' + items.product_title + '"> <span class="new_net_qty">' + items.quantity + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + items.product_title + ' <div class="net_variant_info"> ' + var_title + ' ' + htmlArray.join('') + ' </div> </div> <div class="new_net_item_total"> <span class="new_net_total net-item-total-price-' + (items.key).replace(':', '_') + '"><s></s> <span class="new_order-discount">' + WSAIO_formatMoney(items.price / 100) + '</span></span> </div> </div>';
//                   })
//                   if (WSAIO_generalSetting.additionalFee_enabled) {
//                       item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <svg id="ezg9palcYyL1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 79 80" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" style=" "><image width="79" height="80" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABQCAYAAABYtCjIAAADlUlEQVR4Ae2d15KjMBBF+f8PdM45vtnP2jpU9a5WBUZ4kIPmPqhIEkaH7tuNxDDF/X53Vk6nk5vNZm4wGLher6fiMYAJbGBkvApWbrebWywWbjKZuN1u5y6Xi7teryoeA5jABkawglkJjw2KgMUZjPEqMENoClwcOOMEswI/xhxtp5ZxEGFWIITSuDhgvmHBrCCq+ju1Hg9S8LyI2tZwBE/w4l2trXU9qi/Lk+XJ8r4u6stt5bZyW7nto9Ce2zFpnjRPmifNy03XHvVHmifNk+ZJ86o0gvH+5XJZzntOp1OXqjAfw8zWarV6yY1IrnmAe8cE+isAJoeHxQFvu92Ws+1MnKQq5/PZHQ4H1+/33Xg8Tm59yeHhSsBjfrjKpVPsGw6HjpLi3P45k8ND34D3yunN0WhUvm/jdzTF+lfC40bgnnU3RPBqkleTAQtCbIdWJXgV8DabTSkBwAEaSwtGPkDBq4A3n89LWKQhQLNIzn7BqwDmQyEBBhrwsDyDx9KvJ8urAHk8Hkt4ACQVYUkJ0yDBq4CHdRFlSYAtEWbbtzrWgcfxcH/X21+ZqjRB+DXweGxDs4ikTVBij/8KeBY9TbuqcrZYYH697OEZODq63+9LHQNiFwCzhmcpB51kJASr4VGLQADAMG/zrSpmPVt4VeAMiA+Qerb/0ZI2pDB+nSzhWVJLjmYW53eadR9g04AmQYaUBGtl9Ia2nCM7eDHgDKQPcL1e/2dVVof9QONtfv4mgnXcnrbZwaNzWFz4NGAwwiWWCQTahWmMDRAAzs5HoKEubbKBZwD8joag6rZ9gOSD1GNZdyMsguPKWTxh2DNoKOp1wML9PkCLxoAxiwvrG0AAh8e63v6KxzN0DChAIzA03QisXPBqBgeaLCgbzXvXBFAWmid4T7oP7mUpRF1S3OSCzxzHbdG9Z9q2aZM8YNjjWNWgZZsLbVMXlwVgmzbP1E0OzyZr6BBpC51KWfgdIm0XozNNQJPD4wIASI4GPDr304JL1hVuzCvA0a+XwGu6g996XPB+EAwFT/D0TnLy1KJrbZXbym3ltnLbrnXlk88nzZPmSfOkeZ+sUV1fmzRPmifNk+Z1rSuffD5pnjTvTZrHXIC91/bJLvJp1wYzfer3SbctP/XL20b6yHR7ty8/Ms234ZmYjn0H+NPc5x3XY7z0Yf1It0XjcFUsDnh/P6xv/6IAF2bCmCDCrLvKPwYwgQ2MjNcfoIujjv48ru8AAAAASUVORK5CYII=" preserveAspectRatio="xMidYMid meet"></image></svg> <span class="new_net_qty">' + 1 + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + WSAIO_generalSetting.additionalFee_label + ' </div> <div class="new_net_item_total"> <span class="new_net_total"> <span class="net_additionalFee">...</span></span> </div> </div>';
//                   }
//                   ParentRightChild.innerHTML += '<div class="net_items">' + item + '</div>';
//               }
  
//               if (Show_additional_coupon_field) {
//                   // coupon code field html
//                   ParentRightChild.innerHTML += '<div class="new_discount-code-forms"> <span class="new_wsaio--coupon-code-forms"> <input type="text" name="new_wsaio--discount-code-fields" placeholder="Discount code"> <button name="new_wsaio--discount-code-btns" class="btn new_wsaio--coupon-code-buttons" disabled="disabled" style="opacity:0.2">Apply</button><div class="discount_code_loader" style="display:none;cursor: pointer;background: black;color: white !important;width: 100px !important;margin-top: 10px !important;border-radius: 5px !important;margin-left: 10px !important;"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="40px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="margin: auto !important; display: block;!important; "> <path fill="#808080" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path> </svg></div> </span> </div>';
//               }
//               ParentRightChild.innerHTML += '<div class="new_coupon_error" style="color:red;width: 78% !important;margin: auto !important;display: none;"><p style=" color: red !important; ">Discount code is invalid</p></div><div class="new_coupon_label_div" style="display:none;"> <svg style="width: 14px; margin-right: 3px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="coupon_text" style="font-size: 14px; font-weight: 500; text-transform: uppercase;"></p> <svg class="remove_coupon" style="cursor: pointer;width: 16px !important; height: 24px; margin-left: 10px !important;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M40.90039,30.76628l-10.13411,10.13411l45.09961,45.09961l-45.09961,45.09961l10.13411,10.13411l45.09961,-45.09961l45.09961,45.09961l10.13411,-10.13411l-45.09961,-45.09961l45.09961,-45.09961l-10.13411,-10.13411l-45.09961,45.09961z"></path></g></g></svg> </div>';
  
//               // subtotal html
//               if (WSAIO_generalSetting.additionalFee_enabled) {
//                   var fee = 0;
//                   if (WSAIO_generalSetting.additionalFee_value_type == 'fixed') {
//                       fee = (cart.items_subtotal_price / 100) + parseFloat(WSAIO_generalSetting.additionalFee_value);
//                       fee = WSAIO_formatMoney(parseFloat(fee));
//                   } else {
//                       var p = ((parseFloat(WSAIO_generalSetting.additionalFee_value) / 100) * (cart.items_subtotal_price / 100)).toFixed(2);
//                       fee = WSAIO_formatMoney((cart.items_subtotal_price / 100) + parseFloat(p));
//                   }
//                   ParentRightChild.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + fee + '</p> </div>';
//               } else {
//                   ParentRightChild.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + WSAIO_formatMoney(cart.items_subtotal_price / 100) + '</p> </div>';
//               }
//               // coupon applied html
//               ParentRightChild.innerHTML += '<div class="applied_coupon_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>Rabais</p> <svg style="width: 10px; margin-right: 3px !important;margin-left: 6px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="applied_coupon_text"style="font-size: 12px; font-weight: 500; text-transform: uppercase;"></p> </span> <p class="net_prices new_net--coupon_deduct"></p> </div> </div>';
//               // shipping html
//               if (!hide_shipping_content) {
//                   ParentRightChild.innerHTML += '<div class="new_net_shipping_div"> <p>Expédition</p><p class="new_net--shipping" style="margin-left: auto !important;">Calculé dans le prochaine étape</p> </div>';
//               }
//               // VAT html
//               ParentRightChild.innerHTML += '<div class="new_applied_vat_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>VAT (incl.)</p> </span> <p class="net_prices new_net--vat_deduct"></p> </div> </div>';
//               // total html
//               ParentRightChild.innerHTML += '<div class="new_net_total_div" style="padding: 10px 0px;"> <p style="font-size: 18px !important;font-weight: 600 !important;">Total</p><p class="net_prices new_net_subtotal" style="font-size: 18px !important;font-weight: 600 !important;"><span style="font-size:14px !important;">USD</span> 0</p> </div>';
  
//               var style_element = document.createElement('style');
//               style_element.innerHTML = 'html{padding:0px !important;}header,footer,shopify-section,#shopify-section-header,.breadcrumbs, #shopify-section-announcement{display:none !important;} *{color:black !important;margin:0px !important;font-size:14px !important;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important; letter-spacing: 0 !important;}.NetTerm_div input[type=text], .NetTerm_div input[type=number], .NetTerm_div select,.NetTerm_div [type="date"]{height:43px;}.NetTerm_div textarea{height:70px;} main{padding: 0px !important; margin:0px !important;} a{text-decoration:unset !important;}*:focus-visible { outline: none !important; outline-offset: unset !important; box-shadow: none !important; } .NetTerm_div{background-color:#fafafa !important;} textarea::-webkit-input-placeholder, input::-webkit-input-placeholder,select::-webkit-input-placeholder,option::-webkit-input-placeholder { color: #636c72 !important; }.new_coupon_label_div { background: rgb(113 113 113 / 11%); display: inline-flex; padding: 10px; border-radius: 5px; margin-left: 60px !important; margin-top: 10px !important; } .new_discount-code-forms{ width: 78% !important; margin: auto !important; }[name="new_waioaddress[phone]"]::-webkit-outer-spin-button, [name="new_waioaddress[phone]"]::-webkit-inner-spin-button { -webkit-appearance: none; }[name="new_waioaddress[phone]"]{ -moz-appearance: textfield;appearance: textfield !important; } .NetTerm_div select {   background-image: none !important;background:none !important; }#shopify-section-footer{ display:none !important; } .new_net_shipping_method_title{ font-size: 18px !important; color: #333 !important; font-weight: 400 !important; text-transform: none !important; letter-spacing: normal !important; } .new_net_shipping_method_box{ border: 1px solid #d9d9d9 !important; border-radius: 5px; } .new_net_shipping_method_input_div{ cursor:pointer; padding: 10px !important; font-size: 14px !important; line-height: normal !important; display:flex;    align-items: center !important;}.new_net_shipping_method_input_div label{padding-left: 10px;}.new_net_shipping_method_input_div label,.new_net_shipping_method_input_div input{cursor:pointer;display: inline-block !important;} [name="new_wsaio--discount-code-btns"]{ border: none;cursor: pointer;background: black; color: white !important;  width: 100px !important; margin-top: 10px !important; border-radius: 5px !important; margin-left: 10px !important; } [name="new_wsaio--discount-code-btns"][disabled="disabled"]{cursor: auto;}[name="new_wsaio--discount-code-fields"]{ margin-top: 10px !important; border-radius: 5px !important; width:100% !important; min-height: 43px; padding: 0px 10px !important; border: 1px solid #d9d9d9 !important;}.new_net_img_div{cursor:pointer;} .new_wsaio--coupon-code-forms{ display: flex !important; } textarea:Focus,.textarea:Focus,select:Focus,input:Focus{ outline: none !important; border-color: #d9d9d9 !important; } .NetTerm_div{ width:100%; display:flex; flex-wrap:wrap; } #net-term-order .wrapper.main-content .grid__item { padding: 0px !important; } #net-term-order .wrapper.main-content { max-width: unset !important; padding: 0px !important; } input:focus-visible, textarea:focus,select:focus-visible { outline: none !important; border: 1px solid #d9d9d9 !important; } .new_net_box{ padding-top: 5%; } .new_net_box_2{ width:40%; min-height: 100vh; } .new_net_box_1{ background: white; width:55%; } .net_items{ width:78%; margin:auto !important; max-height: 320px; overflow: hidden !important; padding-right: 3px; } .NetTerm_div .net_items,  .new_mobile_vie_accordian .net_items{ border-bottom: 1px solid rgba(179,179,179,0.34); padding-bottom: 15px; margin-bottom: 15px !important; } .net_items:hover { overflow-y: auto !important; } .net_item{ width:100% !important; display:flex !important; /*     flex-wrap:wrap; */ margin:auto !important; margin-top:10px !important; } .new_net_item_img{ width:70px !important; } .new_net_item_img .net_item__image { position: relative; display: block; width: 65px; height: 65px !important; border: 1px solid rgba(179,179,179,0.34); border-radius: 5px !important; } .new_net_item_img img{ position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; margin: auto !important; max-height: 63px !important; max-width: 63px !important; } .new_net_item_title{ width:57%; padding-right: 4%; padding-left: 10px; position:relative; font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",sans-serif; } .new_mobile_vie_accordian .new_net_item_title{ padding-right: 5px !important; } .new_net_item_total{ text-align: right; width: auto !important; float: right; position: relative; margin-left: auto !important; display: block; } .new_net_item_title  a, .new_net_item_total span{ margin: 0 !important; width: 100%; color:black; } input::placeholder , select, option, textarea { color: #636c72 !important; } .new_net_qty{ position: absolute !important; border: 1px solid gray !important; border-radius: 100% !important; text-align: center !important; background: gray !important; right: -12% !important; top: -5px !important; color: white !important; font-size: 12px !important; padding: 5px !important; line-height: 8px !important;} .new_mobile_vie_accordian .new_net_qty{ right: -11%; } .new_net_sutotal_div,.new_net_total_div,.new_net_shipping_div, .new_net_coupon_div, .net_cartLevel_div{ display:flex !important; width: 78% !important; margin: auto !important; margin-top: 10px !important; } .NetTerm_div .new_net_total_div, .new_mobile_vie_accordian .new_net_total_div{ padding: 15px 0px; padding-right: 13px; border-top: 1px solid rgba(179,179,179,0.34); margin-top: 15px !important; } .net_prices{ margin-left: auto  !important; /*     margin-right: 3% !important; */ color:black; /* font-weight:600 !important; */  } .new_net_total{/* font-weight:bold; */ } .new_net_total s{ display:block;line-height: 10px; } .net_address_fields{ width: 100% !important; max-width: 600px !important; margin-left: auto !important; padding: 0px 30px !important; margin-right:4% !important;} .new_net_cart_link{ color:black; text-decoration: revert; } .new_net_link_div{ cursor: pointer; } .new_net_link_div img{ width: 14px;height: 8px; } .new_net--input_field { margin-top: 15px !important; } .new_net_shipping_title { font-size: 18px !important; color: #333 !important; font-weight: 400 !important; text-transform: none !important; letter-spacing: normal !important; } [type="submit"],.continue_shipping{ background:black !important; color:white !important; width: 200px !important; height: 60px !important; border-radius: 10px !important; } .new_field_style{ border-radius: 5px !important; border: 1px solid #d9d9d9 !important;background-color: white !important; }[name="new_wsaio--discount-code-fields"],option{background-color: white !important;} select{ background-size: 8px 6px !important; background-position: calc(100% - 24px) calc(1rem + 7px),calc(100% - 19px) calc(1rem + 6px) !important; background-repeat: no-repeat !important; appearance: none !important; } .new_w-46{ width: 45.7% !important; } .new_right_input{ margin-left:auto !important; } input::placeholder,textarea::placeholder, #date_picker::placeholder { color: black; } .new_net_mobile_accordion { background-color: #eee; color: #444; cursor: pointer; padding: 18px; width: 100%; border: none; text-align: left; outline: none; font-size: 15px; transition: 0.4s; } .active, .new_net_mobile_accordion:hover { background-color: #ccc; } .nat_mobile_panel { padding: 0 18px; display: none; background-color: white; overflow: hidden; } .new_mobile_vie_accordian { background: #fcfcfc !important; border-bottom: 1px solid rgba(179,179,179,0.34) !important; } .new_mobile_vie_accordian .new_net_panel{ padding:20px 20px 0px 20px !important; background: #fcfcfc; max-width: 600px !important; margin: auto !important; } .new_mobile_vie_accordian .hOuter { position: relative; max-width: 600px !important; margin: auto !important; display: block; padding: 0px 20px !important; } .new_mobile_vie_accordian .net_items{ width:100% !important; } .new_mobile_vie_accordian .new_net_sutotal_div,.new_mobile_vie_accordian .new_net_total_div,.new_mobile_vie_accordian .new_net_shipping_div,.new_mobile_vie_accordian .net_cartLevel_div{ width:100% !important; } .new_net_alert.success { background-color: #04AA6D; } .new_net_alert { padding: 14px; background-color: #04aa4ead; color: white; opacity: 1; transition: opacity 0.6s; margin-bottom: 15px !important; width: 76%; display: block; margin: auto !important; border-radius: 5px; } .new_net_title{ font-size: 26px !important; margin-bottom: 20px !important; text-transform: none !important; letter-spacing: normal !important; } .NetTerm_div input[type=text],.NetTerm_div input[type=number], .NetTerm_div select, .NetTerm_div textarea { border: 1px solid #d9d9d9 !important; padding: 10px !important; font-size: 14px !important; line-height: normal !important; min-height: 49px; width: -webkit-fill-available;width: -moz-available;} .NetTerm_div select{height:45px;} .NetTerm_div .new_net--input_field textarea { display: block !important; } span.new_net_checkbox_shipping { font-size: 12px !important; }.NetTerm_div input[type=text], .NetTerm_div input[type=number]{padding: 0px 10px !important;} /*   //============================================mobile view accordian============= */ .new_net_accordion { background-color: #eee; color: #444; cursor: pointer; padding: 20px 0 !important; width: 100%; border: none; text-align: left; outline: none; font-size: 15px; transition: 0.4s; } .active, .new_net_accordion:hover { background-color: #ccc; } .new_net_panel { padding: 0 18px; display: none; background-color: white; overflow: hidden; } /*   //============================================mobile view accordian end============= */ @media only screen and (min-width: 613px) { .new_net_box.new_net_box_2 { border-left: 1px solid #d6d6d6; } .new_netterm_countries select{ display: inline-block !important; } .new_netterm_countries{ overflow: hidden !important;display: flex; flex-wrap:wrap;} .new_netterm_countries > span, .new_netterm_countries > input { width: 32.5% !important; float: left !important; } .new_netterm_countries > .new_slct_cntry, .new_netterm_countries > .new_slct_cntrybill{ margin-right: 1.25% !important;flex-grow: 1; flex-basis: 0; } .new_netterm_countries > input{ margin-left: 1.25% !important;flex-grow: 1; flex-basis: 0; } } @media only screen and (max-width: 998px) {  .new_netTerm_banner img{ padding: 22px 0px 14px 0px !important; } .new_net_box_2, .NetTerm_div .new_net_title,.NetTerm_div span.new_back_link, .NetTerm_div img{ display:none; } .new_coupon_label_div{ margin-left:0px !important; } .new_net_coupon_div{ width:100% !important; } .new_discount-code-forms{ width:100% !important; } .new_net_box_1{ width:100%; } .new_net_accordion, .new_net_mobile_div{ display:block !important; } .new_net_shipping_title, .new_back_link{ padding-left:unset !important; } .new_net--input_field{ /*      margin-left:unset !important; */ } .new_net_item_title{ width: 58% !important; } /*     .new_net_item_total{ margin-right: 16px !important; } */ .new_net_btn_div{ width:100% !important; } .new_net_alert.success { width: 100% !important; padding: 10px 11px !important; line-height: 1.5; font-size: 12px !important; } .net_items { max-height: unset !important; } .new_back_link{ text-align:center !important; } .new_net_btn_div a{ margin-bottom:20px !important; margin-top:0px !important; } [type="submit"]{ width: auto !important; padding: 10px 48px !important; } .new_net_mobile_div > .new_back_link { display: none !important; } } @media (max-width: 998px) and  (min-width: 612px){ .new_net--input_field{ width:100% !important; } .net_address_fields{ padding: 0px 20px !important; } .new_net_title{ text-align:center; } .new_net--input_field{ width: 100%; } [type="submit"]{ width: auto !important; padding: 10px 48px !important; } } @media  (max-width: 612px) and  (min-width: 320px){ .new_slct_cntry,.new_slct_state{width:100%}.new_netterm_countries{ flex-wrap:wrap;}[name="new_wsaio--discount-code-btns"]{ min-width: 90px !important; padding: 6px 21px !important; border-radius: 5px !important; } .new_discount-code-forms{ width: 100% !important; } .new_net_remove_item{ left: 30px !important; top: 32px !important; } .net_address_fields{ padding: 0px 20px !important; } .new_w-46{ width:100% !important; } .new_right_input{ margin-top:18px !important; } .new_net_small_div select, .new_net_small_div input{ width:100% !important; } .new_slct_state, .new_slct_statebill{ display:block !important; } [name="new_waioaddress[provice]"], [name="new_waiobilladdress[provice]"]{ /*       margin:0px !important; */ margin-top:18px !important; } #AddressCountryNew{ margin-top:0px !important; } .new_net_title{ text-align:center; } .new_net_item_img{ width:70px !important; } .new_net--input_field,.new_place_loader { width: 100% !important; } [type="submit"]{ width: auto !important; padding: 10px 48px !important; } .new_netterm_countries { overflow: hidden; } .new_netterm_countries input { margin-top: 15px !important; } .new_shipping_first_box .new_first_row div,.new_shipping_first_box .new_second_row div{ font-size: 12px !important; } .new_net_btn_div input[type=submit]{ width: 100% !important; margin: 10px 0px !important; } .new_net_btn_div{ flex-direction: column-reverse !important; display: flex !important; }.new_netterm_countries [name="new_waioaddress[zip]"],[name="new_waiobilladdress[zip]"]{    width: -webkit-fill-available !important;} } @media  (max-width: 612px) and  (min-width: 310px){ .net_address_fields{width: auto !important;} .new_slct_cntry svg,.new_slct_cntrybill svg{top: 0px !important;}.new_slct_state svg,.new_slct_statebill svg{top: 33px !important;}} @media  (max-width: 400px) and  (min-width: 320px){ .new_net_tick{ display:none !important; font-size: 30px !important; } .new_net_title, .new_success_title{ font-size: 30px !important; } }input[type="checkbox"] { background: unset !important; appearance: auto !important; -webkit-appearance: auto !important; } .net_line_properties{line-height: 1 !important;} .net_variant_info,.net_line_properties{color: hsl(0, 0%, 44%) !important; font-size: 11px !important;}.shopify_ship{border-top: 1px solid #d9d9d9;}';
  
//               ParentBody.appendChild(inventoryParentLeftChild);
//               ParentBody.appendChild(thankuParentLeftChild);
//               ParentBody.appendChild(ShippingParentLeftChild);
//               ParentBody.appendChild(ParentLeftChild);
//               ParentBody.appendChild(ParentRightChild);
  
//               document.body.innerHTML = "";
//               document.body.appendChild(new_netTerm_banner);
//               document.body.appendChild(Mobile_Accordian);
//               document.body.appendChild(ParentBody);
//               document.body.appendChild(style_element);
  
//               //  ============================= js function event that need to run after html eppend  ==================
  
//               WSAIO.price_with_unit = function(price) {
//                   if (typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined') {
//                       price = price + ' ' + WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
//                   } else {
//                       price = price + ' ' + Shopify.currency.active;
//                   }
//                   return price;
//               }
//               ;
//               WSAIO.change_currency_sign = function(price) {
//                   if (typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1 && typeof WSAIO.market_selected != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && (WSAIO.market_selected != WSAIO.customer.default_address.country_code)) {
//                       var character = null;
//                       price = price.toString();
//                       character = price.replace(/(<([^>]+)>)/ig, '');
//                       character = character.replace(/\d.+/g, '');
//                       character = character.replace(/\d,+/g, '')
//                       price = price.replace(character, WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[1])
//                   }
//                   return price;
//               }
  
//               // disable datepiker dates 
//               if (enable_new_delivery_date) {
//                   var someDate = new Date();
//                   var numberOfDaysToAdd = number_of_days_disabled;
//                   var result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
//                   document.querySelector('[name="new_delivery_date"]').setAttribute('min', (new Date(result).toISOString().split('T')[0]))
//               }
  
//               // ============================= Show hide Billing address fields  =============================
  
//               function make_billing_required() {
//                   var make_required = document.querySelectorAll('.billing_address_required');
//                   for (var i = 0; i < make_required.length; i++) {
//                       make_required[i].setAttribute("required", "required");
//                   }
//               }
//               function make_billing_optional() {
//                   var make_required = document.querySelectorAll('.billing_address_required');
//                   for (var i = 0; i < make_required.length; i++) {
//                       make_required[i].removeAttribute("required");
//                   }
//               }
  
//               if (!is_billing_address_checked) {
//                   make_billing_required()
//               }
  
//               function toggle_billing_form() {
//                   var x = document.querySelector(".new_billingaddress");
//                   if (x.style.display === "none") {
//                       x.style.display = "block";
//                       make_billing_required();
//                   } else {
//                       x.style.display = "none";
//                       make_billing_optional();
//                   }
//               }
//               const billing_form_checkbox = document.querySelectorAll('[name="new_billing_address_same_as_shipping_address"]');
//               if (billing_form_checkbox.length) {
//                   for (var i = 0; i < billing_form_checkbox.length; i++) {
//                       billing_form_checkbox[i].addEventListener('change', toggle_billing_form);
//                   }
//               }
  
//               if (document.querySelector('.new_net_checkbox_shipping') != null) {
//                   document.querySelector('.new_net_checkbox_shipping').addEventListener('click', function() {
//                       var custom_event1 = new Event('change');
//                       var checkox_slect = document.querySelector('[name="new_billing_address_same_as_shipping_address"]');
//                       checkox_slect.dispatchEvent(custom_event1);
//                       if (checkox_slect.checked) {
//                           checkox_slect.checked = false;
//                           make_billing_required();
//                       } else {
//                           checkox_slect.checked = true;
//                           make_billing_optional();
//                       }
  
//                   })
//               }
  
//               // check delivery options
//               function update_deliver_option() {
//                   if (this.value == 'new_pickup') {
//                       delivery_options = 'only_pickup';
//                       var shipping_fields = document.querySelectorAll('.ship_field');
//                       if (shipping_fields.length) {
//                           for (var i = 0; i < shipping_fields.length; i++) {
//                               shipping_fields[i].style.display = 'none'
//                           }
//                       }
//                       var pickup_fields = document.querySelectorAll('.pick_field');
//                       if (pickup_fields.length) {
//                           for (var i = 0; i < pickup_fields.length; i++) {
//                               pickup_fields[i].style.display = 'block'
//                           }
//                       }
//                       var required_element = document.querySelectorAll('[name="new_waioaddress[first_name]"],[name="new_waioaddress[last_name]"],[name="new_waioaddress[address1]"],[name="new_waioaddress[city]"],[name="new_waioaddress[zip]"]');
//                       for (var i = 0; i < required_element.length; i++) {
//                           required_element[i].removeAttribute('required');
//                       }
//                       document.querySelector('.new_net-detail-div').removeAttribute('onsubmit');
//                   } else {
//                       delivery_options = 'only_shipping';
//                       var shipping_fields = document.querySelectorAll('.ship_field');
//                       if (shipping_fields.length) {
//                           for (var i = 0; i < shipping_fields.length; i++) {
//                               shipping_fields[i].style.display = 'block'
//                           }
//                           document.querySelector('.new_d-flex,.new_netterm_countries').style.display = 'flex';
//                           document.querySelector('.new_netterm_countries').style.display = 'flex';
//                       }
//                       var pickup_fields = document.querySelectorAll('.pick_field');
//                       if (pickup_fields.length) {
//                           for (var i = 0; i < pickup_fields.length; i++) {
//                               pickup_fields[i].style.display = 'none'
//                           }
//                       }
//                       var required_element = document.querySelectorAll('[name="new_waioaddress[first_name]"],[name="new_waioaddress[last_name]"],[name="new_waioaddress[address1]"],[name="new_waioaddress[city]"],[name="new_waioaddress[zip]"]');
//                       for (var i = 0; i < required_element.length; i++) {
//                           required_element[i].setAttribute('required', 'required');
//                       }
//                       toggle_billing_form();
//                       document.querySelector('.new_net-detail-div').setAttribute('onsubmit', 'return WSAIO.check_available_shipping(event)');
//                   }
  
//               }
//               var deliver_options_value = document.querySelectorAll('[name="new_pickupx"]');
//               if (deliver_options_value.length) {
//                   for (var i = 0; i < deliver_options_value.length; i++) {
//                       deliver_options_value[i].addEventListener('change', update_deliver_option);
//                   }
//               }
  
//               if (delivery_options == 'pickup_and_shipping_dshipping') {
//                   var pickup_fields = document.querySelectorAll('.pick_field');
//                   if (pickup_fields.length) {
//                       for (var i = 0; i < pickup_fields.length; i++) {
//                           pickup_fields[i].style.display = 'none';
//                       }
//                   }
//               }
//               if (delivery_options == 'pickup_and_shipping_dpickep') {
//                   var pickup_fields = document.querySelectorAll('.ship_field');
//                   if (pickup_fields.length) {
//                       for (var i = 0; i < pickup_fields.length; i++) {
//                           pickup_fields[i].style.display = 'none';
//                       }
//                   }
//                   var required_element = document.querySelectorAll('[name="new_waioaddress[first_name]"],[name="new_waioaddress[last_name]"],[name="new_waioaddress[address1]"],[name="new_waioaddress[city]"],[name="new_waioaddress[zip]"]');
//                   for (var i = 0; i < required_element.length; i++) {
//                       required_element[i].removeAttribute('required')
//                   }
//                   document.querySelector('.new_net-detail-div').removeAttribute('onsubmit');
//               }
  
//               if (delivery_options == 'only_pickup') {
//                   var ship_fields = document.querySelectorAll('.ship_field');
//                   for (var i = 0; i < ship_fields.length; i++) {
//                       ship_fields[i].remove();
//                   }
//               }
//               if (delivery_options == 'only_shipping') {
//                   var ship_fields = document.querySelectorAll('.pick_field');
//                   for (var i = 0; i < ship_fields.length; i++) {
//                       ship_fields[i].remove();
//                   }
//               }
  
//               // check if any item sold out or less inventory
//               if (update_items && Object.keys(update_items).length > 0) {
//                   document.querySelector('.new_net-detail-div ').style.display = 'none';
//                   document.querySelector('.new_net_stockerror_box').style.display = 'block';
//               }
//               //======================================mobile view accordian==================
  
//               var acc1 = document.getElementsByClassName("new_net_accordion");
//               var i;
  
//               for (i = 0; i < acc1.length; i++) {
//                   acc1[i].addEventListener("click", function() {
//                       this.classList.toggle("active");
//                       var panel = this.nextElementSibling;
//                       if (panel.style.display === "block") {
//                           panel.style.display = "none";
//                       } else {
//                           panel.style.display = "block";
//                       }
//                   });
//               }
  
//               //======================================Auto shipping address append event==================
  
//               const shippingselectElement = document.querySelectorAll('.new_shipping_auto_address')
//               if (shippingselectElement.length) {
//                   for (var i = 0; i < shippingselectElement.length; i++) {
//                       shippingselectElement[i].addEventListener('change', (event) => {
//                           var Shipping_form_elements = document.querySelectorAll('input[name="new_waioaddress[first_name]"],input[name="new_waioaddress[last_name]"],input[name="new_waioaddress[company]"],input[name="new_waioaddress[address1]"],input[name="new_waioaddress[address2]"],input[name="new_waioaddress[city]"],input[name="new_waioaddress[zip]"],input[name="new_waioaddress[phone]"]');
//                           for (var i = 0, iLen = Shipping_form_elements.length; i < iLen; i++) {
//                               Shipping_form_elements[i].value = '';
//                           }
//                           if (event.target.value === '')
//                               return;
//                           if (event.target.value == 'default') {
//                               document.querySelector('input[name="new_waioaddress[first_name]"]').value = WSAIO_customer.default_address.first_name;
//                               document.querySelector('input[name="new_waioaddress[last_name]"]').value = WSAIO_customer.default_address.last_name;
//                               document.querySelector('input[name="new_waioaddress[company]"]').value = WSAIO_customer.default_address.company;
//                               document.querySelector('input[name="new_waioaddress[address1]"]').value = WSAIO_customer.default_address.address1;
//                               document.querySelector('input[name="new_waioaddress[address2]"]').value = WSAIO_customer.default_address.address2;
//                               document.querySelector('input[name="new_waioaddress[city]"]').value = WSAIO_customer.default_address.city;
//                               document.querySelector('input[name="new_waioaddress[zip]"]').value = WSAIO_customer.default_address.zip;
//                               if ((WSAIO_customer.default_address.country != undefined && allowed_countries.indexOf(WSAIO_customer.default_address.country) != '-1') || check_specific_country) {
//                                   document.querySelector('[name="new_waioaddress[country] "]').value = countries_based_on_name[WSAIO_customer.default_address.country];
//                               }
//                               document.querySelector('input[name="new_waioaddress[phone]"]').value = WSAIO_customer.default_address.phone;
//                               var ship_customevent = new Event('change');
//                               document.getElementById("AddressCountryNew").dispatchEvent(ship_customevent);
//                               if (WSAIO_customer.default_address.province == null) {
//                                   document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex = 0;
//                               } else {
//                                   document.querySelector('[name="new_waioaddress[provice]"]').value = WSAIO_customer.default_address.province;
//                               }
//                           }
//                           var corresponding_data = WSAIO_customer.addresses[event.target.value];
//                           if (typeof corresponding_data !== "undefined") {
//                               document.querySelector('input[name="new_waioaddress[first_name]"]').value = corresponding_data.first_name;
//                               document.querySelector('input[name="new_waioaddress[last_name]"]').value = corresponding_data.last_name;
//                               document.querySelector('input[name="new_waioaddress[company]"]').value = corresponding_data.company;
//                               document.querySelector('input[name="new_waioaddress[address1]"]').value = corresponding_data.address1;
//                               document.querySelector('input[name="new_waioaddress[address2]"]').value = corresponding_data.address2;
//                               document.querySelector('input[name="new_waioaddress[city]"]').value = corresponding_data.city;
//                               document.querySelector('input[name="new_waioaddress[zip]"]').value = corresponding_data.zip;
//                               document.querySelector('[name="new_waioaddress[country] "]').value = countries_based_on_name[corresponding_data.country];
//                               document.querySelector('input[name="new_waioaddress[phone]"]').value = corresponding_data.phone;
//                               var ship_customevent = new Event('change');
//                               document.getElementById("AddressCountryNew").dispatchEvent(ship_customevent);
//                               if (corresponding_data.province == null) {
//                                   document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex = 0;
//                               } else {
//                                   document.querySelector('[name="new_waioaddress[provice]"]').value = corresponding_data.province;
//                               }
//                           }
  
//                       }
//                       );
//                   }
//               }
//               //======================================Auto shipping address append event==================
  
//               const billingselectElement = document.querySelectorAll('.new_billing_auto_address');
//               if (billingselectElement.length) {
//                   for (var i = 0; i < billingselectElement.length; i++) {
//                       billingselectElement[i].addEventListener('change', (event) => {
//                           var Shipping_form_elements = document.querySelectorAll('input[name="new_waiobilladdress[first_name]"],input[name="new_waiobilladdress[last_name]"],input[name="new_waiobilladdress[company]"],input[name="new_waiobilladdress[address1]"],input[name="new_waiobilladdress[address2]"],input[name="new_waiobilladdress[city]"],input[name="new_waiobilladdress[zip]"],input[name="new_waiobilladdress[phone]"]');
//                           for (var i = 0, iLen = Shipping_form_elements.length; i < iLen; i++) {
//                               Shipping_form_elements[i].value = '';
//                           }
//                           if (event.target.value === '')
//                               return;
//                           if (event.target.value == 'default') {
//                               document.querySelector('input[name="new_waiobilladdress[first_name]"]').value = WSAIO_customer.default_address.first_name;
//                               document.querySelector('input[name="new_waiobilladdress[last_name]"]').value = WSAIO_customer.default_address.last_name;
//                               document.querySelector('input[name="new_waiobilladdress[company]"]').value = WSAIO_customer.default_address.company;
//                               document.querySelector('input[name="new_waiobilladdress[address1]"]').value = WSAIO_customer.default_address.address1;
//                               document.querySelector('input[name="new_waiobilladdress[address2]"]').value = WSAIO_customer.default_address.address2;
//                               document.querySelector('input[name="new_waiobilladdress[city]"]').value = WSAIO_customer.default_address.city;
//                               document.querySelector('input[name="new_waiobilladdress[zip]"]').value = WSAIO_customer.default_address.zip;
//                               if ((WSAIO_customer.default_address.country != undefined && allowed_countries.indexOf(WSAIO_customer.default_address.country) != '-1') || check_specific_country) {
//                                   document.querySelector('[name="new_waiobilladdress[country] "]').value = countries_based_on_name[WSAIO_customer.default_address.country];
//                               }
//                               document.querySelector('input[name="new_waiobilladdress[phone]"]').value = WSAIO_customer.default_address.phone;
//                               var bill_customevent = new Event('change');
//                               document.getElementById("AddressbillCountryNew").dispatchEvent(bill_customevent);
//                               if (WSAIO_customer.default_address.province == null) {
//                                   document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex = 0;
//                               } else {
//                                   document.querySelector('[name="new_waiobilladdress[provice]"]').value = WSAIO_customer.default_address.province;
//                               }
//                           }
//                           var corresponding_data = WSAIO_customer.addresses[event.target.value];
//                           if (typeof corresponding_data !== "undefined") {
//                               document.querySelector('input[name="new_waiobilladdress[first_name]"]').value = corresponding_data.first_name;
//                               document.querySelector('input[name="new_waiobilladdress[last_name]"]').value = corresponding_data.last_name;
//                               document.querySelector('input[name="new_waiobilladdress[company]"]').value = corresponding_data.company;
//                               document.querySelector('input[name="new_waiobilladdress[address1]"]').value = corresponding_data.address1;
//                               document.querySelector('input[name="new_waiobilladdress[address2]"]').value = corresponding_data.address2;
//                               document.querySelector('input[name="new_waiobilladdress[city]"]').value = corresponding_data.city;
//                               document.querySelector('input[name="new_waiobilladdress[zip]"]').value = corresponding_data.zip;
//                               document.querySelector('[name="new_waiobilladdress[country] "]').value = countries_based_on_name[corresponding_data.country];
//                               document.querySelector('input[name="new_waiobilladdress[phone]"]').value = corresponding_data.phone;
//                               var bill_customevent = new Event('change');
//                               document.getElementById("AddressbillCountryNew").dispatchEvent(bill_customevent);
//                               if (corresponding_data.province == null) {
//                                   document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex = 0;
//                               } else {
//                                   document.querySelector('[name="new_waiobilladdress[provice]"]').value = corresponding_data.province;
//                               }
//                           }
  
//                       }
//                       );
//                   }
//               }
  
//               // ============================= Gets provinces based on country select  =============================
//               // For Shipping form
//               const ship_country_select = document.querySelectorAll("#AddressCountryNew");
//               if (ship_country_select.length) {
//                   for (var i = 0; i < ship_country_select.length; i++) {
//                       ship_country_select[i].addEventListener('change', ship_create_states_dropdown);
//                       var ship_customevent = new Event('change');
//                       document.getElementById("AddressCountryNew").dispatchEvent(ship_customevent);
//                   }
//               }
//               // For Billing form
//               const bill_country_select = document.querySelectorAll("#AddressbillCountryNew");
//               if (bill_country_select.length) {
//                   for (var i = 0; i < bill_country_select.length; i++) {
//                       bill_country_select[i].addEventListener('change', bill_create_states_dropdown);
//                       var bill_customevent = new Event('change');
//                       document.getElementById("AddressbillCountryNew").dispatchEvent(bill_customevent);
//                   }
//               }
  
//               // ============================= enable disale coupon field button  =============================
//               // For desktop view
//               function check_field_data1() {
//                   var new_coupon_error = document.querySelectorAll('.new_coupon_error');
//                   for (var i = 0; i < new_coupon_error.length; i++) {
//                       new_coupon_error[i].style.display = 'none';
//                   }
//                   var x = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-btns"]');
//                   if (document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]').value == '') {
//                       x.setAttribute("disabled", "disabled");
//                       x.style.opacity = "0.2";
//                   } else {
//                       x.removeAttribute("disabled");
//                       x.style.opacity = "1";
//                   }
//               }
//               const desktop_coupon_field_input = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]');
//               if (desktop_coupon_field_input != null) {
//                   desktop_coupon_field_input.addEventListener('keyup', check_field_data1);
//               }
  
//               // For mobile view
//               function check_field_data2() {
//                   var new_coupon_error = document.querySelectorAll('.new_coupon_error');
//                   for (var i = 0; i < new_coupon_error.length; i++) {
//                       new_coupon_error[i].style.display = 'none';
//                   }
//                   var x = document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-btns"]');
//                   if (document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-fields"]').value == '') {
//                       x.setAttribute("disabled", "disabled");
//                       x.style.opacity = "0.2";
//                   } else {
//                       x.removeAttribute("disabled");
//                       x.style.opacity = "1";
//                   }
//               }
//               const mobile_coupon_field_input = document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-fields"]');
//               if (mobile_coupon_field_input != null) {
//                   mobile_coupon_field_input.addEventListener('keyup', check_field_data2);
//               }
  
//               // ============/////================= Wholesale app functions  ==============////===============
  
//               // subtotal get function 
//               WSAIO_subtotal = function() {
//                   var subtotal = 0;
//                   if (typeof window.preDiscountData == 'undefined') {
//                       subtotal = parseFloat(WSAIO.cart_object.items_subtotal_price / 100);
//                   } else {
//                       if (typeof window.preDiscountData.checkout_final_price != 'undefined') {
//                           subtotal = parseFloat(window.preDiscountData.checkout_final_price);
//                       }
//                   }
//                   return subtotal;
//               }
//               // Original subtotal without additoional Discount get function 
//               WSAIO_originalSubtotal = function() {
//                   var subtotal = 0;
//                   if (typeof window.preDiscountData == 'undefined') {
//                       subtotal = parseFloat(WSAIO.cart_object.items_subtotal_price / 100);
//                   } else {
//                       if (typeof window.preDiscountData.checkout_price_from_items_subtotal_price != 'undefined') {
//                           subtotal = parseFloat(window.preDiscountData.checkout_price_from_items_subtotal_price);
//                       }
//                   }
//                   return subtotal;
//               }
  
//               // cart get function 
//               WSAIO_cart_item = function() {
//                   var cart_item = null;
//                   if (typeof window.preDiscountData == 'undefined') {
//                       cart_item = WSAIO.cart_object.items;
//                   } else {
//                       if (typeof window.preDiscountData.checkout_final_price != 'undefined') {
//                           cart_item = window.preDiscountData.line_items;
//                       }
//                   }
//                   return cart_item;
//               }
  
//               function get_line_price(cart_item, index) {
//                   var price = 0;
//                   if (typeof window.preDiscountData == 'undefined') {
//                       price = parseFloat(cart_item[index].final_price) / 100;
//                   } else {
//                       price = parseFloat(cart_item[index].wholesale.item_subtotal_price);
//                   }
//                   return price;
//               }
  
//               function show_Additional_Processing_fee(subtotal) {
//                   var fee = 0;
//                   if (WSAIO_generalSetting.additionalFee_value_type == 'fixed') {
//                       subtotal = subtotal + (parseFloat(WSAIO_generalSetting.additionalFee_value) * Shopify.currency.rate);
//                       fee = WSAIO_formatMoney((parseFloat(WSAIO_generalSetting.additionalFee_value) * Shopify.currency.rate).toFixed(2));
//                   } else {
//                       var p = ((parseFloat(WSAIO_generalSetting.additionalFee_value) / 100) * subtotal).toFixed(2);
//                       if (parseFloat(p) == 0) {
//                           fee = '...';
//                       } else {
//                           fee = WSAIO_formatMoney(parseFloat(p));
//                       }
//                       subtotal = subtotal + parseFloat(p);
//                   }
//                   var processing_selecor = document.querySelectorAll('.net_additionalFee');
//                   for (var i = 0; i < processing_selecor.length; i++) {
//                       processing_selecor[i].innerText = fee;
//                   }
//                   return subtotal;
//               }
  
//               // update Total price function
//               WSAIO_update_total_price = function() {
//                   var subtotal = WSAIO_subtotal();
//                   var coupon_price = coupon_applied_value;
//                   var shipping_price = -1;
//                   if (WSAIO_generalSetting.additionalFee_enabled) {
//                       var subt = show_Additional_Processing_fee(subtotal);
//                       subtotal = subt;
//                   }
//                   if (typeof WSAIO_get_shipping_value != 'undefined') {
//                       shipping_price = WSAIO_get_shipping_value();
//                   }
//                   if (free_shipping_coupon_applied) {
//                       shipping_price = 0;
//                   }
//                   var Total_price = subtotal - coupon_price;
//                   if (shipping_price > -1 && netTerm_page_tab == 'shipping') {
//                       Total_price += shipping_price;
//                   }
//                   Total_price = WSAIO_formatMoney(Total_price);
//                   if (typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && typeof WSAIO_formatMoney != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
//                       Total_price = WSAIO.change_currency_sign(Total_price);
//                       document.querySelector('.NetTerm_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] + '</span>' + ' ' + Total_price;
//                       document.querySelector('.new_net_mobile_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] + '</span>' + ' ' + Total_price;
//                   } else {
//                       document.querySelector('.NetTerm_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + window.Shopify.currency.active + '</span>' + ' ' + Total_price;
//                       document.querySelector('.new_net_mobile_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + window.Shopify.currency.active + '</span>' + ' ' + Total_price;
//                   }
  
//               }
  
//               if (typeof show_default_shipping_address != 'undefined' && show_default_shipping_address != null && show_default_shipping_address) {
//                   if (delivery_options == 'only_shipping' || delivery_options == 'pickup_and_shipping_dshipping') {
//                       var event = new Event('change');
//                       if (document.querySelector('.new_shipping_auto_address') != null) {
//                           document.querySelector('.new_shipping_auto_address').value = 'default';
//                           setTimeout(function() {
//                               document.querySelector('.new_shipping_auto_address').dispatchEvent(event);
//                           })
//                       }
//                   }
//               }
  
//               WSAIO.run_wholesale_app_code = function(pre_response) {
//                   setTimeout(function() {
//                       WSAIO_update_total_price()
//                   }, 200);
//               }
  
//               // call app function
//               if (typeof WSAIO.preCheckout != 'undefined') {
//                   WSAIO.NetTerm_version = 1.1;
//                   WSAIO.preCheckout();
//                   WSAIO_update_total_price();
//               } else {
//                   setTimeout(function() {
//                       WSAIO_update_total_price()
//                   }, 200);
//               }
  
//               // Get Discount response
//               WSAIO.pre_response = function(pre_response) {
//                   if (typeof WSAIO.run_wholesale_app_code != 'undefined' && typeof WSAIO.run_wholesale_app_code === 'function') {
//                       WSAIO.run_wholesale_app_code(pre_response);
//                   }
//               }
//               ;
  
//               // ============================= Coupon code apply function  =============================
//               function show_coupon_loader() {
//                   var btn_hide = document.querySelectorAll('[name="new_wsaio--discount-code-btns"]');
//                   for (var i = 0; i < btn_hide.length; i++) {
//                       btn_hide[i].style.display = 'none';
//                   }
//                   var loader_show = document.querySelectorAll('.discount_code_loader');
//                   for (var i = 0; i < loader_show.length; i++) {
//                       loader_show[i].style.display = 'inline-block';
//                   }
//               }
//               function hide_coupon_loader() {
//                   var btn_hide = document.querySelectorAll('[name="new_wsaio--discount-code-btns"]');
//                   for (var i = 0; i < btn_hide.length; i++) {
//                       btn_hide[i].style.display = 'inline-block';
//                   }
//                   var loader_show = document.querySelectorAll('.discount_code_loader');
//                   for (var i = 0; i < loader_show.length; i++) {
//                       loader_show[i].style.display = 'none';
//                   }
//               }
//               function apply_coupon() {
//                   if (WSAIO["debugger"]) {
//                       debugger ;
//                   }
//                   var new_coupon_error = document.querySelectorAll('.new_coupon_error');
//                   for (var i = 0; i < new_coupon_error.length; i++) {
//                       new_coupon_error[i].style.display = 'none';
//                   }
//                   show_coupon_loader();
//                   var _this = this;
//                   var coupon_value = this.closest('.new_wsaio--coupon-code-forms').querySelector('[name="new_wsaio--discount-code-fields"]').value;
//                   let xhr = new XMLHttpRequest();
//                   xhr.open("POST", WSAIO.App.checkoutURL + "/discount-code");
//                   xhr.setRequestHeader("Accept", "application/json");
//                   xhr.setRequestHeader("Content-Type", "application/json");
//                   xhr.onreadystatechange = function() {
//                       if (xhr.readyState === 4) {
//                           var coupon_response = JSON.parse(xhr.responseText);
//                           if (coupon_response.status == 0) {
//                               var new_coupon_error = document.querySelectorAll('.new_coupon_error');
//                               for (var i = 0; i < new_coupon_error.length; i++) {
//                                   new_coupon_error[i].style.display = 'block';
//                               }
//                               hide_coupon_loader()
//                           } else {
//                               WSAIO.application = coupon_response;
//                               if ("undefined" !== typeof coupon_response.wholesale_key) {
//                                   document.querySelector('.NetTerm_div .coupon_text').textContent = coupon_response.coupon_code;
//                                   document.querySelector('.new_net_mobile_div .coupon_text').textContent = coupon_response.coupon_code;
//                                   document.querySelector('.NetTerm_div .applied_coupon_text').textContent = coupon_response.coupon_code;
//                                   document.querySelector('.new_net_mobile_div .applied_coupon_text').textContent = coupon_response.coupon_code;
//                                   document.querySelector('.NetTerm_div .new_coupon_label_div').style.display = 'inline-flex';
//                                   document.querySelector('.new_net_mobile_div  .new_coupon_label_div').style.display = 'inline-flex';
//                                   document.querySelector('.NetTerm_div .applied_coupon_line').style.display = 'inline';
//                                   document.querySelector('.new_net_mobile_div  .applied_coupon_line').style.display = 'inline';
//                                   _this.closest('.new_wsaio--coupon-code-forms').querySelector('[name="new_wsaio--discount-code-fields"]').value = '';
//                               }
  
//                               var subtotal_for_coupon = -1;
//                               var WSAIO_cart_data = WSAIO_cart_item();
  
//                               if (WSAIO.product_collections != undefined && WSAIO.product_collections.length > 0) {
//                                   if (coupon_response.applies_to == 'collections') {
//                                       function removeDuplicates() {
//                                           books = WSAIO.product_collections,
//                                           jsonObject = books.map(JSON.stringify);
//                                           uniqueSet = new Set(jsonObject);
//                                           uniqueArray = Array.from(uniqueSet).map(JSON.parse);
//                                           WSAIO.product_collections = uniqueArray;
//                                       }
//                                       removeDuplicates();
//                                       var coupon_collection_ids = coupon_response.price_rule.entitled_collection_ids;
//                                       coupon_collection_ids.forEach(function(e, i) {
//                                           for (var j = 0; j < WSAIO.product_collections.length; j++) {
//                                               if (WSAIO.product_collections[j].collection_id == e) {
//                                                   var item_indx_found = WSAIO_cart_data.findIndex(function(f, r) {
//                                                       return WSAIO.product_collections[j].product_id == f.product_id
//                                                   })
//                                                   if (item_indx_found > -1) {
//                                                       var item_subtotal = get_line_price(WSAIO_cart_data, item_indx_found);
//                                                       if (item_subtotal != undefined) {
//                                                           subtotal_for_coupon = subtotal_for_coupon + item_subtotal;
//                                                       }
//                                                   }
//                                               }
//                                           }
//                                       })
//                                   }
//                               }
//                               if (coupon_response.applies_to == 'variants') {
//                                   var coupon_variants_ids = coupon_response.price_rule.entitled_variant_ids;
//                                   coupon_variants_ids.forEach(function(e, i) {
//                                       var item_indx_found = WSAIO_cart_data.findIndex(function(f, r) {
//                                           return e == f.id
//                                       })
//                                       if (item_indx_found > -1) {
//                                           var item_subtotal = get_line_price(WSAIO_cart_data, item_indx_found);
//                                           if (item_subtotal != undefined) {
//                                               subtotal_for_coupon = subtotal_for_coupon + item_subtotal;
//                                           }
//                                       }
//                                   })
//                               }
//                               if (coupon_response.applies_to == 'products') {
//                                   var coupon_product_ids = coupon_response.price_rule.entitled_product_ids;
//                                   coupon_product_ids.forEach(function(e, i) {
//                                       var item_indx_found = WSAIO_cart_data.findIndex(function(f, r) {
//                                           return e == f.product_id
//                                       })
//                                       if (item_indx_found > -1) {
//                                           var item_subtotal = get_line_price(WSAIO_cart_data, item_indx_found);
//                                           if (item_subtotal != undefined) {
//                                               subtotal_for_coupon = subtotal_for_coupon + item_subtotal;
//                                           }
//                                       }
//                                   })
//                               }
//                               if (coupon_response.price_rule.value_type == 'percentage' && !coupon_response.free_shipping) {
//                                   var percent = parseFloat(coupon_response.price_rule.value)
//                                   var subtotal = 0;
//                                   if (subtotal_for_coupon != -1) {
//                                       subtotal_for_coupon = subtotal_for_coupon + 1;
//                                       subtotal = (subtotal_for_coupon / 100) * percent;
//                                       coupon_applied_value = subtotal;
//                                       document.querySelector('.NetTerm_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
//                                       document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
//                                   } else {
//                                       subtotal = (WSAIO_originalSubtotal() / 100) * percent;
//                                       coupon_applied_value = subtotal;
//                                       document.querySelector('.NetTerm_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
//                                       document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
//                                   }
//                               } else {
//                                   var price = parseFloat(coupon_response.price_rule.value)
//                                   if (coupon_response.free_shipping) {
//                                       free_shipping_coupon_applied = true;
//                                       coupon_applied_value = 0;
//                                       WSAIO_show_shipping_value();
//                                       document.querySelector('.NetTerm_div .new_net--coupon_deduct').textContent = 'Free Shipping';
//                                       document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').textContent = 'Free Shipping';
//                                   } else {
//                                       coupon_applied_value = parseFloat(price);
//                                       document.querySelector('.NetTerm_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(price));
//                                       document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(price));
//                                   }
//                               }
  
//                               // show total price in information page
//                               WSAIO_update_total_price();
//                               hide_coupon_loader();
//                           }
//                           _this.setAttribute("disabled", "disabled");
//                           _this.style.opacity = "0.2";
//                       }
//                   }
//                   ;
//                   let data = {
//                       cart: cart,
//                       shopInfo: WSAIO.shopInfo,
//                       customer: WSAIO.customer,
//                       coupon_code: coupon_value,
//                       products_with_collections: WSAIO.product_collections || []
//                   }
//                   xhr.send(JSON.stringify(data));
//               }
  
//               const click_coupon_btn1 = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-btns"]');
//               if (click_coupon_btn1 != null) {
//                   click_coupon_btn1.addEventListener('click', apply_coupon);
//               }
//               const click_coupon_btn2 = document.querySelector('.new_net_mobile_div [name="new_wsaio--discount-code-btns"]');
//               if (click_coupon_btn2) {
//                   click_coupon_btn2.addEventListener('click', apply_coupon);
//               }
  
//               // ============================= Coupon code remove function  =============================
//               function remove_coupon() {
//                   document.querySelector('.NetTerm_div .coupon_text').textContent = '';
//                   document.querySelector('.new_net_mobile_div .coupon_text').textContent = '';
//                   document.querySelector('.NetTerm_div .applied_coupon_text').textContent = '';
//                   document.querySelector('.new_net_mobile_div .applied_coupon_text').textContent = '';
//                   document.querySelector('.NetTerm_div .new_coupon_label_div').style.display = 'none';
//                   document.querySelector('.new_net_mobile_div  .new_coupon_label_div').style.display = 'none';
//                   document.querySelector('.NetTerm_div .applied_coupon_line').style.display = 'none';
//                   document.querySelector('.new_net_mobile_div  .applied_coupon_line').style.display = 'none';
//                   coupon_applied_value = 0;
//                   // update total price in information page
//                   WSAIO_update_total_price();
//                   WSAIO.application = {};
//                   free_shipping_coupon_applied = false;
//                   WSAIO_show_shipping_value();
//               }
  
//               const remove_coupon_btn1 = document.querySelector('.NetTerm_div .remove_coupon');
//               remove_coupon_btn1.addEventListener('click', remove_coupon);
//               const remove_coupon_btn2 = document.querySelector('.new_net_mobile_div .remove_coupon');
//               remove_coupon_btn2.addEventListener('click', remove_coupon);
  
//               // ============================= show shipping page function  =============================
  
//               // Show Shipping value function 
//               WSAIO_show_shipping_value = function() {
//                   if (free_shipping_coupon_applied) {
//                       var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
//                       for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
//                           new_netTerm_shipping_selector[j].textContent = 'free';
//                       }
//                   } else {
//                       var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
//                       if (new_netTerm_shipping.length) {
//                           for (i = 0; i < new_netTerm_shipping.length; i++) {
//                               if (new_netTerm_shipping[i].checked) {
//                                   var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
//                                   for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
//                                       if (new_netTerm_shipping[i].value == 0) {
//                                           new_netTerm_shipping_selector[j].textContent = 'free';
//                                       } else {
//                                           new_netTerm_shipping_selector[j].innerHTML = check_formate(new_netTerm_shipping[i].getAttribute('ship_pri'));
//                                       }
//                                   }
//                               }
//                           }
//                       } else {
//                           var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
//                           for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
//                               new_netTerm_shipping_selector[j].textContent = 'Calculé à létape suivante';
//                           }
//                       }
//                   }
//                   setTimeout(function() {
//                       WSAIO_update_total_price()
//                   }, 200);
//               }
  
//               var shipping_rows_event = document.querySelectorAll('.new_net_shipping_method_input_div');
//               for (i = 0; i < shipping_rows_event.length; i++) {
//                   shipping_rows_event[i].addEventListener('click', function(e) {
//                       e.target.previousElementSibling.checked = true;
//                       WSAIO_show_shipping_value()
//                   })
//               }
  
//               // Show Shipping value function 
//               WSAIO_get_shipping_value = function() {
//                   var value = -1;
//                   var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
//                   for (i = 0; i < new_netTerm_shipping.length; i++) {
//                       if (new_netTerm_shipping[i].checked) {
//                           value = parseFloat(new_netTerm_shipping[i].getAttribute('ship_pri'));
//                       }
  
//                   }
//                   return value;
//               }
  
//               //  Shipping radio button trigger function 
//               WSAIO_change_shipping = function() {
//                   var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
//                   for (i = 0; i < new_netTerm_shipping.length; i++) {
//                       new_netTerm_shipping[i].addEventListener('click', function() {
//                           WSAIO_show_shipping_value();
//                       });
//                   }
//               }
  
//               // Show Shipping box function 
  
//               WSAIO_show_shipping_box = function() {
//                   if (document.querySelector('.new_net_shipping_method_input_div') != null) {
//                       document.querySelector('.new_net_shipping_method_input_div').remove();
//                   }
  
//                   // show wholesale shipping in box
//                   if (WSAIO_show_wholesale_shipping && typeof WSAIO.applied_shipping != 'undefined' && WSAIO.applied_shipping.apply_shipping_charges) {
//                       var ship_value = WSAIO.applied_shipping.shipping_line.price;
//                       if (WSAIO_hide_freeShipping && ship_value != 0) {
//                           var ship_price = null;
//                           if (typeof window.market_rate != 'undefined' && window.market_rate != 0 && window.market_rate != null) {
//                               ship_value = Math.ceil(parseFloat(ship_value) * window.market_rate);
//                           }
//                           if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
//                               ship_price = WSAIO.change_currency_sign(WSAIO_formatMoney(ship_value));
//                           } else {
//                               ship_price = WSAIO_formatMoney(ship_value);
//                           }
//                           document.querySelector('.new_net_shipping_method_box').innerHTML = '<div class="new_w-100 new_net_shipping_method_input_div wholesale_ship"> <input type="radio" type_of_shipping="Wholesale" class="new_net_shipping_method_input" name="new_netTerm_shipping" ship_pri="' + ship_value + '" value="' + ship_value + '" title="Wholesale Shipping" style="pointer-events: auto; cursor: pointer;"> <label for="wholesale_flate_rate">Flat rate shipping</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>'
//                       } else {
//                           if (!WSAIO_hide_freeShipping) {
//                               if (ship_value == 0) {
//                                   document.querySelector('.new_net_shipping_method_box').innerHTML = '<div class="new_w-100 new_net_shipping_method_input_div wholesale_ship"> <input type="radio" type_of_shipping="Wholesale" class="new_net_shipping_method_input" name="new_netTerm_shipping" ship_pri="' + ship_value + '" value="' + ship_value + '" title="Wholesale Shipping" style="pointer-events: auto; cursor: pointer;"> <label for="wholesale_flate_rate">Flat rate shipping</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>free</b></span> </div>'
//                               } else {
//                                   var ship_price = null;
//                                   if (typeof window.market_rate != 'undefined' && window.market_rate != 0 && window.market_rate != null) {
//                                       ship_value = Math.ceil(parseFloat(ship_value) * window.market_rate);
//                                   }
//                                   if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
//                                       ship_price = WSAIO.change_currency_sign(WSAIO_formatMoney(ship_value));
//                                   } else {
//                                       ship_price = WSAIO_formatMoney(ship_value);
//                                   }
//                                   document.querySelector('.new_net_shipping_method_box').innerHTML = '<div class="new_w-100 new_net_shipping_method_input_div wholesale_ship"> <input type="radio" type_of_shipping="Wholesale" class="new_net_shipping_method_input" name="new_netTerm_shipping" ship_pri="' + ship_value + '" value="' + ship_value + '" title="Wholesale Shipping" style="pointer-events: auto; cursor: pointer;"> <label for="wholesale_flate_rate">Flat rate shipping</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>'
//                               }
//                           }
//                       }
//                       if (document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type') != null) {
//                           document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type').checked = true;
//                       }
//                   }
  
//                   var is_shopify_error = '';
  
//                   // show Shopify shipping in box
//                   if (WSAIO_show_shopify_shipping) {
//                       shopify_shipping_request = 2;
//                       function show_shopify_shipping(rates) {
//                           if (document.querySelector('.shopify_ship') != null) {
//                               var ship_selector = document.querySelectorAll('.shopify_ship');
//                               for (i = 0; i < ship_selector.length; i++) {
//                                   ship_selector[i].remove();
//                               }
//                           }
//                           rates.forEach(function(e) {
//                               var shipping_pri = e.price;
//                               var shipping_val = e.price;
//                               if (shipping_pri != 0) {
//                                   if (typeof Shopify != 'undefined' && typeof Shopify.currency != 'undefined' && typeof Shopify.currency.active != 'undefined' && typeof WSAIO.shopInfo.currency != 'undefined') {
//                                       if (typeof window.market_rate != 'undefined' && window.market_rate != 0 && window.market_rate != null) {
//                                           shipping_pri = (parseFloat(shipping_pri) * window.market_rate).toFixed(2);
//                                           shipping_val = (parseFloat(shipping_val) * window.market_rate).toFixed(2);
//                                       } else {
//                                           if (WSAIO.shopInfo.currency != Shopify.currency.active) {
//                                               shipping_pri = (parseFloat(10.59) * Shopify.currency.rate).toFixed(2)
//                                           }
//                                       }
//                                   }
//                               }
//                               var ship_price = null;
//                               if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
//                                   ship_price = WSAIO.change_currency_sign(WSAIO_formatMoney(shipping_pri));
//                               } else {
//                                   ship_price = WSAIO_formatMoney(shipping_pri);
//                               }
//                               if (shipping_pri != 0) {
//                                   document.querySelector('.new_net_shipping_method_box').innerHTML += '<div class="new_w-100 new_net_shipping_method_input_div shopify_ship"> <input type="radio" type_of_shipping="' + e.name + '" class="new_net_shipping_method_input " name="new_netTerm_shipping" ship_pri="' + shipping_pri + '" value="' + shipping_val + '" title="Shopify Shipping"> <label for="' + e.name + '">' + e.presentment_name + '</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>';
//                               } else {
//                                   if (!WSAIO_hide_freeShipping)
//                                       document.querySelector('.new_net_shipping_method_box').innerHTML += '<div class="new_w-100 new_net_shipping_method_input_div shopify_ship"> <input type="radio" type_of_shipping="' + e.name + '" class="new_net_shipping_method_input " name="new_netTerm_shipping" ship_pri="' + shipping_pri + '" value="' + shipping_val + '" title="Shopify Shipping"> <label for="' + e.name + '">' + e.presentment_name + '</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>';
//                               }
//                           })
//                           if (document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type') != null) {
//                               document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type').checked = true;
//                           }
//                           shopify_shipping_request = 3;
//                           WSAIO.show_shipping_page();
//                       }
  
//                       function show_shopify_shipping_without_rates() {
//                           shopify_shipping_request = 3;
//                           WSAIO.show_shipping_page();
//                       }
  
//                       function stop_checking_shipping() {
//                           document.querySelector('.continue_loader').style.display = 'none';
//                           document.querySelector('.continue_shipping').style.display = 'block';
//                           document.querySelector('[name="new_waioaddress[zip]"]').style.cssText = 'border:1px solid #b10d0dad !important';
//                           if (document.querySelector('.waio_netAddress_error') != null) {
//                               document.querySelector('.waio_netAddress_error').remove();
//                           }
//                           document.querySelector('.new_netterm_countries.ship_field').insertAdjacentHTML("afterend", '<p class="waio_netAddress_error" style="color: #b10d0dad !important; float: right; max-width: 178px; padding-bottom: 10px;">' + is_shopify_error + '</p>');
//                       }
//                       var outer_counter_trigger = 0;
//                       function run_prepare_shipping_request() {
//                           let xhr1 = new XMLHttpRequest();
//                           xhr1.open("POST", WSAIO.shopInfo.url + "/cart/prepare_shipping_rates");
//                           xhr1.setRequestHeader("Accept", "application/json");
//                           xhr1.setRequestHeader("Content-Type", "application/json");
//                           xhr1.onload = function(ee) {
//                               if (this.readyState === 4 && (this.status === 200 || this.status === 202)) {
//                                   var res = JSON.parse(xhr1.response);
//                                   if (typeof res != 'undefined' && res != null && typeof res.zip != 'undefined' && typeof res.zip[0] != 'undefined') {
//                                       is_shopify_error = res.zip[0];
//                                       if (is_shopify_error != '') {
//                                           stop_checking_shipping()
//                                           return false;
//                                       }
//                                   }
//                                   var counter_trigger = 0;
//                                   function get_shipping_rates() {
//                                       setTimeout(function() {
//                                           const xhr = new XMLHttpRequest();
//                                           xhr.open("GET", WSAIO.shopInfo.url + "/cart/async_shipping_rates");
//                                           xhr.send();
//                                           xhr.onload = function(e) {
//                                               if (this.readyState === 4 && (this.status === 200 || this.status === 202)) {
//                                                   var response2 = JSON.parse(xhr.responseText);
//                                                   if (response2 != null && response2.shipping_rates != undefined) {
//                                                       var shipping_rates_avalaible = response2.shipping_rates;
//                                                       show_shopify_shipping(shipping_rates_avalaible)
//                                                   } else {
//                                                       if (outer_counter_trigger == 0) {
//                                                           outer_counter_trigger++;
//                                                           setTimeout(function() {
//                                                               run_prepare_shipping_request();
//                                                           }, 1000)
//                                                       } else if (counter_trigger == 0) {
//                                                           counter_trigger++;
//                                                           setTimeout(function() {
//                                                               get_shipping_rates();
//                                                           }, 1000)
//                                                       } else {
//                                                           show_shopify_shipping_without_rates();
//                                                       }
//                                                   }
//                                               } else {
//                                                   show_shopify_shipping_without_rates();
//                                               }
//                                           }
//                                       }, 1500)
//                                   }
//                                   get_shipping_rates();
//                               } else if (this.status === 422) {
//                                   var res = JSON.parse(xhr1.response);
//                                   if (typeof res != 'undefined' && res != null && typeof res.zip != 'undefined' && typeof res.zip[0] != 'undefined') {
//                                       is_shopify_error = res.zip[0];
//                                       if (is_shopify_error != '') {
//                                           stop_checking_shipping()
//                                           return false;
//                                       }
//                                   }
//                               } else {
//                                   if (outer_counter_trigger == 0) {
//                                       outer_counter_trigger++;
//                                       setTimeout(function() {
//                                           run_prepare_shipping_request();
//                                       }, 1000)
//                                   } else {
//                                       show_shopify_shipping_without_rates();
//                                   }
//                               }
  
//                           }
//                           let data = {};
//                           data.zip = document.querySelector('[name="new_waioaddress[zip]"]').value;
//                           data.country = countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value];
//                           data.province = document.querySelector('[name="new_waioaddress[provice]"]').value;
//                           xhr1.send(JSON.stringify({
//                               shipping_address: data
//                           }));
//                       }
//                       run_prepare_shipping_request();
//                   }
  
//                   if (!WSAIO_show_shopify_shipping) {
//                       WSAIO.show_shipping_page();
//                   }
  
//               }
  
//               // function show_shipping_page(){
//               WSAIO.show_shipping_page = function(e) {
//                   if ((shopify_shipping_request == 1 || shopify_shipping_request == 3)) {
//                       document.querySelector('.new_net-detail-div ').style.display = 'none';
//                       document.querySelector('.net-shipping-div').style.display = 'block';
//                       document.querySelector('[name="new_waioaddress[zip]"]').style.cssText = '1px solid #d9d9d9 !important';
//                       if (document.querySelector('.waio_netAddress_error') != null) {
//                           document.querySelector('.waio_netAddress_error').remove();
//                       }
//                       netTerm_page_tab = 'shipping';
//                       var new_place_order_btn = document.querySelectorAll('.new_place_order');
//                       for (j = 0; j < new_place_order_btn.length; j++) {
//                           new_place_order_btn[j].setAttribute('disabled', 'disabled');
//                           new_place_order_btn[j].style.backgroundColor = 'gray';
//                       }
//                       var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
//                       for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
//                           new_netTerm_shipping_selector[j].textContent = 'Calculating...';
//                       }
//                       setTimeout(function() {
//                           document.querySelector('.new_net_shipping_method_box').style.display = 'block';
//                           document.querySelector('.new_net_shipping_loader').style.display = 'none';
//                           WSAIO_show_shipping_value();
//                           WSAIO_change_shipping();
//                           setTimeout(function() {
//                               if (document.querySelector('.new_net_shipping_method_box').textContent == ' ') {
//                                   document.querySelector('.new_net_shipping_method_box').innerHTML = '<p style=" text-align: center; padding: 30px; ">Aucun tarif dexpédition trouvé pour cette adresse..</p>';
//                               }
//                           }, 500)
//                           for (j = 0; j < new_place_order_btn.length; j++) {
//                               new_place_order_btn[j].removeAttribute("disabled");
//                               new_place_order_btn[j].style.backgroundColor = 'black';
//                           }
//                           if (document.querySelector('.new_net_shipping_method_input_div') != null) {
//                               var shipping_rows_event = document.querySelectorAll('.new_net_shipping_method_input_div');
//                               for (i = 0; i < shipping_rows_event.length; i++) {
//                                   shipping_rows_event[i].addEventListener('click', function(e) {
//                                       if (e.target != this) {
//                                           if (e.target.previousElementSibling != null) {
//                                               e.target.previousElementSibling.checked = true;
//                                           } else if (e.target.parentNode.parentElement.childNodes[1] != null) {
//                                               e.target.parentNode.parentElement.childNodes[1].checked = true;
//                                           }
//                                       } else {
//                                           e.target.childNodes[1].checked = true
//                                       }
//                                       WSAIO_show_shipping_value()
//                                   })
//                               }
//                           }
//                       }, 500);
//                   }
//               }
  
//               WSAIO.check_market_rate = function(e) {
//                   // Update prices based on market settings
//                   window.market_rate = 0;
//                   if (typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.country_currency_code != undefined && typeof WSAIO.Currency.rates != 'undefined' && typeof WSAIO.Currency.rates[WSAIO.shopInfo.currency] != 'undefined') {
//                       if (WSAIO.shopInfo.currency != (WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0])) {
//                           if (WSAIO.customer.default_address.country_code == 'US') {
//                               rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency] / WSAIO.Currency.rates[WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0]]) * 1.015)
//                           } else {
//                               rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency] / WSAIO.Currency.rates[WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0]]) * 1.02)
//                           }
//                           window.market_rate = rate;
//                       }
  
//                   }
//               }
  
//               // check available shipping
  
//               WSAIO.check_available_shipping = function(e) {
//                   if (document.querySelector('[name="new_waioaddress[country] "]').value == 'default') {
//                       document.querySelector('[name="new_waioaddress[country] "]').style.cssText = 'border:1px solid #b10d0dad !important';
//                       if (document.querySelector('.waio_netAddress_error') != null) {
//                           document.querySelector('.waio_netAddress_error').remove();
//                       }
//                       document.querySelector('.new_netterm_countries.ship_field').insertAdjacentHTML("afterend", '<p class="waio_netAddress_error" style="color: #b10d0dad !important; float: left; max-width: 178px; padding-bottom: 10px;">Select a country</p>');
//                       return false;
//                   }
//                   if (!document.querySelector('[name="new_billing_address_same_as_shipping_address"]').checked) {
//                       if (document.querySelector('[name="new_waiobilladdress[country] "]').value == 'default') {
//                           document.querySelector('[name="new_waiobilladdress[country] "]').style.cssText = 'border:1px solid #b10d0dad !important';
//                           if (document.querySelector('.new_billingaddress .waio_netAddress_error') != null) {
//                               document.querySelector('.new_billingaddress .waio_netAddress_error').remove();
//                           }
//                           document.querySelector('.new_billingaddress .new_netterm_countries').insertAdjacentHTML("afterend", '<p class="waio_netAddress_error" style="color: #b10d0dad !important; float: left; max-width: 178px; padding-bottom: 10px;">Select a country</p>');
//                           return false;
//                       }
//                   }
//                   e.preventDefault();
//                   e.stopImmediatePropagation();
  
//                   if (hide_shipping_content) {
//                       document.querySelector('.new_place_loader').style.display = 'block';
//                       document.querySelector('.continue_shipping').style.display = 'none';
//                       setTimeout(function() {
//                           remove_default_note(e);
//                       }, 200)
//                   } else {
//                       WSAIO.check_market_rate();
//                       document.querySelector('.continue_loader').style.display = 'block';
//                       document.querySelector('.continue_shipping').style.display = 'none';
//                       setTimeout(function() {
//                           document.querySelector('.new_customer_address').textContent = document.querySelector('[name="new_waioaddress[address1]"]').value + ',' + document.querySelector('[name="new_waioaddress[city]"]').value + ' ' + document.querySelector('[name="new_waioaddress[provice]"]').value + ' ' + document.querySelector('[name="new_waioaddress[zip]"]').value + ',' + countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value];
//                           WSAIO_show_shipping_box();
//                       }, 200)
//                   }
  
//                   return false;
//               }
  
//               // ============================= show Information function  =============================
  
//               function show_information_page() {
//                   document.querySelector('.new_net-detail-div ').style.display = 'block';
//                   document.querySelector('.net-shipping-div').style.display = 'none';
//                   document.querySelector('.new_net_shipping_method_box').style.display = 'none';
//                   document.querySelector('.new_net_shipping_loader').style.display = 'block';
//                   netTerm_page_tab = 'information';
//                   if (!free_shipping_coupon_applied) {
//                       var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
//                       for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
//                           new_netTerm_shipping_selector[j].textContent = 'Calculé à létape suivante';
//                       }
//                   }
//                   document.querySelector('.continue_loader').style.display = 'none';
//                   document.querySelector('.continue_shipping').style.display = 'block';
//                   setTimeout(function() {
//                       WSAIO_update_total_price()
//                   }, 100);
//                   var disable_element = document.querySelectorAll('.continue_shipping');
//                   for (var i = 0; i < disable_element.length; i++) {
//                       disable_element[i].removeAttribute('disabled');
//                   }
//                   return false;
//               }
//               const info_update1 = document.querySelector('.new_first_row .new_change_address');
//               const info_update2 = document.querySelector('.new_second_row .new_change_address');
//               const info_update3 = document.querySelector('.net-shipping-div .new_return_information');
//               const info_update4 = document.querySelector('.net-shipping-div .info_link');
//               if (info_update1 != null)
//                   info_update1.addEventListener('click', show_information_page);
//               if (info_update2 != null)
//                   info_update2.addEventListener('click', show_information_page);
//               if (info_update3 != null)
//                   info_update3.addEventListener('click', show_information_page);
//               if (info_update4 != null)
//                   info_update4.addEventListener('click', show_information_page);
  
//               // reset invenory of items if it available quantity is less
//               function reset_inventory() {
//                   var xhttp = new XMLHttpRequest();
//                   xhttp.open("POST", "/cart/update.js", true);
//                   xhttp.setRequestHeader("Accept", "application/json");
//                   xhttp.setRequestHeader("Content-Type", "application/json");
//                   xhttp.onreadystatechange = function() {
//                       if (this.readyState == 4 && this.status == 200) {
//                           window.location.reload();
//                       }
//                   }
//                   var data1 = {
//                       updates: update_items
//                   }
//                   xhttp.send(JSON.stringify(data1));
//               }
  
//               const reset = document.querySelector('.new_net-continue');
//               reset.addEventListener('click', reset_inventory);
  
//               // remove item from less inventory list
//               function remove_item() {
//                   var vid = this.getAttribute('vid');
//                   var obj = {};
//                   obj[vid] = 0;
//                   var xhttp = new XMLHttpRequest();
//                   xhttp.open("POST", "/cart/update.js", true);
//                   xhttp.setRequestHeader("Accept", "application/json");
//                   xhttp.setRequestHeader("Content-Type", "application/json");
//                   xhttp.onreadystatechange = function() {
//                       if (this.readyState == 4 && this.status == 200) {
//                           window.location.reload();
//                       }
//                   }
//                   var data1 = {
//                       updates: obj
//                   }
//                   xhttp.send(JSON.stringify(data1));
//               }
  
//               const remove = document.getElementsByClassName('new_net_remove_item');
//               for (i = 0; i < remove.length; i++) {
//                   remove[i].addEventListener('click', remove_item);
//               }
  
//               if (typeof WSAIO.net_discountMethod != 'undefined' && WSAIO.net_discountMethod != '') {
//                   if (WSAIO.net_discountMethod == 'draft_order') {
//                       netTerm_order_method = 'draft_order';
//                   } else if (WSAIO.net_discountMethod == 'final_order') {
//                       netTerm_order_method = 'final_order';
//                   }
//               }
  
//               function append_shipping_address(shipping_adr, billing_adr) {
//                   if ((delivery_options == 'none' || delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep')) {} else {
//                       var shippingDiv = document.querySelector('.wsaio_shipping_address');
//                       shippingDiv.innerHTML = '';
//                       var billingDiv = document.querySelector('.wsaio_billing_address');
//                       billingDiv.innerHTML = '';
//                       function createAddressLine(value) {
//                           if (value.trim() !== '') {
//                               var p = document.createElement('p');
//                               p.innerHTML = value;
//                               p.style.setProperty('font-size', '13px', 'important');
//                               shippingDiv.appendChild(p);
//                               if (document.querySelector('[name="new_billing_address_same_as_shipping_address"]').checked) {// billingDiv.appendChild(p); 
//                               }
//                           }
//                       }
//                       function createBillingAddressLine(value) {
//                           if (value.trim() !== '') {
//                               var p = document.createElement('p');
//                               p.innerHTML = value;
//                               p.style.setProperty('font-size', '13px', 'important');
//                               billingDiv.appendChild(p);
//                           }
//                       }
//                       // Dynamically create each address line
//                       createAddressLine(shipping_adr.first_name + ' ' + shipping_adr.last_name);
//                       createAddressLine(shipping_adr.company);
//                       createAddressLine(shipping_adr.address1);
//                       createAddressLine(shipping_adr.address2);
//                       createAddressLine(shipping_adr.city);
//                       createAddressLine(shipping_adr.province);
//                       createAddressLine(shipping_adr.zip);
//                       createAddressLine(shipping_adr.country);
//                       createAddressLine(shipping_adr.phone);
  
//                       createBillingAddressLine(billing_adr.first_name + ' ' + billing_adr.last_name);
//                       createBillingAddressLine(billing_adr.company);
//                       createBillingAddressLine(billing_adr.address1);
//                       createBillingAddressLine(billing_adr.address2);
//                       createBillingAddressLine(billing_adr.city);
//                       createBillingAddressLine(billing_adr.province);
//                       createBillingAddressLine(billing_adr.zip);
//                       createBillingAddressLine(billing_adr.country);
//                       createBillingAddressLine(billing_adr.phone);
//                       if (document.querySelector('[name="new_netTerm_shipping"]') != null) {
//                           if (document.querySelector('[name="new_netTerm_shipping"]:checked').getAttribute('type_of_shipping') == 'Wholesale') {
//                               document.querySelector('.waioNt_shipping_method').innerText = 'Flat rate shipping';
//                           } else {
//                               document.querySelector('.waioNt_shipping_method').innerText = document.querySelector('[name="new_netTerm_shipping"]:checked').getAttribute('type_of_shipping');
//                           }
//                       }
//                       var shippingInfoElements = document.querySelectorAll('.waioNT_shipping_info');
//                       shippingInfoElements.forEach(function(element) {
//                           element.style.display = 'block';
//                       });
//                   }
//               }
  
//               // ============================= Place Order function  =============================
//               function place_order() {
//                   var _data = {}
//                     , discount_app = []
//                     , additional_info = {}
//                     , _shipping_charges = true;
//                   _data['cart'] = cart;
//                   _data['shopInfo'] = WSAIO.shopInfo;
//                   _data['customer'] = WSAIO.customer;
//                   _data['user_mode'] = WSAIO.user_mode;
//                   _data["products_with_collections"] = WSAIO.product_collections;
//                   _data["_order_method"] = netTerm_order_method;
//                   if (typeof WSAIO.netTerm_order_tags != 'undefined' && WSAIO.netTerm_order_tags != '') {
//                       _data['tags'] = WSAIO.netTerm_order_tags;
//                   }
  
//                   var note_attr = [];
//                   var shopify_discounts = '';
//                   cart.items.findIndex(function(indx, count) {
//                       if (indx.discounts != undefined && indx.discounts != null && indx.discounts.length > 0) {
//                           $(indx.discounts).each(function(discount_itr) {
//                               if (shopify_discounts.indexOf(indx.discounts[discount_itr].title) == -1) {
//                                   if (shopify_discounts != '')
//                                       shopify_discounts = shopify_discounts + ' , ';
//                                   shopify_discounts = shopify_discounts + indx.discounts[discount_itr].title;
//                               }
//                           })
//                       }
//                   })
//                   if (shopify_discounts != '') {
//                       note_attr.push({
//                           "name": 'Shopify Automatic Discount',
//                           "value": shopify_discounts
//                       });
//                       _data['note_attributes'] = note_attr;
//                   }
  
//                   // App shipping pass value
//                   var shipping_type = ''
//                     , app_shipping_param = {}
//                     , _custom_shipping = {}
//                     , custom_shipping_price = 0
//                     , custom_shipping_title = '';
//                   if (delivery_options != 'only_pickup') {
//                       var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
  
//                       _data['app_shipping_charges'] = false;
//                       _data['shipping_charges'] = app_shipping_param;
//                       _data['custom_shipping_line'] = _custom_shipping;
//                       for (i = 0; i < new_netTerm_shipping.length; i++) {
//                           if (new_netTerm_shipping[i].checked) {
//                               shipping_type = new_netTerm_shipping[i].getAttribute('title');
//                               custom_shipping_price = new_netTerm_shipping[i].getAttribute('value');
//                               custom_shipping_title = new_netTerm_shipping[i].getAttribute('type_of_shipping');
//                           }
  
//                       }
//                       if (free_shipping_coupon_applied) {
//                           if (typeof WSAIO.application != 'undefined') {
//                               _custom_shipping.custom = true;
//                               _custom_shipping.price = 0;
//                               _custom_shipping.title = 'Coupon:' + WSAIO.application.coupon_code;
//                               _data['custom_shipping_line'] = _custom_shipping;
//                           }
//                       } else {
//                           if (shipping_type == 'Wholesale Shipping') {
//                               app_shipping_param['price'] = WSAIO.applied_shipping.shipping_line.price;
//                               app_shipping_param['title'] = WSAIO.applied_shipping.shipping_line.title;
//                               _data['app_shipping_charges'] = WSAIO.applied_shipping.apply_shipping_charges;
//                               _data['shipping_charges'] = app_shipping_param;
//                           } else if (shipping_type == 'Shopify Shipping') {
//                               _custom_shipping.custom = true;
//                               _custom_shipping.price = custom_shipping_price;
//                               _custom_shipping.title = custom_shipping_title;
//                               _data['custom_shipping_line'] = _custom_shipping;
//                           }
//                       }
  
//                   }
  
//                   // additional info => PO,Shipping note etc value pass
//                   if (enable_nerterm_PO) {
//                       additional_info['Purchase_Order(PO)'] = document.querySelector('[name="PO"]').value;
//                   }
//                   if (document.querySelector('[name="new_shipping_notes"]').value != '' && document.querySelector('[name="new_shipping_notes"]').value != 'null') {
//                       additional_info["Order Note"] = document.querySelector('[name="new_shipping_notes"]').value;
//                   }
  
//                   // Delivery address value pass
//                   if (delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep') {
//                       if (document.querySelector('[name="new_pickup_address"]').innerText != '') {
//                           additional_info['Pickup Address'] = document.querySelector('[name="new_pickup_address"]').innerText;
//                       }
//                   }
  
//                   // Delivery options value pass
//                   if (delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep') {
//                       additional_info['Delivery Option'] = 'Pickup';
//                   }
  
//                   // delivery date value pass
//                   if (enable_new_delivery_date && (delivery_options != 'only_pickup' && delivery_options != 'pickup_and_shipping_dpickep' && delivery_options != 'none')) {
//                       additional_info['Delivery Date'] = document.querySelector('[name="new_delivery_date"]').value;
//                   }
  
//                   // payment option value pass
//                   if (enable_nerterm_options && document.querySelector('[name="new_payment"]') != null) {
//                       additional_info['Payment Option'] = document.querySelector('[name="new_payment"]').value;
//                   }
  
//                   _data['additional_info'] = additional_info;
  
//                   // sku value pass
//                   if (WSAIO.variant_sku_are_same) {
//                       _data["variant_sku_are_same"] = WSAIO.variant_sku_are_same;
//                   }
  
//                   // coupon value pass
//                   var discount_app = [];
//                   if (typeof WSAIO.application != 'undefined') {
//                       discount_app = WSAIO.application;
//                   }
//                   _data["discount_code_application"] = discount_app;
  
//                   // shipping address value pass 
//                   if ((delivery_options == 'none' || delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep')) {
//                       var shipping_address = {};
//                       document.querySelector('.net-shipping-div').style.display = 'none';
//                   } else {
//                       var shipping_address = {
//                           "address1": document.querySelector('[name="new_waioaddress[address1]"]').value,
//                           "address2": document.querySelector('[name="new_waioaddress[address2]"]').value,
//                           "city": document.querySelector('[name="new_waioaddress[city]"]').value,
//                           "company": document.querySelector('[name="new_waioaddress[company]"]').value,
//                           "country": countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value],
//                           "first_name": document.querySelector('[name="new_waioaddress[first_name]"]').value,
//                           "last_name": document.querySelector('[name="new_waioaddress[last_name]"]').value,
//                           "latitude": "",
//                           "longitude": "",
//                           "phone": document.querySelector('[name="new_waioaddress[phone]"]').value,
//                           "province": document.querySelector('[name="new_waioaddress[provice]"]').value,
//                           "zip": document.querySelector('[name="new_waioaddress[zip]"]').value,
//                           "name": "",
//                           "country_code": document.querySelector('[name="new_waioaddress[country] "]').value,
//                           "province_code": document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex] ? document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex].getAttribute('code') : ""
//                       }
//                       _data['shipping_address'] = shipping_address;
//                   }
  
//                   // Billing address value pass
//                   if ((delivery_options == 'none' || delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep')) {
//                       var billing_address = {};
//                   } else {
//                       if (!document.querySelector('[name="new_billing_address_same_as_shipping_address"]').checked) {
//                           var billing_address = {
//                               "address1": document.querySelector('[name="new_waiobilladdress[address1]"]').value,
//                               "address2": document.querySelector('[name="new_waiobilladdress[address2]"]').value,
//                               "city": document.querySelector('[name="new_waiobilladdress[city]"]').value,
//                               "company": document.querySelector('[name="new_waiobilladdress[company]"]').value,
//                               "country": countries_based_on_code[document.querySelector('[name="new_waiobilladdress[country] "]').value],
//                               "first_name": document.querySelector('[name="new_waiobilladdress[first_name]"]').value,
//                               "last_name": document.querySelector('[name="new_waiobilladdress[last_name]"]').value,
//                               "latitude": "",
//                               "longitude": "",
//                               "phone": document.querySelector('[name="new_waiobilladdress[phone]"]').value,
//                               "province": document.querySelector('[name="new_waiobilladdress[provice]"]').value,
//                               "zip": document.querySelector('[name="new_waiobilladdress[zip]"]').value,
//                               "name": "",
//                               "country_code": document.querySelector('[name="new_waiobilladdress[country] "]').value,
//                               "province_code": document.querySelector('[name="new_waiobilladdress[provice]"]')[document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex] ? document.querySelector('[name="new_waiobilladdress[provice]"]')[document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex].getAttribute('code') : ""
//                           }
//                           _data['billing_address'] = billing_address;
//                       } else {
//                           additional_info["Billing_Address"] = "same as shipping";
//                           var billing_address = {
//                               "address1": document.querySelector('[name="new_waioaddress[address1]"]').value,
//                               "address2": document.querySelector('[name="new_waioaddress[address2]"]').value,
//                               "city": document.querySelector('[name="new_waioaddress[city]"]').value,
//                               "company": document.querySelector('[name="new_waioaddress[company]"]').value,
//                               "country": countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value],
//                               "first_name": document.querySelector('[name="new_waioaddress[first_name]"]').value,
//                               "last_name": document.querySelector('[name="new_waioaddress[last_name]"]').value,
//                               "latitude": "",
//                               "longitude": "",
//                               "phone": document.querySelector('[name="new_waioaddress[phone]"]').value,
//                               "province": document.querySelector('[name="new_waioaddress[provice]"]').value,
//                               "zip": document.querySelector('[name="new_waioaddress[zip]"]').value,
//                               "name": "",
//                               "country_code": document.querySelector('[name="new_waioaddress[country] "]').value,
//                               "province_code": document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex] ? document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex].getAttribute('code') : ""
//                           }
//                           _data['billing_address'] = billing_address;
//                       }
//                   }
  
//                   // dynamic currency code 
//                   try {
//                       /* send presentment_currency if enabled */
//                       if (WSAIO.selectedCurrency() != '' && WSAIO.selectedCurrency() !== 'undefined') {
//                           var presentment_currency_rate = parseFloat(window.Currency.rates[WSAIO.shopInfo.currency] / window.Currency.rates[WSAIO.selectedCurrency()]) || 1;
//                           /* Append rate in payload to use in server */
//                           _data['presentment_currency'] = {
//                               code: WSAIO.selectedCurrency(),
//                               rate: presentment_currency_rate
//                           };
//                       } else {
//                           if (typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined") {
//                               var presentment_currency_rate = parseFloat(Shopify.currency.rate) || 1;
//                               /* Append rate in payload to use in server */
//                               _data['presentment_currency'] = {
//                                   code: Shopify.currency.active,
//                                   rate: presentment_currency_rate
//                               };
//                           }
//                       }
//                   } catch (e) {
//                       console.log('WSAIO currency rates undefined')
//                   }
//                   if (typeof Shopify !== "undefined" && typeof Shopify.country !== "undefined") {
//                       /* Append country in payload to use in server */
//                       _data['presentment_country'] = Shopify.country;
//                   }
//                   if ((WSAIO.market_selected != undefined && typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.market_selected != WSAIO.customer.default_address.country_code) && WSAIO.country_currency_code != undefined && typeof WSAIO.Currency.rates != 'undefined' && typeof WSAIO.Currency.rates != 'undefined' && typeof WSAIO.Currency.rates[WSAIO.shopInfo.currency] != 'undefined') {
//                       var rate = 0;
//                       var customer_currency = WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
//                       if (customer_currency == WSAIO.shopInfo.currency) {
//                           _data['presentment_currency'] = {
//                               code: WSAIO.shopInfo.currency,
//                               rate: 1
//                           };
//                           _data['presentment_country'] = WSAIO.customer.default_address.country_code;
//                       } else {
//                           if (WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] == Shopify.currency.active) {
//                               rate = Shopify.currency.rate;
//                           } else {
//                               if (WSAIO.shopInfo.currency == 'USD') {
//                                   conversion_fee = 1.015;
//                               } else {
//                                   conversion_fee = 1.02;
//                               }
//                               rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency] / WSAIO.Currency.rates[customer_currency]) * conversion_fee)
//                           }
//                           _data['presentment_currency'] = {
//                               code: customer_currency,
//                               rate: rate
//                           };
//                           _data['presentment_country'] = WSAIO.customer.default_address.country_code;
//                       }
  
//                   }
  
//                   if (typeof Shopify != 'undefined' && typeof Shopify.currency != 'undefined' && typeof Shopify.currency.active != 'undefined') {
//                       _data['active_currency'] = Shopify.currency.active;
//                   }
//                   if (typeof WSAIO.tax_settings !== "undefined" && typeof WSAIO.auto_vat_enable !== "undefined" && WSAIO.auto_vat_enable) {
//                       /* Append tax setting in payload to use in server */
//                       _data['tax_settings'] = WSAIO.tax_settings;
//                   }
  
//                   const loader1 = document.querySelectorAll('.new_place_loader');
//                   for (var i = 0; i < loader1.length; i++) {
//                       loader1[i].style.display = 'block';
//                   }
//                   const place_order_btn11 = document.querySelectorAll('.new_place_order');
//                   for (var i = 0; i < place_order_btn11.length; i++) {
//                       place_order_btn11[i].style.display = 'none';
//                   }
//                   let xhr = new XMLHttpRequest();
//                   xhr.open("POST", app_url + "/net-term/v3");
//                   xhr.setRequestHeader("Accept", "application/json");
//                   xhr.setRequestHeader("Content-Type", "application/json");
//                   xhr.onreadystatechange = function() {
//                       if (xhr.readyState === 4) {
//                           var draft_response = JSON.parse(xhr.responseText);
//                           if (draft_response.status == 0) {
//                               console.log('invalid data or missing something');
//                           } else {
//                               document.querySelector('.new_net-thank-div').style.display = 'block';
//                               append_shipping_address(shipping_address, billing_address);
//                               document.querySelector('.net-shipping-div').style.display = 'none';
//                               document.querySelector('.new_net-detail-div ').style.display = 'none';
//                               if (WSAIO.netTerm.order_method == 'draft_order') {
//                                   document.querySelector('.new_net_order_name').textContent = draft_response.draft_order_info.name;
//                               } else {
//                                   document.querySelector('.new_net_order_name').textContent = 'placed by ' + draft_response.draft_order_info.customer.email;
//                               }
//                               if (typeof draft_response.draft_order_info.isDiscountCodeApplied != 'undefined' && !draft_response.draft_order_info.isDiscountCodeApplied) {
//                                   document.querySelector('.NetTerm_div .remove_coupon').dispatchEvent(new Event('click'));
//                                   document.querySelector('.new_net_mobile_div .remove_coupon').dispatchEvent(new Event('click'));
//                                   if ($('.NetTerm_div .net_discount_error').length == 0) {
//                                       $('.NetTerm_div .new_discount-code-forms').after(`<div class="net_discount_error" style=" border: 1px solid #ffdeb3; background-color: #fff5eb; padding: 10px; font-size: 14px !important; width: 78% !important; margin: 10px auto !important; border-radius: 5px; ">Discount code isn't valid for the items in your cart</div>`)
//                                   }
//                                   if ($('.net_mobile_div .net_discount_error').length == 0) {
//                                       $('.net_mobile_div .new_discount-code-forms').after(`<div class="net_discount_error" style=" border: 1px solid #ffdeb3; background-color: #fff5eb; padding: 10px; font-size: 14px !important; width: 78% !important; margin: 10px auto !important; border-radius: 5px; ">Discount code isn't valid for the items in your cart</div>`)
//                                   }
//                                   var coupon_desktop_btn = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-btns"]');
//                                   var coupon_mobile_btn = document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-btns"]');
//                                   coupon_desktop_btn.setAttribute("disabled", "disabled");
//                                   coupon_desktop_btn.style.opacity = "0.2";
//                                   coupon_mobile_btn.setAttribute("disabled", "disabled");
//                                   coupon_mobile_btn.style.opacity = "0.2";
//                               }
//                               if (document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]') != null) {
//                                   document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]').setAttribute("readonly", "readonly");
//                                   document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-fields"]').setAttribute("readonly", "readonly");
//                               }
//                               var xhttp = new XMLHttpRequest();
//                               xhttp.onreadystatechange = function() {
//                                   if (this.readyState == 4 && this.status == 200) {
//                                       console.log('cart cleared');
//                                   }
//                               }
//                               xhttp.open("POST", "/cart/clear.js", true);
//                               xhttp.send();
//                           }
//                       }
//                   }
//                   let data = _data;
//                   xhr.send(JSON.stringify(data));
  
//               }
//               function remove_default_note(event) {
//                   event.preventDefault();
//                   if (document.querySelector('[name="new_shipping_notes"]').value != '' && document.querySelector('[name="new_shipping_notes"]').value != 'null') {
//                       let xhrr = new XMLHttpRequest();
//                       xhrr.open("POST", "/cart/update.json");
//                       xhrr.setRequestHeader("Accept", "application/json");
//                       xhrr.setRequestHeader("Content-Type", "application/json");
//                       xhrr.onreadystatechange = function() {
//                           if (xhrr.readyState === 4) {
//                               cart = JSON.parse(xhrr.responseText);
//                               place_order()
//                           }
//                       }
//                       ;
//                       let dataa = {
//                           note: ''
//                       };
//                       xhrr.send(JSON.stringify(dataa));
//                   } else {
//                       place_order();
//                   }
//               }
//               const place_order_btn = document.querySelectorAll('.new_place_order');
//               for (var i = 0; i < place_order_btn.length; i++) {
//                   place_order_btn[i].addEventListener('click', remove_default_note);
//               }
  
//           } else {
//               window.location.href = '/cart';
//           }
  
//       }
  
//       // Load net term
//       if (typeof WSAIO.ntCart !== 'undefined') {
//           console.log("NetTerm loaded using WSAIO.ntCart");
//           netTermDesign(WSAIO.ntCart);
//       } else {
//           console.log("NetTerm loaded using cart.json");
//           var xhttp = new XMLHttpRequest();
//           xhttp.open("POST", "/cart", true);
//           xhttp.setRequestHeader("Accept", "application/json");
//           xhttp.setRequestHeader("Content-Type", "application/json");
//           xhttp.onreadystatechange = function() {
//               if (this.readyState == 4 && this.status == 200) {
//                   if (typeof WSAIO != 'undefined') {
//                       netTermDesign(JSON.parse(xhttp.responseText));
//                   }
//               }
//           }
//           xhttp.send();
//       }
  
//   }
//   )();
  
//   },1500)



setTimeout(function(){
    // ---------------------------------------------------------------------------------------------
    //                                         ShopifyCommonJS          
    // ---------------------------------------------------------------------------------------------
    "undefined" == typeof window.Shopify && (window.Shopify = {}),
    Shopify.bind = function(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    ,
    Shopify.setSelectorByValue = function(t, e) {
        for (var n = 0, i = t.options.length; n < i; n++) {
            var o = t.options[n];
            if (e == o.value || e == o.innerHTML)
                return t.selectedIndex = n
        }
    }
    ,
    Shopify.addListener = function(t, e, n) {
        t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent("on" + e, n)
    }
    ,
    Shopify.postLink = function(t, e) {
        var n = (e = e || {}).method || "post"
          , i = e.parameters || {}
          , o = document.createElement("form");
        for (var r in o.setAttribute("method", n),
        o.setAttribute("action", t),
        i) {
            var l = document.createElement("input");
            l.setAttribute("type", "hidden"),
            l.setAttribute("name", r),
            l.setAttribute("value", i[r]),
            o.appendChild(l)
        }
        document.body.appendChild(o),
        o.submit(),
        document.body.removeChild(o)
    }
    ,
    Shopify.CountryProvinceSelector = function(t, e, n) {
        this.countryEl = document.getElementById(t),
        this.provinceEl = document.getElementById(e),
        this.provinceContainer = document.getElementById(n.hideElement || e),
        Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
        this.initCountry(),
        this.initProvince()
    }
    ,
    Shopify.CountryProvinceSelector.prototype = {
        initCountry: function() {
            var t = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, t),
            this.countryHandler()
        },
        initProvince: function() {
            var t = this.provinceEl.getAttribute("data-default");
            t && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, t)
        },
        countryHandler: function() {
            var t = (i = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces")
              , e = JSON.parse(t);
            if (this.clearOptions(this.provinceEl),
            e && 0 == e.length)
                this.provinceContainer.style.display = "none";
            else {
                for (var n = 0; n < e.length; n++) {
                    var i;
                    (i = document.createElement("option")).value = e[n][0],
                    i.innerHTML = e[n][1],
                    this.provinceEl.appendChild(i)
                }
                this.provinceContainer.style.display = ""
            }
        },
        clearOptions: function(t) {
            for (; t.firstChild; )
                t.removeChild(t.firstChild)
        },
        setOptions: function(t, e) {
            var n = 0;
            for (e.length; n < e.length; n++) {
                var i = document.createElement("option");
                i.value = e[n],
                i.innerHTML = e[n],
                t.appendChild(i)
            }
        }
    };
    
    // ---------------------------------------------------------------------------------------------
    //                                          Net-term starts here           
    // ---------------------------------------------------------------------------------------------
    (function() {
    
        var netTermDesign = function(cart) {
            if (cart.items && Object.keys(cart.items).length && typeof WSAIO.customer.id != 'undefined' && WSAIO.netTerm.enabled) {
                // ============================= Global variables =============================
                var WSAIO_customer = WSAIO.customer
                  , WSAIO_netTerm = WSAIO.netTerm;
                var WSAIO_money_format = WSAIO.shopInfo.money_format
                  , WSAIO_shop_money_format = WSAIO.shop_money_format
                  , enable_new_delivery_date = WSAIO_netTerm.show_delivery_date
                  , enable_nerterm_options = WSAIO_netTerm.show_payment_mode
                  , enable_nerterm_PO = WSAIO_netTerm.enable_po
                  , netTerm_page_tab = 'information'
                  , coupon_applied_value = 0
                  , WSAIO_show_wholesale_shipping = WSAIO_netTerm.display_shipping_rates.app
                  , WSAIO_show_shopify_shipping = WSAIO_netTerm.display_shipping_rates.shopify
                  , WSAIO_hide_freeShipping = WSAIO_netTerm.hide_freeshipping
                  , app_url = WSAIO.App.checkoutURL
                  , update_items = {}
                  , shop_logo = WSAIO.cart_additional_info[0].shop.logo_img
                  , shop_logo_banner = WSAIO.cart_additional_info[0].shop.shop_logo_banner
                  , delivery_options = WSAIO_netTerm.delivery_options
                  , delivery_options_pickup_notes = WSAIO_netTerm.delivery_options_pickup_notes
                  , number_of_days_disabled = parseInt(WSAIO_netTerm.number_of_days_disabled)
                  , enable_notes = WSAIO_netTerm.enable_notes
                  , notes = WSAIO_netTerm.notes
                  , free_shipping_coupon_applied = false
                  , shopify_shipping_request = 1
                  , show_default_shipping_address = WSAIO_netTerm.is_default_address_checked
                  , is_logo = WSAIO_netTerm.net_term_logo
                  , is_billing_address_checked = WSAIO_netTerm.is_billing_same_as_shipping
                  , WSAIO_generalSetting = WSAIO.general_settings;
                var netTerm_order_method = WSAIO.netTerm.order_method;
                WSAIO.netTerm_order_tags = 'NetTerm';
                var hide_shipping_content = false;
                if ((!WSAIO_netTerm.display_shipping_rates.app && !WSAIO_netTerm.display_shipping_rates.beskpoke && !WSAIO_netTerm.display_shipping_rates.shopify) || (delivery_options == 'only_pickup' || delivery_options == 'none')) {
                    hide_shipping_content = true;
                }
    
                if (delivery_options == 'only_pickup' || delivery_options == 'none') {
                    enable_new_delivery_date = false;
                }
    
                var Show_additional_coupon_field = false;
                if (WSAIO_generalSetting.enable_additional_coupon_code) {
                    Show_additional_coupon_field = true;
                } else if (WSAIO_generalSetting.additional_coupon_code_tag_based != null && WSAIO_generalSetting.additional_coupon_code_tag_based.enabled) {
                    var setting_tags = WSAIO_generalSetting.additional_coupon_code_tag_based.tags;
                    setting_tags.forEach(function(tag) {
                        const isMatchFound = WSAIO_customer.tags.some(function(customerTag) {
                        return tag.toLowerCase() === customerTag;
                        });
    
                        if (isMatchFound) {
                            Show_additional_coupon_field = true;
                            return;
                        }
                    });
                }
    
                WSAIO.product_collections = [];
                try {
                    WSAIO.products_with_collections.forEach(function(val) {
                        delete val.product_variants;
                        WSAIO.product_collections.push(val);
                    });
                } catch (e) {}
    
                if ('undefined' === typeof WSAIO.Currency) {
                    WSAIO.Currency = {};
                }
                WSAIO.Currency.storeCurrency = WSAIO.shopInfo.currency;
                if ("undefined" !== typeof window.Currency) {
                    WSAIO.Currency.rates = window.Currency.rates;
                }
    
                // ============================= format money function =============================
                WSAIO_formatMoney = function(t, g) {
                    a = parseFloat(t);
                    "string" === typeof a && (a = a.replace(".", ""));
                    var c = ""
                      , e = /\{\{\s*(\w+)\s*\}\}/
                      , f = g || WSAIO_money_format || WSAIO_shop_money_format;
                    Number.prototype.format_pricing = function(n, x, s, c) {
                        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
                          , num = this.toFixed(Math.max(0, ~~n));
                        return (c ? num.replace('.', c) : num).replace(new RegExp(re,'g'), '$&' + (s || ','));
                    }
                    ;
                    switch (f.match(e)[1]) {
                    case "amount":
                        a = parseFloat(a);
                        return f.replace(e, a.format_pricing(2));
                        break;
                    case "amount_no_decimals":
                        a = parseFloat(a);
                        return f.replace(e, a.format_pricing(0));
                        break;
                    case "amount_with_comma_separator":
                        a = parseFloat(a);
                        return f.replace(e, a.format_pricing(2, 3, '.', ','));
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        a = parseFloat(a);
                        return f.replace(e, a.format_pricing(2, 0, '.').replace('.00', ''));
                        break;
                    case "amount_no_decimals_with_space_separator":
                        a = parseFloat(a);
                        return f.replace(e, a.format_pricing(2, 3, ' ').replace('.00', ''));
                        break;
                    case "  ":
                        a = parseFloat(a);
                        return f.replace(e, a.format_pricing(2, 3, "'"));
                    }
                    return f.replace(e, c)
                }
                ;
    
                function check_formate(value) {
                    var formate_check = WSAIO_formatMoney(value);
                    if (formate_check.indexOf('class=hidePrice') > -1) {
                        formate_check = formate_check.split('<span class=hidePrice>')[1];
                        formate_check = formate_check.split('</span>')[0];
                    }
                    if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
                        formate_check = WSAIO.change_currency_sign(formate_check);
                    }
                    return formate_check;
                }
    
                // ========================payment options=============================
                if (enable_nerterm_options) {
                    var _payment_options = []
                      , customize_payment_option = [];
                    if (typeof WSAIO.netTerm.separate_payment_mode != 'undefined' && WSAIO.netTerm.separate_payment_mode) {
                        WSAIO.netTerm.separate_payment_items.forEach(function(e) {
                            WSAIO_customer.tags.forEach(function(t) {
                                if (t.toLowerCase() == e.tag.trim().toLowerCase()) {
                                    if (e.option_text.indexOf(',') > -1) {
                                        var options_value = e.option_text.split(',');
                                        options_value.forEach(function(v) {
                                            if (v.trim() != '') {
                                                var option = {
                                                    'value': v.trim(),
                                                    'text': v.trim()
                                                };
                                                if (!customize_payment_option.some(function(o) {
                                                    return o.value.toLowerCase() === option.value.toLowerCase();
                                                })) {
                                                    customize_payment_option.push(option);
                                                }
                                            }
                                        })
                                    } else {
                                        if (e.option_text.trim() != '') {
                                            var option = {
                                                'value': e.option_text.trim(),
                                                'text': e.option_text.trim()
                                            };
                                            if (!customize_payment_option.some(function(o) {
                                                return o.value.toLowerCase() === option.value.toLowerCase();
                                            })) {
                                                customize_payment_option.push(option);
                                            }
                                        }
                                    }
                                }
                            })
                        })
                    } else {
                        WSAIO_netTerm.payment_options.split(',').forEach(function(d, i) {
                            if (d != '') {
                                _payment_options.push({
                                    value: d,
                                    text: d
                                })
                            }
                        })
                        if (_payment_options.length) {
                            _payment_options.forEach(function(e) {
                                WSAIO_customer.tags.forEach(function(t) {
                                    if (e.value.trim().toLowerCase() == t.toLowerCase() && e.value != '') {
                                        customize_payment_option.push({
                                            'value': e.value.trim(),
                                            'text': e.value.trim()
                                        });
                                    }
                                })
                            })
                        }
                    }
                    if (customize_payment_option.length) {
                        _payment_options = customize_payment_option
                    }
                    _payment_options.forEach(function(po, i) {
                        _payment_options += '<option value="' + po.value + '">' + po.text + '</option>';
                    });
                }
                // ============================= Auto address dropdown values =============================
                var new_customer_addresses_HTML = ''
                  , selectaddress1 = ''
                  , selectaddress2 = ''
                  , new_customer_addresses = WSAIO_customer.addresses;
                new_customer_addresses.forEach(function(address, i) {
                    new_customer_addresses_HTML += '<option value="' + i + '">Address : ' + address.city + ' : ' + address.address1 + '</option>';
                });
                if (new_customer_addresses_HTML == '') {
                    selectaddress1 = '';
                    selectaddress2 = '';
                } else {
                    selectaddress1 = '  <div class="new_net--input_field ship_field" style="position:relative;">  ' + '                   <select class="new_shipping_auto_address new_field_style new_w-100"><option value="">Sélectionnez votre adresse</option><option value="default">Adresse par défaut</option>' + new_customer_addresses_HTML + '<option value="">Use a different address</option></select> <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg> ' + '                 </div>  ';
                    selectaddress2 = '                 <div class="new_net--input_field ship_field">  ' + '                   <select class="new_billing_auto_address new_field_style new_w-100"><option value="">Sélectionnez votre adresse</option><option value="default">Adresse par défaut</option>' + new_customer_addresses_HTML + '<option value="">Use a different address</option></select>  ' + '                 </div>  ';
                }
    
                // ============================= Countries Province dropdown code =============================
                var country_and_states = {
                    "country": {
                        "AF": "Afghanistan",
                        "AX": "Åland Islands",
                        "AL": "Albania",
                        "DZ": "Algeria",
                        "AD": "Andorra",
                        "AO": "Angola",
                        "AI": "Anguilla",
                        "AG": "Antigua & Barbuda",
                        "AR": "Argentina",
                        "AM": "Armenia",
                        "AW": "Aruba",
                        "AC": "Ascension Island",
                        "AU": "Australia",
                        "AT": "Austria",
                        "AZ": "Azerbaijan",
                        "BS": "Bahamas",
                        "BH": "Bahrain",
                        "BD": "Bangladesh",
                        "BB": "Barbados",
                        "BY": "Belarus",
                        "BE": "Belgium",
                        "BZ": "Belize",
                        "BJ": "Benin",
                        "BM": "Bermuda",
                        "BT": "Bhutan",
                        "BO": "Bolivia",
                        "BA": "Bosnia & Herzegovina",
                        "BW": "Botswana",
                        "BR": "Brazil",
                        "IO": "British Indian Ocean Territory",
                        "VG": "British Virgin Islands",
                        "BN": "Brunei",
                        "BG": "Bulgaria",
                        "BF": "Burkina Faso",
                        "BI": "Burundi",
                        "KH": "Cambodia",
                        "CM": "Cameroon",
                        "CA": "Canada",
                        "CV": "Cape Verde",
                        "BQ": "Caribbean Netherlands",
                        "KY": "Cayman Islands",
                        "CF": "Central African Republic",
                        "TD": "Chad",
                        "CL": "Chile",
                        "CN": "China",
                        "CX": "Christmas Island",
                        "CC": "Cocos (Keeling) Islands",
                        "CO": "Colombia",
                        "KM": "Comoros",
                        "CG": "Congo - Brazzaville",
                        "CD": "Congo - Kinshasa",
                        "CK": "Cook Islands",
                        "CR": "Costa Rica",
                        "CI": "Côte d’Ivoire",
                        "HR": "Croatia",
                        "CW": "Curaçao",
                        "CY": "Cyprus",
                        "CZ": "Czech Republic",
                        "DK": "Denmark",
                        "DJ": "Djibouti",
                        "DM": "Dominica",
                        "DO": "Dominican Republic",
                        "EC": "Ecuador",
                        "EG": "Egypt",
                        "SV": "El Salvador",
                        "GQ": "Equatorial Guinea",
                        "ER": "Eritrea",
                        "EE": "Estonia",
                        "SZ": "Eswatini",
                        "ET": "Ethiopia",
                        "FK": "Falkland Islands",
                        "FO": "Faroe Islands",
                        "FJ": "Fiji",
                        "FI": "Finland",
                        "FR": "France",
                        "GF": "French Guiana",
                        "PF": "French Polynesia",
                        "TF": "French Southern Territories",
                        "GA": "Gabon",
                        "GM": "Gambia",
                        "GE": "Georgia",
                        "DE": "Germany",
                        "GH": "Ghana",
                        "GI": "Gibraltar",
                        "GR": "Greece",
                        "GL": "Greenland",
                        "GD": "Grenada",
                        "GP": "Guadeloupe",
                        "GT": "Guatemala",
                        "GG": "Guernsey",
                        "GN": "Guinea",
                        "GW": "Guinea-Bissau",
                        "GY": "Guyana",
                        "HT": "Haiti",
                        "HN": "Honduras",
                        "HK": "Hong Kong SAR",
                        "HU": "Hungary",
                        "IS": "Iceland",
                        "IN": "India",
                        "ID": "Indonesia",
                        "IQ": "Iraq",
                        "IE": "Ireland",
                        "IM": "Isle of Man",
                        "IL": "Israel",
                        "IT": "Italy",
                        "JM": "Jamaica",
                        "JP": "Japan",
                        "JE": "Jersey",
                        "JO": "Jordan",
                        "KZ": "Kazakhstan",
                        "KE": "Kenya",
                        "KI": "Kiribati",
                        "XK": "Kosovo",
                        "KW": "Kuwait",
                        "KG": "Kyrgyzstan",
                        "LA": "Laos",
                        "LV": "Latvia",
                        "LB": "Lebanon",
                        "LS": "Lesotho",
                        "LR": "Liberia",
                        "LY": "Libya",
                        "LI": "Liechtenstein",
                        "LT": "Lithuania",
                        "LU": "Luxembourg",
                        "MO": "Macao SAR",
                        "MG": "Madagascar",
                        "MW": "Malawi",
                        "MY": "Malaysia",
                        "MV": "Maldives",
                        "ML": "Mali",
                        "MT": "Malta",
                        "MQ": "Martinique",
                        "MR": "Mauritania",
                        "MU": "Mauritius",
                        "YT": "Mayotte",
                        "MX": "Mexico",
                        "MD": "Moldova",
                        "MC": "Monaco",
                        "MN": "Mongolia",
                        "ME": "Montenegro",
                        "MS": "Montserrat",
                        "MA": "Morocco",
                        "MZ": "Mozambique",
                        "MM": "Myanmar (Burma)",
                        "NA": "Namibia",
                        "NR": "Nauru",
                        "NP": "Nepal",
                        "NL": "Netherlands",
                        "NC": "New Caledonia",
                        "NZ": "New Zealand",
                        "NI": "Nicaragua",
                        "NE": "Niger",
                        "NG": "Nigeria",
                        "NU": "Niue",
                        "NF": "Norfolk Island",
                        "MK": "North Macedonia",
                        "NO": "Norway",
                        "OM": "Oman",
                        "PK": "Pakistan",
                        "PS": "Palestinian Territories",
                        "PA": "Panama",
                        "PG": "Papua New Guinea",
                        "PY": "Paraguay",
                        "PE": "Peru",
                        "PH": "Philippines",
                        "PN": "Pitcairn Islands",
                        "PL": "Poland",
                        "PT": "Portugal",
                        "QA": "Qatar",
                        "RE": "Réunion",
                        "RO": "Romania",
                        "RU": "Russia",
                        "RW": "Rwanda",
                        "WS": "Samoa",
                        "SM": "San Marino",
                        "ST": "São Tomé & Príncipe",
                        "SA": "Saudi Arabia",
                        "SN": "Senegal",
                        "RS": "Serbia",
                        "SC": "Seychelles",
                        "SL": "Sierra Leone",
                        "SG": "Singapore",
                        "SX": "Sint Maarten",
                        "SK": "Slovakia",
                        "SI": "Slovenia",
                        "SB": "Solomon Islands",
                        "SO": "Somalia",
                        "ZA": "South Africa",
                        "GS": "South Georgia & South Sandwich Islands",
                        "KR": "South Korea",
                        "SS": "South Sudan",
                        "ES": "Spain",
                        "LK": "Sri Lanka",
                        "BL": "St Barthélemy",
                        "SH": "St Helena",
                        "KN": "St Kitts & Nevis",
                        "LC": "St Lucia",
                        "MF": "St Martin",
                        "PM": "St Pierre & Miquelon",
                        "VC": "St Vincent & the Grenadines",
                        "SD": "Sudan",
                        "SR": "Suriname",
                        "SJ": "Svalbard & Jan Mayen",
                        "SE": "Sweden",
                        "CH": "Switzerland",
                        "TW": "Taiwan",
                        "TJ": "Tajikistan",
                        "TZ": "Tanzania",
                        "TH": "Thailand",
                        "TL": "Timor-Leste",
                        "TG": "Togo",
                        "TK": "Tokelau",
                        "TO": "Tonga",
                        "TT": "Trinidad & Tobago",
                        "TA": "Tristan da Cunha",
                        "TN": "Tunisia",
                        "TR": "Turkey",
                        "TM": "Turkmenistan",
                        "TC": "Turks & Caicos Islands",
                        "TV": "Tuvalu",
                        "UM": "US Outlying Islands",
                        "UG": "Uganda",
                        "UA": "Ukraine",
                        "AE": "United Arab Emirates",
                        "GB": "United Kingdom",
                        "US": "United States",
                        "UY": "Uruguay",
                        "UZ": "Uzbekistan",
                        "VU": "Vanuatu",
                        "VA": "Vatican City",
                        "VE": "Venezuela",
                        "VN": "Vietnam",
                        "WF": "Wallis & Futuna",
                        "EH": "Western Sahara",
                        "YE": "Yemen",
                        "ZM": "Zambia",
                        "ZW": "Zimbabwe"
                    },
                    "states": {
                        "AR": [{
                            "name": "Buenos Aires",
                            "code": "B"
                        }, {
                            "name": "Catamarca",
                            "code": "K"
                        }, {
                            "name": "Chaco",
                            "code": "H"
                        }, {
                            "name": "Chubut",
                            "code": "U"
                        }, {
                            "name": "Ciudad Autónoma de Buenos Aires",
                            "code": "C"
                        }, {
                            "name": "Córdoba",
                            "code": "X"
                        }, {
                            "name": "Corrientes",
                            "code": "W"
                        }, {
                            "name": "Entre Ríos",
                            "code": "E"
                        }, {
                            "name": "Formosa",
                            "code": "P"
                        }, {
                            "name": "Jujuy",
                            "code": "Y"
                        }, {
                            "name": "La Pampa",
                            "code": "L"
                        }, {
                            "name": "La Rioja",
                            "code": "F"
                        }, {
                            "name": "Mendoza",
                            "code": "M"
                        }, {
                            "name": "Misiones",
                            "code": "N"
                        }, {
                            "name": "Neuquén",
                            "code": "Q"
                        }, {
                            "name": "Río Negro",
                            "code": "R"
                        }, {
                            "name": "Salta",
                            "code": "A"
                        }, {
                            "name": "San Juan",
                            "code": "J"
                        }, {
                            "name": "San Luis",
                            "code": "D"
                        }, {
                            "name": "Santa Cruz",
                            "code": "Z"
                        }, {
                            "name": "Santa Fe",
                            "code": "S"
                        }, {
                            "name": "Santiago Del Estero",
                            "code": "G"
                        }, {
                            "name": "Tierra Del Fuego",
                            "code": "V"
                        }, {
                            "name": "Tucumán",
                            "code": "T"
                        }],
                        "AU": [{
                            "name": "Australian Capital Territory",
                            "code": "ACT"
                        }, {
                            "name": "New South Wales",
                            "code": "NSW"
                        }, {
                            "name": "Northern Territory",
                            "code": "NT"
                        }, {
                            "name": "Queensland",
                            "code": "QLD"
                        }, {
                            "name": "South Australia",
                            "code": "SA"
                        }, {
                            "name": "Tasmania",
                            "code": "TAS"
                        }, {
                            "name": "Victoria",
                            "code": "VIC"
                        }, {
                            "name": "Western Australia",
                            "code": "WA"
                        }],
                        "BR": [{
                            "name": "Acre",
                            "code": "AC"
                        }, {
                            "name": "Alagoas",
                            "code": "AL"
                        }, {
                            "name": "Amapá",
                            "code": "AP"
                        }, {
                            "name": "Amazonas",
                            "code": "AM"
                        }, {
                            "name": "Bahia",
                            "code": "BA"
                        }, {
                            "name": "Ceará",
                            "code": "CE"
                        }, {
                            "name": "Distrito Federal",
                            "code": "DF"
                        }, {
                            "name": "Espírito Santo",
                            "code": "ES"
                        }, {
                            "name": "Goiás",
                            "code": "GO"
                        }, {
                            "name": "Maranhão",
                            "code": "MA"
                        }, {
                            "name": "Mato Grosso",
                            "code": "MT"
                        }, {
                            "name": "Mato Grosso do Sul",
                            "code": "MS"
                        }, {
                            "name": "Minas Gerais",
                            "code": "MG"
                        }, {
                            "name": "Pará",
                            "code": "PA"
                        }, {
                            "name": "Paraíba",
                            "code": "PB"
                        }, {
                            "name": "Paraná",
                            "code": "PR"
                        }, {
                            "name": "Pernambuco",
                            "code": "PE"
                        }, {
                            "name": "Piauí",
                            "code": "PI"
                        }, {
                            "name": "Rio de Janeiro",
                            "code": "RJ"
                        }, {
                            "name": "Rio Grande do Norte",
                            "code": "RN"
                        }, {
                            "name": "Rio Grande do Sul",
                            "code": "RS"
                        }, {
                            "name": "Rondônia",
                            "code": "RO"
                        }, {
                            "name": "Roraima",
                            "code": "RR"
                        }, {
                            "name": "Santa Catarina",
                            "code": "SC"
                        }, {
                            "name": "São Paulo",
                            "code": "SP"
                        }, {
                            "name": "Sergipe",
                            "code": "SE"
                        }, {
                            "name": "Tocantins",
                            "code": "TO"
                        }],
                        "CA": [{
                            "name": "Alberta",
                            "code": "AB"
                        }, {
                            "name": "British Columbia",
                            "code": "BC"
                        }, {
                            "name": "Manitoba",
                            "code": "MB"
                        }, {
                            "name": "New Brunswick",
                            "code": "NB"
                        }, {
                            "name": "Newfoundland and Labrador",
                            "code": "NL"
                        }, {
                            "name": "Northwest Territories",
                            "code": "NT"
                        }, {
                            "name": "Nova Scotia",
                            "code": "NS"
                        }, {
                            "name": "Nunavut",
                            "code": "NU"
                        }, {
                            "name": "Ontario",
                            "code": "ON"
                        }, {
                            "name": "Prince Edward Island",
                            "code": "PE"
                        }, {
                            "name": "Quebec",
                            "code": "QC"
                        }, {
                            "name": "Saskatchewan",
                            "code": "SK"
                        }, {
                            "name": "Yukon",
                            "code": "YT"
                        }],
                        "CL": [{
                            "name": "Antofagasta",
                            "code": "AN"
                        }, {
                            "name": "Araucanía",
                            "code": "AR"
                        }, {
                            "name": "Arica and Parinacota",
                            "code": "AP"
                        }, {
                            "name": "Atacama",
                            "code": "AT"
                        }, {
                            "name": "Aysén",
                            "code": "AI"
                        }, {
                            "name": "Biobío",
                            "code": "BI"
                        }, {
                            "name": "Coquimbo",
                            "code": "CO"
                        }, {
                            "name": "Los Lagos",
                            "code": "LL"
                        }, {
                            "name": "Los Ríos",
                            "code": "LR"
                        }, {
                            "name": "Magallanes",
                            "code": "MA"
                        }, {
                            "name": "Maule",
                            "code": "ML"
                        }, {
                            "name": "Ñuble",
                            "code": "NB"
                        }, {
                            "name": "O'Higgins",
                            "code": "LI"
                        }, {
                            "name": "Santiago",
                            "code": "RM"
                        }, {
                            "name": "Tarapacá",
                            "code": "TA"
                        }, {
                            "name": "Valparaíso",
                            "code": "VS"
                        }],
                        "CN": [{
                            "name": "Anhui",
                            "code": "AH"
                        }, {
                            "name": "Beijing",
                            "code": "BJ"
                        }, {
                            "name": "Chongqing",
                            "code": "CQ"
                        }, {
                            "name": "Fujian",
                            "code": "FJ"
                        }, {
                            "name": "Gansu",
                            "code": "GS"
                        }, {
                            "name": "Guangdong",
                            "code": "GD"
                        }, {
                            "name": "Guangxi",
                            "code": "GX"
                        }, {
                            "name": "Guizhou",
                            "code": "GZ"
                        }, {
                            "name": "Hainan",
                            "code": "HI"
                        }, {
                            "name": "Hebei",
                            "code": "HE"
                        }, {
                            "name": "Heilongjiang",
                            "code": "HL"
                        }, {
                            "name": "Henan",
                            "code": "HA"
                        }, {
                            "name": "Hubei",
                            "code": "HB"
                        }, {
                            "name": "Hunan",
                            "code": "HN"
                        }, {
                            "name": "Inner Mongolia",
                            "code": "NM"
                        }, {
                            "name": "Jiangsu",
                            "code": "JS"
                        }, {
                            "name": "Jiangxi",
                            "code": "JX"
                        }, {
                            "name": "Jilin",
                            "code": "JL"
                        }, {
                            "name": "Liaoning",
                            "code": "LN"
                        }, {
                            "name": "Ningxia",
                            "code": "NX"
                        }, {
                            "name": "Qinghai",
                            "code": "QH"
                        }, {
                            "name": "Shaanxi",
                            "code": "SN"
                        }, {
                            "name": "Shandong",
                            "code": "SD"
                        }, {
                            "name": "Shanghai",
                            "code": "SH"
                        }, {
                            "name": "Shanxi",
                            "code": "SX"
                        }, {
                            "name": "Sichuan",
                            "code": "SC"
                        }, {
                            "name": "Tianjin",
                            "code": "TJ"
                        }, {
                            "name": "Xinjiang",
                            "code": "XJ"
                        }, {
                            "name": "Xizang",
                            "code": "YZ"
                        }, {
                            "name": "Yunnan",
                            "code": "YN"
                        }, {
                            "name": "Zhejiang",
                            "code": "ZJ"
                        }],
                        "CO": [{
                            "name": "Amazonas",
                            "code": "AMA"
                        }, {
                            "name": "Antioquia",
                            "code": "ANT"
                        }, {
                            "name": "Arauca",
                            "code": "ARA"
                        }, {
                            "name": "Atlántico",
                            "code": "ATL"
                        }, {
                            "name": "Bogotá, D.C.",
                            "code": "DC"
                        }, {
                            "name": "Bolívar",
                            "code": "BOL"
                        }, {
                            "name": "Boyacá",
                            "code": "BOY"
                        }, {
                            "name": "Caldas",
                            "code": "CAL"
                        }, {
                            "name": "Caquetá",
                            "code": "CAQ"
                        }, {
                            "name": "Casanare",
                            "code": "CAS"
                        }, {
                            "name": "Cauca",
                            "code": "CAU"
                        }, {
                            "name": "Cesar",
                            "code": "CES"
                        }, {
                            "name": "Chocó",
                            "code": "CHO"
                        }, {
                            "name": "Córdoba",
                            "code": "COR"
                        }, {
                            "name": "Cundinamarca",
                            "code": "CUN"
                        }, {
                            "name": "Guainía",
                            "code": "GUA"
                        }, {
                            "name": "Guaviare",
                            "code": "GUV"
                        }, {
                            "name": "Huila",
                            "code": "HUI"
                        }, {
                            "name": "La Guajira",
                            "code": "LAG"
                        }, {
                            "name": "Magdalena",
                            "code": "MAG"
                        }, {
                            "name": "Meta",
                            "code": "MET"
                        }, {
                            "name": "Nariño",
                            "code": "NAR"
                        }, {
                            "name": "Norte de Santander",
                            "code": "NSA"
                        }, {
                            "name": "Putumayo",
                            "code": "PUT"
                        }, {
                            "name": "Quindío",
                            "code": "QUI"
                        }, {
                            "name": "Risaralda",
                            "code": "RIS"
                        }, {
                            "name": "San Andrés, Providencia y Santa Catalina",
                            "code": "SAP"
                        }, {
                            "name": "Santander",
                            "code": "SAN"
                        }, {
                            "name": "Sucre",
                            "code": "SUC"
                        }, {
                            "name": "Tolima",
                            "code": "TOL"
                        }, {
                            "name": "Valle del Cauca",
                            "code": "VAC"
                        }, {
                            "name": "Vaupés",
                            "code": "VAU"
                        }, {
                            "name": "Vichada",
                            "code": "VID"
                        }],
                        "CR": [{
                            "name": "Alajuela",
                            "code": "CR-A"
                        }, {
                            "name": "Cartago",
                            "code": "CR-C"
                        }, {
                            "name": "Guanacaste",
                            "code": "CR-G"
                        }, {
                            "name": "Heredia",
                            "code": "CR-H"
                        }, {
                            "name": "Limón",
                            "code": "CR-L"
                        }, {
                            "name": "Puntarenas",
                            "code": "CR-P"
                        }, {
                            "name": "San José",
                            "code": "CR-SJ"
                        }],
                        "EG": [{
                            "name": "6th of October",
                            "code": "SU"
                        }, {
                            "name": "Al Sharqia",
                            "code": "SHR"
                        }, {
                            "name": "Alexandria",
                            "code": "ALX"
                        }, {
                            "name": "Aswan",
                            "code": "ASN"
                        }, {
                            "name": "Asyut",
                            "code": "AST"
                        }, {
                            "name": "Beheira",
                            "code": "BH"
                        }, {
                            "name": "Beni Suef",
                            "code": "BNS"
                        }, {
                            "name": "Cairo",
                            "code": "C"
                        }, {
                            "name": "Dakahlia",
                            "code": "DK"
                        }, {
                            "name": "Damietta",
                            "code": "DT"
                        }, {
                            "name": "Faiyum",
                            "code": "FYM"
                        }, {
                            "name": "Gharbia",
                            "code": "GH"
                        }, {
                            "name": "Giza",
                            "code": "GZ"
                        }, {
                            "name": "Helwan",
                            "code": "HU"
                        }, {
                            "name": "Ismailia",
                            "code": "IS"
                        }, {
                            "name": "Kafr el-Sheikh",
                            "code": "KFS"
                        }, {
                            "name": "Luxor",
                            "code": "LX"
                        }, {
                            "name": "Matrouh",
                            "code": "MT"
                        }, {
                            "name": "Minya",
                            "code": "MN"
                        }, {
                            "name": "Monufia",
                            "code": "MNF"
                        }, {
                            "name": "New Valley",
                            "code": "WAD"
                        }, {
                            "name": "North Sinai",
                            "code": "SIN"
                        }, {
                            "name": "Port Said",
                            "code": "PTS"
                        }, {
                            "name": "Qalyubia",
                            "code": "KB"
                        }, {
                            "name": "Qena",
                            "code": "KN"
                        }, {
                            "name": "Red Sea",
                            "code": "BA"
                        }, {
                            "name": "Sohag",
                            "code": "SHG"
                        }, {
                            "name": "South Sinai",
                            "code": "JS"
                        }, {
                            "name": "Suez",
                            "code": "SUZ"
                        }],
                        "SV": [{
                            "name": "Ahuachapán",
                            "code": "SV-AH"
                        }, {
                            "name": "Cabañas",
                            "code": "SV-CA"
                        }, {
                            "name": "Chalatenango",
                            "code": "SV-CH"
                        }, {
                            "name": "Cuscatlán",
                            "code": "SV-CU"
                        }, {
                            "name": "La Libertad",
                            "code": "SV-LI"
                        }, {
                            "name": "La Paz",
                            "code": "SV-PA"
                        }, {
                            "name": "La Unión",
                            "code": "SV-UN"
                        }, {
                            "name": "Morazán",
                            "code": "SV-MO"
                        }, {
                            "name": "San Miguel",
                            "code": "SV-SM"
                        }, {
                            "name": "San Salvador",
                            "code": "SV-SS"
                        }, {
                            "name": "San Vicente",
                            "code": "SV-SV"
                        }, {
                            "name": "Santa Ana",
                            "code": "SV-SA"
                        }, {
                            "name": "Sonsonate",
                            "code": "SV-SO"
                        }, {
                            "name": "Usulután",
                            "code": "SV-US"
                        }],
                        "GT": [{
                            "name": "Alta Verapaz",
                            "code": "AVE"
                        }, {
                            "name": "Baja Verapaz",
                            "code": "BVE"
                        }, {
                            "name": "Chimaltenango",
                            "code": "CMT"
                        }, {
                            "name": "Chiquimula",
                            "code": "CQM"
                        }, {
                            "name": "El Progreso",
                            "code": "EPR"
                        }, {
                            "name": "Escuintla",
                            "code": "ESC"
                        }, {
                            "name": "Guatemala",
                            "code": "GUA"
                        }, {
                            "name": "Huehuetenango",
                            "code": "HUE"
                        }, {
                            "name": "Izabal",
                            "code": "IZA"
                        }, {
                            "name": "Jalapa",
                            "code": "JAL"
                        }, {
                            "name": "Jutiapa",
                            "code": "JUT"
                        }, {
                            "name": "Petén",
                            "code": "PET"
                        }, {
                            "name": "Quetzaltenango",
                            "code": "QUE"
                        }, {
                            "name": "Quiché",
                            "code": "QUI"
                        }, {
                            "name": "Retalhuleu",
                            "code": "RET"
                        }, {
                            "name": "Sacatepéquez",
                            "code": "SAC"
                        }, {
                            "name": "San Marcos",
                            "code": "SMA"
                        }, {
                            "name": "Santa Rosa",
                            "code": "SRO"
                        }, {
                            "name": "Sololá",
                            "code": "SOL"
                        }, {
                            "name": "Suchitepéquez",
                            "code": "SUC"
                        }, {
                            "name": "Totonicapán",
                            "code": "TOT"
                        }, {
                            "name": "Zacapa",
                            "code": "ZAC"
                        }],
                        "HK": [{
                            "name": "Hong Kong Island",
                            "code": "HK"
                        }, {
                            "name": "Kowloon",
                            "code": "KL"
                        }, {
                            "name": "New Territories",
                            "code": "NT"
                        }],
                        "IN": [{
                            "name": "Andaman and Nicobar Islands",
                            "code": "AN"
                        }, {
                            "name": "Andhra Pradesh",
                            "code": "AP"
                        }, {
                            "name": "Arunachal Pradesh",
                            "code": "AR"
                        }, {
                            "name": "Assam",
                            "code": "AS"
                        }, {
                            "name": "Bihar",
                            "code": "BR"
                        }, {
                            "name": "Chandigarh",
                            "code": "CH"
                        }, {
                            "name": "Chhattisgarh",
                            "code": "CG"
                        }, {
                            "name": "Dadra and Nagar Haveli",
                            "code": "DN"
                        }, {
                            "name": "Daman and Diu",
                            "code": "DD"
                        }, {
                            "name": "Delhi",
                            "code": "DL"
                        }, {
                            "name": "Goa",
                            "code": "GA"
                        }, {
                            "name": "Gujarat",
                            "code": "GJ"
                        }, {
                            "name": "Haryana",
                            "code": "HR"
                        }, {
                            "name": "Himachal Pradesh",
                            "code": "HP"
                        }, {
                            "name": "Jammu and Kashmir",
                            "code": "JK"
                        }, {
                            "name": "Jharkhand",
                            "code": "JH"
                        }, {
                            "name": "Karnataka",
                            "code": "KA"
                        }, {
                            "name": "Kerala",
                            "code": "KL"
                        }, {
                            "name": "Ladakh",
                            "code": "LA"
                        }, {
                            "name": "Lakshadweep",
                            "code": "LD"
                        }, {
                            "name": "Madhya Pradesh",
                            "code": "MP"
                        }, {
                            "name": "Maharashtra",
                            "code": "MH"
                        }, {
                            "name": "Manipur",
                            "code": "MN"
                        }, {
                            "name": "Meghalaya",
                            "code": "ML"
                        }, {
                            "name": "Mizoram",
                            "code": "MZ"
                        }, {
                            "name": "Nagaland",
                            "code": "NL"
                        }, {
                            "name": "Odisha",
                            "code": "OR"
                        }, {
                            "name": "Puducherry",
                            "code": "PY"
                        }, {
                            "name": "Punjab",
                            "code": "PB"
                        }, {
                            "name": "Rajasthan",
                            "code": "RJ"
                        }, {
                            "name": "Sikkim",
                            "code": "SK"
                        }, {
                            "name": "Tamil Nadu",
                            "code": "TN"
                        }, {
                            "name": "Telangana",
                            "code": "TS"
                        }, {
                            "name": "Tripura",
                            "code": "TR"
                        }, {
                            "name": "Uttar Pradesh",
                            "code": "UP"
                        }, {
                            "name": "Uttarakhand",
                            "code": "UK"
                        }, {
                            "name": "West Bengal",
                            "code": "WB"
                        }],
                        "ID": [{
                            "name": "Aceh",
                            "code": "AC"
                        }, {
                            "name": "Bali",
                            "code": "BA"
                        }, {
                            "name": "Bangka Belitung",
                            "code": "BB"
                        }, {
                            "name": "Banten",
                            "code": "BT"
                        }, {
                            "name": "Bengkulu",
                            "code": "BE"
                        }, {
                            "name": "Gorontalo",
                            "code": "GO"
                        }, {
                            "name": "Jakarta",
                            "code": "JK"
                        }, {
                            "name": "Jambi",
                            "code": "JA"
                        }, {
                            "name": "Jawa Barat",
                            "code": "JB"
                        }, {
                            "name": "Jawa Tengah",
                            "code": "JT"
                        }, {
                            "name": "Jawa Timur",
                            "code": "JI"
                        }, {
                            "name": "Kalimantan Barat",
                            "code": "KB"
                        }, {
                            "name": "Kalimantan Selatan",
                            "code": "KS"
                        }, {
                            "name": "Kalimantan Tengah",
                            "code": "KT"
                        }, {
                            "name": "Kalimantan Timur",
                            "code": "KI"
                        }, {
                            "name": "Kalimantan Utara",
                            "code": "KU"
                        }, {
                            "name": "Kepulauan Riau",
                            "code": "KR"
                        }, {
                            "name": "Lampung",
                            "code": "LA"
                        }, {
                            "name": "Maluku",
                            "code": "MA"
                        }, {
                            "name": "Maluku Utara",
                            "code": "MU"
                        }, {
                            "name": "North Sumatra",
                            "code": "SU"
                        }, {
                            "name": "Nusa Tenggara Barat",
                            "code": "NB"
                        }, {
                            "name": "Nusa Tenggara Timur",
                            "code": "NT"
                        }, {
                            "name": "Papua",
                            "code": "PA"
                        }, {
                            "name": "Papua Barat",
                            "code": "PB"
                        }, {
                            "name": "Riau",
                            "code": "RI"
                        }, {
                            "name": "South Sumatra",
                            "code": "SS"
                        }, {
                            "name": "Sulawesi Barat",
                            "code": "SR"
                        }, {
                            "name": "Sulawesi Selatan",
                            "code": "SN"
                        }, {
                            "name": "Sulawesi Tengah",
                            "code": "ST"
                        }, {
                            "name": "Sulawesi Tenggara",
                            "code": "SG"
                        }, {
                            "name": "Sulawesi Utara",
                            "code": "SA"
                        }, {
                            "name": "West Sumatra",
                            "code": "SB"
                        }, {
                            "name": "Yogyakarta",
                            "code": "YO"
                        }],
                        "IE": [{
                            "name": "Carlow",
                            "code": "CW"
                        }, {
                            "name": "Cavan",
                            "code": "CN"
                        }, {
                            "name": "Clare",
                            "code": "CE"
                        }, {
                            "name": "Cork",
                            "code": "CO"
                        }, {
                            "name": "Donegal",
                            "code": "DL"
                        }, {
                            "name": "Dublin",
                            "code": "D"
                        }, {
                            "name": "Galway",
                            "code": "G"
                        }, {
                            "name": "Kerry",
                            "code": "KY"
                        }, {
                            "name": "Kildare",
                            "code": "KE"
                        }, {
                            "name": "Kilkenny",
                            "code": "KK"
                        }, {
                            "name": "Laois",
                            "code": "LS"
                        }, {
                            "name": "Leitrim",
                            "code": "LM"
                        }, {
                            "name": "Limerick",
                            "code": "LK"
                        }, {
                            "name": "Longford",
                            "code": "LD"
                        }, {
                            "name": "Louth",
                            "code": "LH"
                        }, {
                            "name": "Mayo",
                            "code": "MO"
                        }, {
                            "name": "Meath",
                            "code": "MH"
                        }, {
                            "name": "Monaghan",
                            "code": "MN"
                        }, {
                            "name": "Offaly",
                            "code": "OY"
                        }, {
                            "name": "Roscommon",
                            "code": "RN"
                        }, {
                            "name": "Sligo",
                            "code": "SO"
                        }, {
                            "name": "Tipperary",
                            "code": "TA"
                        }, {
                            "name": "Waterford",
                            "code": "WD"
                        }, {
                            "name": "Westmeath",
                            "code": "WH"
                        }, {
                            "name": "Wexford",
                            "code": "WX"
                        }, {
                            "name": "Wicklow",
                            "code": "WW"
                        }],
                        "IT": [{
                            "name": "Agrigento",
                            "code": "AG"
                        }, {
                            "name": "Alessandria",
                            "code": "AL"
                        }, {
                            "name": "Ancona",
                            "code": "AN"
                        }, {
                            "name": "Aosta",
                            "code": "AO"
                        }, {
                            "name": "Arezzo",
                            "code": "AR"
                        }, {
                            "name": "Ascoli Piceno",
                            "code": "AP"
                        }, {
                            "name": "Asti",
                            "code": "AT"
                        }, {
                            "name": "Avellino",
                            "code": "AV"
                        }, {
                            "name": "Bari",
                            "code": "BA"
                        }, {
                            "name": "Barletta-Andria-Trani",
                            "code": "BT"
                        }, {
                            "name": "Belluno",
                            "code": "BL"
                        }, {
                            "name": "Benevento",
                            "code": "BN"
                        }, {
                            "name": "Bergamo",
                            "code": "BG"
                        }, {
                            "name": "Biella",
                            "code": "BI"
                        }, {
                            "name": "Bologna",
                            "code": "BO"
                        }, {
                            "name": "Bolzano",
                            "code": "BZ"
                        }, {
                            "name": "Brescia",
                            "code": "BS"
                        }, {
                            "name": "Brindisi",
                            "code": "BR"
                        }, {
                            "name": "Cagliari",
                            "code": "CA"
                        }, {
                            "name": "Caltanissetta",
                            "code": "CL"
                        }, {
                            "name": "Campobasso",
                            "code": "CB"
                        }, {
                            "name": "Carbonia-Iglesias",
                            "code": "CI"
                        }, {
                            "name": "Caserta",
                            "code": "CE"
                        }, {
                            "name": "Catania",
                            "code": "CT"
                        }, {
                            "name": "Catanzaro",
                            "code": "CZ"
                        }, {
                            "name": "Chieti",
                            "code": "CH"
                        }, {
                            "name": "Como",
                            "code": "CO"
                        }, {
                            "name": "Cosenza",
                            "code": "CS"
                        }, {
                            "name": "Cremona",
                            "code": "CR"
                        }, {
                            "name": "Crotone",
                            "code": "KR"
                        }, {
                            "name": "Cuneo",
                            "code": "CN"
                        }, {
                            "name": "Enna",
                            "code": "EN"
                        }, {
                            "name": "Fermo",
                            "code": "FM"
                        }, {
                            "name": "Ferrara",
                            "code": "FE"
                        }, {
                            "name": "Firenze",
                            "code": "FI"
                        }, {
                            "name": "Foggia",
                            "code": "FG"
                        }, {
                            "name": "Forlì-Cesena",
                            "code": "FC"
                        }, {
                            "name": "Frosinone",
                            "code": "FR"
                        }, {
                            "name": "Genova",
                            "code": "GE"
                        }, {
                            "name": "Gorizia",
                            "code": "GO"
                        }, {
                            "name": "Grosseto",
                            "code": "GR"
                        }, {
                            "name": "Imperia",
                            "code": "IM"
                        }, {
                            "name": "Isernia",
                            "code": "IS"
                        }, {
                            "name": "L'Aquila",
                            "code": "AQ"
                        }, {
                            "name": "La Spezia",
                            "code": "SP"
                        }, {
                            "name": "Latina",
                            "code": "LT"
                        }, {
                            "name": "Lecce",
                            "code": "LE"
                        }, {
                            "name": "Lecco",
                            "code": "LC"
                        }, {
                            "name": "Livorno",
                            "code": "LI"
                        }, {
                            "name": "Lodi",
                            "code": "LO"
                        }, {
                            "name": "Lucca",
                            "code": "LU"
                        }, {
                            "name": "Macerata",
                            "code": "MC"
                        }, {
                            "name": "Mantova",
                            "code": "MN"
                        }, {
                            "name": "Massa-Carrara",
                            "code": "MS"
                        }, {
                            "name": "Matera",
                            "code": "MT"
                        }, {
                            "name": "Medio Campidano",
                            "code": "VS"
                        }, {
                            "name": "Messina",
                            "code": "ME"
                        }, {
                            "name": "Milano",
                            "code": "MI"
                        }, {
                            "name": "Modena",
                            "code": "MO"
                        }, {
                            "name": "Monza e Brianza",
                            "code": "MB"
                        }, {
                            "name": "Napoli",
                            "code": "NA"
                        }, {
                            "name": "Novara",
                            "code": "NO"
                        }, {
                            "name": "Nuoro",
                            "code": "NU"
                        }, {
                            "name": "Ogliastra",
                            "code": "OG"
                        }, {
                            "name": "Olbia-Tempio",
                            "code": "OT"
                        }, {
                            "name": "Oristano",
                            "code": "OR"
                        }, {
                            "name": "Padova",
                            "code": "PD"
                        }, {
                            "name": "Palermo",
                            "code": "PA"
                        }, {
                            "name": "Parma",
                            "code": "PR"
                        }, {
                            "name": "Pavia",
                            "code": "PV"
                        }, {
                            "name": "Perugia",
                            "code": "PG"
                        }, {
                            "name": "Pesaro e Urbino",
                            "code": "PU"
                        }, {
                            "name": "Pescara",
                            "code": "PE"
                        }, {
                            "name": "Piacenza",
                            "code": "PC"
                        }, {
                            "name": "Pisa",
                            "code": "PI"
                        }, {
                            "name": "Pistoia",
                            "code": "PT"
                        }, {
                            "name": "Pordenone",
                            "code": "PN"
                        }, {
                            "name": "Potenza",
                            "code": "PZ"
                        }, {
                            "name": "Prato",
                            "code": "PO"
                        }, {
                            "name": "Ragusa",
                            "code": "RG"
                        }, {
                            "name": "Ravenna",
                            "code": "RA"
                        }, {
                            "name": "Reggio Calabria",
                            "code": "RC"
                        }, {
                            "name": "Reggio Emilia",
                            "code": "RE"
                        }, {
                            "name": "Rieti",
                            "code": "RI"
                        }, {
                            "name": "Rimini",
                            "code": "RN"
                        }, {
                            "name": "Roma",
                            "code": "RM"
                        }, {
                            "name": "Rovigo",
                            "code": "RO"
                        }, {
                            "name": "Salerno",
                            "code": "SA"
                        }, {
                            "name": "Sassari",
                            "code": "SS"
                        }, {
                            "name": "Savona",
                            "code": "SV"
                        }, {
                            "name": "Siena",
                            "code": "SI"
                        }, {
                            "name": "Siracusa",
                            "code": "SR"
                        }, {
                            "name": "Sondrio",
                            "code": "SO"
                        }, {
                            "name": "Taranto",
                            "code": "TA"
                        }, {
                            "name": "Teramo",
                            "code": "TE"
                        }, {
                            "name": "Terni",
                            "code": "TR"
                        }, {
                            "name": "Torino",
                            "code": "TO"
                        }, {
                            "name": "Trapani",
                            "code": "TP"
                        }, {
                            "name": "Trento",
                            "code": "TN"
                        }, {
                            "name": "Treviso",
                            "code": "TV"
                        }, {
                            "name": "Trieste",
                            "code": "TS"
                        }, {
                            "name": "Udine",
                            "code": "UD"
                        }, {
                            "name": "Varese",
                            "code": "VA"
                        }, {
                            "name": "Venezia",
                            "code": "VE"
                        }, {
                            "name": "Verbano-Cusio-Ossola",
                            "code": "VB"
                        }, {
                            "name": "Vercelli",
                            "code": "VC"
                        }, {
                            "name": "Verona",
                            "code": "VR"
                        }, {
                            "name": "Vibo Valentia",
                            "code": "VV"
                        }, {
                            "name": "Vicenza",
                            "code": "VI"
                        }, {
                            "name": "Viterbo",
                            "code": "VT"
                        }],
                        "JP": [{
                            "name": "Aichi",
                            "code": "JP-23"
                        }, {
                            "name": "Akita",
                            "code": "JP-05"
                        }, {
                            "name": "Aomori",
                            "code": "JP-02"
                        }, {
                            "name": "Chiba",
                            "code": "JP-12"
                        }, {
                            "name": "Ehime",
                            "code": "JP-38"
                        }, {
                            "name": "Fukui",
                            "code": "JP-18"
                        }, {
                            "name": "Fukuoka",
                            "code": "JP-40"
                        }, {
                            "name": "Fukushima",
                            "code": "JP-07"
                        }, {
                            "name": "Gifu",
                            "code": "JP-21"
                        }, {
                            "name": "Gunma",
                            "code": "JP-10"
                        }, {
                            "name": "Hiroshima",
                            "code": "JP-34"
                        }, {
                            "name": "Hokkaidō",
                            "code": "JP-01"
                        }, {
                            "name": "Hyōgo",
                            "code": "JP-28"
                        }, {
                            "name": "Ibaraki",
                            "code": "JP-08"
                        }, {
                            "name": "Ishikawa",
                            "code": "JP-17"
                        }, {
                            "name": "Iwate",
                            "code": "JP-03"
                        }, {
                            "name": "Kagawa",
                            "code": "JP-37"
                        }, {
                            "name": "Kagoshima",
                            "code": "JP-46"
                        }, {
                            "name": "Kanagawa",
                            "code": "JP-14"
                        }, {
                            "name": "Kōchi",
                            "code": "JP-39"
                        }, {
                            "name": "Kumamoto",
                            "code": "JP-43"
                        }, {
                            "name": "Kyōto",
                            "code": "JP-26"
                        }, {
                            "name": "Mie",
                            "code": "JP-24"
                        }, {
                            "name": "Miyagi",
                            "code": "JP-04"
                        }, {
                            "name": "Miyazaki",
                            "code": "JP-45"
                        }, {
                            "name": "Nagano",
                            "code": "JP-20"
                        }, {
                            "name": "Nagasaki",
                            "code": "JP-42"
                        }, {
                            "name": "Nara",
                            "code": "JP-29"
                        }, {
                            "name": "Niigata",
                            "code": "JP-15"
                        }, {
                            "name": "Ōita",
                            "code": "JP-44"
                        }, {
                            "name": "Okayama",
                            "code": "JP-33"
                        }, {
                            "name": "Okinawa",
                            "code": "JP-47"
                        }, {
                            "name": "Ōsaka",
                            "code": "JP-27"
                        }, {
                            "name": "Saga",
                            "code": "JP-41"
                        }, {
                            "name": "Saitama",
                            "code": "JP-11"
                        }, {
                            "name": "Shiga",
                            "code": "JP-25"
                        }, {
                            "name": "Shimane",
                            "code": "JP-32"
                        }, {
                            "name": "Shizuoka",
                            "code": "JP-22"
                        }, {
                            "name": "Tochigi",
                            "code": "JP-09"
                        }, {
                            "name": "Tokushima",
                            "code": "JP-36"
                        }, {
                            "name": "Tōkyō",
                            "code": "JP-13"
                        }, {
                            "name": "Tottori",
                            "code": "JP-31"
                        }, {
                            "name": "Toyama",
                            "code": "JP-16"
                        }, {
                            "name": "Wakayama",
                            "code": "JP-30"
                        }, {
                            "name": "Yamagata",
                            "code": "JP-06"
                        }, {
                            "name": "Yamaguchi",
                            "code": "JP-35"
                        }, {
                            "name": "Yamanashi",
                            "code": "JP-19"
                        }],
                        "KW": [{
                            "name": "Al Ahmadi",
                            "code": "KW-AH"
                        }, {
                            "name": "Al Asimah",
                            "code": "KW-KU"
                        }, {
                            "name": "Al Farwaniyah",
                            "code": "KW-FA"
                        }, {
                            "name": "Al Jahra",
                            "code": "KW-JA"
                        }, {
                            "name": "Hawalli",
                            "code": "KW-HA"
                        }, {
                            "name": "Mubarak Al-Kabeer",
                            "code": "KW-MU"
                        }],
                        "MY": [{
                            "name": "Johor",
                            "code": "JHR"
                        }, {
                            "name": "Kedah",
                            "code": "KDH"
                        }, {
                            "name": "Kelantan",
                            "code": "KTN"
                        }, {
                            "name": "Kuala Lumpur",
                            "code": "KUL"
                        }, {
                            "name": "Labuan",
                            "code": "LBN"
                        }, {
                            "name": "Melaka",
                            "code": "MLK"
                        }, {
                            "name": "Negeri Sembilan",
                            "code": "NSN"
                        }, {
                            "name": "Pahang",
                            "code": "PHG"
                        }, {
                            "name": "Penang",
                            "code": "PNG"
                        }, {
                            "name": "Perak",
                            "code": "PRK"
                        }, {
                            "name": "Perlis",
                            "code": "PLS"
                        }, {
                            "name": "Putrajaya",
                            "code": "PJY"
                        }, {
                            "name": "Sabah",
                            "code": "SBH"
                        }, {
                            "name": "Sarawak",
                            "code": "SWK"
                        }, {
                            "name": "Selangor",
                            "code": "SGR"
                        }, {
                            "name": "Terengganu",
                            "code": "TRG"
                        }],
                        "MX": [{
                            "name": "Aguascalientes",
                            "code": "AGS"
                        }, {
                            "name": "Baja California",
                            "code": "BC"
                        }, {
                            "name": "Baja California Sur",
                            "code": "BCS"
                        }, {
                            "name": "Campeche",
                            "code": "CAMP"
                        }, {
                            "name": "Chiapas",
                            "code": "CHIS"
                        }, {
                            "name": "Chihuahua",
                            "code": "CHIH"
                        }, {
                            "name": "Ciudad de México",
                            "code": "DF"
                        }, {
                            "name": "Coahuila",
                            "code": "COAH"
                        }, {
                            "name": "Colima",
                            "code": "COL"
                        }, {
                            "name": "Durango",
                            "code": "DGO"
                        }, {
                            "name": "Guanajuato",
                            "code": "GTO"
                        }, {
                            "name": "Guerrero",
                            "code": "GRO"
                        }, {
                            "name": "Hidalgo",
                            "code": "HGO"
                        }, {
                            "name": "Jalisco",
                            "code": "JAL"
                        }, {
                            "name": "México",
                            "code": "MEX"
                        }, {
                            "name": "Michoacán",
                            "code": "MICH"
                        }, {
                            "name": "Morelos",
                            "code": "MOR"
                        }, {
                            "name": "Nayarit",
                            "code": "NAY"
                        }, {
                            "name": "Nuevo León",
                            "code": "NL"
                        }, {
                            "name": "Oaxaca",
                            "code": "OAX"
                        }, {
                            "name": "Puebla",
                            "code": "PUE"
                        }, {
                            "name": "Querétaro",
                            "code": "QRO"
                        }, {
                            "name": "Quintana Roo",
                            "code": "Q ROO"
                        }, {
                            "name": "San Luis Potosí",
                            "code": "SLP"
                        }, {
                            "name": "Sinaloa",
                            "code": "SIN"
                        }, {
                            "name": "Sonora",
                            "code": "SON"
                        }, {
                            "name": "Tabasco",
                            "code": "TAB"
                        }, {
                            "name": "Tamaulipas",
                            "code": "TAMPS"
                        }, {
                            "name": "Tlaxcala",
                            "code": "TLAX"
                        }, {
                            "name": "Veracruz",
                            "code": "VER"
                        }, {
                            "name": "Yucatán",
                            "code": "YUC"
                        }, {
                            "name": "Zacatecas",
                            "code": "ZAC"
                        }],
                        "NZ": [{
                            "name": "Auckland",
                            "code": "AUK"
                        }, {
                            "name": "Bay of Plenty",
                            "code": "BOP"
                        }, {
                            "name": "Canterbury",
                            "code": "CAN"
                        }, {
                            "name": "Chatham Islands",
                            "code": "CIT"
                        }, {
                            "name": "Gisborne",
                            "code": "GIS"
                        }, {
                            "name": "Hawke's Bay",
                            "code": "HKB"
                        }, {
                            "name": "Manawatu-Wanganui",
                            "code": "MWT"
                        }, {
                            "name": "Marlborough",
                            "code": "MBH"
                        }, {
                            "name": "Nelson",
                            "code": "NSN"
                        }, {
                            "name": "Northland",
                            "code": "NTL"
                        }, {
                            "name": "Otago",
                            "code": "OTA"
                        }, {
                            "name": "Southland",
                            "code": "STL"
                        }, {
                            "name": "Taranaki",
                            "code": "TKI"
                        }, {
                            "name": "Tasman",
                            "code": "TAS"
                        }, {
                            "name": "Waikato",
                            "code": "WKO"
                        }, {
                            "name": "Wellington",
                            "code": "WGN"
                        }, {
                            "name": "West Coast",
                            "code": "WTC"
                        }],
                        "NG": [{
                            "name": "Abia",
                            "code": "AB"
                        }, {
                            "name": "Abuja Federal Capital Territory",
                            "code": "FC"
                        }, {
                            "name": "Adamawa",
                            "code": "AD"
                        }, {
                            "name": "Akwa Ibom",
                            "code": "AK"
                        }, {
                            "name": "Anambra",
                            "code": "AN"
                        }, {
                            "name": "Bauchi",
                            "code": "BA"
                        }, {
                            "name": "Bayelsa",
                            "code": "BY"
                        }, {
                            "name": "Benue",
                            "code": "BE"
                        }, {
                            "name": "Borno",
                            "code": "BO"
                        }, {
                            "name": "Cross River",
                            "code": "CR"
                        }, {
                            "name": "Delta",
                            "code": "DE"
                        }, {
                            "name": "Ebonyi",
                            "code": "EB"
                        }, {
                            "name": "Edo",
                            "code": "ED"
                        }, {
                            "name": "Ekiti",
                            "code": "EK"
                        }, {
                            "name": "Enugu",
                            "code": "EN"
                        }, {
                            "name": "Gombe",
                            "code": "GO"
                        }, {
                            "name": "Imo",
                            "code": "IM"
                        }, {
                            "name": "Jigawa",
                            "code": "JI"
                        }, {
                            "name": "Kaduna",
                            "code": "KD"
                        }, {
                            "name": "Kano",
                            "code": "KN"
                        }, {
                            "name": "Katsina",
                            "code": "KT"
                        }, {
                            "name": "Kebbi",
                            "code": "KE"
                        }, {
                            "name": "Kogi",
                            "code": "KO"
                        }, {
                            "name": "Kwara",
                            "code": "KW"
                        }, {
                            "name": "Lagos",
                            "code": "LA"
                        }, {
                            "name": "Nasarawa",
                            "code": "NA"
                        }, {
                            "name": "Niger",
                            "code": "NI"
                        }, {
                            "name": "Ogun",
                            "code": "OG"
                        }, {
                            "name": "Ondo",
                            "code": "ON"
                        }, {
                            "name": "Osun",
                            "code": "OS"
                        }, {
                            "name": "Oyo",
                            "code": "OY"
                        }, {
                            "name": "Plateau",
                            "code": "PL"
                        }, {
                            "name": "Rivers",
                            "code": "RI"
                        }, {
                            "name": "Sokoto",
                            "code": "SO"
                        }, {
                            "name": "Taraba",
                            "code": "TA"
                        }, {
                            "name": "Yobe",
                            "code": "YO"
                        }, {
                            "name": "Zamfara",
                            "code": "ZA"
                        }],
                        "PA": [{
                            "name": "Bocas del Toro",
                            "code": "PA-1"
                        }, {
                            "name": "Chiriquí",
                            "code": "PA-4"
                        }, {
                            "name": "Coclé",
                            "code": "PA-2"
                        }, {
                            "name": "Colón",
                            "code": "PA-3"
                        }, {
                            "name": "Darién",
                            "code": "PA-5"
                        }, {
                            "name": "Emberá",
                            "code": "PA-EM"
                        }, {
                            "name": "Herrera",
                            "code": "PA-6"
                        }, {
                            "name": "Kuna Yala",
                            "code": "PA-KY"
                        }, {
                            "name": "Los Santos",
                            "code": "PA-7"
                        }, {
                            "name": "Ngöbe-Buglé",
                            "code": "PA-NB"
                        }, {
                            "name": "Panamá",
                            "code": "PA-8"
                        }, {
                            "name": "Panamá Oeste",
                            "code": "PA-10"
                        }, {
                            "name": "Veraguas",
                            "code": "PA-9"
                        }],
                        "PE": [{
                            "name": "Amazonas",
                            "code": "PE-AMA"
                        }, {
                            "name": "Áncash",
                            "code": "PE-ANC"
                        }, {
                            "name": "Apurímac",
                            "code": "PE-APU"
                        }, {
                            "name": "Arequipa",
                            "code": "PE-ARE"
                        }, {
                            "name": "Ayacucho",
                            "code": "PE-AYA"
                        }, {
                            "name": "Cajamarca",
                            "code": "PE-CAJ"
                        }, {
                            "name": "Callao",
                            "code": "PE-CAL"
                        }, {
                            "name": "Cuzco",
                            "code": "PE-CUS"
                        }, {
                            "name": "Huancavelica",
                            "code": "PE-HUV"
                        }, {
                            "name": "Huánuco",
                            "code": "PE-HUC"
                        }, {
                            "name": "Ica",
                            "code": "PE-ICA"
                        }, {
                            "name": "Junín",
                            "code": "PE-JUN"
                        }, {
                            "name": "La Libertad",
                            "code": "PE-LAL"
                        }, {
                            "name": "Lambayeque",
                            "code": "PE-LAM"
                        }, {
                            "name": "Lima (departamento)",
                            "code": "PE-LIM"
                        }, {
                            "name": "Lima (provincia)",
                            "code": "PE-LMA"
                        }, {
                            "name": "Loreto",
                            "code": "PE-LOR"
                        }, {
                            "name": "Madre de Dios",
                            "code": "PE-MDD"
                        }, {
                            "name": "Moquegua",
                            "code": "PE-MOQ"
                        }, {
                            "name": "Pasco",
                            "code": "PE-PAS"
                        }, {
                            "name": "Piura",
                            "code": "PE-PIU"
                        }, {
                            "name": "Puno",
                            "code": "PE-PUN"
                        }, {
                            "name": "San Martín",
                            "code": "PE-SAM"
                        }, {
                            "name": "Tacna",
                            "code": "PE-TAC"
                        }, {
                            "name": "Tumbes",
                            "code": "PE-TUM"
                        }, {
                            "name": "Ucayali",
                            "code": "PE-UCA"
                        }],
                        "PH": [{
                            "name": "Abra",
                            "code": "PH-ABR"
                        }, {
                            "name": "Agusan del Norte",
                            "code": "PH-AGN"
                        }, {
                            "name": "Agusan del Sur",
                            "code": "PH-AGS"
                        }, {
                            "name": "Aklan",
                            "code": "PH-AKL"
                        }, {
                            "name": "Albay",
                            "code": "PH-ALB"
                        }, {
                            "name": "Antique",
                            "code": "PH-ANT"
                        }, {
                            "name": "Apayao",
                            "code": "PH-APA"
                        }, {
                            "name": "Aurora",
                            "code": "PH-AUR"
                        }, {
                            "name": "Basilan",
                            "code": "PH-BAS"
                        }, {
                            "name": "Bataan",
                            "code": "PH-BAN"
                        }, {
                            "name": "Batanes",
                            "code": "PH-BTN"
                        }, {
                            "name": "Batangas",
                            "code": "PH-BTG"
                        }, {
                            "name": "Benguet",
                            "code": "PH-BEN"
                        }, {
                            "name": "Biliran",
                            "code": "PH-BIL"
                        }, {
                            "name": "Bohol",
                            "code": "PH-BOH"
                        }, {
                            "name": "Bukidnon",
                            "code": "PH-BUK"
                        }, {
                            "name": "Bulacan",
                            "code": "PH-BUL"
                        }, {
                            "name": "Cagayan",
                            "code": "PH-CAG"
                        }, {
                            "name": "Camarines Norte",
                            "code": "PH-CAN"
                        }, {
                            "name": "Camarines Sur",
                            "code": "PH-CAS"
                        }, {
                            "name": "Camiguin",
                            "code": "PH-CAM"
                        }, {
                            "name": "Capiz",
                            "code": "PH-CAP"
                        }, {
                            "name": "Catanduanes",
                            "code": "PH-CAT"
                        }, {
                            "name": "Cavite",
                            "code": "PH-CAV"
                        }, {
                            "name": "Cebu",
                            "code": "PH-CEB"
                        }, {
                            "name": "Cotabato",
                            "code": "PH-NCO"
                        }, {
                            "name": "Davao de Oro",
                            "code": "PH-COM"
                        }, {
                            "name": "Davao del Norte",
                            "code": "PH-DAV"
                        }, {
                            "name": "Davao del Sur",
                            "code": "PH-DAS"
                        }, {
                            "name": "Davao Occidental",
                            "code": "PH-DAO"
                        }, {
                            "name": "Davao Oriental",
                            "code": "PH-DAO"
                        }, {
                            "name": "Dinagat Islands",
                            "code": "PH-DIN"
                        }, {
                            "name": "Eastern Samar",
                            "code": "PH-EAS"
                        }, {
                            "name": "Guimaras",
                            "code": "PH-GUI"
                        }, {
                            "name": "Ifugao",
                            "code": "PH-IFU"
                        }, {
                            "name": "Ilocos Norte",
                            "code": "PH-ILN"
                        }, {
                            "name": "Ilocos Sur",
                            "code": "PH-ILS"
                        }, {
                            "name": "Iloilo",
                            "code": "PH-ILI"
                        }, {
                            "name": "Isabela",
                            "code": "PH-ISA"
                        }, {
                            "name": "Kalinga",
                            "code": "PH-KAL"
                        }, {
                            "name": "La Union",
                            "code": "PH-LUN"
                        }, {
                            "name": "Laguna",
                            "code": "PH-LAG"
                        }, {
                            "name": "Lanao del Norte",
                            "code": "PH-LAN"
                        }, {
                            "name": "Lanao del Sur",
                            "code": "PH-LAS"
                        }, {
                            "name": "Leyte",
                            "code": "PH-LEY"
                        }, {
                            "name": "Maguindanao",
                            "code": "PH-MAG"
                        }, {
                            "name": "Marinduque",
                            "code": "PH-MAD"
                        }, {
                            "name": "Masbate",
                            "code": "PH-MAS"
                        }, {
                            "name": "Metro Manila",
                            "code": "PH-00"
                        }, {
                            "name": "Misamis Occidental",
                            "code": "PH-MSC"
                        }, {
                            "name": "Misamis Oriental",
                            "code": "PH-MSR"
                        }, {
                            "name": "Mountain Province",
                            "code": "PH-MOU"
                        }, {
                            "name": "Negros Occidental",
                            "code": "PH-NEC"
                        }, {
                            "name": "Negros Oriental",
                            "code": "PH-NER"
                        }, {
                            "name": "Northern Samar",
                            "code": "PH-NSA"
                        }, {
                            "name": "Nueva Ecija",
                            "code": "PH-NUE"
                        }, {
                            "name": "Nueva Vizcaya",
                            "code": "PH-NUV"
                        }, {
                            "name": "Occidental Mindoro",
                            "code": "PH-MDC"
                        }, {
                            "name": "Oriental Mindoro",
                            "code": "PH-MDR"
                        }, {
                            "name": "Palawan",
                            "code": "PH-PLW"
                        }, {
                            "name": "Pampanga",
                            "code": "PH-PAM"
                        }, {
                            "name": "Pangasinan",
                            "code": "PH-PAN"
                        }, {
                            "name": "Quezon",
                            "code": "PH-QUE"
                        }, {
                            "name": "Quirino",
                            "code": "PH-QUI"
                        }, {
                            "name": "Rizal",
                            "code": "PH-RIZ"
                        }, {
                            "name": "Romblon",
                            "code": "PH-ROM"
                        }, {
                            "name": "Samar",
                            "code": "PH-WSA"
                        }, {
                            "name": "Sarangani",
                            "code": "PH-SAR"
                        }, {
                            "name": "Siquijor",
                            "code": "PH-SIG"
                        }, {
                            "name": "Sorsogon",
                            "code": "PH-SOR"
                        }, {
                            "name": "South Cotabato",
                            "code": "PH-SCO"
                        }, {
                            "name": "Southern Leyte",
                            "code": "PH-SLE"
                        }, {
                            "name": "Sultan Kudarat",
                            "code": "PH-SUK"
                        }, {
                            "name": "Sulu",
                            "code": "PH-SLU"
                        }, {
                            "name": "Surigao del Norte",
                            "code": "PH-SUN"
                        }, {
                            "name": "Surigao del Sur",
                            "code": "PH-SUR"
                        }, {
                            "name": "Tarlac",
                            "code": "PH-TAR"
                        }, {
                            "name": "Tawi-Tawi",
                            "code": "PH-TAW"
                        }, {
                            "name": "Zambales",
                            "code": "PH-ZMB"
                        }, {
                            "name": "Zamboanga del Norte",
                            "code": "PH-ZAN"
                        }, {
                            "name": "Zamboanga del Sur",
                            "code": "PH-ZAS"
                        }, {
                            "name": "Zamboanga Sibugay",
                            "code": "PH-ZSI"
                        }],
                        "PT": [{
                            "name": "Açores",
                            "code": "PT-20"
                        }, {
                            "name": "Aveiro",
                            "code": "PT-01"
                        }, {
                            "name": "Beja",
                            "code": "PT-02"
                        }, {
                            "name": "Braga",
                            "code": "PT-03"
                        }, {
                            "name": "Bragança",
                            "code": "PT-04"
                        }, {
                            "name": "Castelo Branco",
                            "code": "PT-05"
                        }, {
                            "name": "Coimbra",
                            "code": "PT-06"
                        }, {
                            "name": "Évora",
                            "code": "PT-07"
                        }, {
                            "name": "Faro",
                            "code": "PT-08"
                        }, {
                            "name": "Guarda",
                            "code": "PT-09"
                        }, {
                            "name": "Leiria",
                            "code": "PT-10"
                        }, {
                            "name": "Lisboa",
                            "code": "PT-11"
                        }, {
                            "name": "Madeira",
                            "code": "PT-30"
                        }, {
                            "name": "Portalegre",
                            "code": "PT-12"
                        }, {
                            "name": "Porto",
                            "code": "PT-13"
                        }, {
                            "name": "Santarém",
                            "code": "PT-14"
                        }, {
                            "name": "Setúbal",
                            "code": "PT-15"
                        }, {
                            "name": "Viana do Castelo",
                            "code": "PT-16"
                        }, {
                            "name": "Vila Real",
                            "code": "PT-17"
                        }, {
                            "name": "Viseu",
                            "code": "PT-18"
                        }],
                        "RO": [{
                            "name": "Alba",
                            "code": "AB"
                        }, {
                            "name": "Arad",
                            "code": "AR"
                        }, {
                            "name": "Argeș",
                            "code": "AG"
                        }, {
                            "name": "Bacău",
                            "code": "BC"
                        }, {
                            "name": "Bihor",
                            "code": "BH"
                        }, {
                            "name": "Bistrița-Năsăud",
                            "code": "BN"
                        }, {
                            "name": "Botoșani",
                            "code": "BT"
                        }, {
                            "name": "Brăila",
                            "code": "BR"
                        }, {
                            "name": "Brașov",
                            "code": "BV"
                        }, {
                            "name": "București",
                            "code": "B"
                        }, {
                            "name": "Buzău",
                            "code": "BZ"
                        }, {
                            "name": "Călărași",
                            "code": "CL"
                        }, {
                            "name": "Caraș-Severin",
                            "code": "CS"
                        }, {
                            "name": "Cluj",
                            "code": "CJ"
                        }, {
                            "name": "Constanța",
                            "code": "CT"
                        }, {
                            "name": "Covasna",
                            "code": "CV"
                        }, {
                            "name": "Dâmbovița",
                            "code": "DB"
                        }, {
                            "name": "Dolj",
                            "code": "DJ"
                        }, {
                            "name": "Galați",
                            "code": "GL"
                        }, {
                            "name": "Giurgiu",
                            "code": "GR"
                        }, {
                            "name": "Gorj",
                            "code": "GJ"
                        }, {
                            "name": "Harghita",
                            "code": "HR"
                        }, {
                            "name": "Hunedoara",
                            "code": "HD"
                        }, {
                            "name": "Ialomița",
                            "code": "IL"
                        }, {
                            "name": "Iași",
                            "code": "IS"
                        }, {
                            "name": "Ilfov",
                            "code": "IF"
                        }, {
                            "name": "Maramureș",
                            "code": "MM"
                        }, {
                            "name": "Mehedinți",
                            "code": "MH"
                        }, {
                            "name": "Mureș",
                            "code": "MS"
                        }, {
                            "name": "Neamț",
                            "code": "NT"
                        }, {
                            "name": "Olt",
                            "code": "OT"
                        }, {
                            "name": "Prahova",
                            "code": "PH"
                        }, {
                            "name": "Sălaj",
                            "code": "SJ"
                        }, {
                            "name": "Satu Mare",
                            "code": "SM"
                        }, {
                            "name": "Sibiu",
                            "code": "SB"
                        }, {
                            "name": "Suceava",
                            "code": "SV"
                        }, {
                            "name": "Teleorman",
                            "code": "TR"
                        }, {
                            "name": "Timiș",
                            "code": "TM"
                        }, {
                            "name": "Tulcea",
                            "code": "TL"
                        }, {
                            "name": "Vâlcea",
                            "code": "VL"
                        }, {
                            "name": "Vaslui",
                            "code": "VS"
                        }, {
                            "name": "Vrancea",
                            "code": "VN"
                        }],
                        "RU": [{
                            "name": "Altai Krai",
                            "code": "ALT"
                        }, {
                            "name": "Altai Republic",
                            "code": "AL"
                        }, {
                            "name": "Amur Oblast",
                            "code": "AMU"
                        }, {
                            "name": "Arkhangelsk Oblast",
                            "code": "ARK"
                        }, {
                            "name": "Astrakhan Oblast",
                            "code": "AST"
                        }, {
                            "name": "Belgorod Oblast",
                            "code": "BEL"
                        }, {
                            "name": "Bryansk Oblast",
                            "code": "BRY"
                        }, {
                            "name": "Chechen Republic",
                            "code": "CE"
                        }, {
                            "name": "Chelyabinsk Oblast",
                            "code": "CHE"
                        }, {
                            "name": "Chukotka Autonomous Okrug",
                            "code": "CHU"
                        }, {
                            "name": "Chuvash Republic",
                            "code": "CU"
                        }, {
                            "name": "Irkutsk Oblast",
                            "code": "IRK"
                        }, {
                            "name": "Ivanovo Oblast",
                            "code": "IVA"
                        }, {
                            "name": "Jewish Autonomous Oblast",
                            "code": "YEV"
                        }, {
                            "name": "Kabardino-Balkarian Republic",
                            "code": "KB"
                        }, {
                            "name": "Kaliningrad Oblast",
                            "code": "KGD"
                        }, {
                            "name": "Kaluga Oblast",
                            "code": "KLU"
                        }, {
                            "name": "Kamchatka Krai",
                            "code": "KAM"
                        }, {
                            "name": "Karachay–Cherkess Republic",
                            "code": "KC"
                        }, {
                            "name": "Kemerovo Oblast",
                            "code": "KEM"
                        }, {
                            "name": "Khabarovsk Krai",
                            "code": "KHA"
                        }, {
                            "name": "Khanty-Mansi Autonomous Okrug",
                            "code": "KHM"
                        }, {
                            "name": "Kirov Oblast",
                            "code": "KIR"
                        }, {
                            "name": "Komi Republic",
                            "code": "KO"
                        }, {
                            "name": "Kostroma Oblast",
                            "code": "KOS"
                        }, {
                            "name": "Krasnodar Krai",
                            "code": "KDA"
                        }, {
                            "name": "Krasnoyarsk Krai",
                            "code": "KYA"
                        }, {
                            "name": "Kurgan Oblast",
                            "code": "KGN"
                        }, {
                            "name": "Kursk Oblast",
                            "code": "KRS"
                        }, {
                            "name": "Leningrad Oblast",
                            "code": "LEN"
                        }, {
                            "name": "Lipetsk Oblast",
                            "code": "LIP"
                        }, {
                            "name": "Magadan Oblast",
                            "code": "MAG"
                        }, {
                            "name": "Mari El Republic",
                            "code": "ME"
                        }, {
                            "name": "Moscow",
                            "code": "MOW"
                        }, {
                            "name": "Moscow Oblast",
                            "code": "MOS"
                        }, {
                            "name": "Murmansk Oblast",
                            "code": "MUR"
                        }, {
                            "name": "Nizhny Novgorod Oblast",
                            "code": "NIZ"
                        }, {
                            "name": "Novgorod Oblast",
                            "code": "NGR"
                        }, {
                            "name": "Novosibirsk Oblast",
                            "code": "NVS"
                        }, {
                            "name": "Omsk Oblast",
                            "code": "OMS"
                        }, {
                            "name": "Orenburg Oblast",
                            "code": "ORE"
                        }, {
                            "name": "Oryol Oblast",
                            "code": "ORL"
                        }, {
                            "name": "Penza Oblast",
                            "code": "PNZ"
                        }, {
                            "name": "Perm Krai",
                            "code": "PER"
                        }, {
                            "name": "Primorsky Krai",
                            "code": "PRI"
                        }, {
                            "name": "Pskov Oblast",
                            "code": "PSK"
                        }, {
                            "name": "Republic of Adygeya",
                            "code": "AD"
                        }, {
                            "name": "Republic of Bashkortostan",
                            "code": "BA"
                        }, {
                            "name": "Republic of Buryatia",
                            "code": "BU"
                        }, {
                            "name": "Republic of Dagestan",
                            "code": "DA"
                        }, {
                            "name": "Republic of Ingushetia",
                            "code": "IN"
                        }, {
                            "name": "Republic of Kalmykia",
                            "code": "KL"
                        }, {
                            "name": "Republic of Karelia",
                            "code": "KR"
                        }, {
                            "name": "Republic of Khakassia",
                            "code": "KK"
                        }, {
                            "name": "Republic of Mordovia",
                            "code": "MO"
                        }, {
                            "name": "Republic of North Ossetia–Alania",
                            "code": "SE"
                        }, {
                            "name": "Republic of Tatarstan",
                            "code": "TA"
                        }, {
                            "name": "Rostov Oblast",
                            "code": "ROS"
                        }, {
                            "name": "Ryazan Oblast",
                            "code": "RYA"
                        }, {
                            "name": "Saint Petersburg",
                            "code": "SPE"
                        }, {
                            "name": "Sakha Republic (Yakutia)",
                            "code": "SA"
                        }, {
                            "name": "Sakhalin Oblast",
                            "code": "SAK"
                        }, {
                            "name": "Samara Oblast",
                            "code": "SAM"
                        }, {
                            "name": "Saratov Oblast",
                            "code": "SAR"
                        }, {
                            "name": "Smolensk Oblast",
                            "code": "SMO"
                        }, {
                            "name": "Stavropol Krai",
                            "code": "STA"
                        }, {
                            "name": "Sverdlovsk Oblast",
                            "code": "SVE"
                        }, {
                            "name": "Tambov Oblast",
                            "code": "TAM"
                        }, {
                            "name": "Tomsk Oblast",
                            "code": "TOM"
                        }, {
                            "name": "Tula Oblast",
                            "code": "TUL"
                        }, {
                            "name": "Tver Oblast",
                            "code": "TVE"
                        }, {
                            "name": "Tyumen Oblast",
                            "code": "TYU"
                        }, {
                            "name": "Tyva Republic",
                            "code": "TY"
                        }, {
                            "name": "Udmurtia",
                            "code": "UD"
                        }, {
                            "name": "Ulyanovsk Oblast",
                            "code": "ULY"
                        }, {
                            "name": "Vladimir Oblast",
                            "code": "VLA"
                        }, {
                            "name": "Volgograd Oblast",
                            "code": "VGG"
                        }, {
                            "name": "Vologda Oblast",
                            "code": "VLG"
                        }, {
                            "name": "Voronezh Oblast",
                            "code": "VOR"
                        }, {
                            "name": "Yamalo-Nenets Autonomous Okrug",
                            "code": "YAN"
                        }, {
                            "name": "Yaroslavl Oblast",
                            "code": "YAR"
                        }, {
                            "name": "Zabaykalsky Krai",
                            "code": "ZAB"
                        }],
                        "ZA": [{
                            "name": "Eastern Cape",
                            "code": "EC"
                        }, {
                            "name": "Free State",
                            "code": "FS"
                        }, {
                            "name": "Gauteng",
                            "code": "GP"
                        }, {
                            "name": "KwaZulu-Natal",
                            "code": "NL"
                        }, {
                            "name": "Limpopo",
                            "code": "LP"
                        }, {
                            "name": "Mpumalanga",
                            "code": "MP"
                        }, {
                            "name": "North West",
                            "code": "NW"
                        }, {
                            "name": "Northern Cape",
                            "code": "NC"
                        }, {
                            "name": "Western Cape",
                            "code": "WC"
                        }],
                        "KR": [{
                            "name": "Busan",
                            "code": "KR-26"
                        }, {
                            "name": "Chungbuk",
                            "code": "KR-43"
                        }, {
                            "name": "Chungnam",
                            "code": "KR-44"
                        }, {
                            "name": "Daegu",
                            "code": "KR-27"
                        }, {
                            "name": "Daejeon",
                            "code": "KR-30"
                        }, {
                            "name": "Gangwon",
                            "code": "KR-42"
                        }, {
                            "name": "Gwangju",
                            "code": "KR-29"
                        }, {
                            "name": "Gyeongbuk",
                            "code": "KR-47"
                        }, {
                            "name": "Gyeonggi",
                            "code": "KR-41"
                        }, {
                            "name": "Gyeongnam",
                            "code": "KR-48"
                        }, {
                            "name": "Incheon",
                            "code": "KR-28"
                        }, {
                            "name": "Jeju",
                            "code": "KR-49"
                        }, {
                            "name": "Jeonbuk",
                            "code": "KR-45"
                        }, {
                            "name": "Jeonnam",
                            "code": "KR-46"
                        }, {
                            "name": "Sejong",
                            "code": "KR-50"
                        }, {
                            "name": "Seoul",
                            "code": "KR-11"
                        }, {
                            "name": "Ulsan",
                            "code": "KR-31"
                        }],
                        "ES": [{
                            "name": "A Coruña",
                            "code": "C"
                        }, {
                            "name": "Álava",
                            "code": "VI"
                        }, {
                            "name": "Albacete",
                            "code": "AB"
                        }, {
                            "name": "Alicante",
                            "code": "A"
                        }, {
                            "name": "Almería",
                            "code": "AL"
                        }, {
                            "name": "Asturias",
                            "code": "O"
                        }, {
                            "name": "Ávila",
                            "code": "AV"
                        }, {
                            "name": "Badajoz",
                            "code": "BA"
                        }, {
                            "name": "Balears",
                            "code": "PM"
                        }, {
                            "name": "Barcelona",
                            "code": "B"
                        }, {
                            "name": "Burgos",
                            "code": "BU"
                        }, {
                            "name": "Cáceres",
                            "code": "CC"
                        }, {
                            "name": "Cádiz",
                            "code": "CA"
                        }, {
                            "name": "Cantabria",
                            "code": "S"
                        }, {
                            "name": "Castellón",
                            "code": "CS"
                        }, {
                            "name": "Ceuta",
                            "code": "CE"
                        }, {
                            "name": "Ciudad Real",
                            "code": "CR"
                        }, {
                            "name": "Córdoba",
                            "code": "CO"
                        }, {
                            "name": "Cuenca",
                            "code": "CU"
                        }, {
                            "name": "Girona",
                            "code": "GI"
                        }, {
                            "name": "Granada",
                            "code": "GR"
                        }, {
                            "name": "Guadalajara",
                            "code": "GU"
                        }, {
                            "name": "Guipúzcoa",
                            "code": "SS"
                        }, {
                            "name": "Huelva",
                            "code": "H"
                        }, {
                            "name": "Huesca",
                            "code": "HU"
                        }, {
                            "name": "Jaén",
                            "code": "J"
                        }, {
                            "name": "La Rioja",
                            "code": "LO"
                        }, {
                            "name": "Las Palmas",
                            "code": "GC"
                        }, {
                            "name": "León",
                            "code": "LE"
                        }, {
                            "name": "Lleida",
                            "code": "L"
                        }, {
                            "name": "Lugo",
                            "code": "LU"
                        }, {
                            "name": "Madrid",
                            "code": "M"
                        }, {
                            "name": "Málaga",
                            "code": "MA"
                        }, {
                            "name": "Melilla",
                            "code": "ML"
                        }, {
                            "name": "Murcia",
                            "code": "MU"
                        }, {
                            "name": "Navarra",
                            "code": "NA"
                        }, {
                            "name": "Ourense",
                            "code": "OR"
                        }, {
                            "name": "Palencia",
                            "code": "P"
                        }, {
                            "name": "Pontevedra",
                            "code": "PO"
                        }, {
                            "name": "Salamanca",
                            "code": "SA"
                        }, {
                            "name": "Santa Cruz de Tenerife",
                            "code": "TF"
                        }, {
                            "name": "Segovia",
                            "code": "SG"
                        }, {
                            "name": "Sevilla",
                            "code": "SE"
                        }, {
                            "name": "Soria",
                            "code": "SO"
                        }, {
                            "name": "Tarragona",
                            "code": "T"
                        }, {
                            "name": "Teruel",
                            "code": "TE"
                        }, {
                            "name": "Toledo",
                            "code": "TO"
                        }, {
                            "name": "Valencia",
                            "code": "V"
                        }, {
                            "name": "Valladolid",
                            "code": "VA"
                        }, {
                            "name": "Vizcaya",
                            "code": "BI"
                        }, {
                            "name": "Zamora",
                            "code": "ZA"
                        }, {
                            "name": "Zaragoza",
                            "code": "Z"
                        }],
                        "TH": [{
                            "name": "Amnat Charoen",
                            "code": "TH-37"
                        }, {
                            "name": "Ang Thong",
                            "code": "TH-15"
                        }, {
                            "name": "Bangkok",
                            "code": "TH-10"
                        }, {
                            "name": "Bueng Kan",
                            "code": "TH-38"
                        }, {
                            "name": "Buriram",
                            "code": "TH-31"
                        }, {
                            "name": "Chachoengsao",
                            "code": "TH-24"
                        }, {
                            "name": "Chai Nat",
                            "code": "TH-18"
                        }, {
                            "name": "Chaiyaphum",
                            "code": "TH-36"
                        }, {
                            "name": "Chanthaburi",
                            "code": "TH-22"
                        }, {
                            "name": "Chiang Mai",
                            "code": "TH-50"
                        }, {
                            "name": "Chiang Rai",
                            "code": "TH-57"
                        }, {
                            "name": "Chon Buri",
                            "code": "TH-20"
                        }, {
                            "name": "Chumphon",
                            "code": "TH-86"
                        }, {
                            "name": "Kalasin",
                            "code": "TH-46"
                        }, {
                            "name": "Kamphaeng Phet",
                            "code": "TH-62"
                        }, {
                            "name": "Kanchanaburi",
                            "code": "TH-71"
                        }, {
                            "name": "Khon Kaen",
                            "code": "TH-40"
                        }, {
                            "name": "Krabi",
                            "code": "TH-81"
                        }, {
                            "name": "Lampang",
                            "code": "TH-52"
                        }, {
                            "name": "Lamphun",
                            "code": "TH-51"
                        }, {
                            "name": "Loei",
                            "code": "TH-42"
                        }, {
                            "name": "Lopburi",
                            "code": "TH-16"
                        }, {
                            "name": "Mae Hong Son",
                            "code": "TH-58"
                        }, {
                            "name": "Maha Sarakham",
                            "code": "TH-44"
                        }, {
                            "name": "Mukdahan",
                            "code": "TH-49"
                        }, {
                            "name": "Nakhon Nayok",
                            "code": "TH-26"
                        }, {
                            "name": "Nakhon Pathom",
                            "code": "TH-73"
                        }, {
                            "name": "Nakhon Phanom",
                            "code": "TH-48"
                        }, {
                            "name": "Nakhon Ratchasima",
                            "code": "TH-30"
                        }, {
                            "name": "Nakhon Sawan",
                            "code": "TH-60"
                        }, {
                            "name": "Nakhon Si Thammarat",
                            "code": "TH-80"
                        }, {
                            "name": "Nan",
                            "code": "TH-55"
                        }, {
                            "name": "Narathiwat",
                            "code": "TH-96"
                        }, {
                            "name": "Nong Bua Lam Phu",
                            "code": "TH-39"
                        }, {
                            "name": "Nong Khai",
                            "code": "TH-43"
                        }, {
                            "name": "Nonthaburi",
                            "code": "TH-12"
                        }, {
                            "name": "Pathum Thani",
                            "code": "TH-13"
                        }, {
                            "name": "Pattani",
                            "code": "TH-94"
                        }, {
                            "name": "Pattaya",
                            "code": "TH-S"
                        }, {
                            "name": "Phangnga",
                            "code": "TH-82"
                        }, {
                            "name": "Phatthalung",
                            "code": "TH-93"
                        }, {
                            "name": "Phayao",
                            "code": "TH-56"
                        }, {
                            "name": "Phetchabun",
                            "code": "TH-67"
                        }, {
                            "name": "Phetchaburi",
                            "code": "TH-76"
                        }, {
                            "name": "Phichit",
                            "code": "TH-66"
                        }, {
                            "name": "Phitsanulok",
                            "code": "TH-65"
                        }, {
                            "name": "Phra Nakhon Si Ayutthaya",
                            "code": "TH-14"
                        }, {
                            "name": "Phrae",
                            "code": "TH-54"
                        }, {
                            "name": "Phuket",
                            "code": "TH-83"
                        }, {
                            "name": "Prachin Buri",
                            "code": "TH-25"
                        }, {
                            "name": "Prachuap Khiri Khan",
                            "code": "TH-77"
                        }, {
                            "name": "Ranong",
                            "code": "TH-85"
                        }, {
                            "name": "Ratchaburi",
                            "code": "TH-70"
                        }, {
                            "name": "Rayong",
                            "code": "TH-21"
                        }, {
                            "name": "Roi Et",
                            "code": "TH-45"
                        }, {
                            "name": "Sa Kaeo",
                            "code": "TH-27"
                        }, {
                            "name": "Sakon Nakhon",
                            "code": "TH-47"
                        }, {
                            "name": "Samut Prakan",
                            "code": "TH-11"
                        }, {
                            "name": "Samut Sakhon",
                            "code": "TH-74"
                        }, {
                            "name": "Samut Songkhram",
                            "code": "TH-75"
                        }, {
                            "name": "Saraburi",
                            "code": "TH-19"
                        }, {
                            "name": "Satun",
                            "code": "TH-91"
                        }, {
                            "name": "Sing Buri",
                            "code": "TH-17"
                        }, {
                            "name": "Sisaket",
                            "code": "TH-33"
                        }, {
                            "name": "Songkhla",
                            "code": "TH-90"
                        }, {
                            "name": "Sukhothai",
                            "code": "TH-64"
                        }, {
                            "name": "Suphan Buri",
                            "code": "TH-72"
                        }, {
                            "name": "Surat Thani",
                            "code": "TH-84"
                        }, {
                            "name": "Surin",
                            "code": "TH-32"
                        }, {
                            "name": "Tak",
                            "code": "TH-63"
                        }, {
                            "name": "Trang",
                            "code": "TH-92"
                        }, {
                            "name": "Trat",
                            "code": "TH-23"
                        }, {
                            "name": "Ubon Ratchathani",
                            "code": "TH-34"
                        }, {
                            "name": "Udon Thani",
                            "code": "TH-41"
                        }, {
                            "name": "Uthai Thani",
                            "code": "TH-61"
                        }, {
                            "name": "Uttaradit",
                            "code": "TH-53"
                        }, {
                            "name": "Yala",
                            "code": "TH-95"
                        }, {
                            "name": "Yasothon",
                            "code": "TH-35"
                        }],
                        "AE": [{
                            "name": "Abu Dhabi",
                            "code": "AZ"
                        }, {
                            "name": "Ajman",
                            "code": "AJ"
                        }, {
                            "name": "Dubai",
                            "code": "DU"
                        }, {
                            "name": "Fujairah",
                            "code": "FU"
                        }, {
                            "name": "Ras al-Khaimah",
                            "code": "RK"
                        }, {
                            "name": "Sharjah",
                            "code": "SH"
                        }, {
                            "name": "Umm al-Quwain",
                            "code": "UQ"
                        }],
                        "GB": [{
                            "name": "British Forces",
                            "code": "BFP"
                        }, {
                            "name": "England",
                            "code": "ENG"
                        }, {
                            "name": "Northern Ireland",
                            "code": "NIR"
                        }, {
                            "name": "Scotland",
                            "code": "SCT"
                        }, {
                            "name": "Wales",
                            "code": "WLS"
                        }],
                        "US": [{
                            "name": "Alabama",
                            "code": "AL"
                        }, {
                            "name": "Alaska",
                            "code": "AK"
                        }, {
                            "name": "American Samoa",
                            "code": "AS"
                        }, {
                            "name": "Arizona",
                            "code": "AZ"
                        }, {
                            "name": "Arkansas",
                            "code": "AR"
                        }, {
                            "name": "Armed Forces Americas",
                            "code": "AA"
                        }, {
                            "name": "Armed Forces Europe",
                            "code": "AE"
                        }, {
                            "name": "Armed Forces Pacific",
                            "code": "AP"
                        }, {
                            "name": "California",
                            "code": "CA"
                        }, {
                            "name": "Colorado",
                            "code": "CO"
                        }, {
                            "name": "Connecticut",
                            "code": "CT"
                        }, {
                            "name": "Delaware",
                            "code": "DE"
                        }, {
                            "name": "District of Columbia",
                            "code": "DC"
                        }, {
                            "name": "Federated States of Micronesia",
                            "code": "FM"
                        }, {
                            "name": "Florida",
                            "code": "FL"
                        }, {
                            "name": "Georgia",
                            "code": "GA"
                        }, {
                            "name": "Guam",
                            "code": "GU"
                        }, {
                            "name": "Hawaii",
                            "code": "HI"
                        }, {
                            "name": "Idaho",
                            "code": "ID"
                        }, {
                            "name": "Illinois",
                            "code": "IL"
                        }, {
                            "name": "Indiana",
                            "code": "IN"
                        }, {
                            "name": "Iowa",
                            "code": "IA"
                        }, {
                            "name": "Kansas",
                            "code": "KS"
                        }, {
                            "name": "Kentucky",
                            "code": "KY"
                        }, {
                            "name": "Louisiana",
                            "code": "LA"
                        }, {
                            "name": "Maine",
                            "code": "ME"
                        }, {
                            "name": "Marshall Islands",
                            "code": "MH"
                        }, {
                            "name": "Maryland",
                            "code": "MD"
                        }, {
                            "name": "Massachusetts",
                            "code": "MA"
                        }, {
                            "name": "Michigan",
                            "code": "MI"
                        }, {
                            "name": "Minnesota",
                            "code": "MN"
                        }, {
                            "name": "Mississippi",
                            "code": "MS"
                        }, {
                            "name": "Missouri",
                            "code": "MO"
                        }, {
                            "name": "Montana",
                            "code": "MT"
                        }, {
                            "name": "Nebraska",
                            "code": "NE"
                        }, {
                            "name": "Nevada",
                            "code": "NV"
                        }, {
                            "name": "New Hampshire",
                            "code": "NH"
                        }, {
                            "name": "New Jersey",
                            "code": "NJ"
                        }, {
                            "name": "New Mexico",
                            "code": "NM"
                        }, {
                            "name": "New York",
                            "code": "NY"
                        }, {
                            "name": "North Carolina",
                            "code": "NC"
                        }, {
                            "name": "North Dakota",
                            "code": "ND"
                        }, {
                            "name": "Northern Mariana Islands",
                            "code": "MP"
                        }, {
                            "name": "Ohio",
                            "code": "OH"
                        }, {
                            "name": "Oklahoma",
                            "code": "OK"
                        }, {
                            "name": "Oregon",
                            "code": "OR"
                        }, {
                            "name": "Palau",
                            "code": "PW"
                        }, {
                            "name": "Pennsylvania",
                            "code": "PA"
                        }, {
                            "name": "Puerto Rico",
                            "code": "PR"
                        }, {
                            "name": "Rhode Island",
                            "code": "RI"
                        }, {
                            "name": "South Carolina",
                            "code": "SC"
                        }, {
                            "name": "South Dakota",
                            "code": "SD"
                        }, {
                            "name": "Tennessee",
                            "code": "TN"
                        }, {
                            "name": "Texas",
                            "code": "TX"
                        }, {
                            "name": "Utah",
                            "code": "UT"
                        }, {
                            "name": "Vermont",
                            "code": "VT"
                        }, {
                            "name": "Virgin Islands",
                            "code": "VI"
                        }, {
                            "name": "Virginia",
                            "code": "VA"
                        }, {
                            "name": "Washington",
                            "code": "WA"
                        }, {
                            "name": "West Virginia",
                            "code": "WV"
                        }, {
                            "name": "Wisconsin",
                            "code": "WI"
                        }, {
                            "name": "Wyoming",
                            "code": "WY"
                        }],
                        "UY": [{
                            "name": "Artigas",
                            "code": "UY-AR"
                        }, {
                            "name": "Canelones",
                            "code": "UY-CA"
                        }, {
                            "name": "Cerro Largo",
                            "code": "UY-CL"
                        }, {
                            "name": "Colonia",
                            "code": "UY-CO"
                        }, {
                            "name": "Durazno",
                            "code": "UY-DU"
                        }, {
                            "name": "Flores",
                            "code": "UY-FS"
                        }, {
                            "name": "Florida",
                            "code": "UY-FD"
                        }, {
                            "name": "Lavalleja",
                            "code": "UY-LA"
                        }, {
                            "name": "Maldonado",
                            "code": "UY-MA"
                        }, {
                            "name": "Montevideo",
                            "code": "UY-MO"
                        }, {
                            "name": "Paysandú",
                            "code": "UY-PA"
                        }, {
                            "name": "Río Negro",
                            "code": "UY-RN"
                        }, {
                            "name": "Rivera",
                            "code": "UY-RV"
                        }, {
                            "name": "Rocha",
                            "code": "UY-RO"
                        }, {
                            "name": "Salto",
                            "code": "UY-SA"
                        }, {
                            "name": "San José",
                            "code": "UY-SJ"
                        }, {
                            "name": "Soriano",
                            "code": "UY-SO"
                        }, {
                            "name": "Tacuarembó",
                            "code": "UY-TA"
                        }, {
                            "name": "Treinta y Tres",
                            "code": "UY-TT"
                        }],
                        "VE": [{
                            "name": "Amazonas",
                            "code": "VE-Z"
                        }, {
                            "name": "Anzoátegui",
                            "code": "VE-B"
                        }, {
                            "name": "Apure",
                            "code": "VE-C"
                        }, {
                            "name": "Aragua",
                            "code": "VE-D"
                        }, {
                            "name": "Barinas",
                            "code": "VE-E"
                        }, {
                            "name": "Bolívar",
                            "code": "VE-F"
                        }, {
                            "name": "Carabobo",
                            "code": "VE-G"
                        }, {
                            "name": "Cojedes",
                            "code": "VE-H"
                        }, {
                            "name": "Delta Amacuro",
                            "code": "VE-Y"
                        }, {
                            "name": "Dependencias Federales",
                            "code": "VE-W"
                        }, {
                            "name": "Distrito Capital",
                            "code": "VE-A"
                        }, {
                            "name": "Falcón",
                            "code": "VE-I"
                        }, {
                            "name": "Guárico",
                            "code": "VE-J"
                        }, {
                            "name": "La Guaira",
                            "code": "VE-X"
                        }, {
                            "name": "Lara",
                            "code": "VE-K"
                        }, {
                            "name": "Mérida",
                            "code": "VE-L"
                        }, {
                            "name": "Miranda",
                            "code": "VE-M"
                        }, {
                            "name": "Monagas",
                            "code": "VE-N"
                        }, {
                            "name": "Nueva Esparta",
                            "code": "VE-O"
                        }, {
                            "name": "Portuguesa",
                            "code": "VE-P"
                        }, {
                            "name": "Sucre",
                            "code": "VE-R"
                        }, {
                            "name": "Táchira",
                            "code": "VE-S"
                        }, {
                            "name": "Trujillo",
                            "code": "VE-T"
                        }, {
                            "name": "Yaracuy",
                            "code": "VE-U"
                        }, {
                            "name": "Zulia",
                            "code": "VE-V"
                        }]
                    }
                };
                var countries_based_on_code = country_and_states.country;
                function swapcountryJSON(j) {
                    var res = {};
                    Object.keys(j).forEach(function(key) {
                        res[j[key]] = key;
                    });
                    return res;
                }
                var countries_based_on_name = swapcountryJSON(countries_based_on_code);
                // Get the country name and state name from the imported script.
                let country_list = country_and_states['country'];
                let states_list = country_and_states['states'];
                window.user_country_code = "US";
                // creating country name drop-down
                let ship_countries_dropdown_values = ''
                  , bill_countries_dropdown_values = '';
                ship_countries_dropdown_values += '<option value="default">sélectionner un pays</option>';
                bill_countries_dropdown_values += '<option value="default">sélectionner un pays</option>';
                var htmlObject = document.createElement('select');
                var all_countries = false
                  , allowed_countries = []
                  , check_specific_country = false;
                if (WSAIO.shipping_zone_countries != 'undefined' && WSAIO.shipping_zone_countries != '') {
                    htmlObject.innerHTML = WSAIO.shipping_zone_countries;
                    for (var i = 0; i < htmlObject.length; i++) {
                        if (htmlObject[i] != undefined) {
                            allowed_countries[i] = htmlObject[i].value
                        }
                    }
                    user_country_code = "";
                } else {
                    all_countries = true;
                    check_specific_country = true;
                }
                for (let country_code in country_list) {
                    // set selected option user country
                    if (allowed_countries.indexOf(country_list[country_code]) != '-1' || all_countries) {
                        let selected = (country_code == user_country_code) ? ' selected' : '';
                        ship_countries_dropdown_values += '<option value="' + country_code + '"' + selected + '>' + country_list[country_code] + '</option>';
                    }
                }
                for (let country_code in country_list) {
                    // set selected option user country
                    if (allowed_countries.indexOf(country_list[country_code]) != '-1' || all_countries) {
                        let selected = (country_code == user_country_code) ? ' selected' : '';
                        bill_countries_dropdown_values += '<option value="' + country_code + '"' + selected + '>' + country_list[country_code] + '</option>';
                    }
                }
    
                function ship_create_states_dropdown() {
                    // get selected country code
                    let country_code = document.getElementById("AddressCountryNew").value;
                    let states = states_list[country_code];
                    // invalid country code or no states add textbox
                    let option = '';
                    if (states != undefined && states.length > 0) {
                        for (let i = 0; i < states.length; i++) {
                            option += '<option value="' + states[i].name + '" code="' + states[i].code + '">' + states[i].name + '</option>';
                        }
                    }
                    if (option == '') {
                        document.querySelector('.new_slct_state').style.display = 'none';
                    } else {
                        document.querySelector('.new_slct_state').style.display = 'inline-block';
                    }
                    document.querySelector('[name="new_waioaddress[provice]"]').innerHTML = option;
                }
                function bill_create_states_dropdown() {
                    // get selected country code
                    let country_code = document.getElementById("AddressbillCountryNew").value;
                    let states = states_list[country_code];
                    let option = '';
                    if (states != undefined && states.length > 0) {
                        for (let i = 0; i < states.length; i++) {
                            option += '<option value="' + states[i].name + '" code="' + states[i].code + '">' + states[i].name + '</option>';
                        }
                    }
                    if (option == '') {
                        document.querySelector('.new_slct_statebill').style.display = 'none';
                    } else {
                        document.querySelector('.new_slct_statebill').style.display = 'inline-block';
                    }
                    document.querySelector('[name="new_waiobilladdress[provice]"]').innerHTML = option;
                }
    
                // =========handle undefined variables=====
    
                if (WSAIO.netTerm.net_term_title == undefined) {
                    WSAIO.netTerm.net_term_title = 'Net term Order';
                }
                if (is_logo == undefined) {
                    is_logo = false;
                }
                if (is_billing_address_checked == undefined) {
                    is_billing_address_checked = true;
                }
    
                //=========================== Page design start  =======================//
                let new_netTerm_banner = document.createElement('div');
                new_netTerm_banner.className = 'new_netTerm_banner';
                if (typeof shop_logo_banner != 'undefined' && shop_logo_banner != '' && is_logo == true) {
                    new_netTerm_banner.style.backgroundImage = 'url(' + shop_logo_banner + ')';
                    new_netTerm_banner.style.backgroundSize = 'cover';
                    new_netTerm_banner.style.backgroundPosition = 'center';
                    new_netTerm_banner.style.backgroundRepeat = 'no-repeat';
                    new_netTerm_banner.style.display = 'block';
                    if (typeof shop_logo != 'undefined' && shop_logo != '') {
                        new_netTerm_banner.innerHTML = '<div style="width: 100%; display: flex; flex-wrap: wrap; align-items: center; height: 100%;"> <div style="width: 60%;"> <a href="' + WSAIO.local_param + '" style="width: 100% !important; max-width: 600px !important; margin: auto !important; padding: 0px 30px !important; display: flex;"><img src="' + shop_logo + '" style="margin:66px 0px 30px 0px !important;display: block;width:150px; " /></a></div> </div>';
                    }
                }
    
                let ParentBody = document.createElement('div');
                ParentBody.className = 'NetTerm_div';
    
                // Mobile view Top design
                var Mobile_Accordian = document.createElement('div');
                Mobile_Accordian.className = 'new_net_mobile_div';
                Mobile_Accordian.style.display = 'none';
                Mobile_Accordian.style.backgroundColor = 'white';
                if ((typeof shop_logo != 'undefined' && shop_logo != '') && (typeof shop_logo_banner == 'undefined' || shop_logo_banner == '') && is_logo == true) {
                    Mobile_Accordian.innerHTML = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="display: block; margin: auto !important; padding: 20px 0px !important;width:150px;" /></a>';
                }
                if ((is_logo == false || (typeof shop_logo == 'undefined' || shop_logo == '')) && WSAIO.netTerm.net_term_title != undefined) {
                    Mobile_Accordian.innerHTML += '<h1 class="new_net_title" style="text-align:center;padding-top: 10px;">' + WSAIO.netTerm.net_term_title + '</h1>';
                }
                Mobile_Accordian.innerHTML += '<div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;">Cart</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black;font-size: 14px !important;">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:#6666667a !important;font-size: 14px !important;">Shipping</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;"> Checkout </span> </div><br>';
                var mobile_inner = document.createElement('div');
                mobile_inner.className = 'new_mobile_vie_accordian';
                mobile_inner.innerHTML = '<button class="new_net_accordion" style="position:relative;box-shadow: 0 0 0 1px #fafafa !important;display:none ;color: #ef520e !important;background: #fafafa !important;border: 1px solid rgba(179,179,179,0.34) !important; border-left: none !important;border-right: none !important;"><span class="hOuter"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#fa314a;position:absolute;left: 20px !important;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#f4743c"><path d="M31.63411,14.30534l-24.43945,0.12598l0.06999,14.33333l14.83724,-0.06999l23.61361,56.64746l-8.5804,13.73145c-2.86667,4.58667 -3.01493,10.38036 -0.39193,15.10319c2.623,4.72283 7.59991,7.65657 13.00358,7.65657h86.41992v-14.33333h-86.41992l-0.46191,-0.83985l8.42643,-13.49349h53.52604c5.21017,0 10.005,-2.83296 12.52767,-7.37663l25.8252,-46.47135c1.23983,-2.22167 1.20601,-4.93167 -0.08399,-7.12467c-1.29,-2.18583 -3.64985,-3.52734 -6.18685,-3.52734h-105.69434zM43.58789,43h87.55371l-19.9043,35.83333h-52.71419zM50.16667,129c-7.91608,0 -14.33333,6.41725 -14.33333,14.33333c0,7.91608 6.41725,14.33333 14.33333,14.33333c7.91608,0 14.33333,-6.41725 14.33333,-14.33333c0,-7.91608 -6.41725,-14.33333 -14.33333,-14.33333zM121.83333,129c-7.91608,0 -14.33333,6.41725 -14.33333,14.33333c0,7.91608 6.41725,14.33333 14.33333,14.33333c7.91608,0 14.33333,-6.41725 14.33333,-14.33333c0,-7.91608 -6.41725,-14.33333 -14.33333,-14.33333z"></path></g></g></svg><span class="summry" style="padding-left: 30px;">Show order summary</span> <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#fa314a;height: 22px; position: absolute;" class="net_down"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#f4743c"><path d="M53.24609,68.08333l-10.75,10.75l43.50391,43.5039l43.5039,-43.5039l-10.75,-10.75l-32.7539,32.7539z"></path></g></g></svg><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172" style=" fill:#fa314a;height: 22px; position: absolute;display:none;" class="net_up"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#ef520e"><path d="M86,49.66276l-43.50391,43.50391l10.75,10.75l32.75391,-32.75391l32.7539,32.75391l10.75,-10.75z"></path></g></g></svg><p class="net_prices net--subtotal" style="float:right;text-align: right;">' + WSAIO_formatMoney(cart.items_subtotal_price / 100) + '</p><span></span></span></button>';
                var mobile_inner_items = document.createElement('div');
                mobile_inner_items.className = 'new_net_panel';
                mobile_inner_items.style.transition = 'all 0.5s ease-in-out';
                // mobile cart items html
                var cart_items = cart.items;
                if (cart_items.length > 0) {
                    var item = '';
                    cart_items.forEach(function(items) {
                        const htmlArray = [];
                        var obj = items.properties;
                    if (items.sku != '' && items.sku != null && items.sku != 'null') {
                            htmlArray.push(`<div class="net_line_properties net_line_sku">SKU: ${items.sku}</div>`);
                        }
                        for (const key in obj) {
                            if (obj.hasOwnProperty(key)) {
                            if (typeof key === 'string' && key.startsWith('_')) {
                                continue;
                                // skip this iteration
                            }
                            if (typeof key === 'string' && key == 'Preview') {
                                htmlArray.push(`<a class="net_line_properties" href="${obj[key]}" style="text-decoration: underline !important;">Preview</a>`);
                                continue;
                                // skip this iteration
                            }
                                htmlArray.push(`<div class="net_line_properties">${key}: ${obj[key]}</div>`);
                            }
                        }
                        var var_title = items.variant_title;
                        if (var_title == null)
                            var_title = '';
                        item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <img src="' + items.image + '" alt="' + items.product_title + '"> <span class="new_net_qty">' + items.quantity + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + items.product_title + ' <div class="net_variant_info"> ' + var_title + ' ' + htmlArray.join('') + ' </div> </div> <div class="new_net_item_total"> <span class="new_net_total net-item-total-price-' + (items.key).replace(':', '_') + '"><s></s> <span class="new_order-discount">' + WSAIO_formatMoney(items.price / 100) + '</span></span> </div> </div>';
                    })
                    if (WSAIO_generalSetting.additionalFee_enabled) {
                        item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <svg id="ezg9palcYyL1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 79 80" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" style=" "><image width="79" height="80" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABQCAYAAABYtCjIAAADlUlEQVR4Ae2d15KjMBBF+f8PdM45vtnP2jpU9a5WBUZ4kIPmPqhIEkaH7tuNxDDF/X53Vk6nk5vNZm4wGLher6fiMYAJbGBkvApWbrebWywWbjKZuN1u5y6Xi7teryoeA5jABkawglkJjw2KgMUZjPEqMENoClwcOOMEswI/xhxtp5ZxEGFWIITSuDhgvmHBrCCq+ju1Hg9S8LyI2tZwBE/w4l2trXU9qi/Lk+XJ8r4u6stt5bZyW7nto9Ce2zFpnjRPmifNy03XHvVHmifNk+ZJ86o0gvH+5XJZzntOp1OXqjAfw8zWarV6yY1IrnmAe8cE+isAJoeHxQFvu92Ws+1MnKQq5/PZHQ4H1+/33Xg8Tm59yeHhSsBjfrjKpVPsGw6HjpLi3P45k8ND34D3yunN0WhUvm/jdzTF+lfC40bgnnU3RPBqkleTAQtCbIdWJXgV8DabTSkBwAEaSwtGPkDBq4A3n89LWKQhQLNIzn7BqwDmQyEBBhrwsDyDx9KvJ8urAHk8Hkt4ACQVYUkJ0yDBq4CHdRFlSYAtEWbbtzrWgcfxcH/X21+ZqjRB+DXweGxDs4ikTVBij/8KeBY9TbuqcrZYYH697OEZODq63+9LHQNiFwCzhmcpB51kJASr4VGLQADAMG/zrSpmPVt4VeAMiA+Qerb/0ZI2pDB+nSzhWVJLjmYW53eadR9g04AmQYaUBGtl9Ia2nCM7eDHgDKQPcL1e/2dVVof9QONtfv4mgnXcnrbZwaNzWFz4NGAwwiWWCQTahWmMDRAAzs5HoKEubbKBZwD8joag6rZ9gOSD1GNZdyMsguPKWTxh2DNoKOp1wML9PkCLxoAxiwvrG0AAh8e63v6KxzN0DChAIzA03QisXPBqBgeaLCgbzXvXBFAWmid4T7oP7mUpRF1S3OSCzxzHbdG9Z9q2aZM8YNjjWNWgZZsLbVMXlwVgmzbP1E0OzyZr6BBpC51KWfgdIm0XozNNQJPD4wIASI4GPDr304JL1hVuzCvA0a+XwGu6g996XPB+EAwFT/D0TnLy1KJrbZXbym3ltnLbrnXlk88nzZPmSfOkeZ+sUV1fmzRPmifNk+Z1rSuffD5pnjTvTZrHXIC91/bJLvJp1wYzfer3SbctP/XL20b6yHR7ty8/Ms234ZmYjn0H+NPc5x3XY7z0Yf1It0XjcFUsDnh/P6xv/6IAF2bCmCDCrLvKPwYwgQ2MjNcfoIujjv48ru8AAAAASUVORK5CYII=" preserveAspectRatio="xMidYMid meet"></image></svg> <span class="new_net_qty">' + 1 + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + WSAIO_generalSetting.additionalFee_label + ' </div> <div class="new_net_item_total"> <span class="new_net_total"> <span class="net_additionalFee">...</span></span> </div> </div>';
                    }
                    mobile_inner_items.innerHTML += '<div class="net_items">' + item + '</div>';
                }
                if (Show_additional_coupon_field) {
                    // coupon code field html
                    mobile_inner_items.innerHTML += '<div class="new_discount-code-forms"> <span class="new_wsaio--coupon-code-forms"> <input type="text" name="new_wsaio--discount-code-fields" placeholder="Discount code"> <button name="new_wsaio--discount-code-btns" class="btn new_wsaio--coupon-code-buttons" disabled="disabled" style="opacity:0.2">Apply</button><div class="discount_code_loader" style="display:none;cursor: pointer;background: black;color: white !important;width: 100px !important;margin-top: 10px !important;border-radius: 5px !important;margin-left: 10px !important;"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="40px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="margin: auto !important; display: block;height: 40px !important; "> <path fill="#808080" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path> </svg></div> </span> </div>';
                }
    
                mobile_inner_items.innerHTML += '<div class="new_coupon_error" style="color:red;width: 78% !important;margin: auto !important;display: none;"><p style=" color: red !important; ">Discount code is invalid</p></div><div class="new_coupon_label_div" style="display:none;"> <svg style="width: 14px; margin-right: 3px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="coupon_text" style="font-size: 14px; font-weight: 500; text-transform: uppercase;"></p> <svg class="remove_coupon" style="cursor: pointer;width: 16px !important; height: 24px; margin-left: 10px !important;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M40.90039,30.76628l-10.13411,10.13411l45.09961,45.09961l-45.09961,45.09961l10.13411,10.13411l45.09961,-45.09961l45.09961,45.09961l10.13411,-10.13411l-45.09961,-45.09961l45.09961,-45.09961l-10.13411,-10.13411l-45.09961,45.09961z"></path></g></g></svg> </div>';
    
                // subtotal html
                if (WSAIO_generalSetting.additionalFee_enabled) {
                    var fee = 0;
                    if (WSAIO_generalSetting.additionalFee_value_type == 'fixed') {
                        fee = (cart.items_subtotal_price / 100) + parseFloat(WSAIO_generalSetting.additionalFee_value);
                        fee = WSAIO_formatMoney(parseFloat(fee));
                    } else {
                        var p = ((parseFloat(WSAIO_generalSetting.additionalFee_value) / 100) * (cart.items_subtotal_price / 100)).toFixed(2);
                        fee = WSAIO_formatMoney((cart.items_subtotal_price / 100) + parseFloat(p));
                    }
                    mobile_inner_items.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + fee + '</p> </div>';
                } else {
                    mobile_inner_items.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + WSAIO_formatMoney(cart.items_subtotal_price / 100) + '</p> </div>';
                }
                // coupon applied html
                mobile_inner_items.innerHTML += '<div class="applied_coupon_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>Rabais</p> <svg style="width: 10px; margin-right: 3px !important;margin-left: 6px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="applied_coupon_text"style="font-size: 12px; font-weight: 500; text-transform: uppercase;"></p> </span> <p class="net_prices new_net--coupon_deduct"></p> </div> </div>';
                // shipping html
                if (!hide_shipping_content) {
                    mobile_inner_items.innerHTML += '<div class="new_net_shipping_div"> <p>Expédition</p><p class="new_net--shipping" style="margin-left: auto !important;">Calculé dans le prochaine étape</p> </div>';
                }
                // VAT html
                mobile_inner_items.innerHTML += '<div class="new_applied_vat_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>VAT (incl.)</p> </span> <p class="net_prices new_net--vat_deduct"></p> </div> </div>';
                // total html
                mobile_inner_items.innerHTML += '<div class="new_net_total_div" style="padding: 10px 0px;"> <p style="font-size: 18px !important;">Total</p><p class="net_prices new_net_subtotal" style="font-size: 18px !important;"><span style="font-size:14px !important;">USD</span> 0</p> </div>';
    
                mobile_inner.appendChild(mobile_inner_items);
                Mobile_Accordian.appendChild(mobile_inner);
    
                // Soldout or less inventory issue side design
                var inventoryParentLeftChild = document.createElement('div');
                inventoryParentLeftChild.className = 'new_net_box new_net_box_1 new_net_stockerror_box';
                inventoryParentLeftChild.style.display = 'none';
                inventoryParentLeftChild.style.background = 'white';
                var inventoryLeftChild_inner = document.createElement('div');
                inventoryLeftChild_inner.style.display = 'flex';
                inventoryLeftChild_inner.style.background = 'white';
                inventoryLeftChild_inner.className = 'net_address_fields net_stockerror_div';
                inventoryLeftChild_inner.innerHTML += '<div style="padding-top: 85px;padding-right: 10px; " class="new_net_tick"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 172 172" style=" fill:#000000;"><g transform=""><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><path d="M0,86c0,-47.49649 38.50351,-86 86,-86c47.49649,0 86,38.50351 86,86c0,47.49649 -38.50351,86 -86,86c-47.49649,0 -86,-38.50351 -86,-86zM86,165.12c43.69677,0 79.12,-35.42323 79.12,-79.12c0,-43.69677 -35.42323,-79.12 -79.12,-79.12c-43.69677,0 -79.12,35.42323 -79.12,79.12c0,43.69677 35.42323,79.12 79.12,79.12z" fill="#666666"></path><g fill="#666666"><path d="M85.92861,37.18424c-2.68959,0.03942 -4.83874,2.25033 -4.80195,4.93996v68.25522c-0.02486,1.7575 0.89852,3.39224 2.41655,4.27824c1.51803,0.886 3.39553,0.886 4.91356,0c1.51803,-0.886 2.44141,-2.52074 2.41655,-4.27824v-68.25522c0.01801,-1.31643 -0.49732,-2.58414 -1.42871,-3.51463c-0.93139,-0.93049 -2.1996,-1.4446 -3.51601,-1.42533zM86,124.97087c-2.69147,0 -4.87333,2.18187 -4.87333,4.87333c0,2.69147 2.18187,4.87333 4.87333,4.87333c2.69147,0 4.87333,-2.18187 4.87333,-4.87333c0,-2.69147 -2.18187,-4.87333 -4.87333,-4.87333z"></path></g><path d="" fill="none"></path><path d="" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path><path d="M86,172c-47.49649,0 -86,-38.50351 -86,-86v0c0,-47.49649 38.50351,-86 86,-86h0c47.49649,0 86,38.50351 86,86v0c0,47.49649 -38.50351,86 -86,86z" fill="none"></path><path d="M86,165.12c-43.69677,0 -79.12,-35.42323 -79.12,-79.12v0c0,-43.69677 35.42323,-79.12 79.12,-79.12h0c43.69677,0 79.12,35.42323 79.12,79.12v0c0,43.69677 -35.42323,79.12 -79.12,79.12z" fill="none"></path></g></g></svg> </div>';
                var inventoryLeftChild_inner_div = document.createElement('div');
                inventoryLeftChild_inner_div.style.width = '100%';
                var logo_or_name = '<h1 class="new_success_title" style="font-size: 26px !important; margin-bottom: 20px !important; text-transform: none !important; letter-spacing: normal !important;">' + WSAIO.netTerm.net_term_title + '</h1>';
                if (typeof shop_logo_banner == 'undefined' && (typeof shop_logo != 'undefined' && shop_logo != '') && is_logo == true) {
                    var logo_or_name = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a>';
                }
                inventoryLeftChild_inner_div.innerHTML += logo_or_name + '<p style="font-size:18px;">Out of stock</p> <p style="color:#666666 !important;">Some items are no longer available. Your cart has been updated.</p> <div style="display:flex;margin-top: 60px !important;margin-bottom: 18px !important; font-weight: 500;"> <p>Description</p> <p style="margin-left: auto !important;">Quantity</p> </div>';
                var inventoryLeftChild_inner_div_sub = document.createElement('div');
                inventoryLeftChild_inner_div_sub.style.border = '1px solid #cecece38';
                inventoryLeftChild_inner_div_sub.style.borderLeft = 'none';
                inventoryLeftChild_inner_div_sub.style.borderRight = 'none';
                inventoryLeftChild_inner_div_sub.style.paddingTop = '10px';
                inventoryLeftChild_inner_div_sub.style.paddingBottom = '10px';
    
                cart.items.forEach(function(e) {
                    var item_qty = parseInt(e.quantity)
                      , update_item = '';
                    WSAIO.cart_additional_info[0].line_item.forEach(function(ee) {
                        if (e.id == ee.variant_id) {
                            var available_qty = parseInt(ee.inventory_quantity);
                            if (item_qty > available_qty) {
                                if (ee.track_inventory_management == "shopify" && ee.continue_inventory_policy == 'deny') {
                                    inventoryLeftChild_inner_div_sub.innerHTML += '<div class="net_item" available_qty="' + available_qty + '" vid="' + ee.variant_id + '"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <img src="' + e.image + '" alt="' + e.product_title + '"> <span class="new_net_qty">' + item_qty + '</span> </span> </a> </div> <div class="new_net_item_title" style="color:#666666 !important;"> ' + e.product_title + ' </div> <div class="new_net_item_total" style="color:#666666 !important;"> ' + item_qty + ' <svg style="width: 14px; padding-top: 14px !important;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M129,57.33333v21.5h-129v14.33333h129v21.5l40.13053,-28.66667z"></path></g></g></svg> ' + available_qty + ' <svg class="new_net_remove_item" vid="' + ee.variant_id + '" style="cursor:pointer;position: absolute; left: 80px; top: 7px; width: 15px;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M86,14.33333c-39.48833,0 -71.66667,32.17833 -71.66667,71.66667c0,39.48833 32.17833,71.66667 71.66667,71.66667c39.48833,0 71.66667,-32.17833 71.66667,-71.66667c0,-39.48833 -32.17833,-71.66667 -71.66667,-71.66667zM131.22167,121.11667c-2.86667,3.79833 -6.30667,7.23833 -10.105,10.105l-35.11667,-35.11667l-35.11667,35.11667c-3.79833,-2.86667 -7.23833,-6.30667 -10.105,-10.105l35.11667,-35.11667l-35.11667,-35.11667c2.86667,-3.79833 6.30667,-7.23833 10.105,-10.105l35.11667,35.11667l35.11667,-35.11667c3.79833,2.86667 7.23833,6.30667 10.105,10.105l-35.11667,35.11667z"></path></g></g></svg> </div> </div>'
                                    update_items[ee.variant_id] = available_qty;
                                }
                            } else if (available_qty <= 0) {
                                update_items[ee.variant_id] = 0;
                            }
                        }
                    })
                })
    
                inventoryLeftChild_inner_div.appendChild(inventoryLeftChild_inner_div_sub);
                inventoryLeftChild_inner_div.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a class="new_net-continue" style="max-height: 50px !important;justify-content: center !important; border-radius: 6px !important; background: black; color: white !important; padding: 12px 22px; display: block; max-width: 182px; margin: auto !important; border: none !important; margin-top: 30px !important; margin-bottom: 20px !important; text-align: center;">Continue</a> <a href="' + WSAIO.local_param + 'cart" style="margin-left: 20px !important; font-weight: 500;margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> Retour au panier</a> </div></div>';
    
                inventoryLeftChild_inner.appendChild(inventoryLeftChild_inner_div);
                inventoryParentLeftChild.appendChild(inventoryLeftChild_inner);
    
                // Shipping left side design
                var ShippingParentLeftChild = document.createElement('div');
                ShippingParentLeftChild.className = 'new_net_box new_net_box_1 net-shipping-div';
                ShippingParentLeftChild.style.display = 'none';
                if ((typeof shop_logo != 'undefined' && shop_logo != '') && (typeof shop_logo_banner == 'undefined' || shop_logo_banner == '') && is_logo == true) {
                    ShippingParentLeftChild.innerHTML = '<div class="net_address_fields" style="display:flex;"><a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a></div>';
                }
                if ((is_logo == false || (typeof shop_logo == 'undefined' || shop_logo == '')) && WSAIO.netTerm.net_term_title != undefined) {
                    ShippingParentLeftChild.innerHTML += '<div class="net_address_fields" style="display:flex;"> <h1 class="new_net_title">' + WSAIO.netTerm.net_term_title + '</h1> </div>';
                }
                ShippingParentLeftChild.innerHTML += '<div class="net_address_fields" style="display:flex;"> <div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;cursor: pointer;">Panier</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:#6666667a !important;font-size: 14px !important;cursor: pointer;" class="info_link">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black !important;font-size: 14px !important;cursor: pointer;" class="ship_link">Expédition</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;" class="new_checkout_link"> Vérifier </span> </div> </div>';
                var ShippingLeftChild_inner = document.createElement('div');
                ShippingLeftChild_inner.className = 'net_address_fields';
                var ShippingLeftChild_inner_sub = document.createElement('div');
                ShippingLeftChild_inner_sub.className = 'new_net--input_field';
                ShippingLeftChild_inner_sub.style.width = '100%';
                ShippingLeftChild_inner_sub.innerHTML += '<div class="new_shipping_first_box" style="border: 1px solid #d9d9d9 !important; border-radius: 5px;margin-bottom: 40px !important;"> <div class="new_first_row" style="display: flex; padding: 12px 0px; border-bottom: 1px solid #d9d9d9; width: 96%; margin: auto !important;"> <div style="width:25%;font-size: 14px;color:#545454 !important;">Contact</div> <div style="width:60%;font-size: 14px;color:#545454 !important;" class="new_customer_email">' + WSAIO_customer.email + '</div> <div class="new_change_address"  style="cursor: pointer;font-size: 14px;text-align: right; width: 15%; color: #1773b0 !important; text-transform: capitalize;"></div> </div> <div class="new_second_row" style="display: flex; padding: 12px 0px; width: 96%; margin: auto !important;"> <div style="width:25%;font-size: 14px;color:#545454 !important;">Envoyez à</div> <div style="width:60%;font-size: 14px;color:#545454 !important;" class="new_customer_address"></div> <div class="new_change_address"  style="cursor: pointer;font-size: 14px;text-align: right; width: 15%; color: #1773b0 !important; text-transform: capitalize;">change</div> </div> </div>';
                ShippingLeftChild_inner_sub.innerHTML += '<span class="new_net_shipping_method" style=""> <label class="new_net_shipping_method_title">Méthode dexpédition</label> <div style="border: 1px solid #d9d9d9 !important; border-radius: 5px; padding: 30px;" class="new_net_shipping_loader new_net--input_field"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px"  viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="margin: auto !important; display: block; "> <path fill="#808080" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path> </svg><p style=" text-align: center; padding-top: 10px; ">Getting available shipping rates...</p></div><div class="new_net--input_field new_net_shipping_method_box" style="display:none;"> </div> </span>';
                ShippingLeftChild_inner_sub.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <div class="new_return_information" style="margin-top: 16px !important;display: inline-flex;line-height:22px ;color: black !important;cursor:pointer;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22pxvertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour aux informations</div> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span> <button class="new_place_order new_net--input_field ship_field" style="cursor: pointer; border: none !important; float: right !important; margin-top: 0px !important; background: black !important; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; display: block;">Passer la commande</button> </div>';
    
                ShippingLeftChild_inner.appendChild(ShippingLeftChild_inner_sub);
                ShippingParentLeftChild.appendChild(ShippingLeftChild_inner);
    
                // thanku page left side design
                var thankuParentLeftChild = document.createElement('div');
                thankuParentLeftChild.className = 'new_net_box new_net_box_1 new_net-thank-div';
                thankuParentLeftChild.style.display = 'none';
                var thankuLeftChild_inner = document.createElement('div');
                thankuLeftChild_inner.style.display = 'flex';
                thankuLeftChild_inner.className = 'net_address_fields';
                var logo_or_name = '<h1 class="new_success_title" style="font-size: 26px !important; margin-bottom: 20px !important; text-transform: none !important; letter-spacing: normal !important;">' + WSAIO.netTerm.net_term_title + '</h1>';
                if (typeof shop_logo_banner == 'undefined' && (typeof shop_logo != 'undefined' && shop_logo != '') && is_logo == true) {
                    var logo_or_name = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a>';
                }
                thankuLeftChild_inner.innerHTML += '<div> ' + logo_or_name + ' <p>Order <span class="new_net_order_name"></span></p> <h6 class="" style="font-size: 26px !important;padding-bottom: 20px !important;">Merci!</h6> <div style="border: 1px solid #cecece38;padding: 10px !important;border-radius: 5px !important;"> <p style="font-size: 16px !important;font-weight: 600;padding-bottom: 10px;">' + WSAIO.netTerm.messages.confirmation + '</p> <p style="font-size: 14px !important;"> ' + WSAIO.netTerm.messages.thank_you + '</p> </div> <div style="border: 1px solid #cecece38;padding: 10px !important;border-radius: 5px !important;margin-top: 10px !important;"><p style="font-size: 16px !important;font-weight: 600;padding-bottom: 10px;">Détails de la commande</p><div style=" display: flex; "><div style=" width: 50%; "><p style="font-size: 14px !important;font-weight: 600;">Coordonnées</p><p style="font-size: 13px !important;">' + WSAIO_customer.email + '</p></div><div style=" width: 50%; "><p style="font-weight: 600; display: block; font-size: 14px !important;display:none;" class="waioNT_shipping_info">Méthode d expédition</p><p style="font-size: 13px !important; display: block;" class="waioNT_shipping_info waioNt_shipping_method"></p></div></div><div style=" display: flex;    margin-top: 14px !important; "><div style=" width: 50%; "><p style="font-weight: 600; display: block; font-size: 14px !important;display:none; " class="waioNT_shipping_info">Méthode d expédition</p><div class="wsaio_shipping_address waioNT_shipping_info" style="display: none;"></div></div><div style=" width: 50%; "><p style="font-weight: 600; display: block; font-size: 14px !important; display:none;" class="waioNT_shipping_info">Mode de facturation</p><div class="wsaio_billing_address waioNT_shipping_info" style="display: none;"></div></div></div></div> <a class="new_net-continue" href="' + WSAIO.local_param + '" style="max-height: 50px !important;justify-content: center !important; border-radius: 6px !important; background: black; color: white !important; padding: 12px 22px; display: block; max-width: 182px; margin-left: auto !important; border: none !important; margin-top: 30px !important; margin-bottom: 20px !important; text-align: center;justify-content: center !important;">Continuer vos achats</a> </div>';
    
                thankuParentLeftChild.appendChild(thankuLeftChild_inner);
    
                // Information left side design
                var ParentLeftChild = document.createElement('form');
                ParentLeftChild.className = 'new_net_box new_net_box_1 new_net-detail-div ';
                ParentLeftChild.setAttribute('onsubmit', 'return WSAIO.check_available_shipping(event)');
                var LeftChild_inner = document.createElement('div');
                LeftChild_inner.className = 'net_address_fields';
                if ((typeof shop_logo != 'undefined' && shop_logo != '') && (typeof shop_logo_banner == 'undefined' || shop_logo_banner == '') && is_logo == true) {
                    LeftChild_inner.innerHTML = '<a href="' + WSAIO.local_param + '"><img src="' + shop_logo + '" style="margin-bottom: 20px !important;width:150px;" /></a>';
                }
                if ((is_logo == false || (typeof shop_logo == 'undefined' || shop_logo == '')) && WSAIO.netTerm.net_term_title != undefined) {
                    LeftChild_inner.innerHTML += '<h1 class="new_net_title">' + WSAIO.netTerm.net_term_title + '</h1>';
                }
                if (hide_shipping_content) {
                    LeftChild_inner.innerHTML += '<div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;cursor: pointer;">Panier</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black;font-size: 14px !important;cursor: pointer;" class="info_link">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;" class="new_checkout_link"> Vérifier </span> </div>';
                } else {
                    LeftChild_inner.innerHTML += '<div class="new_back_link" > <a href="' + WSAIO.local_param + 'cart" style="color:#1773b0 !important;font-size: 14px !important;cursor: pointer;">Panier</a><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:black;font-size: 14px !important;cursor: pointer;" class="info_link">Information</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg>  <div style="display: contents;color:#6666667a !important;font-size: 14px !important;" class="ship_link">Expédition</div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style=" height: 21px; vertical-align: middle; width: 17px; "> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <polyline points="9 6 15 12 9 18" style=" color: gray !important; "></polyline> </svg> <span style="color: #6666667a !important;font-size: 14px !important;" class="new_checkout_link"> Vérifier </span> </div>';
                }
                if (enable_notes && notes != '') {
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field"><div class="new_w-100 new_field_style" style=" padding: 20px 16px; border: 1px solid #0000ff38 !important; background-color: #0000ff26 !important; ">' + notes + '</div></div>';
                }
                var cart_note = '';
                if (cart.note != '' && cart.note != null) {
                    cart_note = cart.note
                }
                LeftChild_inner.innerHTML += '<div class="new_net--input_field"> <textarea class="new_net_shipping_area new_w-100 new_field_style" name="new_shipping_notes" placeholder="Remarque sur la commande">' + cart_note + '</textarea> </div>';
    
                if (enable_nerterm_PO) {
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field Net_PO_field"> <label style="font-size:14px !important;">PO Number</label> <input type="text" id="PO" name="PO" autocomplete="off" placeholder="Enter PO Number" class="new_w-100 new_field_style" style="width: -webkit-fill-available;width: -moz-available; padding: 12px 10px;margin-top: 5px !important;"> </div>';
                }
    
                if (delivery_options == 'pickup_and_shipping_dshipping') {
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field new_pkc" style="display:inline-flex; align-items: center; justify-content: left;"> <label style=" display: block; font-size: 14px !important;padding-right: 14px; ">Options de livraison: </label> <input id="new_shippingx" checked="" name="new_pickupx" value="new_Shipping" type="radio" class="new_shippingchoose" style="cursor:pointer;"> <label for="new_shippingx" style="cursor:pointer; padding: 5px; padding-top: 5px;">Shipping</label><input id="new_pickup" name="new_pickupx" type="radio" value="new_pickup" class="pickupchoose" style="cursor:pointer; margin-left: 10px !important;"> <label for="new_pickup" style=" padding: 5px;padding-top: 5px;cursor:pointer; ">Pickup</label><br> </div>';
                }
                if (delivery_options == 'pickup_and_shipping_dpickep') {
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field new_pkc" style="display:inline-flex; align-items: center; justify-content: left;"> <label style=" display: block;font-size: 14px !important; ">Options de livraison: </label><input id="new_pickup" name="new_pickupx" checked="" type="radio" value="new_pickup" class="pickupchoose" style=" margin-left: 10px !important;cursor:pointer; "> <label for="new_pickup" style="cursor:pointer; padding: 5px; padding-top: 5px;">Pickup</label> <input id="new_shippingx"  name="new_pickupx" value="new_Shipping" type="radio" class="new_shippingchoose" style="cursor:pointer;"> <label for="new_shippingx" style="cursor:pointer; padding: 5px; padding-top: 5px; ">Shipping</label></div>';
                }
    
                if (enable_new_delivery_date) {
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <label style="font-size:14px !important;">Sélectionnez la date de livraison</label> <input type="date" id="datepicker" name="new_delivery_date" autocomplete="off" placeholder="Sélectionnez la date de livraison (FUTURE-MM/DD/YYYY)" class="new_w-100 new_field_style" style="width: -webkit-fill-available;width: -moz-available; padding: 12px 10px;margin-top: 5px !important;"> </div>';
                }
    
                if (enable_nerterm_options && _payment_options.length > 0) {
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field"> <select name="new_payment" required="" class="new_w-100 new_field_style"> <option value="" class="new_payments_option">Sélectionnez une option de paiement</option>' + _payment_options;
                    LeftChild_inner.innerHTML += '</select></div>';
                }
    
                //==============================Pickup address fields =====

            if (delivery_options !== 'none' && delivery_options_pickup_notes != '') {
                LeftChild_inner.innerHTML += '<br><label class="shipping new_net_shipping_title pick_field">Pickup address</label>';
                    LeftChild_inner.innerHTML += '<div class="new_net_shipping_area new_w-100 new_field_style pick_field" name="new_pickup_address"  readonly style="margin-top: 10px !important;background-color: #d9d9d95c !important; padding: 20px 15px;">' + delivery_options_pickup_notes + '</div>';
                }
                //==============================Shipping address fields ==================================== -->
    
                if (delivery_options !== 'none') {
                    LeftChild_inner.innerHTML += '<br><label class="shipping new_net_shipping_title ship_field">Adresse de livraison</label>';
                    LeftChild_inner.innerHTML += selectaddress1;
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field new_d-flex" style="display:flex;"> <input type="text" name="new_waioaddress[first_name]" placeholder="Prénom" required="" class="new_w-46 new_field_style"> <input type="text" name="new_waioaddress[last_name]" placeholder="Nom de famille" required="" class="new_w-46 new_field_style new_right_input"> </div>';
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[company]" placeholder="Entreprise" class="new_w-100 new_field_style"> </div>';
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[address1]" placeholder="Adresse Ligne 1" required="" class="new_w-100 new_field_style"> </div>';
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[address2]" placeholder="Adresse Ligne 2" class="new_w-100 new_field_style"> </div>';
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="text" name="new_waioaddress[city]" placeholder="Ville" required="" class="new_w-100 new_field_style"> </div>';
                    var ship_country_province_zip_div = document.createElement('div');
                    ship_country_province_zip_div.className = 'new_net--input_field new_net_small_div new_netterm_countries ship_field';
                    ship_country_province_zip_div.innerHTML += '<span class="new_slct_cntry" style="position:relative;"> <select id="AddressCountryNew" name="new_waioaddress[country] " data-default=""  class="new_field_style" >' + ship_countries_dropdown_values + '</select> <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg></span>';
                    ship_country_province_zip_div.innerHTML += '<span class="new_slct_state" style="position:relative;"> <select name="new_waioaddress[provice]" class="new_field_style" > <option value="">State/Province</option> </select><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg> </span>';
                    ship_country_province_zip_div.innerHTML += '<input type="text" name="new_waioaddress[zip]" placeholder="Zip/Postcode" required="" class="new_field_style">';
                    LeftChild_inner.appendChild(ship_country_province_zip_div);
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field"> <input type="number" name="new_waioaddress[phone]" placeholder="Téléphone" class="new_w-100 new_field_style"> </div>';
    
                    //==============================Billing address fields ==================================== -->
                    var billing_checkbox_field = '<input type="checkbox" name="new_billing_address_same_as_shipping_address" checked="checked">';
                    if (is_billing_address_checked != undefined && !is_billing_address_checked) {
                        billing_checkbox_field = '<input type="checkbox" name="new_billing_address_same_as_shipping_address">';
                    }
                    LeftChild_inner.innerHTML += '<div class="new_net--input_field ship_field" style="display:inline-block;"> ' + billing_checkbox_field + ' <span class="new_net_checkbox_shipping" style="cursor:pointer;">Adresse de facturation identique à adresse de livraison</span> </div>';
                    var billing_address_fields = document.createElement('div');
                    billing_address_fields.className = 'new_billingaddress ship_field';
                    if (is_billing_address_checked == undefined || is_billing_address_checked) {
                        billing_address_fields.style.display = 'none';
                    }
                    billing_address_fields.innerHTML += '<br><h2 class="new_net_shipping_title" style="text-align: left;">Billing address</h2>';
                    billing_address_fields.innerHTML += selectaddress2;
                    billing_address_fields.innerHTML += '<div class="new_net--input_field" style="display:flex;flex-wrap:wrap;"> <input type="text" name="new_waiobilladdress[first_name]" placeholder="Prénom" class="new_w-46 new_field_style billing_address_required"> <input type="text" name="new_waiobilladdress[last_name]" placeholder="Last Name" class="new_w-46 new_field_style new_right_input billing_address_required"> </div>';
                    billing_address_fields.innerHTML += '<div class="new_net--input_field "> <input type="text" name="new_waiobilladdress[company]" placeholder="Company" class="new_w-100 new_field_style"> </div>';
                    billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="text" name="new_waiobilladdress[address1]" placeholder="Address Line 1" class="new_w-100 new_field_style billing_address_required"> </div>';
                    billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="text" name="new_waiobilladdress[address2]" placeholder="Address Line 2" class="new_w-100 new_field_style"> </div>';
                    billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="text" name="new_waiobilladdress[city]" placeholder="City" class="new_w-100 new_field_style billing_address_required"> </div>';
                    var bill_country_province_zip_div = document.createElement('div');
                    bill_country_province_zip_div.className = 'new_net--input_field new_net_small_div new_netterm_countries';
                    bill_country_province_zip_div.innerHTML += '<span class="new_slct_cntrybill" style="position:relative;"> <select id="AddressbillCountryNew" name="new_waiobilladdress[country] " data-default=""  class="new_field_style" >' + bill_countries_dropdown_values + '</select> <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg></span>';
                    bill_country_province_zip_div.innerHTML += '<span class="new_slct_statebill" style="position:relative;"> <select name="new_waiobilladdress[provice]" class="new_field_style" > <option value="">State/Province</option> </select><svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" id="dropdown" style="width: 20px; position: absolute; top: 14px; height: 20px; right: 10px;"><path d="M128 192l128 128 128-128z"></path></svg> </span>';
                    bill_country_province_zip_div.innerHTML += '<input type="text" name="new_waiobilladdress[zip]" placeholder="Zip/Postcode"  class="new_field_style billing_address_required">';
                    billing_address_fields.appendChild(bill_country_province_zip_div);
                    billing_address_fields.innerHTML += '<div class="new_net--input_field"> <input type="number" name="new_waiobilladdress[phone]" placeholder="Phone" class="new_w-100 new_field_style"> </div>';
    
                    LeftChild_inner.appendChild(billing_address_fields);
                }
                //==============================continue and back button ==================================== -->
                if (delivery_options !== 'none') {
                    if (hide_shipping_content) {
                        LeftChild_inner.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a href="' + WSAIO.local_param + 'cart" style="margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22px;vertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour au panier</a> <span class="continue_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><input class="new_net--input_field ship_field continue_shipping" type="submit" value="Place Order" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;height: 50px !important;justify-content: center !important; border-radius: 6px !important;"> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><button class="new_place_order new_net--input_field pick_field" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;background: black !important;color: white !important;width: 200px;height: 60px !important;border-radius: 10px !important;">Passer la commande</button> </div>';
                    } else {
                        LeftChild_inner.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a href="' + WSAIO.local_param + 'cart" style="margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22px;vertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour au panier</a> <span class="continue_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><input class="new_net--input_field ship_field continue_shipping" type="submit" value="Continue" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;height: 50px !important;justify-content: center !important; border-radius: 6px !important;"> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><button class="new_place_order new_net--input_field pick_field" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;background: black !important;color: white !important;width: 200px;height: 60px !important;border-radius: 10px !important;">Passer la commande</button> </div>';
                    }
                } else {
                    LeftChild_inner.innerHTML += '<div style="margin-top: 25px !important;margin-bottom: 80px !important;" class="new_net_btn_div"> <a href="' + WSAIO.local_param + 'cart" style="margin-top: 16px !important;display: inline-flex;line-height: 22px; color: black !important;"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;height: 22px;vertical-align: bottom;"><path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path></svg> Retour au panier</a> <span class="continue_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span> <span class="new_place_loader" style=" float: right !important; background: black; color: white !important; width: 200px; height: 60px !important; border-radius: 10px !important; padding-top: 10px; display: none; "><svg style="margin: auto;display: block;margin: auto !important;" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" xml:space="preserve"> <path fill="#00000052" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" style=" fill: white; "> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></span><button class="new_place_order new_net--input_field pick_field" style="cursor: pointer;border: none !important;float:right !important;margin-top: 0px !important;background: black !important;color: white !important;width: 200px;height: 60px !important;border-radius: 10px !important;">Passer la commande</button> </div>';
                }
    
                ParentLeftChild.appendChild(LeftChild_inner);
    
                // right side
                var ParentRightChild = document.createElement('div');
                ParentRightChild.className = 'new_net_box new_net_box_2';
    
                // cart items html
                var cart_items = cart.items;
                if (cart_items.length > 0) {
                    var item = '';
                    cart_items.forEach(function(items) {
                        const htmlArray = [];
                        var obj = items.properties;
                        if (items.sku != '' && items.sku != null) {
                            htmlArray.push(`<div class="net_line_properties net_line_sku">SKU: ${items.sku}</div>`);
                        }
                        for (const key in obj) {
                            if (obj.hasOwnProperty(key)) {
                            if (typeof key === 'string' && key.startsWith('_')) {
                                continue;
                                // skip this iteration
                            }
                            if (typeof key === 'string' && key == 'Preview') {
                                htmlArray.push(`<a class="net_line_properties" href="${obj[key]}" style="text-decoration: underline !important;">Preview</a>`);
                                continue;
                                // skip this iteration
                            }
                                htmlArray.push(`<div class="net_line_properties">${key}: ${obj[key]}</div>`);
                            }
                        }
                        var var_title = items.variant_title;
                        if (var_title == null)
                            var_title = '';
                        item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <img src="' + items.image + '" alt="' + items.product_title + '"> <span class="new_net_qty">' + items.quantity + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + items.product_title + ' <div class="net_variant_info"> ' + var_title + ' ' + htmlArray.join('') + ' </div> </div> <div class="new_net_item_total"> <span class="new_net_total net-item-total-price-' + (items.key).replace(':', '_') + '"><s></s> <span class="new_order-discount">' + WSAIO_formatMoney(items.price / 100) + '</span></span> </div> </div>';
                    })
                    if (WSAIO_generalSetting.additionalFee_enabled) {
                        item += '<div class="net_item"> <div class="new_net_item_img"> <a class="net_item__image"> <span class="new_net_img_div"> <svg id="ezg9palcYyL1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 79 80" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" style=" "><image width="79" height="80" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABQCAYAAABYtCjIAAADlUlEQVR4Ae2d15KjMBBF+f8PdM45vtnP2jpU9a5WBUZ4kIPmPqhIEkaH7tuNxDDF/X53Vk6nk5vNZm4wGLher6fiMYAJbGBkvApWbrebWywWbjKZuN1u5y6Xi7teryoeA5jABkawglkJjw2KgMUZjPEqMENoClwcOOMEswI/xhxtp5ZxEGFWIITSuDhgvmHBrCCq+ju1Hg9S8LyI2tZwBE/w4l2trXU9qi/Lk+XJ8r4u6stt5bZyW7nto9Ce2zFpnjRPmifNy03XHvVHmifNk+ZJ86o0gvH+5XJZzntOp1OXqjAfw8zWarV6yY1IrnmAe8cE+isAJoeHxQFvu92Ws+1MnKQq5/PZHQ4H1+/33Xg8Tm59yeHhSsBjfrjKpVPsGw6HjpLi3P45k8ND34D3yunN0WhUvm/jdzTF+lfC40bgnnU3RPBqkleTAQtCbIdWJXgV8DabTSkBwAEaSwtGPkDBq4A3n89LWKQhQLNIzn7BqwDmQyEBBhrwsDyDx9KvJ8urAHk8Hkt4ACQVYUkJ0yDBq4CHdRFlSYAtEWbbtzrWgcfxcH/X21+ZqjRB+DXweGxDs4ikTVBij/8KeBY9TbuqcrZYYH697OEZODq63+9LHQNiFwCzhmcpB51kJASr4VGLQADAMG/zrSpmPVt4VeAMiA+Qerb/0ZI2pDB+nSzhWVJLjmYW53eadR9g04AmQYaUBGtl9Ia2nCM7eDHgDKQPcL1e/2dVVof9QONtfv4mgnXcnrbZwaNzWFz4NGAwwiWWCQTahWmMDRAAzs5HoKEubbKBZwD8joag6rZ9gOSD1GNZdyMsguPKWTxh2DNoKOp1wML9PkCLxoAxiwvrG0AAh8e63v6KxzN0DChAIzA03QisXPBqBgeaLCgbzXvXBFAWmid4T7oP7mUpRF1S3OSCzxzHbdG9Z9q2aZM8YNjjWNWgZZsLbVMXlwVgmzbP1E0OzyZr6BBpC51KWfgdIm0XozNNQJPD4wIASI4GPDr304JL1hVuzCvA0a+XwGu6g996XPB+EAwFT/D0TnLy1KJrbZXbym3ltnLbrnXlk88nzZPmSfOkeZ+sUV1fmzRPmifNk+Z1rSuffD5pnjTvTZrHXIC91/bJLvJp1wYzfer3SbctP/XL20b6yHR7ty8/Ms234ZmYjn0H+NPc5x3XY7z0Yf1It0XjcFUsDnh/P6xv/6IAF2bCmCDCrLvKPwYwgQ2MjNcfoIujjv48ru8AAAAASUVORK5CYII=" preserveAspectRatio="xMidYMid meet"></image></svg> <span class="new_net_qty">' + 1 + '</span> </span> </a> </div> <div class="new_net_item_title"> ' + WSAIO_generalSetting.additionalFee_label + ' </div> <div class="new_net_item_total"> <span class="new_net_total"> <span class="net_additionalFee">...</span></span> </div> </div>';
                    }
                    ParentRightChild.innerHTML += '<div class="net_items">' + item + '</div>';
                }
    
                if (Show_additional_coupon_field) {
                    // coupon code field html
                    ParentRightChild.innerHTML += '<div class="new_discount-code-forms"> <span class="new_wsaio--coupon-code-forms"> <input type="text" name="new_wsaio--discount-code-fields" placeholder="Discount code"> <button name="new_wsaio--discount-code-btns" class="btn new_wsaio--coupon-code-buttons" disabled="disabled" style="opacity:0.2">Apply</button><div class="discount_code_loader" style="display:none;cursor: pointer;background: black;color: white !important;width: 100px !important;margin-top: 10px !important;border-radius: 5px !important;margin-left: 10px !important;"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="40px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="margin: auto !important; display: block;!important; "> <path fill="#808080" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform> </path> </svg></div> </span> </div>';
                }
                ParentRightChild.innerHTML += '<div class="new_coupon_error" style="color:red;width: 78% !important;margin: auto !important;display: none;"><p style=" color: red !important; ">Discount code is invalid</p></div><div class="new_coupon_label_div" style="display:none;"> <svg style="width: 14px; margin-right: 3px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="coupon_text" style="font-size: 14px; font-weight: 500; text-transform: uppercase;"></p> <svg class="remove_coupon" style="cursor: pointer;width: 16px !important; height: 24px; margin-left: 10px !important;" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 172 172"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#666666"><path d="M40.90039,30.76628l-10.13411,10.13411l45.09961,45.09961l-45.09961,45.09961l10.13411,10.13411l45.09961,-45.09961l45.09961,45.09961l10.13411,-10.13411l-45.09961,-45.09961l45.09961,-45.09961l-10.13411,-10.13411l-45.09961,45.09961z"></path></g></g></svg> </div>';
    
                // subtotal html
                if (WSAIO_generalSetting.additionalFee_enabled) {
                    var fee = 0;
                    if (WSAIO_generalSetting.additionalFee_value_type == 'fixed') {
                        fee = (cart.items_subtotal_price / 100) + parseFloat(WSAIO_generalSetting.additionalFee_value);
                        fee = WSAIO_formatMoney(parseFloat(fee));
                    } else {
                        var p = ((parseFloat(WSAIO_generalSetting.additionalFee_value) / 100) * (cart.items_subtotal_price / 100)).toFixed(2);
                        fee = WSAIO_formatMoney((cart.items_subtotal_price / 100) + parseFloat(p));
                    }
                    ParentRightChild.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + fee + '</p> </div>';
                } else {
                    ParentRightChild.innerHTML += '<div class="new_net_sutotal_div"> <p>Total</p><p class="net_prices net--subtotal subtotal">' + WSAIO_formatMoney(cart.items_subtotal_price / 100) + '</p> </div>';
                }
                // coupon applied html
                ParentRightChild.innerHTML += '<div class="applied_coupon_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>Rabais</p> <svg style="width: 10px; margin-right: 3px !important;margin-left: 6px !important;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg> <p class="applied_coupon_text"style="font-size: 12px; font-weight: 500; text-transform: uppercase;"></p> </span> <p class="net_prices new_net--coupon_deduct"></p> </div> </div>';
                // shipping html
                if (!hide_shipping_content) {
                    ParentRightChild.innerHTML += '<div class="new_net_shipping_div"> <p>Expédition</p><p class="new_net--shipping" style="margin-left: auto !important;">Calculé dans le prochaine étape</p> </div>';
                }
                // VAT html
                ParentRightChild.innerHTML += '<div class="new_applied_vat_line" style="display:none;"> <div class="new_net_coupon_div"> <span style="display: flex;"> <p>VAT (incl.)</p> </span> <p class="net_prices new_net--vat_deduct"></p> </div> </div>';
                // total html
                ParentRightChild.innerHTML += '<div class="new_net_total_div" style="padding: 10px 0px;"> <p style="font-size: 18px !important;font-weight: 600 !important;">Total</p><p class="net_prices new_net_subtotal" style="font-size: 18px !important;font-weight: 600 !important;"><span style="font-size:14px !important;">USD</span> 0</p> </div>';
    
                var style_element = document.createElement('style');
                style_element.innerHTML = 'html{padding:0px !important;}header,footer,shopify-section,#shopify-section-header,.breadcrumbs, #shopify-section-announcement{display:none !important;} *{color:black !important;margin:0px !important;font-size:14px !important;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif !important; letter-spacing: 0 !important;}.NetTerm_div input[type=text], .NetTerm_div input[type=number], .NetTerm_div select,.NetTerm_div [type="date"]{height:43px;}.NetTerm_div textarea{height:70px;} main{padding: 0px !important; margin:0px !important;} a{text-decoration:unset !important;}*:focus-visible { outline: none !important; outline-offset: unset !important; box-shadow: none !important; } .NetTerm_div{background-color:#fafafa !important;} textarea::-webkit-input-placeholder, input::-webkit-input-placeholder,select::-webkit-input-placeholder,option::-webkit-input-placeholder { color: #636c72 !important; }.new_coupon_label_div { background: rgb(113 113 113 / 11%); display: inline-flex; padding: 10px; border-radius: 5px; margin-left: 60px !important; margin-top: 10px !important; } .new_discount-code-forms{ width: 78% !important; margin: auto !important; }[name="new_waioaddress[phone]"]::-webkit-outer-spin-button, [name="new_waioaddress[phone]"]::-webkit-inner-spin-button { -webkit-appearance: none; }[name="new_waioaddress[phone]"]{ -moz-appearance: textfield;appearance: textfield !important; } .NetTerm_div select {   background-image: none !important;background:none !important; }#shopify-section-footer{ display:none !important; } .new_net_shipping_method_title{ font-size: 18px !important; color: #333 !important; font-weight: 400 !important; text-transform: none !important; letter-spacing: normal !important; } .new_net_shipping_method_box{ border: 1px solid #d9d9d9 !important; border-radius: 5px; } .new_net_shipping_method_input_div{ cursor:pointer; padding: 10px !important; font-size: 14px !important; line-height: normal !important; display:flex;    align-items: center !important;}.new_net_shipping_method_input_div label{padding-left: 10px;}.new_net_shipping_method_input_div label,.new_net_shipping_method_input_div input{cursor:pointer;display: inline-block !important;} [name="new_wsaio--discount-code-btns"]{ border: none;cursor: pointer;background: black; color: white !important;  width: 100px !important; margin-top: 10px !important; border-radius: 5px !important; margin-left: 10px !important; } [name="new_wsaio--discount-code-btns"][disabled="disabled"]{cursor: auto;}[name="new_wsaio--discount-code-fields"]{ margin-top: 10px !important; border-radius: 5px !important; width:100% !important; min-height: 43px; padding: 0px 10px !important; border: 1px solid #d9d9d9 !important;}.new_net_img_div{cursor:pointer;} .new_wsaio--coupon-code-forms{ display: flex !important; } textarea:Focus,.textarea:Focus,select:Focus,input:Focus{ outline: none !important; border-color: #d9d9d9 !important; } .NetTerm_div{ width:100%; display:flex; flex-wrap:wrap; } #net-term-order .wrapper.main-content .grid__item { padding: 0px !important; } #net-term-order .wrapper.main-content { max-width: unset !important; padding: 0px !important; } input:focus-visible, textarea:focus,select:focus-visible { outline: none !important; border: 1px solid #d9d9d9 !important; } .new_net_box{ padding-top: 5%; } .new_net_box_2{ width:40%; min-height: 100vh; } .new_net_box_1{ background: white; width:55%; } .net_items{ width:78%; margin:auto !important; max-height: 320px; overflow: hidden !important; padding-right: 3px; } .NetTerm_div .net_items,  .new_mobile_vie_accordian .net_items{ border-bottom: 1px solid rgba(179,179,179,0.34); padding-bottom: 15px; margin-bottom: 15px !important; } .net_items:hover { overflow-y: auto !important; } .net_item{ width:100% !important; display:flex !important; /*     flex-wrap:wrap; */ margin:auto !important; margin-top:10px !important; } .new_net_item_img{ width:70px !important; } .new_net_item_img .net_item__image { position: relative; display: block; width: 65px; height: 65px !important; border: 1px solid rgba(179,179,179,0.34); border-radius: 5px !important; } .new_net_item_img img{ position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; margin: auto !important; max-height: 63px !important; max-width: 63px !important; } .new_net_item_title{ width:57%; padding-right: 4%; padding-left: 10px; position:relative; font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol",sans-serif; } .new_mobile_vie_accordian .new_net_item_title{ padding-right: 5px !important; } .new_net_item_total{ text-align: right; width: auto !important; float: right; position: relative; margin-left: auto !important; display: block; } .new_net_item_title  a, .new_net_item_total span{ margin: 0 !important; width: 100%; color:black; } input::placeholder , select, option, textarea { color: #636c72 !important; } .new_net_qty{ position: absolute !important; border: 1px solid gray !important; border-radius: 100% !important; text-align: center !important; background: gray !important; right: -12% !important; top: -5px !important; color: white !important; font-size: 12px !important; padding: 5px !important; line-height: 8px !important;} .new_mobile_vie_accordian .new_net_qty{ right: -11%; } .new_net_sutotal_div,.new_net_total_div,.new_net_shipping_div, .new_net_coupon_div, .net_cartLevel_div{ display:flex !important; width: 78% !important; margin: auto !important; margin-top: 10px !important; } .NetTerm_div .new_net_total_div, .new_mobile_vie_accordian .new_net_total_div{ padding: 15px 0px; padding-right: 13px; border-top: 1px solid rgba(179,179,179,0.34); margin-top: 15px !important; } .net_prices{ margin-left: auto  !important; /*     margin-right: 3% !important; */ color:black; /* font-weight:600 !important; */  } .new_net_total{/* font-weight:bold; */ } .new_net_total s{ display:block;line-height: 10px; } .net_address_fields{ width: 100% !important; max-width: 600px !important; margin-left: auto !important; padding: 0px 30px !important; margin-right:4% !important;} .new_net_cart_link{ color:black; text-decoration: revert; } .new_net_link_div{ cursor: pointer; } .new_net_link_div img{ width: 14px;height: 8px; } .new_net--input_field { margin-top: 15px !important; } .new_net_shipping_title { font-size: 18px !important; color: #333 !important; font-weight: 400 !important; text-transform: none !important; letter-spacing: normal !important; } [type="submit"],.continue_shipping{ background:black !important; color:white !important; width: 200px !important; height: 60px !important; border-radius: 10px !important; } .new_field_style{ border-radius: 5px !important; border: 1px solid #d9d9d9 !important;background-color: white !important; }[name="new_wsaio--discount-code-fields"],option{background-color: white !important;} select{ background-size: 8px 6px !important; background-position: calc(100% - 24px) calc(1rem + 7px),calc(100% - 19px) calc(1rem + 6px) !important; background-repeat: no-repeat !important; appearance: none !important; } .new_w-46{ width: 45.7% !important; } .new_right_input{ margin-left:auto !important; } input::placeholder,textarea::placeholder, #date_picker::placeholder { color: black; } .new_net_mobile_accordion { background-color: #eee; color: #444; cursor: pointer; padding: 18px; width: 100%; border: none; text-align: left; outline: none; font-size: 15px; transition: 0.4s; } .active, .new_net_mobile_accordion:hover { background-color: #ccc; } .nat_mobile_panel { padding: 0 18px; display: none; background-color: white; overflow: hidden; } .new_mobile_vie_accordian { background: #fcfcfc !important; border-bottom: 1px solid rgba(179,179,179,0.34) !important; } .new_mobile_vie_accordian .new_net_panel{ padding:20px 20px 0px 20px !important; background: #fcfcfc; max-width: 600px !important; margin: auto !important; } .new_mobile_vie_accordian .hOuter { position: relative; max-width: 600px !important; margin: auto !important; display: block; padding: 0px 20px !important; } .new_mobile_vie_accordian .net_items{ width:100% !important; } .new_mobile_vie_accordian .new_net_sutotal_div,.new_mobile_vie_accordian .new_net_total_div,.new_mobile_vie_accordian .new_net_shipping_div,.new_mobile_vie_accordian .net_cartLevel_div{ width:100% !important; } .new_net_alert.success { background-color: #04AA6D; } .new_net_alert { padding: 14px; background-color: #04aa4ead; color: white; opacity: 1; transition: opacity 0.6s; margin-bottom: 15px !important; width: 76%; display: block; margin: auto !important; border-radius: 5px; } .new_net_title{ font-size: 26px !important; margin-bottom: 20px !important; text-transform: none !important; letter-spacing: normal !important; } .NetTerm_div input[type=text],.NetTerm_div input[type=number], .NetTerm_div select, .NetTerm_div textarea { border: 1px solid #d9d9d9 !important; padding: 10px !important; font-size: 14px !important; line-height: normal !important; min-height: 49px; width: -webkit-fill-available;width: -moz-available;} .NetTerm_div select{height:45px;} .NetTerm_div .new_net--input_field textarea { display: block !important; } span.new_net_checkbox_shipping { font-size: 12px !important; }.NetTerm_div input[type=text], .NetTerm_div input[type=number]{padding: 0px 10px !important;} /*   //============================================mobile view accordian============= */ .new_net_accordion { background-color: #eee; color: #444; cursor: pointer; padding: 20px 0 !important; width: 100%; border: none; text-align: left; outline: none; font-size: 15px; transition: 0.4s; } .active, .new_net_accordion:hover { background-color: #ccc; } .new_net_panel { padding: 0 18px; display: none; background-color: white; overflow: hidden; } /*   //============================================mobile view accordian end============= */ @media only screen and (min-width: 613px) { .new_net_box.new_net_box_2 { border-left: 1px solid #d6d6d6; } .new_netterm_countries select{ display: inline-block !important; } .new_netterm_countries{ overflow: hidden !important;display: flex; flex-wrap:wrap;} .new_netterm_countries > span, .new_netterm_countries > input { width: 32.5% !important; float: left !important; } .new_netterm_countries > .new_slct_cntry, .new_netterm_countries > .new_slct_cntrybill{ margin-right: 1.25% !important;flex-grow: 1; flex-basis: 0; } .new_netterm_countries > input{ margin-left: 1.25% !important;flex-grow: 1; flex-basis: 0; } } @media only screen and (max-width: 998px) {  .new_netTerm_banner img{ padding: 22px 0px 14px 0px !important; } .new_net_box_2, .NetTerm_div .new_net_title,.NetTerm_div span.new_back_link, .NetTerm_div img{ display:none; } .new_coupon_label_div{ margin-left:0px !important; } .new_net_coupon_div{ width:100% !important; } .new_discount-code-forms{ width:100% !important; } .new_net_box_1{ width:100%; } .new_net_accordion, .new_net_mobile_div{ display:block !important; } .new_net_shipping_title, .new_back_link{ padding-left:unset !important; } .new_net--input_field{ /*      margin-left:unset !important; */ } .new_net_item_title{ width: 58% !important; } /*     .new_net_item_total{ margin-right: 16px !important; } */ .new_net_btn_div{ width:100% !important; } .new_net_alert.success { width: 100% !important; padding: 10px 11px !important; line-height: 1.5; font-size: 12px !important; } .net_items { max-height: unset !important; } .new_back_link{ text-align:center !important; } .new_net_btn_div a{ margin-bottom:20px !important; margin-top:0px !important; } [type="submit"]{ width: auto !important; padding: 10px 48px !important; } .new_net_mobile_div > .new_back_link { display: none !important; } } @media (max-width: 998px) and  (min-width: 612px){ .new_net--input_field{ width:100% !important; } .net_address_fields{ padding: 0px 20px !important; } .new_net_title{ text-align:center; } .new_net--input_field{ width: 100%; } [type="submit"]{ width: auto !important; padding: 10px 48px !important; } } @media  (max-width: 612px) and  (min-width: 320px){ .new_slct_cntry,.new_slct_state{width:100%}.new_netterm_countries{ flex-wrap:wrap;}[name="new_wsaio--discount-code-btns"]{ min-width: 90px !important; padding: 6px 21px !important; border-radius: 5px !important; } .new_discount-code-forms{ width: 100% !important; } .new_net_remove_item{ left: 30px !important; top: 32px !important; } .net_address_fields{ padding: 0px 20px !important; } .new_w-46{ width:100% !important; } .new_right_input{ margin-top:18px !important; } .new_net_small_div select, .new_net_small_div input{ width:100% !important; } .new_slct_state, .new_slct_statebill{ display:block !important; } [name="new_waioaddress[provice]"], [name="new_waiobilladdress[provice]"]{ /*       margin:0px !important; */ margin-top:18px !important; } #AddressCountryNew{ margin-top:0px !important; } .new_net_title{ text-align:center; } .new_net_item_img{ width:70px !important; } .new_net--input_field,.new_place_loader { width: 100% !important; } [type="submit"]{ width: auto !important; padding: 10px 48px !important; } .new_netterm_countries { overflow: hidden; } .new_netterm_countries input { margin-top: 15px !important; } .new_shipping_first_box .new_first_row div,.new_shipping_first_box .new_second_row div{ font-size: 12px !important; } .new_net_btn_div input[type=submit]{ width: 100% !important; margin: 10px 0px !important; } .new_net_btn_div{ flex-direction: column-reverse !important; display: flex !important; }.new_netterm_countries [name="new_waioaddress[zip]"],[name="new_waiobilladdress[zip]"]{    width: -webkit-fill-available !important;} } @media  (max-width: 612px) and  (min-width: 310px){ .net_address_fields{width: auto !important;} .new_slct_cntry svg,.new_slct_cntrybill svg{top: 0px !important;}.new_slct_state svg,.new_slct_statebill svg{top: 33px !important;}} @media  (max-width: 400px) and  (min-width: 320px){ .new_net_tick{ display:none !important; font-size: 30px !important; } .new_net_title, .new_success_title{ font-size: 30px !important; } }input[type="checkbox"] { background: unset !important; appearance: auto !important; -webkit-appearance: auto !important; } .net_line_properties{line-height: 1 !important;} .net_variant_info,.net_line_properties{color: hsl(0, 0%, 44%) !important; font-size: 11px !important;}.shopify_ship{border-top: 1px solid #d9d9d9;}';
    
                ParentBody.appendChild(inventoryParentLeftChild);
                ParentBody.appendChild(thankuParentLeftChild);
                ParentBody.appendChild(ShippingParentLeftChild);
                ParentBody.appendChild(ParentLeftChild);
                ParentBody.appendChild(ParentRightChild);
    
                document.body.innerHTML = "";
                document.body.appendChild(new_netTerm_banner);
                document.body.appendChild(Mobile_Accordian);
                document.body.appendChild(ParentBody);
                document.body.appendChild(style_element);
    
                //  ============================= js function event that need to run after html eppend  ==================
    
                WSAIO.price_with_unit = function(price) {
                    if (typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined') {
                        price = price + ' ' + WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
                    } else {
                        price = price + ' ' + Shopify.currency.active;
                    }
                    return price;
                }
                ;
                WSAIO.change_currency_sign = function(price) {
                    if (typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1 && typeof WSAIO.market_selected != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && (WSAIO.market_selected != WSAIO.customer.default_address.country_code)) {
                        var character = null;
                        price = price.toString();
                        character = price.replace(/(<([^>]+)>)/ig, '');
                        character = character.replace(/\d.+/g, '');
                        character = character.replace(/\d,+/g, '')
                        price = price.replace(character, WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[1])
                    }
                    return price;
                }
    
                // disable datepiker dates 
                if (enable_new_delivery_date) {
                    var someDate = new Date();
                    var numberOfDaysToAdd = number_of_days_disabled;
                    var result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                    document.querySelector('[name="new_delivery_date"]').setAttribute('min', (new Date(result).toISOString().split('T')[0]))
                }
    
                // ============================= Show hide Billing address fields  =============================
    
                function make_billing_required() {
                    var make_required = document.querySelectorAll('.billing_address_required');
                    for (var i = 0; i < make_required.length; i++) {
                        make_required[i].setAttribute("required", "required");
                    }
                }
                function make_billing_optional() {
                    var make_required = document.querySelectorAll('.billing_address_required');
                    for (var i = 0; i < make_required.length; i++) {
                        make_required[i].removeAttribute("required");
                    }
                }
    
                if (!is_billing_address_checked) {
                    make_billing_required()
                }
    
                function toggle_billing_form() {
                    var x = document.querySelector(".new_billingaddress");
                    if (x.style.display === "none") {
                        x.style.display = "block";
                        make_billing_required();
                    } else {
                        x.style.display = "none";
                        make_billing_optional();
                    }
                }
                const billing_form_checkbox = document.querySelectorAll('[name="new_billing_address_same_as_shipping_address"]');
                if (billing_form_checkbox.length) {
                    for (var i = 0; i < billing_form_checkbox.length; i++) {
                        billing_form_checkbox[i].addEventListener('change', toggle_billing_form);
                    }
                }
    
                if (document.querySelector('.new_net_checkbox_shipping') != null) {
                    document.querySelector('.new_net_checkbox_shipping').addEventListener('click', function() {
                        var custom_event1 = new Event('change');
                        var checkox_slect = document.querySelector('[name="new_billing_address_same_as_shipping_address"]');
                        checkox_slect.dispatchEvent(custom_event1);
                        if (checkox_slect.checked) {
                            checkox_slect.checked = false;
                            make_billing_required();
                        } else {
                            checkox_slect.checked = true;
                            make_billing_optional();
                        }
    
                    })
                }
    
                // check delivery options
                function update_deliver_option() {
                    if (this.value == 'new_pickup') {
                        delivery_options = 'only_pickup';
                        var shipping_fields = document.querySelectorAll('.ship_field');
                        if (shipping_fields.length) {
                            for (var i = 0; i < shipping_fields.length; i++) {
                                shipping_fields[i].style.display = 'none'
                            }
                        }
                        var pickup_fields = document.querySelectorAll('.pick_field');
                        if (pickup_fields.length) {
                            for (var i = 0; i < pickup_fields.length; i++) {
                                pickup_fields[i].style.display = 'block'
                            }
                        }
                        var required_element = document.querySelectorAll('[name="new_waioaddress[first_name]"],[name="new_waioaddress[last_name]"],[name="new_waioaddress[address1]"],[name="new_waioaddress[city]"],[name="new_waioaddress[zip]"]');
                        for (var i = 0; i < required_element.length; i++) {
                            required_element[i].removeAttribute('required');
                        }
                        document.querySelector('.new_net-detail-div').removeAttribute('onsubmit');
                    } else {
                        delivery_options = 'only_shipping';
                        var shipping_fields = document.querySelectorAll('.ship_field');
                        if (shipping_fields.length) {
                            for (var i = 0; i < shipping_fields.length; i++) {
                                shipping_fields[i].style.display = 'block'
                            }
                            document.querySelector('.new_d-flex,.new_netterm_countries').style.display = 'flex';
                            document.querySelector('.new_netterm_countries').style.display = 'flex';
                        }
                        var pickup_fields = document.querySelectorAll('.pick_field');
                        if (pickup_fields.length) {
                            for (var i = 0; i < pickup_fields.length; i++) {
                                pickup_fields[i].style.display = 'none'
                            }
                        }
                        var required_element = document.querySelectorAll('[name="new_waioaddress[first_name]"],[name="new_waioaddress[last_name]"],[name="new_waioaddress[address1]"],[name="new_waioaddress[city]"],[name="new_waioaddress[zip]"]');
                        for (var i = 0; i < required_element.length; i++) {
                            required_element[i].setAttribute('required', 'required');
                        }
                        toggle_billing_form();
                        document.querySelector('.new_net-detail-div').setAttribute('onsubmit', 'return WSAIO.check_available_shipping(event)');
                    }
    
                }
                var deliver_options_value = document.querySelectorAll('[name="new_pickupx"]');
                if (deliver_options_value.length) {
                    for (var i = 0; i < deliver_options_value.length; i++) {
                        deliver_options_value[i].addEventListener('change', update_deliver_option);
                    }
                }
    
                if (delivery_options == 'pickup_and_shipping_dshipping') {
                    var pickup_fields = document.querySelectorAll('.pick_field');
                    if (pickup_fields.length) {
                        for (var i = 0; i < pickup_fields.length; i++) {
                            pickup_fields[i].style.display = 'none';
                        }
                    }
                }
                if (delivery_options == 'pickup_and_shipping_dpickep') {
                    var pickup_fields = document.querySelectorAll('.ship_field');
                    if (pickup_fields.length) {
                        for (var i = 0; i < pickup_fields.length; i++) {
                            pickup_fields[i].style.display = 'none';
                        }
                    }
                    var required_element = document.querySelectorAll('[name="new_waioaddress[first_name]"],[name="new_waioaddress[last_name]"],[name="new_waioaddress[address1]"],[name="new_waioaddress[city]"],[name="new_waioaddress[zip]"]');
                    for (var i = 0; i < required_element.length; i++) {
                        required_element[i].removeAttribute('required')
                    }
                    document.querySelector('.new_net-detail-div').removeAttribute('onsubmit');
                }
    
                if (delivery_options == 'only_pickup') {
                    var ship_fields = document.querySelectorAll('.ship_field');
                    for (var i = 0; i < ship_fields.length; i++) {
                        ship_fields[i].remove();
                    }
                }
                if (delivery_options == 'only_shipping') {
                    var ship_fields = document.querySelectorAll('.pick_field');
                    for (var i = 0; i < ship_fields.length; i++) {
                        ship_fields[i].remove();
                    }
                }
    
                // check if any item sold out or less inventory
                if (update_items && Object.keys(update_items).length > 0) {
                    document.querySelector('.new_net-detail-div ').style.display = 'none';
                    document.querySelector('.new_net_stockerror_box').style.display = 'block';
                }
                //======================================mobile view accordian==================
    
                var acc1 = document.getElementsByClassName("new_net_accordion");
                var i;
    
                for (i = 0; i < acc1.length; i++) {
                    acc1[i].addEventListener("click", function() {
                        this.classList.toggle("active");
                        var panel = this.nextElementSibling;
                        if (panel.style.display === "block") {
                            panel.style.display = "none";
                        } else {
                            panel.style.display = "block";
                        }
                    });
                }
    
                //======================================Auto shipping address append event==================
    
                const shippingselectElement = document.querySelectorAll('.new_shipping_auto_address')
                if (shippingselectElement.length) {
                    for (var i = 0; i < shippingselectElement.length; i++) {
                        shippingselectElement[i].addEventListener('change', (event) => {
                            var Shipping_form_elements = document.querySelectorAll('input[name="new_waioaddress[first_name]"],input[name="new_waioaddress[last_name]"],input[name="new_waioaddress[company]"],input[name="new_waioaddress[address1]"],input[name="new_waioaddress[address2]"],input[name="new_waioaddress[city]"],input[name="new_waioaddress[zip]"],input[name="new_waioaddress[phone]"]');
                            for (var i = 0, iLen = Shipping_form_elements.length; i < iLen; i++) {
                                Shipping_form_elements[i].value = '';
                            }
                            if (event.target.value === '')
                                return;
                            if (event.target.value == 'default') {
                                document.querySelector('input[name="new_waioaddress[first_name]"]').value = WSAIO_customer.default_address.first_name;
                                document.querySelector('input[name="new_waioaddress[last_name]"]').value = WSAIO_customer.default_address.last_name;
                                document.querySelector('input[name="new_waioaddress[company]"]').value = WSAIO_customer.default_address.company;
                                document.querySelector('input[name="new_waioaddress[address1]"]').value = WSAIO_customer.default_address.address1;
                                document.querySelector('input[name="new_waioaddress[address2]"]').value = WSAIO_customer.default_address.address2;
                                document.querySelector('input[name="new_waioaddress[city]"]').value = WSAIO_customer.default_address.city;
                                document.querySelector('input[name="new_waioaddress[zip]"]').value = WSAIO_customer.default_address.zip;
                                if ((WSAIO_customer.default_address.country != undefined && allowed_countries.indexOf(WSAIO_customer.default_address.country) != '-1') || check_specific_country) {
                                    document.querySelector('[name="new_waioaddress[country] "]').value = countries_based_on_name[WSAIO_customer.default_address.country];
                                }
                                document.querySelector('input[name="new_waioaddress[phone]"]').value = WSAIO_customer.default_address.phone;
                                var ship_customevent = new Event('change');
                                document.getElementById("AddressCountryNew").dispatchEvent(ship_customevent);
                                if (WSAIO_customer.default_address.province == null) {
                                    document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex = 0;
                                } else {
                                    document.querySelector('[name="new_waioaddress[provice]"]').value = WSAIO_customer.default_address.province;
                                }
                            }
                            var corresponding_data = WSAIO_customer.addresses[event.target.value];
                            if (typeof corresponding_data !== "undefined") {
                                document.querySelector('input[name="new_waioaddress[first_name]"]').value = corresponding_data.first_name;
                                document.querySelector('input[name="new_waioaddress[last_name]"]').value = corresponding_data.last_name;
                                document.querySelector('input[name="new_waioaddress[company]"]').value = corresponding_data.company;
                                document.querySelector('input[name="new_waioaddress[address1]"]').value = corresponding_data.address1;
                                document.querySelector('input[name="new_waioaddress[address2]"]').value = corresponding_data.address2;
                                document.querySelector('input[name="new_waioaddress[city]"]').value = corresponding_data.city;
                                document.querySelector('input[name="new_waioaddress[zip]"]').value = corresponding_data.zip;
                                document.querySelector('[name="new_waioaddress[country] "]').value = countries_based_on_name[corresponding_data.country];
                                document.querySelector('input[name="new_waioaddress[phone]"]').value = corresponding_data.phone;
                                var ship_customevent = new Event('change');
                                document.getElementById("AddressCountryNew").dispatchEvent(ship_customevent);
                                if (corresponding_data.province == null) {
                                    document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex = 0;
                                } else {
                                    document.querySelector('[name="new_waioaddress[provice]"]').value = corresponding_data.province;
                                }
                            }
    
                        }
                        );
                    }
                }
                //======================================Auto shipping address append event==================
    
                const billingselectElement = document.querySelectorAll('.new_billing_auto_address');
                if (billingselectElement.length) {
                    for (var i = 0; i < billingselectElement.length; i++) {
                        billingselectElement[i].addEventListener('change', (event) => {
                            var Shipping_form_elements = document.querySelectorAll('input[name="new_waiobilladdress[first_name]"],input[name="new_waiobilladdress[last_name]"],input[name="new_waiobilladdress[company]"],input[name="new_waiobilladdress[address1]"],input[name="new_waiobilladdress[address2]"],input[name="new_waiobilladdress[city]"],input[name="new_waiobilladdress[zip]"],input[name="new_waiobilladdress[phone]"]');
                            for (var i = 0, iLen = Shipping_form_elements.length; i < iLen; i++) {
                                Shipping_form_elements[i].value = '';
                            }
                            if (event.target.value === '')
                                return;
                            if (event.target.value == 'default') {
                                document.querySelector('input[name="new_waiobilladdress[first_name]"]').value = WSAIO_customer.default_address.first_name;
                                document.querySelector('input[name="new_waiobilladdress[last_name]"]').value = WSAIO_customer.default_address.last_name;
                                document.querySelector('input[name="new_waiobilladdress[company]"]').value = WSAIO_customer.default_address.company;
                                document.querySelector('input[name="new_waiobilladdress[address1]"]').value = WSAIO_customer.default_address.address1;
                                document.querySelector('input[name="new_waiobilladdress[address2]"]').value = WSAIO_customer.default_address.address2;
                                document.querySelector('input[name="new_waiobilladdress[city]"]').value = WSAIO_customer.default_address.city;
                                document.querySelector('input[name="new_waiobilladdress[zip]"]').value = WSAIO_customer.default_address.zip;
                                if ((WSAIO_customer.default_address.country != undefined && allowed_countries.indexOf(WSAIO_customer.default_address.country) != '-1') || check_specific_country) {
                                    document.querySelector('[name="new_waiobilladdress[country] "]').value = countries_based_on_name[WSAIO_customer.default_address.country];
                                }
                                document.querySelector('input[name="new_waiobilladdress[phone]"]').value = WSAIO_customer.default_address.phone;
                                var bill_customevent = new Event('change');
                                document.getElementById("AddressbillCountryNew").dispatchEvent(bill_customevent);
                                if (WSAIO_customer.default_address.province == null) {
                                    document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex = 0;
                                } else {
                                    document.querySelector('[name="new_waiobilladdress[provice]"]').value = WSAIO_customer.default_address.province;
                                }
                            }
                            var corresponding_data = WSAIO_customer.addresses[event.target.value];
                            if (typeof corresponding_data !== "undefined") {
                                document.querySelector('input[name="new_waiobilladdress[first_name]"]').value = corresponding_data.first_name;
                                document.querySelector('input[name="new_waiobilladdress[last_name]"]').value = corresponding_data.last_name;
                                document.querySelector('input[name="new_waiobilladdress[company]"]').value = corresponding_data.company;
                                document.querySelector('input[name="new_waiobilladdress[address1]"]').value = corresponding_data.address1;
                                document.querySelector('input[name="new_waiobilladdress[address2]"]').value = corresponding_data.address2;
                                document.querySelector('input[name="new_waiobilladdress[city]"]').value = corresponding_data.city;
                                document.querySelector('input[name="new_waiobilladdress[zip]"]').value = corresponding_data.zip;
                                document.querySelector('[name="new_waiobilladdress[country] "]').value = countries_based_on_name[corresponding_data.country];
                                document.querySelector('input[name="new_waiobilladdress[phone]"]').value = corresponding_data.phone;
                                var bill_customevent = new Event('change');
                                document.getElementById("AddressbillCountryNew").dispatchEvent(bill_customevent);
                                if (corresponding_data.province == null) {
                                    document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex = 0;
                                } else {
                                    document.querySelector('[name="new_waiobilladdress[provice]"]').value = corresponding_data.province;
                                }
                            }
    
                        }
                        );
                    }
                }
    
                // ============================= Gets provinces based on country select  =============================
                // For Shipping form
                const ship_country_select = document.querySelectorAll("#AddressCountryNew");
                if (ship_country_select.length) {
                    for (var i = 0; i < ship_country_select.length; i++) {
                        ship_country_select[i].addEventListener('change', ship_create_states_dropdown);
                        var ship_customevent = new Event('change');
                        document.getElementById("AddressCountryNew").dispatchEvent(ship_customevent);
                    }
                }
                // For Billing form
                const bill_country_select = document.querySelectorAll("#AddressbillCountryNew");
                if (bill_country_select.length) {
                    for (var i = 0; i < bill_country_select.length; i++) {
                        bill_country_select[i].addEventListener('change', bill_create_states_dropdown);
                        var bill_customevent = new Event('change');
                        document.getElementById("AddressbillCountryNew").dispatchEvent(bill_customevent);
                    }
                }
    
                // ============================= enable disale coupon field button  =============================
                // For desktop view
                function check_field_data1() {
                    var new_coupon_error = document.querySelectorAll('.new_coupon_error');
                    for (var i = 0; i < new_coupon_error.length; i++) {
                        new_coupon_error[i].style.display = 'none';
                    }
                    var x = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-btns"]');
                    if (document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]').value == '') {
                        x.setAttribute("disabled", "disabled");
                        x.style.opacity = "0.2";
                    } else {
                        x.removeAttribute("disabled");
                        x.style.opacity = "1";
                    }
                }
                const desktop_coupon_field_input = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]');
                if (desktop_coupon_field_input != null) {
                    desktop_coupon_field_input.addEventListener('keyup', check_field_data1);
                }
    
                // For mobile view
                function check_field_data2() {
                    var new_coupon_error = document.querySelectorAll('.new_coupon_error');
                    for (var i = 0; i < new_coupon_error.length; i++) {
                        new_coupon_error[i].style.display = 'none';
                    }
                    var x = document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-btns"]');
                    if (document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-fields"]').value == '') {
                        x.setAttribute("disabled", "disabled");
                        x.style.opacity = "0.2";
                    } else {
                        x.removeAttribute("disabled");
                        x.style.opacity = "1";
                    }
                }
                const mobile_coupon_field_input = document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-fields"]');
                if (mobile_coupon_field_input != null) {
                    mobile_coupon_field_input.addEventListener('keyup', check_field_data2);
                }
    
                // ============/////================= Wholesale app functions  ==============////===============
    
                // subtotal get function 
                WSAIO_subtotal = function() {
                    var subtotal = 0;
                    if (typeof window.preDiscountData == 'undefined') {
                        subtotal = parseFloat(WSAIO.cart_object.items_subtotal_price / 100);
                    } else {
                        if (typeof window.preDiscountData.checkout_final_price != 'undefined') {
                            subtotal = parseFloat(window.preDiscountData.checkout_final_price);
                        }
                    }
                    return subtotal;
                }
                // Original subtotal without additoional Discount get function 
                WSAIO_originalSubtotal = function() {
                    var subtotal = 0;
                    if (typeof window.preDiscountData == 'undefined') {
                        subtotal = parseFloat(WSAIO.cart_object.items_subtotal_price / 100);
                    } else {
                        if (typeof window.preDiscountData.checkout_price_from_items_subtotal_price != 'undefined') {
                            subtotal = parseFloat(window.preDiscountData.checkout_price_from_items_subtotal_price);
                        }
                    }
                    return subtotal;
                }
    
                // cart get function 
                WSAIO_cart_item = function() {
                    var cart_item = null;
                    if (typeof window.preDiscountData == 'undefined') {
                        cart_item = WSAIO.cart_object.items;
                    } else {
                        if (typeof window.preDiscountData.checkout_final_price != 'undefined') {
                            cart_item = window.preDiscountData.line_items;
                        }
                    }
                    return cart_item;
                }
    
                function get_line_price(cart_item, index) {
                    var price = 0;
                    if (typeof window.preDiscountData == 'undefined') {
                        price = parseFloat(cart_item[index].final_price) / 100;
                    } else {
                        price = parseFloat(cart_item[index].wholesale.item_subtotal_price);
                    }
                    return price;
                }
    
                function show_Additional_Processing_fee(subtotal) {
                    var fee = 0;
                    if (WSAIO_generalSetting.additionalFee_value_type == 'fixed') {
                        subtotal = subtotal + (parseFloat(WSAIO_generalSetting.additionalFee_value) * Shopify.currency.rate);
                        fee = WSAIO_formatMoney((parseFloat(WSAIO_generalSetting.additionalFee_value) * Shopify.currency.rate).toFixed(2));
                    } else {
                        var p = ((parseFloat(WSAIO_generalSetting.additionalFee_value) / 100) * subtotal).toFixed(2);
                        if (parseFloat(p) == 0) {
                            fee = '...';
                        } else {
                            fee = WSAIO_formatMoney(parseFloat(p));
                        }
                        subtotal = subtotal + parseFloat(p);
                    }
                    var processing_selecor = document.querySelectorAll('.net_additionalFee');
                    for (var i = 0; i < processing_selecor.length; i++) {
                        processing_selecor[i].innerText = fee;
                    }
                    return subtotal;
                }
    
                // update Total price function
                WSAIO_update_total_price = function() {
                    var subtotal = WSAIO_subtotal();
                    var coupon_price = coupon_applied_value;
                    var shipping_price = -1;
                    if (WSAIO_generalSetting.additionalFee_enabled) {
                        var subt = show_Additional_Processing_fee(subtotal);
                        subtotal = subt;
                    }
                    if (typeof WSAIO_get_shipping_value != 'undefined') {
                        shipping_price = WSAIO_get_shipping_value();
                    }
                    if (free_shipping_coupon_applied) {
                        shipping_price = 0;
                    }
                    var Total_price = subtotal - coupon_price;
                    if (shipping_price > -1 && netTerm_page_tab == 'shipping') {
                        Total_price += shipping_price;
                    }
                    Total_price = WSAIO_formatMoney(Total_price);
                    if (typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && typeof WSAIO_formatMoney != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
                        Total_price = WSAIO.change_currency_sign(Total_price);
                        document.querySelector('.NetTerm_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] + '</span>' + ' ' + Total_price;
                        document.querySelector('.new_net_mobile_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] + '</span>' + ' ' + Total_price;
                    } else {
                        document.querySelector('.NetTerm_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + window.Shopify.currency.active + '</span>' + ' ' + Total_price;
                        document.querySelector('.new_net_mobile_div .new_net_subtotal').innerHTML = '<span style="font-size:14px !important;">' + window.Shopify.currency.active + '</span>' + ' ' + Total_price;
                    }
    
                }
    
                if (typeof show_default_shipping_address != 'undefined' && show_default_shipping_address != null && show_default_shipping_address) {
                    if (delivery_options == 'only_shipping' || delivery_options == 'pickup_and_shipping_dshipping') {
                        var event = new Event('change');
                        if (document.querySelector('.new_shipping_auto_address') != null) {
                            document.querySelector('.new_shipping_auto_address').value = 'default';
                            setTimeout(function() {
                                document.querySelector('.new_shipping_auto_address').dispatchEvent(event);
                            })
                        }
                    }
                }
    
                WSAIO.run_wholesale_app_code = function(pre_response) {
                    setTimeout(function() {
                        WSAIO_update_total_price()
                    }, 200);
                }
    
                // call app function
                if (typeof WSAIO.preCheckout != 'undefined') {
                    WSAIO.NetTerm_version = 1.1;
                    WSAIO.preCheckout();
                    WSAIO_update_total_price();
                } else {
                    setTimeout(function() {
                        WSAIO_update_total_price()
                    }, 200);
                }
    
                // Get Discount response
                WSAIO.pre_response = function(pre_response) {
                    if (typeof WSAIO.run_wholesale_app_code != 'undefined' && typeof WSAIO.run_wholesale_app_code === 'function') {
                        WSAIO.run_wholesale_app_code(pre_response);
                    }
                }
                ;
    
                // ============================= Coupon code apply function  =============================
                function show_coupon_loader() {
                    var btn_hide = document.querySelectorAll('[name="new_wsaio--discount-code-btns"]');
                    for (var i = 0; i < btn_hide.length; i++) {
                        btn_hide[i].style.display = 'none';
                    }
                    var loader_show = document.querySelectorAll('.discount_code_loader');
                    for (var i = 0; i < loader_show.length; i++) {
                        loader_show[i].style.display = 'inline-block';
                    }
                }
                function hide_coupon_loader() {
                    var btn_hide = document.querySelectorAll('[name="new_wsaio--discount-code-btns"]');
                    for (var i = 0; i < btn_hide.length; i++) {
                        btn_hide[i].style.display = 'inline-block';
                    }
                    var loader_show = document.querySelectorAll('.discount_code_loader');
                    for (var i = 0; i < loader_show.length; i++) {
                        loader_show[i].style.display = 'none';
                    }
                }
                function apply_coupon() {
                    if (WSAIO["debugger"]) {
                        debugger ;
                    }
                    var new_coupon_error = document.querySelectorAll('.new_coupon_error');
                    for (var i = 0; i < new_coupon_error.length; i++) {
                        new_coupon_error[i].style.display = 'none';
                    }
                    show_coupon_loader();
                    var _this = this;
                    var coupon_value = this.closest('.new_wsaio--coupon-code-forms').querySelector('[name="new_wsaio--discount-code-fields"]').value;
                    let xhr = new XMLHttpRequest();
                    xhr.open("POST", WSAIO.App.checkoutURL + "/discount-code");
                    xhr.setRequestHeader("Accept", "application/json");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4) {
                            var coupon_response = JSON.parse(xhr.responseText);
                            if (coupon_response.status == 0) {
                                var new_coupon_error = document.querySelectorAll('.new_coupon_error');
                                for (var i = 0; i < new_coupon_error.length; i++) {
                                    new_coupon_error[i].style.display = 'block';
                                }
                                hide_coupon_loader()
                            } else {
                                WSAIO.application = coupon_response;
                                if ("undefined" !== typeof coupon_response.wholesale_key) {
                                    document.querySelector('.NetTerm_div .coupon_text').textContent = coupon_response.coupon_code;
                                    document.querySelector('.new_net_mobile_div .coupon_text').textContent = coupon_response.coupon_code;
                                    document.querySelector('.NetTerm_div .applied_coupon_text').textContent = coupon_response.coupon_code;
                                    document.querySelector('.new_net_mobile_div .applied_coupon_text').textContent = coupon_response.coupon_code;
                                    document.querySelector('.NetTerm_div .new_coupon_label_div').style.display = 'inline-flex';
                                    document.querySelector('.new_net_mobile_div  .new_coupon_label_div').style.display = 'inline-flex';
                                    document.querySelector('.NetTerm_div .applied_coupon_line').style.display = 'inline';
                                    document.querySelector('.new_net_mobile_div  .applied_coupon_line').style.display = 'inline';
                                    _this.closest('.new_wsaio--coupon-code-forms').querySelector('[name="new_wsaio--discount-code-fields"]').value = '';
                                }
    
                                var subtotal_for_coupon = -1;
                                var WSAIO_cart_data = WSAIO_cart_item();
    
                                if (WSAIO.product_collections != undefined && WSAIO.product_collections.length > 0) {
                                    if (coupon_response.applies_to == 'collections') {
                                        function removeDuplicates() {
                                            books = WSAIO.product_collections,
                                            jsonObject = books.map(JSON.stringify);
                                            uniqueSet = new Set(jsonObject);
                                            uniqueArray = Array.from(uniqueSet).map(JSON.parse);
                                            WSAIO.product_collections = uniqueArray;
                                        }
                                        removeDuplicates();
                                        var coupon_collection_ids = coupon_response.price_rule.entitled_collection_ids;
                                        coupon_collection_ids.forEach(function(e, i) {
                                            for (var j = 0; j < WSAIO.product_collections.length; j++) {
                                                if (WSAIO.product_collections[j].collection_id == e) {
                                                    var item_indx_found = WSAIO_cart_data.findIndex(function(f, r) {
                                                        return WSAIO.product_collections[j].product_id == f.product_id
                                                    })
                                                    if (item_indx_found > -1) {
                                                        var item_subtotal = get_line_price(WSAIO_cart_data, item_indx_found);
                                                        if (item_subtotal != undefined) {
                                                            subtotal_for_coupon = subtotal_for_coupon + item_subtotal;
                                                        }
                                                    }
                                                }
                                            }
                                        })
                                    }
                                }
                                if (coupon_response.applies_to == 'variants') {
                                    var coupon_variants_ids = coupon_response.price_rule.entitled_variant_ids;
                                    coupon_variants_ids.forEach(function(e, i) {
                                        var item_indx_found = WSAIO_cart_data.findIndex(function(f, r) {
                                            return e == f.id
                                        })
                                        if (item_indx_found > -1) {
                                            var item_subtotal = get_line_price(WSAIO_cart_data, item_indx_found);
                                            if (item_subtotal != undefined) {
                                                subtotal_for_coupon = subtotal_for_coupon + item_subtotal;
                                            }
                                        }
                                    })
                                }
                                if (coupon_response.applies_to == 'products') {
                                    var coupon_product_ids = coupon_response.price_rule.entitled_product_ids;
                                    coupon_product_ids.forEach(function(e, i) {
                                        var item_indx_found = WSAIO_cart_data.findIndex(function(f, r) {
                                            return e == f.product_id
                                        })
                                        if (item_indx_found > -1) {
                                            var item_subtotal = get_line_price(WSAIO_cart_data, item_indx_found);
                                            if (item_subtotal != undefined) {
                                                subtotal_for_coupon = subtotal_for_coupon + item_subtotal;
                                            }
                                        }
                                    })
                                }
                                if (coupon_response.price_rule.value_type == 'percentage' && !coupon_response.free_shipping) {
                                    var percent = parseFloat(coupon_response.price_rule.value)
                                    var subtotal = 0;
                                    if (subtotal_for_coupon != -1) {
                                        subtotal_for_coupon = subtotal_for_coupon + 1;
                                        subtotal = (subtotal_for_coupon / 100) * percent;
                                        coupon_applied_value = subtotal;
                                        document.querySelector('.NetTerm_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
                                        document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
                                    } else {
                                        subtotal = (WSAIO_originalSubtotal() / 100) * percent;
                                        coupon_applied_value = subtotal;
                                        document.querySelector('.NetTerm_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
                                        document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(subtotal));
                                    }
                                } else {
                                    var price = parseFloat(coupon_response.price_rule.value)
                                    if (coupon_response.free_shipping) {
                                        free_shipping_coupon_applied = true;
                                        coupon_applied_value = 0;
                                        WSAIO_show_shipping_value();
                                        document.querySelector('.NetTerm_div .new_net--coupon_deduct').textContent = 'Free Shipping';
                                        document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').textContent = 'Free Shipping';
                                    } else {
                                        coupon_applied_value = parseFloat(price);
                                        document.querySelector('.NetTerm_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(price));
                                        document.querySelector('.new_net_mobile_div .new_net--coupon_deduct').innerHTML = '-' + check_formate(parseFloat(price));
                                    }
                                }
    
                                // show total price in information page
                                WSAIO_update_total_price();
                                hide_coupon_loader();
                            }
                            _this.setAttribute("disabled", "disabled");
                            _this.style.opacity = "0.2";
                        }
                    }
                    ;
                    let data = {
                        cart: cart,
                        shopInfo: WSAIO.shopInfo,
                        customer: WSAIO.customer,
                        coupon_code: coupon_value,
                        products_with_collections: WSAIO.product_collections || []
                    }
                    xhr.send(JSON.stringify(data));
                }
    
                const click_coupon_btn1 = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-btns"]');
                if (click_coupon_btn1 != null) {
                    click_coupon_btn1.addEventListener('click', apply_coupon);
                }
                const click_coupon_btn2 = document.querySelector('.new_net_mobile_div [name="new_wsaio--discount-code-btns"]');
                if (click_coupon_btn2) {
                    click_coupon_btn2.addEventListener('click', apply_coupon);
                }
    
                // ============================= Coupon code remove function  =============================
                function remove_coupon() {
                    document.querySelector('.NetTerm_div .coupon_text').textContent = '';
                    document.querySelector('.new_net_mobile_div .coupon_text').textContent = '';
                    document.querySelector('.NetTerm_div .applied_coupon_text').textContent = '';
                    document.querySelector('.new_net_mobile_div .applied_coupon_text').textContent = '';
                    document.querySelector('.NetTerm_div .new_coupon_label_div').style.display = 'none';
                    document.querySelector('.new_net_mobile_div  .new_coupon_label_div').style.display = 'none';
                    document.querySelector('.NetTerm_div .applied_coupon_line').style.display = 'none';
                    document.querySelector('.new_net_mobile_div  .applied_coupon_line').style.display = 'none';
                    coupon_applied_value = 0;
                    // update total price in information page
                    WSAIO_update_total_price();
                    WSAIO.application = {};
                    free_shipping_coupon_applied = false;
                    WSAIO_show_shipping_value();
                }
    
                const remove_coupon_btn1 = document.querySelector('.NetTerm_div .remove_coupon');
                remove_coupon_btn1.addEventListener('click', remove_coupon);
                const remove_coupon_btn2 = document.querySelector('.new_net_mobile_div .remove_coupon');
                remove_coupon_btn2.addEventListener('click', remove_coupon);
    
                // ============================= show shipping page function  =============================
    
                // Show Shipping value function 
                WSAIO_show_shipping_value = function() {
                    if (free_shipping_coupon_applied) {
                        var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
                        for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
                            new_netTerm_shipping_selector[j].textContent = 'free';
                        }
                    } else {
                        var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
                        if (new_netTerm_shipping.length) {
                            for (i = 0; i < new_netTerm_shipping.length; i++) {
                                if (new_netTerm_shipping[i].checked) {
                                    var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
                                    for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
                                        if (new_netTerm_shipping[i].value == 0) {
                                            new_netTerm_shipping_selector[j].textContent = 'free';
                                        } else {
                                            new_netTerm_shipping_selector[j].innerHTML = check_formate(new_netTerm_shipping[i].getAttribute('ship_pri'));
                                        }
                                    }
                                }
                            }
                        } else {
                            var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
                            for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
                                new_netTerm_shipping_selector[j].textContent = 'Calculé à létape suivante';
                            }
                        }
                    }
                    setTimeout(function() {
                        WSAIO_update_total_price()
                    }, 200);
                }
    
                var shipping_rows_event = document.querySelectorAll('.new_net_shipping_method_input_div');
                for (i = 0; i < shipping_rows_event.length; i++) {
                    shipping_rows_event[i].addEventListener('click', function(e) {
                        e.target.previousElementSibling.checked = true;
                        WSAIO_show_shipping_value()
                    })
                }
    
                // Show Shipping value function 
                WSAIO_get_shipping_value = function() {
                    var value = -1;
                    var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
                    for (i = 0; i < new_netTerm_shipping.length; i++) {
                        if (new_netTerm_shipping[i].checked) {
                            value = parseFloat(new_netTerm_shipping[i].getAttribute('ship_pri'));
                        }
    
                    }
                    return value;
                }
    
                //  Shipping radio button trigger function 
                WSAIO_change_shipping = function() {
                    var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
                    for (i = 0; i < new_netTerm_shipping.length; i++) {
                        new_netTerm_shipping[i].addEventListener('click', function() {
                            WSAIO_show_shipping_value();
                        });
                    }
                }
    
                // Show Shipping box function 
    
                WSAIO_show_shipping_box = function() {
                    if (document.querySelector('.new_net_shipping_method_input_div') != null) {
                        document.querySelector('.new_net_shipping_method_input_div').remove();
                    }
    
                    // show wholesale shipping in box
                    if (WSAIO_show_wholesale_shipping && typeof WSAIO.applied_shipping != 'undefined' && WSAIO.applied_shipping.apply_shipping_charges) {
                        var ship_value = WSAIO.applied_shipping.shipping_line.price;
                        if (WSAIO_hide_freeShipping && ship_value != 0) {
                            var ship_price = null;
                            if (typeof window.market_rate != 'undefined' && window.market_rate != 0 && window.market_rate != null) {
                                ship_value = Math.ceil(parseFloat(ship_value) * window.market_rate);
                            }
                            if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
                                ship_price = WSAIO.change_currency_sign(WSAIO_formatMoney(ship_value));
                            } else {
                                ship_price = WSAIO_formatMoney(ship_value);
                            }
                            document.querySelector('.new_net_shipping_method_box').innerHTML = '<div class="new_w-100 new_net_shipping_method_input_div wholesale_ship"> <input type="radio" type_of_shipping="Wholesale" class="new_net_shipping_method_input" name="new_netTerm_shipping" ship_pri="' + ship_value + '" value="' + ship_value + '" title="Wholesale Shipping" style="pointer-events: auto; cursor: pointer;"> <label for="wholesale_flate_rate">Flat rate shipping</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>'
                        } else {
                            if (!WSAIO_hide_freeShipping) {
                                if (ship_value == 0) {
                                    document.querySelector('.new_net_shipping_method_box').innerHTML = '<div class="new_w-100 new_net_shipping_method_input_div wholesale_ship"> <input type="radio" type_of_shipping="Wholesale" class="new_net_shipping_method_input" name="new_netTerm_shipping" ship_pri="' + ship_value + '" value="' + ship_value + '" title="Wholesale Shipping" style="pointer-events: auto; cursor: pointer;"> <label for="wholesale_flate_rate">Flat rate shipping</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>free</b></span> </div>'
                                } else {
                                    var ship_price = null;
                                    if (typeof window.market_rate != 'undefined' && window.market_rate != 0 && window.market_rate != null) {
                                        ship_value = Math.ceil(parseFloat(ship_value) * window.market_rate);
                                    }
                                    if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
                                        ship_price = WSAIO.change_currency_sign(WSAIO_formatMoney(ship_value));
                                    } else {
                                        ship_price = WSAIO_formatMoney(ship_value);
                                    }
                                    document.querySelector('.new_net_shipping_method_box').innerHTML = '<div class="new_w-100 new_net_shipping_method_input_div wholesale_ship"> <input type="radio" type_of_shipping="Wholesale" class="new_net_shipping_method_input" name="new_netTerm_shipping" ship_pri="' + ship_value + '" value="' + ship_value + '" title="Wholesale Shipping" style="pointer-events: auto; cursor: pointer;"> <label for="wholesale_flate_rate">Flat rate shipping</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>'
                                }
                            }
                        }
                        if (document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type') != null) {
                            document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type').checked = true;
                        }
                    }
    
                    var is_shopify_error = '';
    
                    // show Shopify shipping in box
                    if (WSAIO_show_shopify_shipping) {
                        shopify_shipping_request = 2;
                        function show_shopify_shipping(rates) {
                            if (document.querySelector('.shopify_ship') != null) {
                                var ship_selector = document.querySelectorAll('.shopify_ship');
                                for (i = 0; i < ship_selector.length; i++) {
                                    ship_selector[i].remove();
                                }
                            }
                            rates.forEach(function(e) {
                                var shipping_pri = e.price;
                                var shipping_val = e.price;
                                if (shipping_pri != 0) {
                                    if (typeof Shopify != 'undefined' && typeof Shopify.currency != 'undefined' && typeof Shopify.currency.active != 'undefined' && typeof WSAIO.shopInfo.currency != 'undefined') {
                                        if (typeof window.market_rate != 'undefined' && window.market_rate != 0 && window.market_rate != null) {
                                            shipping_pri = (parseFloat(shipping_pri) * window.market_rate).toFixed(2);
                                            shipping_val = (parseFloat(shipping_val) * window.market_rate).toFixed(2);
                                        } else {
                                            if (WSAIO.shopInfo.currency != Shopify.currency.active) {
                                                shipping_pri = (parseFloat(10.59) * Shopify.currency.rate).toFixed(2)
                                            }
                                        }
                                    }
                                }
                                var ship_price = null;
                                if (typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO_formatMoney('0').indexOf(Shopify.currency.active) == -1) {
                                    ship_price = WSAIO.change_currency_sign(WSAIO_formatMoney(shipping_pri));
                                } else {
                                    ship_price = WSAIO_formatMoney(shipping_pri);
                                }
                                if (shipping_pri != 0) {
                                    document.querySelector('.new_net_shipping_method_box').innerHTML += '<div class="new_w-100 new_net_shipping_method_input_div shopify_ship"> <input type="radio" type_of_shipping="' + e.name + '" class="new_net_shipping_method_input " name="new_netTerm_shipping" ship_pri="' + shipping_pri + '" value="' + shipping_val + '" title="Shopify Shipping"> <label for="' + e.name + '">' + e.presentment_name + '</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>';
                                } else {
                                    if (!WSAIO_hide_freeShipping)
                                        document.querySelector('.new_net_shipping_method_box').innerHTML += '<div class="new_w-100 new_net_shipping_method_input_div shopify_ship"> <input type="radio" type_of_shipping="' + e.name + '" class="new_net_shipping_method_input " name="new_netTerm_shipping" ship_pri="' + shipping_pri + '" value="' + shipping_val + '" title="Shopify Shipping"> <label for="' + e.name + '">' + e.presentment_name + '</label> <span class="new_ship_value" style="margin-left: auto !important;"><b>' + ship_price + '</b></span> </div>';
                                }
                            })
                            if (document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type') != null) {
                                document.querySelector('.new_net_shipping_method_box [name="new_netTerm_shipping"]:first-of-type').checked = true;
                            }
                            shopify_shipping_request = 3;
                            WSAIO.show_shipping_page();
                        }
    
                        function show_shopify_shipping_without_rates() {
                            shopify_shipping_request = 3;
                            WSAIO.show_shipping_page();
                        }
    
                        function stop_checking_shipping() {
                            document.querySelector('.continue_loader').style.display = 'none';
                            document.querySelector('.continue_shipping').style.display = 'block';
                            document.querySelector('[name="new_waioaddress[zip]"]').style.cssText = 'border:1px solid #b10d0dad !important';
                            if (document.querySelector('.waio_netAddress_error') != null) {
                                document.querySelector('.waio_netAddress_error').remove();
                            }
                            document.querySelector('.new_netterm_countries.ship_field').insertAdjacentHTML("afterend", '<p class="waio_netAddress_error" style="color: #b10d0dad !important; float: right; max-width: 178px; padding-bottom: 10px;">' + is_shopify_error + '</p>');
                        }
                        var outer_counter_trigger = 0;
                        function run_prepare_shipping_request() {
                            let xhr1 = new XMLHttpRequest();
                            xhr1.open("POST", WSAIO.shopInfo.url + "/cart/prepare_shipping_rates");
                            xhr1.setRequestHeader("Accept", "application/json");
                            xhr1.setRequestHeader("Content-Type", "application/json");
                            xhr1.onload = function(ee) {
                                if (this.readyState === 4 && (this.status === 200 || this.status === 202)) {
                                if (xhr1.response != '') {
                                    var res = JSON.parse(xhr1.response);
                                    if (typeof res != 'undefined' && res != null && typeof res.zip != 'undefined' && typeof res.zip[0] != 'undefined') {
                                        is_shopify_error = res.zip[0];
                                        if (is_shopify_error != '') {
                                            stop_checking_shipping()
                                            return false;
                                        }
                                        }
                                    }
                                    var counter_trigger = 0;
                                    function get_shipping_rates() {
                                        setTimeout(function() {
                                            const xhr = new XMLHttpRequest();
                                            xhr.open("GET", WSAIO.shopInfo.url + "/cart/async_shipping_rates");
                                            xhr.send();
                                            xhr.onload = function(e) {
                                                if (this.readyState === 4 && (this.status === 200 || this.status === 202)) {
                                                    var response2 = JSON.parse(xhr.responseText);
                                                    if (response2 != null && response2.shipping_rates != undefined) {
                                                        var shipping_rates_avalaible = response2.shipping_rates;
                                                        show_shopify_shipping(shipping_rates_avalaible)
                                                    } else {
                                                        if (outer_counter_trigger == 0) {
                                                            outer_counter_trigger++;
                                                            setTimeout(function() {
                                                                run_prepare_shipping_request();
                                                            }, 1000)
                                                        } else if (counter_trigger == 0) {
                                                            counter_trigger++;
                                                            setTimeout(function() {
                                                                get_shipping_rates();
                                                            }, 1000)
                                                        } else {
                                                            show_shopify_shipping_without_rates();
                                                        }
                                                    }
                                                } else {
                                                    show_shopify_shipping_without_rates();
                                                }
                                            }
                                        }, 1500)
                                    }
                                    get_shipping_rates();
                                } else if (this.status === 422) {
                                if (xhr1.response != '') {
                                    var res = JSON.parse(xhr1.response);
                                    if (typeof res != 'undefined' && res != null && typeof res.zip != 'undefined' && typeof res.zip[0] != 'undefined') {
                                        is_shopify_error = res.zip[0];
                                        if (is_shopify_error != '') {
                                            stop_checking_shipping()
                                            return false;
                                        }
                                    }
                                } else {
                                    stop_checking_shipping()
                                    return false;
                                    }
                                } else {
                                    if (outer_counter_trigger == 0) {
                                        outer_counter_trigger++;
                                        setTimeout(function() {
                                            run_prepare_shipping_request();
                                        }, 1000)
                                    } else {
                                        show_shopify_shipping_without_rates();
                                    }
                                }
    
                            }
                            let data = {};
                            data.zip = document.querySelector('[name="new_waioaddress[zip]"]').value;
                            data.country = countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value];
                            data.province = document.querySelector('[name="new_waioaddress[provice]"]').value;
                            xhr1.send(JSON.stringify({
                                shipping_address: data
                            }));
                        }
                        run_prepare_shipping_request();
                    }
    
                    if (!WSAIO_show_shopify_shipping) {
                        WSAIO.show_shipping_page();
                    }
    
                }
    
                // function show_shipping_page(){
                WSAIO.show_shipping_page = function(e) {
                    if ((shopify_shipping_request == 1 || shopify_shipping_request == 3)) {
                        document.querySelector('.new_net-detail-div ').style.display = 'none';
                        document.querySelector('.net-shipping-div').style.display = 'block';
                        document.querySelector('[name="new_waioaddress[zip]"]').style.cssText = '1px solid #d9d9d9 !important';
                        if (document.querySelector('.waio_netAddress_error') != null) {
                            document.querySelector('.waio_netAddress_error').remove();
                        }
                        netTerm_page_tab = 'shipping';
                        var new_place_order_btn = document.querySelectorAll('.new_place_order');
                        for (j = 0; j < new_place_order_btn.length; j++) {
                            new_place_order_btn[j].setAttribute('disabled', 'disabled');
                            new_place_order_btn[j].style.backgroundColor = 'gray';
                        }
                        var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
                        for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
                            new_netTerm_shipping_selector[j].textContent = 'Calculating...';
                        }
                        setTimeout(function() {
                            document.querySelector('.new_net_shipping_method_box').style.display = 'block';
                            document.querySelector('.new_net_shipping_loader').style.display = 'none';
                            WSAIO_show_shipping_value();
                            WSAIO_change_shipping();
                            setTimeout(function() {
                                if (document.querySelector('.new_net_shipping_method_box').textContent == ' ') {
                                    document.querySelector('.new_net_shipping_method_box').innerHTML = '<p style=" text-align: center; padding: 30px; ">Aucun tarif dexpédition trouvé pour cette adresse..</p>';
                                }
                            }, 500)
                            for (j = 0; j < new_place_order_btn.length; j++) {
                                new_place_order_btn[j].removeAttribute("disabled");
                                new_place_order_btn[j].style.backgroundColor = 'black';
                            }
                            if (document.querySelector('.new_net_shipping_method_input_div') != null) {
                                var shipping_rows_event = document.querySelectorAll('.new_net_shipping_method_input_div');
                                for (i = 0; i < shipping_rows_event.length; i++) {
                                    shipping_rows_event[i].addEventListener('click', function(e) {
                                        if (e.target != this) {
                                            if (e.target.previousElementSibling != null) {
                                                e.target.previousElementSibling.checked = true;
                                            } else if (e.target.parentNode.parentElement.childNodes[1] != null) {
                                                e.target.parentNode.parentElement.childNodes[1].checked = true;
                                            }
                                        } else {
                                            e.target.childNodes[1].checked = true
                                        }
                                        WSAIO_show_shipping_value()
                                    })
                                }
                            }
                        }, 500);
                    }
                }
    
                WSAIO.check_market_rate = function(e) {
                    // Update prices based on market settings
                    window.market_rate = 0;
                    if (typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.country_currency_code != undefined && typeof WSAIO.Currency.rates != 'undefined' && typeof WSAIO.Currency.rates[WSAIO.shopInfo.currency] != 'undefined') {
                        if (WSAIO.shopInfo.currency != (WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0])) {
                            if (WSAIO.customer.default_address.country_code == 'US') {
                                rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency] / WSAIO.Currency.rates[WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0]]) * 1.015)
                            } else {
                                rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency] / WSAIO.Currency.rates[WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0]]) * 1.02)
                            }
                            window.market_rate = rate;
                        }
    
                    }
                }
    
                // check available shipping
    
                WSAIO.check_available_shipping = function(e) {
                    if (document.querySelector('[name="new_waioaddress[country] "]').value == 'default') {
                        document.querySelector('[name="new_waioaddress[country] "]').style.cssText = 'border:1px solid #b10d0dad !important';
                        if (document.querySelector('.waio_netAddress_error') != null) {
                            document.querySelector('.waio_netAddress_error').remove();
                        }
                        document.querySelector('.new_netterm_countries.ship_field').insertAdjacentHTML("afterend", '<p class="waio_netAddress_error" style="color: #b10d0dad !important; float: left; max-width: 178px; padding-bottom: 10px;">Select a country</p>');
                        return false;
                    }
                    if (!document.querySelector('[name="new_billing_address_same_as_shipping_address"]').checked) {
                        if (document.querySelector('[name="new_waiobilladdress[country] "]').value == 'default') {
                            document.querySelector('[name="new_waiobilladdress[country] "]').style.cssText = 'border:1px solid #b10d0dad !important';
                            if (document.querySelector('.new_billingaddress .waio_netAddress_error') != null) {
                                document.querySelector('.new_billingaddress .waio_netAddress_error').remove();
                            }
                            document.querySelector('.new_billingaddress .new_netterm_countries').insertAdjacentHTML("afterend", '<p class="waio_netAddress_error" style="color: #b10d0dad !important; float: left; max-width: 178px; padding-bottom: 10px;">Select a country</p>');
                            return false;
                        }
                    }
                    e.preventDefault();
                    e.stopImmediatePropagation();
    
                    if (hide_shipping_content) {
                        document.querySelector('.new_place_loader').style.display = 'block';
                        document.querySelector('.continue_shipping').style.display = 'none';
                        setTimeout(function() {
                            remove_default_note(e);
                        }, 200)
                    } else {
                        WSAIO.check_market_rate();
                        document.querySelector('.continue_loader').style.display = 'block';
                        document.querySelector('.continue_shipping').style.display = 'none';
                        setTimeout(function() {
                            document.querySelector('.new_customer_address').textContent = document.querySelector('[name="new_waioaddress[address1]"]').value + ',' + document.querySelector('[name="new_waioaddress[city]"]').value + ' ' + document.querySelector('[name="new_waioaddress[provice]"]').value + ' ' + document.querySelector('[name="new_waioaddress[zip]"]').value + ',' + countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value];
                            WSAIO_show_shipping_box();
                        }, 200)
                    }
    
                    return false;
                }
    
                // ============================= show Information function  =============================
    
                function show_information_page() {
                    document.querySelector('.new_net-detail-div ').style.display = 'block';
                    document.querySelector('.net-shipping-div').style.display = 'none';
                    document.querySelector('.new_net_shipping_method_box').style.display = 'none';
                    document.querySelector('.new_net_shipping_loader').style.display = 'block';
                    netTerm_page_tab = 'information';
                    if (!free_shipping_coupon_applied) {
                        var new_netTerm_shipping_selector = document.querySelectorAll('.new_net--shipping');
                        for (j = 0; j < new_netTerm_shipping_selector.length; j++) {
                            new_netTerm_shipping_selector[j].textContent = 'Calculé à létape suivante';
                        }
                    }
                    document.querySelector('.continue_loader').style.display = 'none';
                    document.querySelector('.continue_shipping').style.display = 'block';
                    setTimeout(function() {
                        WSAIO_update_total_price()
                    }, 100);
                    var disable_element = document.querySelectorAll('.continue_shipping');
                    for (var i = 0; i < disable_element.length; i++) {
                        disable_element[i].removeAttribute('disabled');
                    }
                    return false;
                }
                const info_update1 = document.querySelector('.new_first_row .new_change_address');
                const info_update2 = document.querySelector('.new_second_row .new_change_address');
                const info_update3 = document.querySelector('.net-shipping-div .new_return_information');
                const info_update4 = document.querySelector('.net-shipping-div .info_link');
                if (info_update1 != null)
                    info_update1.addEventListener('click', show_information_page);
                if (info_update2 != null)
                    info_update2.addEventListener('click', show_information_page);
                if (info_update3 != null)
                    info_update3.addEventListener('click', show_information_page);
                if (info_update4 != null)
                    info_update4.addEventListener('click', show_information_page);
    
                // reset invenory of items if it available quantity is less
                function reset_inventory() {
                    var xhttp = new XMLHttpRequest();
                    xhttp.open("POST", "/cart/update.js", true);
                    xhttp.setRequestHeader("Accept", "application/json");
                    xhttp.setRequestHeader("Content-Type", "application/json");
                    xhttp.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            window.location.reload();
                        }
                    }
                    var data1 = {
                        updates: update_items
                    }
                    xhttp.send(JSON.stringify(data1));
                }
    
                const reset = document.querySelector('.new_net-continue');
                reset.addEventListener('click', reset_inventory);
    
                // remove item from less inventory list
                function remove_item() {
                    var vid = this.getAttribute('vid');
                    var obj = {};
                    obj[vid] = 0;
                    var xhttp = new XMLHttpRequest();
                    xhttp.open("POST", "/cart/update.js", true);
                    xhttp.setRequestHeader("Accept", "application/json");
                    xhttp.setRequestHeader("Content-Type", "application/json");
                    xhttp.onreadystatechange = function() {
                        if (this.readyState == 4 && this.status == 200) {
                            window.location.reload();
                        }
                    }
                    var data1 = {
                        updates: obj
                    }
                    xhttp.send(JSON.stringify(data1));
                }
    
                const remove = document.getElementsByClassName('new_net_remove_item');
                for (i = 0; i < remove.length; i++) {
                    remove[i].addEventListener('click', remove_item);
                }
    
                if (typeof WSAIO.net_discountMethod != 'undefined' && WSAIO.net_discountMethod != '') {
                    if (WSAIO.net_discountMethod == 'draft_order') {
                        netTerm_order_method = 'draft_order';
                    } else if (WSAIO.net_discountMethod == 'final_order') {
                        netTerm_order_method = 'final_order';
                    }
                }
    
                function append_shipping_address(shipping_adr, billing_adr) {
                    if ((delivery_options == 'none' || delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep')) {} else {
                        var shippingDiv = document.querySelector('.wsaio_shipping_address');
                        shippingDiv.innerHTML = '';
                        var billingDiv = document.querySelector('.wsaio_billing_address');
                        billingDiv.innerHTML = '';
                        function createAddressLine(value) {
                            if (value.trim() !== '') {
                                var p = document.createElement('p');
                                p.innerHTML = value;
                                p.style.setProperty('font-size', '13px', 'important');
                                shippingDiv.appendChild(p);
                                if (document.querySelector('[name="new_billing_address_same_as_shipping_address"]').checked) {// billingDiv.appendChild(p); 
                                }
                            }
                        }
                        function createBillingAddressLine(value) {
                            if (value.trim() !== '') {
                                var p = document.createElement('p');
                                p.innerHTML = value;
                                p.style.setProperty('font-size', '13px', 'important');
                                billingDiv.appendChild(p);
                            }
                        }
                        // Dynamically create each address line
                        createAddressLine(shipping_adr.first_name + ' ' + shipping_adr.last_name);
                        createAddressLine(shipping_adr.company);
                        createAddressLine(shipping_adr.address1);
                        createAddressLine(shipping_adr.address2);
                        createAddressLine(shipping_adr.city);
                        createAddressLine(shipping_adr.province);
                        createAddressLine(shipping_adr.zip);
                        createAddressLine(shipping_adr.country);
                        createAddressLine(shipping_adr.phone);
    
                        createBillingAddressLine(billing_adr.first_name + ' ' + billing_adr.last_name);
                        createBillingAddressLine(billing_adr.company);
                        createBillingAddressLine(billing_adr.address1);
                        createBillingAddressLine(billing_adr.address2);
                        createBillingAddressLine(billing_adr.city);
                        createBillingAddressLine(billing_adr.province);
                        createBillingAddressLine(billing_adr.zip);
                        createBillingAddressLine(billing_adr.country);
                        createBillingAddressLine(billing_adr.phone);
                        if (document.querySelector('[name="new_netTerm_shipping"]') != null) {
                            if (document.querySelector('[name="new_netTerm_shipping"]:checked').getAttribute('type_of_shipping') == 'Wholesale') {
                                document.querySelector('.waioNt_shipping_method').innerText = 'Flat rate shipping';
                            } else {
                                document.querySelector('.waioNt_shipping_method').innerText = document.querySelector('[name="new_netTerm_shipping"]:checked').getAttribute('type_of_shipping');
                            }
                        }
                        var shippingInfoElements = document.querySelectorAll('.waioNT_shipping_info');
                        shippingInfoElements.forEach(function(element) {
                            element.style.display = 'block';
                        });
                    }
                }
    
                // ============================= Place Order function  =============================
                function place_order() {
                    var _data = {}
                      , discount_app = []
                      , additional_info = {}
                      , _shipping_charges = true;
                if (WSAIO.product_collections != null && WSAIO.cart_relevent_collectionID != null) {
                    WSAIO.product_collections = WSAIO.cart_relevent_collectionID();
                }
                    _data['cart'] = cart;
                    _data['shopInfo'] = WSAIO.shopInfo;
                    _data['customer'] = WSAIO.customer;
                    _data['user_mode'] = WSAIO.user_mode;
                    _data["products_with_collections"] = WSAIO.product_collections;
                    _data["_order_method"] = netTerm_order_method;
                    if (typeof WSAIO.netTerm_order_tags != 'undefined' && WSAIO.netTerm_order_tags != '') {
                        _data['tags'] = WSAIO.netTerm_order_tags;
                    }
    
                    var note_attr = [];
                let shopify_discounts = '';

                cart.items.findIndex(function(item) {
                    if (item.discounts && item.discounts.length > 0) {
                        item.discounts.forEach(function(discount) {
                            if (!shopify_discounts.includes(discount.title)) {
                                if (shopify_discounts !== '') {
                                    shopify_discounts += ' , ';
                                }
                                shopify_discounts += discount.title;
                                }
                        });
                        }
                });

                if (shopify_discounts !== '') {
                        note_attr.push({
                        name: 'Shopify Automatic Discount',
                        value: shopify_discounts
                        });
                        _data['note_attributes'] = note_attr;
                    }
    
                    // App shipping pass value
                    var shipping_type = ''
                      , app_shipping_param = {}
                      , _custom_shipping = {}
                      , custom_shipping_price = 0
                      , custom_shipping_title = '';
                    if (delivery_options != 'only_pickup') {
                        var new_netTerm_shipping = document.querySelectorAll('[name="new_netTerm_shipping"]');
    
                        _data['app_shipping_charges'] = false;
                        _data['shipping_charges'] = app_shipping_param;
                        _data['custom_shipping_line'] = _custom_shipping;
                        for (i = 0; i < new_netTerm_shipping.length; i++) {
                            if (new_netTerm_shipping[i].checked) {
                                shipping_type = new_netTerm_shipping[i].getAttribute('title');
                                custom_shipping_price = new_netTerm_shipping[i].getAttribute('value');
                                custom_shipping_title = new_netTerm_shipping[i].getAttribute('type_of_shipping');
                            }
    
                        }
                        if (free_shipping_coupon_applied) {
                            if (typeof WSAIO.application != 'undefined') {
                                _custom_shipping.custom = true;
                                _custom_shipping.price = 0;
                                _custom_shipping.title = 'Coupon:' + WSAIO.application.coupon_code;
                                _data['custom_shipping_line'] = _custom_shipping;
                            }
                        } else {
                            if (shipping_type == 'Wholesale Shipping') {
                                app_shipping_param['price'] = WSAIO.applied_shipping.shipping_line.price;
                                app_shipping_param['title'] = WSAIO.applied_shipping.shipping_line.title;
                                _data['app_shipping_charges'] = WSAIO.applied_shipping.apply_shipping_charges;
                                _data['shipping_charges'] = app_shipping_param;
                            } else if (shipping_type == 'Shopify Shipping') {
                                _custom_shipping.custom = true;
                                _custom_shipping.price = custom_shipping_price;
                                _custom_shipping.title = custom_shipping_title;
                                _data['custom_shipping_line'] = _custom_shipping;
                            }
                        }
    
                    }
    
                    // additional info => PO,Shipping note etc value pass
                    if (enable_nerterm_PO) {
                        additional_info['Purchase_Order(PO)'] = document.querySelector('[name="PO"]').value;
                    }
                    if (document.querySelector('[name="new_shipping_notes"]').value != '' && document.querySelector('[name="new_shipping_notes"]').value != 'null') {
                        additional_info["Order Note"] = document.querySelector('[name="new_shipping_notes"]').value;
                    }
    
                    // Delivery address value pass
                    if (delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep') {
                        if (document.querySelector('[name="new_pickup_address"]').innerText != '') {
                            additional_info['Pickup Address'] = document.querySelector('[name="new_pickup_address"]').innerText;
                        }
                    }
    
                    // Delivery options value pass
                    if (delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep') {
                        additional_info['Delivery Option'] = 'Pickup';
                    }
    
                    // delivery date value pass
                    if (enable_new_delivery_date && (delivery_options != 'only_pickup' && delivery_options != 'pickup_and_shipping_dpickep' && delivery_options != 'none')) {
                        additional_info['Delivery Date'] = document.querySelector('[name="new_delivery_date"]').value;
                    }
    
                    // payment option value pass
                    if (enable_nerterm_options && document.querySelector('[name="new_payment"]') != null) {
                        additional_info['Payment Option'] = document.querySelector('[name="new_payment"]').value;
                    }
    
                    _data['additional_info'] = additional_info;
    
                    // sku value pass
                    if (WSAIO.variant_sku_are_same) {
                        _data["variant_sku_are_same"] = WSAIO.variant_sku_are_same;
                    }
    
                    // coupon value pass
                    var discount_app = [];
                    if (typeof WSAIO.application != 'undefined') {
                        discount_app = WSAIO.application;
                    }
                    _data["discount_code_application"] = discount_app;
    
                    // shipping address value pass 
                    if ((delivery_options == 'none' || delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep')) {
                        var shipping_address = {};
                        document.querySelector('.net-shipping-div').style.display = 'none';
                    } else {
                        var shipping_address = {
                            "address1": document.querySelector('[name="new_waioaddress[address1]"]').value,
                            "address2": document.querySelector('[name="new_waioaddress[address2]"]').value,
                            "city": document.querySelector('[name="new_waioaddress[city]"]').value,
                            "company": document.querySelector('[name="new_waioaddress[company]"]').value,
                            "country": countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value],
                            "first_name": document.querySelector('[name="new_waioaddress[first_name]"]').value,
                            "last_name": document.querySelector('[name="new_waioaddress[last_name]"]').value,
                            "latitude": "",
                            "longitude": "",
                            "phone": document.querySelector('[name="new_waioaddress[phone]"]').value,
                            "province": document.querySelector('[name="new_waioaddress[provice]"]').value,
                            "zip": document.querySelector('[name="new_waioaddress[zip]"]').value,
                            "name": "",
                            "country_code": document.querySelector('[name="new_waioaddress[country] "]').value,
                            "province_code": document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex] ? document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex].getAttribute('code') : ""
                        }
                        _data['shipping_address'] = shipping_address;
                    }
    
                    // Billing address value pass
                    if ((delivery_options == 'none' || delivery_options == 'only_pickup' || delivery_options == 'pickup_and_shipping_dpickep')) {
                        var billing_address = {};
                    } else {
                        if (!document.querySelector('[name="new_billing_address_same_as_shipping_address"]').checked) {
                            var billing_address = {
                                "address1": document.querySelector('[name="new_waiobilladdress[address1]"]').value,
                                "address2": document.querySelector('[name="new_waiobilladdress[address2]"]').value,
                                "city": document.querySelector('[name="new_waiobilladdress[city]"]').value,
                                "company": document.querySelector('[name="new_waiobilladdress[company]"]').value,
                                "country": countries_based_on_code[document.querySelector('[name="new_waiobilladdress[country] "]').value],
                                "first_name": document.querySelector('[name="new_waiobilladdress[first_name]"]').value,
                                "last_name": document.querySelector('[name="new_waiobilladdress[last_name]"]').value,
                                "latitude": "",
                                "longitude": "",
                                "phone": document.querySelector('[name="new_waiobilladdress[phone]"]').value,
                                "province": document.querySelector('[name="new_waiobilladdress[provice]"]').value,
                                "zip": document.querySelector('[name="new_waiobilladdress[zip]"]').value,
                                "name": "",
                                "country_code": document.querySelector('[name="new_waiobilladdress[country] "]').value,
                                "province_code": document.querySelector('[name="new_waiobilladdress[provice]"]')[document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex] ? document.querySelector('[name="new_waiobilladdress[provice]"]')[document.querySelector('[name="new_waiobilladdress[provice]"]').selectedIndex].getAttribute('code') : ""
                            }
                            _data['billing_address'] = billing_address;
                        } else {
                            additional_info["Billing_Address"] = "same as shipping";
                            var billing_address = {
                                "address1": document.querySelector('[name="new_waioaddress[address1]"]').value,
                                "address2": document.querySelector('[name="new_waioaddress[address2]"]').value,
                                "city": document.querySelector('[name="new_waioaddress[city]"]').value,
                                "company": document.querySelector('[name="new_waioaddress[company]"]').value,
                                "country": countries_based_on_code[document.querySelector('[name="new_waioaddress[country] "]').value],
                                "first_name": document.querySelector('[name="new_waioaddress[first_name]"]').value,
                                "last_name": document.querySelector('[name="new_waioaddress[last_name]"]').value,
                                "latitude": "",
                                "longitude": "",
                                "phone": document.querySelector('[name="new_waioaddress[phone]"]').value,
                                "province": document.querySelector('[name="new_waioaddress[provice]"]').value,
                                "zip": document.querySelector('[name="new_waioaddress[zip]"]').value,
                                "name": "",
                                "country_code": document.querySelector('[name="new_waioaddress[country] "]').value,
                                "province_code": document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex] ? document.querySelector('[name="new_waioaddress[provice]"]')[document.querySelector('[name="new_waioaddress[provice]"]').selectedIndex].getAttribute('code') : ""
                            }
                            _data['billing_address'] = billing_address;
                        }
                    }
    
                    // dynamic currency code 
                    try {
                        /* send presentment_currency if enabled */
                        if (WSAIO.selectedCurrency() != '' && WSAIO.selectedCurrency() !== 'undefined') {
                            var presentment_currency_rate = parseFloat(window.Currency.rates[WSAIO.shopInfo.currency] / window.Currency.rates[WSAIO.selectedCurrency()]) || 1;
                            /* Append rate in payload to use in server */
                            _data['presentment_currency'] = {
                                code: WSAIO.selectedCurrency(),
                                rate: presentment_currency_rate
                            };
                        } else {
                            if (typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined") {
                                var presentment_currency_rate = parseFloat(Shopify.currency.rate) || 1;
                                /* Append rate in payload to use in server */
                                _data['presentment_currency'] = {
                                    code: Shopify.currency.active,
                                    rate: presentment_currency_rate
                                };
                            }
                        }
                    } catch (e) {
                        console.log('WSAIO currency rates undefined')
                    }
                    if (typeof Shopify !== "undefined" && typeof Shopify.country !== "undefined") {
                        /* Append country in payload to use in server */
                        _data['presentment_country'] = Shopify.country;
                    }
                    if ((WSAIO.market_selected != undefined && typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.market_selected != WSAIO.customer.default_address.country_code) && WSAIO.country_currency_code != undefined && typeof WSAIO.Currency.rates != 'undefined' && typeof WSAIO.Currency.rates != 'undefined' && typeof WSAIO.Currency.rates[WSAIO.shopInfo.currency] != 'undefined') {
                        var rate = 0;
                        var customer_currency = WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
                        if (customer_currency == WSAIO.shopInfo.currency) {
                            _data['presentment_currency'] = {
                                code: WSAIO.shopInfo.currency,
                                rate: 1
                            };
                            _data['presentment_country'] = WSAIO.customer.default_address.country_code;
                        } else {
                            if (WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] == Shopify.currency.active) {
                                rate = Shopify.currency.rate;
                            } else {
                                if (WSAIO.shopInfo.currency == 'USD') {
                                    conversion_fee = 1.015;
                                } else {
                                    conversion_fee = 1.02;
                                }
                                rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency] / WSAIO.Currency.rates[customer_currency]) * conversion_fee)
                            }
                            _data['presentment_currency'] = {
                                code: customer_currency,
                                rate: rate
                            };
                            _data['presentment_country'] = WSAIO.customer.default_address.country_code;
                        }
    
                    }
    
                    if (typeof Shopify != 'undefined' && typeof Shopify.currency != 'undefined' && typeof Shopify.currency.active != 'undefined') {
                        _data['active_currency'] = Shopify.currency.active;
                    }
                    if (typeof WSAIO.tax_settings !== "undefined" && typeof WSAIO.auto_vat_enable !== "undefined" && WSAIO.auto_vat_enable) {
                        /* Append tax setting in payload to use in server */
                        _data['tax_settings'] = WSAIO.tax_settings;
                    }
                if (typeof window.company_data != 'undefined') {
                    _data["company"] = window.company_data;
                }

                if (typeof WSAIO.multiple_markets_available != 'undefined') {
                    _data["multiple_markets_available"] = WSAIO.multiple_markets_available;
                }
    
                    const loader1 = document.querySelectorAll('.new_place_loader');
                    for (var i = 0; i < loader1.length; i++) {
                        loader1[i].style.display = 'block';
                    }
                    const place_order_btn11 = document.querySelectorAll('.new_place_order');
                    for (var i = 0; i < place_order_btn11.length; i++) {
                        place_order_btn11[i].style.display = 'none';
                    }
                    let xhr = new XMLHttpRequest();
                    xhr.open("POST", app_url + "/net-term/v3");
                    xhr.setRequestHeader("Accept", "application/json");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4) {
                            var draft_response = JSON.parse(xhr.responseText);
                            if (draft_response.status == 0) {
                            if (draft_response.error.errors[0].message === 'Deferred payments are not allowed. Please check your order and try again.') {

                                // Remove any existing error messages
                                document.querySelectorAll('.netTerm_error-message').forEach(el => el.remove());

                                // Add the error message before each .new_net_btn_div
                                document.querySelectorAll('.new_net_btn_div').forEach(targetElement => {
                                    const errorMessage = document.createElement('p');
                                    errorMessage.textContent = 'Order must be over ' + WSAIO_formatMoney(0) + '. Contact the store to use the Draft Order method.';
                                    errorMessage.className = 'netTerm_error-message';
                                    errorMessage.style.setProperty('color', 'red', 'important');
                                    errorMessage.style.setProperty('margin-top', '-65px', 'important');
                                    errorMessage.style.setProperty('margin-bottom', '65px', 'important');
                                    errorMessage.style.textAlign = 'center';
                                    targetElement.insertAdjacentElement('afterend', errorMessage);
                                }
                                );

                                // Hide loaders
                                document.querySelectorAll('.new_place_loader').forEach(loader => {
                                    loader.style.display = 'none';
                                }
                                );

                                document.querySelectorAll('[value="Place Order"]').forEach(placeOrderBtn => {
                                    const parent = placeOrderBtn.parentElement;
                                    const newOrderBtn = parent.querySelector('button.new_place_order');
                                    if (newOrderBtn) {
                                        placeOrderBtn.style.setProperty('display', 'none', 'important');
                                        newOrderBtn.style.setProperty('display', 'block', 'important');
                                    } else {
                                        placeOrderBtn.style.setProperty('display', 'block', 'important');
                                    }
                                }
                                );

                                document.querySelectorAll('button.new_place_order').forEach(newOrderBtn => {
                                    const parent = newOrderBtn.parentElement;
                                    const placeOrderBtn = parent.querySelector('[value="Place Order"]');
                                    if (!placeOrderBtn) {
                                        newOrderBtn.style.setProperty('display', 'block', 'important');
                                    }
                                }
                                );

                            }

                                console.log('invalid data or missing something');
                            } else {
                                document.querySelector('.new_net-thank-div').style.display = 'block';
                                append_shipping_address(shipping_address, billing_address);
                                document.querySelector('.net-shipping-div').style.display = 'none';
                                document.querySelector('.new_net-detail-div ').style.display = 'none';
                                if (WSAIO.netTerm.order_method == 'draft_order') {
                                    document.querySelector('.new_net_order_name').textContent = draft_response.draft_order_info.name;
                                } else {
                                    document.querySelector('.new_net_order_name').textContent = 'placed by ' + draft_response.draft_order_info.customer.email;
                                }
                                if (typeof draft_response.draft_order_info.isDiscountCodeApplied != 'undefined' && !draft_response.draft_order_info.isDiscountCodeApplied) {
                                    document.querySelector('.NetTerm_div .remove_coupon').dispatchEvent(new Event('click'));
                                    document.querySelector('.new_net_mobile_div .remove_coupon').dispatchEvent(new Event('click'));
                                // Handle .NetTerm_div
                                document.querySelectorAll('.NetTerm_div .new_discount-code-forms').forEach(form => {
                                    const hasError = form.parentElement.querySelector('.net_discount_error');
                                    if (!hasError) {
                                        const errorDiv = document.createElement('div');
                                        errorDiv.className = 'net_discount_error';
                                        errorDiv.style.cssText = `
                                                border: 1px solid #ffdeb3;
                                                background-color: #fff5eb;
                                                padding: 10px;
                                                font-size: 14px !important;
                                                width: 78% !important;
                                                margin: 10px auto !important;
                                                border-radius: 5px;
                                            `;
                                        errorDiv.textContent = "Discount code isn't valid for the items in your cart";
                                        form.insertAdjacentElement('afterend', errorDiv);
                                    }
                                }
                                );

                                // Handle .net_mobile_div
                                document.querySelectorAll('.net_mobile_div .new_discount-code-forms').forEach(form => {
                                    const hasError = form.parentElement.querySelector('.net_discount_error');
                                    if (!hasError) {
                                        const errorDiv = document.createElement('div');
                                        errorDiv.className = 'net_discount_error';
                                        errorDiv.style.cssText = `
                                                border: 1px solid #ffdeb3;
                                                background-color: #fff5eb;
                                                padding: 10px;
                                                font-size: 14px !important;
                                                width: 78% !important;
                                                margin: 10px auto !important;
                                                border-radius: 5px;
                                            `;
                                        errorDiv.textContent = "Discount code isn't valid for the items in your cart";
                                        form.insertAdjacentElement('afterend', errorDiv);
                                    }
                                }
                                );

                                    var coupon_desktop_btn = document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-btns"]');
                                    var coupon_mobile_btn = document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-btns"]');
                                    coupon_desktop_btn.setAttribute("disabled", "disabled");
                                    coupon_desktop_btn.style.opacity = "0.2";
                                    coupon_mobile_btn.setAttribute("disabled", "disabled");
                                    coupon_mobile_btn.style.opacity = "0.2";
                                }
                                if (document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]') != null) {
                                    document.querySelector('.NetTerm_div [name="new_wsaio--discount-code-fields"]').setAttribute("readonly", "readonly");
                                    document.querySelector('.new_mobile_vie_accordian [name="new_wsaio--discount-code-fields"]').setAttribute("readonly", "readonly");
                                }
                                var xhttp = new XMLHttpRequest();
                                xhttp.onreadystatechange = function() {
                                    if (this.readyState == 4 && this.status == 200) {
                                        console.log('cart cleared');
                                    }
                                }
                                xhttp.open("POST", "/cart/clear.js", true);
                                xhttp.send();
                            }
                        }
                    }
                    let data = _data;
                    xhr.send(JSON.stringify(data));
    
                }
                function remove_default_note(event) {
                    event.preventDefault();
                    if (document.querySelector('[name="new_shipping_notes"]').value != '' && document.querySelector('[name="new_shipping_notes"]').value != 'null') {
                        let xhrr = new XMLHttpRequest();
                        xhrr.open("POST", "/cart/update.json");
                        xhrr.setRequestHeader("Accept", "application/json");
                        xhrr.setRequestHeader("Content-Type", "application/json");
                        xhrr.onreadystatechange = function() {
                            if (xhrr.readyState === 4) {
                                cart = JSON.parse(xhrr.responseText);
                                place_order()
                            }
                        }
                        ;
                        let dataa = {
                            note: ''
                        };
                        xhrr.send(JSON.stringify(dataa));
                    } else {
                        place_order();
                    }
                }
                const place_order_btn = document.querySelectorAll('.new_place_order');
                for (var i = 0; i < place_order_btn.length; i++) {
                    place_order_btn[i].addEventListener('click', remove_default_note);
                }
    
            } else {
                window.location.href = '/cart';
            }
    
        }
    
        // Load net term
        if (typeof WSAIO.ntCart !== 'undefined') {
            console.log("NetTerm loaded using WSAIO.ntCart");
            netTermDesign(WSAIO.ntCart);
        } else {
            console.log("NetTerm loaded using cart.json");
            var xhttp = new XMLHttpRequest();
            xhttp.open("POST", "/cart", true);
            xhttp.setRequestHeader("Accept", "application/json");
            xhttp.setRequestHeader("Content-Type", "application/json");
            xhttp.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    if (typeof WSAIO != 'undefined') {
                        netTermDesign(JSON.parse(xhttp.responseText));
                    }
                }
            }
            xhttp.send();
        }
    
    }
    )();
    
    },1500)